// @ts-strict-ignore
/* tslint:disable:max-line-length */
/**
 * AI-generated code:
 * This code (or portions of it) was generated with the assistance of an AI tool
 * and has been reviewed and modified by a developer for correctness, security,
 * and maintainability.
 *
 * [1](LMWEB-24737) Hide/Show mask on a list
 */
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostBinding,
  HostListener,
  Inject,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Optional,
  Output,
  Renderer2,
  signal,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, NavigationStart, Router, RouterStateSnapshot, } from '@angular/router';
import { SohoPopupMenuComponent } from 'ids-enterprise-ng';
import {
  BehaviorSubject,
  EMPTY,
  forkJoin,
  lastValueFrom,
  Observable,
  Observer,
  of as observableOf,
  of,
  Subject,
  Subscription,
  SubscriptionLike as ISubscription,
  throwError
} from 'rxjs';
import {
  catchError,
  distinctUntilChanged,
  first,
  flatMap,
  map,
  startWith,
  switchMap,
  takeUntil,
  tap
} from 'rxjs/operators';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

import { LMBaseComponent, LMDialogInfo, LMDialogType, LMRefreshRequest, SaveRequired } from '@base/index';
import { LMDashboardViewComponent } from '@dashboard/lm-dashboard-view.component';
import {
  DefineFormSpecUrlResponse,
  LandmarkPanel,
  LMFormActionUtilService,
  LMFormComponent,
  LMFormContentSearchComponent,
  LMFormService,
  LMModel,
  LMModelCache,
  LMModelServiceAdapter,
  LMModelStatusEvent,
} from '@form/index';
import { LMFormManualRepService } from '@form/lm-form-manual-rep.service';
import { LMFormSpecUtilService } from '../form/services';
import { LMHtmlPageUtilService } from '@html/lm-html-page-util.service';
import {
  ConfirmationDialogResult,
  GenAIPromptDialogResult,
  GenAIPromptDialogStatus,
  GenAISummarizeDialogResult,
  LMActionFormDialogResult,
  LMAddTagDialogService,
  LMChartNames,
  LMCompactFormDialogResult,
  LMCompactFormDialogService,
  LMCompactFormResult,
  LMConfirmationMessageService,
  LMFieldPickerService,
  LMGenAIPromptDialogService,
  LMGenAISummarizeDialogService,
  LMGenAISummarizeInfo,
  LMHelperListDialogResult,
  LMHelperListDialogResultCode,
  LMHelperListDialogService,
  LMPanelDetail,
  LMPrintCsvInfo,
  LMPrintDialogService,
  LMPrintPdfInfo,
  LMSavedSearchService,
  LMSelectDialogService,
  LMSelectResponse,
  LMSubFormActionInfo,
  LMSubFormActionResults,
  LMSubFormDialogResult,
  LMSubFormDialogService,
  LMSubFormResult
} from '@modal/index';
import {
  LMReportPersonalizationDialogResult,
  LMReportPersonalizationDialogResultCode,
  LMReportPersonalizationDialogService
} from '@report/index';
import { DocumentResource, FormResource, KeyedResource, ListResource, RelationResource } from '@resources/index';
import {
  LMGlobalPersonalizationService,
  LMGlobalStateService,
  LMListPersonalizationKeyParams,
  LMListPersonalizationService,
  LMListStateKeyParams,
  LMListStateService,
} from '@states/index';
import {
  LMActionRequest,
  LMActionService,
  LMBusyIndicatorService,
  LMComponentInfoService,
  LMCompoundFieldService,
  LMConfigurationService,
  LMContextService,
  LMErrorUtilService,
  LMFieldUtilService,
  LMFormatUtilService,
  LMLoggerService,
  LMMessageWrapperDialogRef,
  LMModalOpenService,
  LMModalWrapperService,
  LMOverlayAction,
  LMOverlayService,
  LMRoamingUIProfileService,
  LMRouteComponentService,
  LMRouteReuseCacheService,
  LMSpecService,
  LMUrlInfoBuilderService,
  LMUrlUtilService,
  PersonalizeParams,
  RelatedReportParams,
  RoamingUIProfileResponse,
  RoamingUIProfileResult,
  URLOptions
} from '@services/index';
import {
  AppConstants,
  LMCommonUtilService,
  LMConditionUtilService,
  LMContextUtilService,
  LMDialogButtonKey,
  LMFormType,
  LMGlobalUtilService,
  LMToolbarActionTypeEnum,
  LMTransformOptions,
  LMUniqueIdService
} from '@utils/index';

// -----------------------------------------------------------------
// package and sub package imports
// -----------------------------------------------------------------
import {
  LMListCardService,
  LMListContext,
  LMListGridBuilderService,
  LMListSpecUtilService,
  LMListToolbarService,
  LMListTransactionResultInfo,
  LMListTransactionService,
  LMListUtilService,
} from './services';
import { LMListService } from './services/lm-list.service';
import { LMFormRequestService } from '@form/services/lm-form-request.service';
import { LMMultiPartFields, LMTransactionState } from '@transaction/lm-transaction-state';
import { LMListActionFormDialogService } from '@list/services/lm-list-action-form-dialog.service';
import { LMListSearchFormDialogComponent } from './lm-list-search-form-dialog.component';
import { LMListLookupDialogComponent } from './lm-list-lookup-dialog.component';
import { LMListContentComponent } from './lm-list-content.component';
import { LMDetailSectionsComponent } from './lm-detail-sections.component';
import { LMToolbarComponent } from '@toolbar/lm-toolbar.component';
import { LMActionFormDialogResultCode } from '@modal/lm-action-form-dialog.service';
import { DrillPointsParams } from '@services/lm-drill.service';
import { environment } from '@environments/environment';
import { LMCreateReportPersonalizationCubeEvent, LMCubeSearchEvent, } from './lm-list-cube-viewer.component';
import { LMListViewComponent } from './lm-list-view.component';
import { LMListAuditComparePanelComponent } from './lm-list-audit-compare-panel.component';
import { LMAuditLogCompareDialogComponent } from '@auditlog/lm-audit-log-compare-dialog.component';
import { LMListEventService } from '@list/services/lm-list-event.service';
import { LMNavigationService } from '@navigation/lm-navigation.service';
import { LMFormatterService } from './formatters/';
import { LMEditorService } from './editors';
import { LMStateHelperService } from '@services/lm-state-helper.service';
import { LMKeyboardShortcutService, LMKeyType } from '@services/lm-keyboard-shortcut.service';
import { BreakpointChangeService } from '@drawer/breakpoint-change.service';
import { LMHtmlUrlDocService } from '@services/lm-html-url-doc.service';
import { LMCubeSearchOpenLookupEvent, LMFieldSubscriptionService, LMGenAIEvent } from '../field';
import { LMFilterOperatorEvent } from '../field/lm-field-base.component';
import { LMFieldOptionsService } from '../field/services';
import { LMFieldPickerSelectOptions, LMFieldPickerSelectResponse } from '@modal/field-picker/lm-field-picker';
import { Location } from '@angular/common';
import { LMAppComponentService } from '@utils/lm-app-component.service';
import {
  ApplicationMenuAsOfDateDialogStatus,
  ApplicationMenuAsOfDateResult,
  LMAdHocSelectedField,
  LMApplicationMenuAsOfDateDialogService,
  LMApplicationMenuTransactionService,
  LMBuilderService,
  LMDetailSectionBase,
  LMDetailSectionListComponent,
  LMDetailSectionMultiListComponent,
  LMDrillAroundService,
  LMHtmlUrlDocComponent,
  LMListSelectionTagsComponent
} from '@app/components';
import { LMBannerHeaderComponentRef } from '../banner/lm-banner-header-component-ref.service';
import { LMComponentTrackerService } from '@services/lm-component-tracker.service';
import { LMFormTransactionService } from '@form/services/lm-form-transaction.service';
import { LMDrillAroundStateService } from "@components/drillaround/lm-drill-around-state.service";
import { LMNotificationComponent } from '@components/notification';
import { LMFieldValidatorService } from '@modal/lm-field-validator.service';
import { LMValidateFieldResponse } from '@modal/lm-field-editor-dialog';
import { HttpClient } from "@angular/common/http";
import { LiveRegionConfig } from "../../../directives/lm-live-region.directive";
import { LMWebAppService } from '@services/lm-webapp.service';
import { LMRouteReuse } from '@base/lm-route-reuse';
import { isEmpty } from 'lodash-es';
import { HtmlUrlDocHost } from '@html/lm-html-url-doc-host';
import { LMPortalOverlaySizingService } from '@services/lm-portal-overlay-sizing.service';

declare let urltemplate: any;

export class LMListFieldChangedEvent {
  event: Event;
  columnDef: ListGridColumn;
  dataView: LMDataView;
}

export class LMListSelectionEvent {
  constructor(
    public eventSource: LMListComponent,
    public selectedRows: LMListRowData[]) {}
}

export class LMListLookupSelectionEvent {
  constructor(public eventSource: LMListLookupDialogComponent,
    public rows: Array<any>) {
  }
}

export class LMListRowActivationEvent {
  constructor(
    public eventSource: LMListComponent,
    public activatedEvent: LMListRowActivatedEvent) {}
}

export class LMListTransactionEvent {
  public constructor(
    public eventSource: LMListComponent,
    public actionResultArray: LMActionResult[]) {} // TODO: this is never user
}

export class LMCubeDetailSectionPVPeriodEvent {
  public constructor(public eventSource: LMListComponent, public pvPeriodIdx: number) {}
}

export class LMListDragDropEvent {
  public constructor(
    public eventSource: LMListViewComponent,
    public row: number,
    public filterRow: number) {
  }
}

// used privately by detail fields mechanism
interface LMListDetailFieldsModelCache {
  id: string;
  cache: LMModelCache;
  dataView: LMDataView;
}

@Component({
  selector: 'lm-list',
  standalone: false,
  templateUrl: './lm-list.component.html',
  styleUrls: [ 'lm-list.component.scss', '../../routereuse.component.scss' ],
  providers: [
  LMEditorService,
  LMFormatterService,
  LMFormManualRepService,
  LMHtmlPageUtilService,
  LMHtmlUrlDocService,
  LMKeyboardShortcutService,
  LMListCardService,
  LMListEventService,
  LMListGridBuilderService,
  LMListToolbarService,
  LMListService,
  LMModelServiceAdapter,
  LMFormActionUtilService,
  LMFormService,
  LMFieldSubscriptionService,
  LMComponentTrackerService,
  LMFieldOptionsService,
  LMAddTagDialogService,
  LMRoamingUIProfileService,
  LMGenAIPromptDialogService,
  LMGenAISummarizeDialogService,
  LMPortalOverlaySizingService
  ]
  })
export class LMListComponent extends LMBaseComponent implements AfterViewInit, OnInit, OnDestroy, SaveRequired, LMRouteReuse, HtmlUrlDocHost {
  @HostBinding('id') get listId() {
    if (!this.listSpec || !this.listComponentId) {
      return null;
    }
    return this.listComponentId;
  }

  @HostBinding('attr.data-automation-id') get listAutomationId() {
    if (!this.listSpec || !this.screenAutomationId) {
      return null;
    }
    return 'lm-' + this.screenAutomationId + '-list';
  }

  @HostBinding('style.height') get hostHeight() {
    if (this.listState.displayAs === 'chart') {
      return '100%';
    }

    // LMWEB-22753: when the search form is open in a page pane (top/bottom),
    // let the list grow to natural height so the pane-list section scrolls
    if (this.paneIsVertical && this.showSearchForm) {
      return 'auto';
    }

    if (this.listSpec && this.lmListSpecUtilService.isFormListPanelContent(this.listSpec) && this.formContextOnLeft){
      return '100%';
    }

    // don't set height to 100% for normal lists in panels on forms or pages
    if (this.listSpec && this.lmListSpecUtilService.isFormListPanelContent(this.listSpec) && !this.lmListSpecUtilService.isCardViewWithDetailSections(this.listSpec) ||
      (this.listInPagePaneTab && !this.isDashBoardContent && this.pageHasContextForm && !this.pageHasTabs)) {
      return 'auto';
    }

    if (this.listSpec && this.listSpec.listType === 'select') {
      return (this.hasSearchForm && this.showSearchForm) ? 'auto' : '100%';
    }

    let autoStr = 'auto';
    if (this.bannerInRoute)  {
      autoStr = 'auto !important';
    }

    return this.lmListSpecUtilService.isMultiListPanelContent(this.listSpec) || this.inMultiList ? autoStr : '100%'/*'calc(100vh - 60px)'*/;
  }

  @HostBinding('style.width') get width() {
    return this.lmContextService.useListFormOverlay() && this.topLevelOverlayComponent ? 'inherit' : null;
  }

  @HostBinding('class.lm-disable-component') get hostDisableClass() {
    return this.disabled;
  }

  // hard coded flag - when true will display the list button in the list toolbar
  // and not in the banner/header toolbar. - Phillip 1/20/23
  @HostBinding('class.lm-toolbar-above-list') public toolbarAboveList = true;

  @HostBinding('class.lm-make-detail-section-dashboard-homepage-position-static') get makeHomepagePositionStatic(): boolean {
    if (this.listSpec) {
      return this.hasStandardDetailSections;
    }
    return false;
  }

  @HostBinding('class.card-with-detail') get classCarDetail(): boolean {
    return this.isCardViewWithDetailSections;
  }

  @HostBinding('class.card-content') get classCardContent() {
    if (!this.listSpec) {
      return false;
    }
    return this.listSpec.showAsMingleWidget;
  }

  @HostBinding('class.scrollable') get classScrollable() {
    if (!this.listSpec || this.inMultiList) {
      return false;
    }
    return !this.isCardViewWithDetailSections;
  }

  @HostBinding('class.lm-cards-compact') get compactCards() {
    return this?.lmGlobalPersonalizationService?.getGlobalPersonalization()?.useCompactFormLayout;
  }

  @HostBinding('class.lm-banner-in-route') get classBannerInRoute() {
    return this.bannerInRoute;
  }

  @HostBinding('class.lm-router-outlet-root') get classRouterOutletRootComponent() {
    return this.isRouterOutletRootComponent;
  }

  @HostListener('window:resize') onResize() {
    // Search form is on top when phablet size or smaller
    this.searchFormOnLeft = window.innerWidth > 610;
  }

  @HostListener('window:pagehide', [ '$event' ]) onPageHide(event) {
    // stop auto resizing when overlay closes; this may not be needed since iframe is destroyed on close
    if (this.lmContextService.inMingleOverlay()) {
      this.stopOverlayAutoResizing?.();
    }
  }

  @ViewChild(LMListContentComponent) listContentComponent: LMListContentComponent;
  @ViewChild(forwardRef(() => LMFormComponent)) searchFormComponent: LMFormComponent;
  @ViewChild(forwardRef(() => LMFormContentSearchComponent)) searchFormContentComponent: LMFormContentSearchComponent;
  @ViewChild(LMDetailSectionsComponent) detailSectionsComponent: LMDetailSectionsComponent;
  @ViewChild(forwardRef(() => LMDashboardViewComponent)) dashboardViewComponent; // : LMDashboardViewComponent;
  @ViewChild(LMListAuditComparePanelComponent) auditComparePanelComponent: LMListAuditComparePanelComponent;
  @ViewChild(SohoPopupMenuComponent) sohoRightClickMenu: SohoPopupMenuComponent;
  @ViewChild('ListToolbar') toolbarComponent: LMToolbarComponent;
  @ViewChild(forwardRef(() => 'detailFieldsFormComponent')) lmDetailFieldsFormComponent;
  @ViewChild('SearchFormPlaceholder', { read: ViewContainerRef }) searchFormPlaceholder: ViewContainerRef;
  @ViewChild('modalPlaceholder', { read: ViewContainerRef, static: true }) modalPlaceholder: ViewContainerRef;
  @ViewChild('standardDownloadAction', { read:ViewContainerRef }) attachmentListDownload!: ViewContainerRef;
  @ViewChild('attachmentFileInput', { read:ViewContainerRef }) attachmentListFileInput!: ViewContainerRef;
  @ViewChild(LMListSelectionTagsComponent) selectionTagsComponent: LMListSelectionTagsComponent;
  @ViewChild(LMNotificationComponent) lmNotificationComponent: LMNotificationComponent;
  @ViewChild('SetAsOfDateDialog', { read: ViewContainerRef, static: true }) setAsOfDatePlaceholder: ViewContainerRef;

  @Input() previewMode = false;     // only allows paging calls, navigation and actions are not available

  @Input() modelLpl: string | undefined;
  @Input() modelUserFolder: LMUserFolderPSpec | undefined;

  @Input() listUrlInfo: LMListUrlInfo;

  /**
   * The LMListSpec that used to build and drive the list. If no listSpec is passed
   * in then the routes url will be used to retrieve the LMListSpec.
   * NOTE: A root level component instance will have the complete set of specs for
   * all of its sublevel components.
   * @type {LMListSpec} The LMListSpec used to build the list.
   */
  @Input() listSpec: LMListSpec = null;

  /**
   * Only load data if filterCriteria or filterListFilterCriteria are set.
   */
  @Input() hasFilterList = false;

  /**
   * This list is used in a cartView composite form
   */
  @Input() usedInCartView = false;

  /**
   *
   */
  @Input() implementsDragAndDrop = false;

  @Input() helperListOptions: LMHelperListOptions = null;

  /**
   * This text will be displayed between the toolbar and the list content.
   */
  @Input() listText: LMMessageRule;

  /**
   * Use to drive this "dependent" lists data when there this list is related
   * to parent data elsewhere on the current web page.
   *
   * Examples:
   * - a list with detail sections with lists.
   * - a page panel with multiple list 'panes'
   * - a composite form with lists in it's panels/tabs
   * - others?
   *
   * @type {LMDataView} The selected dataview from the driving list or form.
   */
  @Input() set fromDataView(fromDataView: LMDataView) {
    if (this.listSpec.dependentList) {
      this._fromDataView = fromDataView;
      this.buildListStateKeyParams(true);

      //only send the fromDataView to the setLegacyDataView method of the HtmlUrlDoc component when an unspported pattern is detected(only Quad chart remains)
      if (!this.isRouterOutletRootComponent && this.unsupportedPattern && this.legacyWebUI) {
        const htmlDocComp: LMHtmlUrlDocComponent = this.currentComponent.getHtmlUrlDocComponent();
        const url: string = this.listSpec?.initialDataUrl;

        htmlDocComp?.setLegacyDataView(fromDataView, url);
      }

      // todo: look into loading state for a list when it's fromDataviewChanges.
      //  usefull when nexting through form records and expanding tree lists.
      // this.loadComponentState(true);
      this.setExportedFilterCriteria(this._fromDataView?.exportFilterCriteria);

      this.disabled = !this.fromDataView;
    }
  }

  get fromDataView(): LMDataView {
    return this._fromDataView;
  }

  /**
   * Whether the list component is disabled or not
   */
  @Input() disabled = false;

  /**
   * Used to correctly page select list records based on a passed in dataView.
   */
  @Input() selectRequestData: SelectRequestData;

  /**
   * Passed down to content components (i.e. lm-list-grid, lm-list-chart, etc...).
   * See filterCriteria @Input on lm-list-grid.component.ts for more information.
   */
  @Input() set filterCriteria(filterCriteriaArray: Array<LMFilterFieldCriteria>) {
    this._filterCriteria = filterCriteriaArray;
  }

  get filterCriteria(): Array<LMFilterFieldCriteria> {
    return this._filterCriteria;
  }

  get columnfilterOperators(): Map<string, string> {
    return this._columnfilterOperators;
  }

  @Input() multiSelectedValues: Array<LMMultiSelectedValue>;

  @Input() implementsManualLoad: boolean;

  @Input() manualLoadInfo: LMManualLoadInfo;

  /**
   * Used by the filter list pattern to set a filter on it's target list.
   * Using a new input for these because:
   * - These should not be shown as filter tags
   * - These will be sent to the server with a different "prefix" in it's url param (flc.fld=value)
   */
  @Input() set filterListFilterCriteria(filterListFilterCriteria: LMFilterListCriteria) {
    this._filterListFilterCriteria = filterListFilterCriteria;
  }

  get filterListFilterCriteria(): LMFilterListCriteria {
    return this._filterListFilterCriteria;
  }

  /**
   * Cause the sort order to change and data to be reloaded.
   * This currently only works with lm-list-view (i.e. card stack).
   * @param sortOrder
   */
  @Input() set sortOrder(sortOrder: LMListSortOrder) {
    this.m_sortOrder = sortOrder;
  }

  get sortOrder(): LMListSortOrder {
    return this.m_sortOrder;
  }

 get liveMessageToast() {
    return this.lmGlobalUtilService.liveMessageToast;
  }

  /**
   * Whether the filtering should be displayed or not. Only used on lm-list-grid at this time.
   */
  @Input() showFilter: boolean;

  /**
   * Whether the search form should be displayed or not.
   */
  @Input() showSearchForm = false;

  /**
   * Additional special actions to be added the toolbar
   */
  @Input() specialActions: Array<LMBusActionReference>;

  /**
   * passed in when in a single pane panel so the tab text will display
   * in place of the list title (if no list title already exists).
   */
  @Input() overrideListTitle: string;

  /**
   * Whether this list is part of a larger composite (Page.multiPanePanel or hasDetailSections)
   * where a selected row drives loading related data in another areas (a list, form, url, etc...)
   */
  @Input() hasDependentData = false;

  /**
   * IF the list is a within a page pane tab
   */
  @Input() listInPagePaneTab = false;

  /**
   * LMWEB-22753: IF the list is in a vertical (top/bottom) pane
   */
  @Input() paneIsVertical = false;

  /**
   * IF the list is in a page with a context form
   */
  @Input() pageHasContextForm = false;

  /**
   * IF the list is in a composite form with a context form on left
   */
  @Input() formContextOnLeft = false;

  /**
   * IF the list is within a multilist detail section
   */
  @Input() inMultiList = false;

  /**
   * IF the list is within a multi pane section
   */
  @Input() pageHasTabs = false;

  @Input() inSelectListEditMode = false;

  @Input() isInOverlay = false;
  @Input() overlayUrl = '';
  @Input() topLevelOverlayComponent = false;

  @Input() lmBuildDependentPaneDetail: () => LMPanelDetail[];

  @Input() isDrillPointRootComponent = false;

  @Output() contentModified = new EventEmitter<any>();
  @Output() fieldChanged = new EventEmitter<LMListFieldChangedEvent>();
  @Output() toolbarButtonEvent = new EventEmitter<LMToolbarButtonEvent>();
  @Output() specialActionToolbarButtonEvent = new EventEmitter<LMSpecialActionToolbarButtonEvent>();
  @Output() cubeDetailSectionPVPeriodEvent = new EventEmitter<LMCubeDetailSectionPVPeriodEvent>();

  /**
   * Event fired when a row selection has changed.
   */
  @Output() listDragDropEvent = new EventEmitter<LMListDragDropEvent>();
  @Output() listRowSelected = new EventEmitter<LMListSelectionEvent>();
  @Output() listRowActivated = new EventEmitter<LMListRowActivationEvent>();
  @Output() listRowDeactivated = new EventEmitter<LMListRowActivationEvent>();
  @Output() listRowClicked = new EventEmitter<LMListRowClickedEvent>();
  @Output() listRowDoubleClicked = new EventEmitter<LMListRowClickedEvent>();

  /**
   * Event fired when the list title is built. This will happen whether it's the first time
   * the title is built or if it's rebuild due to context changes. i.e. when rebuilding the
   * title when the fromDataViewChanges and fromDataView has values used in the titles
   * MessageRule.
   * @type {EventEmitter<newTitle: string>}
   */
  @Output() titleChanged = new EventEmitter<string>();

  @Output() listDisplayed = new EventEmitter<any>();

  @Output() listKeyDown = new EventEmitter<any>();

  @Output() panelContentDisplayed = new EventEmitter<LMContentDisplayedEvent>();

  @Output() sendContextMessageEvent = new EventEmitter<any>();

  @Output() listTransactionEvent = new EventEmitter<LMListTransactionEvent>();

  @Output() updateToolbarStateEvent = new EventEmitter<any>();

  @Output() busyIndicatorDisplayedEvent = new EventEmitter<LMBusyIndicatorDisplayedEvent>();

  @Output() drillAroundEvent = new EventEmitter<LMDrillAroundEvent>();

  private destroyer$ = new Subject<void>();

  /**
   * Used to set the search Forms LMDataView once the dataViewSet as been initially
   * loaded. A searchDataView is returned with the dataViewSet for this purpose.
   */
  public searchFormDataView: LMDataView;
  public searchFormSpec: LMFormSpec; // listSpec.busListSpec.searchForm.formSpec
  public searchFormUrlInfo: LMFormUrlInfo;

  public displaySearchInDialog = false;

  public testVersion1: boolean;
  public keywordSearchTagOnlyCleared = false;

  private toolbarSearchFieldFilterCriteria: Array<LMFilterFieldCriteria> = [];
  private searchFormFilterFieldCriteria: Array<LMFilterFieldCriteria> = [];
  private previousSearchFormFilterFieldCriteria: Array<LMFilterFieldCriteria> = [];
  private filterBarFilterFieldCriteria: Array<LMFilterFieldCriteria> = [];
  public exportFilterCriteria: Array<LMFilterFieldCriteria> = [];

  protected auditCompareViewSubscription: Subscription;

  // ---------------------------------------------------------------------
  // Template Control/Bound Variables
  // ---------------------------------------------------------------------
  // private listViewData: ListViewData = new ListViewData();
  // ---------------------------------------------------------------------

  /**
   * Hold the state of this list.
   */
  private listStateKeyParams: LMListStateKeyParams = null;
  public listState: LMListState = {};
  private listPersonalizationKeyParams: LMListPersonalizationKeyParams = null;
  public listPersonalization: LMListPersonalization = {};
  public uiLoadingIndicatorTimeout = 0;
  public lazyDashboardConditions = false;

  public chartName: string;
  public adhocReportMode = false;
  public openAdhocReportOverlay = false;
  private chartVisibilityFields: LMDataView;
  public searchPlaceholder = '';
  private disableComponent = false;

  // Prevent multiple saves of the same unsaved list changes. Occurred when handling
  // unsaved changes and the user hits the browser back/forward buttons.
  private performingSaveUnsavedChanges = false;

  private dirtyCheckComplete = false;

  // Prevent opening multiple lookup select dialogs from the same column.  Occurred
  // when the user was rapidly hitting the down arrow key on the lookup input element.
  private lookupSelectThrottleId = null;

  // Prevent multiple copies of the same inline create row from being saved if the
  // user holds down the tab key without releasing it from the last editable cell.
  private performingSaveNewViaHotkey = false;

  /** so JSON can be used in the components template */
  public JSON = JSON;
  public displayContextMenu = false;

  /**
   * Don't use directly, use property getter and setter instead
   */
  private _fromDataView: LMDataView;

  /**
   * Whether or not this ListComponent is the root router-outlet component.
   * If it is then use the headerToolbarRef to set the toolbar view data.
   * Otherwise use the toolbar in this lists template.
   * @type {boolean}
   */
  public isRouterOutletRootComponent = false;

  private listResourceImpl: ListResource;
  private listComponentId: string;
  public screenAutomationId: string;
  public contextMenuAttributes: SohoAttributesArray;
  public listTitle: string;
  public overlayTitle: string;
  private reportListTitle: string;
  public columnarSubTitle: string;
  private oldScreenTitle: string;
  public bannerInRoute = false;

  // route reuse
  public displayLoadTime = signal<string | '0'>('0');
  public routeReuseMode = false;    // is roure reuse enabled
  private relativeUrl: string;  // used to check if route is active
  public isInstanceRouteActive = true;    // is this instance of the list active
  private routeReuseDataLoading = false;
  private allowRouteReuseSaveFlag = true;
  private routeReuseTemplateLoad = 0;

  // private scheduleActionAllowed: boolean = false;
  /**
   * Used internally so that the subscription can be released when
   * the component is destroyed.
   */
  private routerEventsSubscription: ISubscription;
  private toolbarButtonEventSubscription: ISubscription;
  private toolbarSearchEventSubscription: ISubscription;
  private toolbarSearchClearedEventSubscription: ISubscription;
  private relatedActonSubscription: ISubscription;
  private saveDrillStateSubscription: ISubscription;
  private overlaySubscription: ISubscription;
  private toolbarReportAsOfDateUpdateEventSubscription: ISubscription;

  private listEventSubs: Subscription[] = [];
  private listLookupSelectionEvent: LMListLookupSelectionEvent;

  private listLookupSelectionSubscription;

  /**
   * don't set this directly, use the set/getter property functions
   */
  private _toolbarSearchField: LMToolbarSearchField = null;
  public mustacheText: string;
  public isReportAsOfDate = false;
  public isReportAsOfDateChanged = false;
  public showResultSet = false;
  public initialAnalyticsComplete = false;
  // Tabs for Detail Sections
  public detailSectionPanels: Array<LandmarkPanel> = [];
  public dashboardVisibility = 'hidden';
  public listViewSearchFieldValue: string;
  public showDetails$: Observable<boolean>;
  private overlayShowDetails$: Subject<boolean>;

  public showScanOptionsContextMenu = false;
  private _contextScanMenuEvent: any;
  public lmListBarCodeEvent: LMListBarCodeClickedEvent;
  public scanMenuId: string;

  public selectedDataView: LMDataView;
  // stupid flags so we can know when certain things are complete.
  public initialBuildComplete = false;

  public performInitialRowSelectionComplete = false;
  private backReferenceSub: Subscription;
  private pushedBackReferences = false;
  private _contextMenuEvent: any;
  private _filterCriteria: Array<LMFilterFieldCriteria> = null;
  private _columnfilterOperators: Map<string, string> = new Map<string, string>();
  private _filterOperators: Map<string, string> = new Map<string, string>();
  private _filterListFilterCriteria: LMFilterListCriteria = null;
  private _selectionTags: Array<LMListSelectionTag> = [];
  private m_sortOrder: LMListSortOrder;
  public showCancellableNotification = false;
  private cancelPagingNotifier$: Subject<string>;
  public implementsCancellablePaging = false;
  public cancelablePagingMessage: string;
  public cancelablePagingActionMessage: string;
  // This is a route level component variable that is set and was readonly in the past as it was designed to be around for the full length of that route.
  // With route reuse enabled the same component is used many times but to the logging and tracking the screen or route level component is new.
  // We will set the instanceId in the constructor as the component is first built and since the constructor is not called as a route is activated we will
  // reset the instanceId value. The only place this should be set is in the constructor and when the component is activated from a stored route.
  public instanceId: string;
  public isProduction = environment.production;
  public screenId: string;
  public toolbarButtons: Observable<Array<LMToolbarButton>>;
  public overlayButtons: Observable<Array<LMToolbarButton>>;
  public showCalledOutMenuButton = false;
  public drawerCollapse$: Observable<boolean>;
  public isAbovePhoneView$: Observable<boolean>;
  private defaultUserListViewItem: LMUserListViewItem;
  private searchInitialValueCriteria: Array<LMFilterFieldCriteria>;
  private searchInitialValueCriteriaNoFilter: Array<LMFilterFieldCriteria>;
  private drillbackFilterCriteria: Array<LMFilterFieldCriteria>;
  private drillbackFilterDataView: LMDataView;

  //detail fields variables
  private detailFieldsFormModelSub$: Subscription;
  private detailfieldsFormModelCache: Array<LMListDetailFieldsModelCache> = [];
  public detailFieldsFormModel: LMModel;
  public detailFieldsSpecFields: LMSpecFields;
  public detailFieldsFormLayout: LMFormLayout;
  public detailFieldsFormSpec: LMFormSpec;
  public detailFieldsFormUrlInfo: LMFormUrlInfo;
  private stepUpActionResult: LMActionResult;

  private _searchFormOnLeft = false;

  public showListDetailOnSide = false;
  public hasContextCardView = false;

  private titleHasMessageRule = false;

  private lazyAuditCompare = false;
  public isAttachmentList = false;
  public attachmentListHasCreateAction = false;
  public liveMessageList: LiveRegionConfig = { liveMessage: '', useHostAsLiveRegion: true };
  public reportAsOfDate;

  private formIsOverlayPOC = false;
  private enableAdHocSearch = false;
  private overlayDataView: LMListDataView;
  public allowOverlayInteractions = false;
  public showOverlayBackButton = false;
  private stopOverlayAutoResizing = null; // function to disconnect auto size mutation observer when Portal overlay closes

  private adHocModel: LMModel = null;
  private adHocImplicitFormSpec: LMFormSpec = null;

  public searchTagsIdPrefix: string = null;
  public searchTagsAutomationIdPrefix: string = null;

  constructor(
    private   changeDetectorRef: ChangeDetectorRef,
    public    elementRef: ElementRef,
    private   http: HttpClient,
    private   router: Router,
    private   route: ActivatedRoute,
    private   renderer: Renderer2,
    private   zone: NgZone,
    private   location: Location,
    @Inject(forwardRef(() => LMGenAISummarizeDialogService)) private lmGenAIDialogService,
    private   lmAddTagDialogService: LMAddTagDialogService,
    private   currentComponent: LMRouteComponentService,
    private   lmActionService: LMActionService,
    @Inject(forwardRef(() => LMBannerHeaderComponentRef)) private lmBannerHeaderCompRef: LMBannerHeaderComponentRef,
    protected lmBusyIndicatorService: LMBusyIndicatorService,
    private   lmCommonUtilService: LMCommonUtilService,
    private   lmConditionUtilService: LMConditionUtilService,
    private   lmConfirmationMessageService: LMConfirmationMessageService,
    public    lmContextService: LMContextService,
    private   lmContextUtilService: LMContextUtilService,
    protected lmErrorUtilService: LMErrorUtilService,
    private   lmFormatUtilService: LMFormatUtilService,
    private   lmFormSpecUtilService: LMFormSpecUtilService,
    private   lmFieldUtilService: LMFieldUtilService,
    private   lmGlobalStateService: LMGlobalStateService,
    private   lmGlobalPersonalizationService: LMGlobalPersonalizationService,
    private   lmGlobalUtilService: LMGlobalUtilService,
    @Inject(forwardRef(() => LMHelperListDialogService)) private lmHelperListDialogService, // LMHelperListDialogService,
    private   lmHtmlPageUtilService: LMHtmlPageUtilService,
    private   lmReportPersonalizationDialogService: LMReportPersonalizationDialogService,
    private   lmListActionFormDialogService: LMListActionFormDialogService,
    private   lmPrintDialogService: LMPrintDialogService,
    private   lmCompactFormDialogService: LMCompactFormDialogService,
    private   lmSelectDialogService: LMSelectDialogService,
    @Inject(forwardRef(() => LMSubFormDialogService)) private lmSubFormDialogService, // LMSubFormDialogService,
    private   lmListPersonalizationService: LMListPersonalizationService,
    private   lmListEventService: LMListEventService,
    private   lmListSpecUtilService: LMListSpecUtilService,
    private   lmListStateService: LMListStateService,
    private   lmStateHelperService: LMStateHelperService,
    private   lmListTransactionService: LMListTransactionService,
    private   lmListToolbarService: LMListToolbarService,
    private   lmListUtilService: LMListUtilService,
    private   lmLoggerService: LMLoggerService,
    private   lmNavigationService: LMNavigationService,
    private   lmSpecService: LMSpecService,
    private   lmCompoundFieldService: LMCompoundFieldService,
    private   lmUrlUtilService: LMUrlUtilService,
    private   lmComponentTrackerService: LMComponentTrackerService,
    protected lmComponentInfoService: LMComponentInfoService,
    protected lmUniqueIdService: LMUniqueIdService,
    private   lmUrlInfoBuilderService: LMUrlInfoBuilderService,
    private   lmFieldPickerService: LMFieldPickerService,
    private   lmKeyboardShortcutService: LMKeyboardShortcutService,
    private   breakpointChangeService: BreakpointChangeService,
    private   lmFormatterService: LMFormatterService,
    private   lmConfigurationService: LMConfigurationService,
    private   lmModelServiceAdapter: LMModelServiceAdapter,
    private   lmSavedSearchService: LMSavedSearchService,
    private   lmFormRequestService: LMFormRequestService,
    protected lmAppComponentService: LMAppComponentService,
    private   lmFormTransactionService: LMFormTransactionService,
    private   lmRoamingUIProfileService: LMRoamingUIProfileService,
    private   lmDrillAroundService: LMDrillAroundService,
    private   lmFieldValidatorService: LMFieldValidatorService,
    @Optional() private lmDrillAroundStateService: LMDrillAroundStateService,
    private   lmGenAIPromptDialogService: LMGenAIPromptDialogService,
    private   responsive: BreakpointObserver,
    private   lmApplicationMenuTransactionService: LMApplicationMenuTransactionService,
    protected lmModalWrapperService: LMModalWrapperService,
    protected lmModalOpenService: LMModalOpenService,
    private   lmOverlayService: LMOverlayService,
    private   lmHtmlUrlDocService: LMHtmlUrlDocService,
    private   lmWebAppService: LMWebAppService,
    protected lmRouteReuseCacheService: LMRouteReuseCacheService,
    protected lmAsOfDateService: LMApplicationMenuAsOfDateDialogService,
    private lmPortalOverlaySizingService: LMPortalOverlaySizingService,
    private lmBuilderService: LMBuilderService
  ) {
    super(lmBusyIndicatorService, lmComponentInfoService, lmUniqueIdService, lmAppComponentService, lmModalWrapperService, lmModalOpenService);
    this.instanceId = this.lmLoggerService.instanceId;
    this.implementsCancellablePaging = this.lmContextService.isUiPagingRequestWaitTimeEnabled;
    this.cancelablePagingMessage = Soho.Locale.translate('CancellablePageRequestMessage');
    this.cancelablePagingActionMessage = Soho.Locale.translate('CancellablePageRequestActionMessage');
    this.uiLoadingIndicatorTimeout = this.lmContextService.uiLoadingIndicatorTimeout;
    this.formIsOverlayPOC = this.lmContextService.useListFormOverlay();
    this.enableAdHocSearch = this.lmContextService.enableAdhocSearch();

    this.testVersion1 = lmContextService.testVersion() === AppConstants.TESTVERSION_V1;

    // //  This is added for now to get by an issue where the preceived loading of the component is delayed.
    // //  The constructor is called but then a 4-10 second delay is seen before the ngOnInit is called.
    // //  The issue was written up but the issue closed as no example was submitted and the problem was not
    // //  seen by a large number of people. Current plan is to try to dup the issue in a small example and
    // //  submit. A link to the issue Below
    // //  https://github.com/angular/angular/issues/18816
    setTimeout(() => {
      this.zone.run(() => {
        // CHANGE DETECTION
        if (this.url3_5) {
          this.changeDetectorRef.detectChanges();
        }
      });
    });

    this.routerEventsSubscription = router.events.subscribe((event: Event) => {
      // todo ppatton comment out navigation end now that we don't re-use routes.
      // Will need to handle this once we implement our own RouteReuseStrategy.
      if (event instanceof NavigationEnd) {
        this.routeReuseDataLoading = false;
        //   this.currentComponent.setRouteComponent(<Component>this); // why do I have to cast this?
        //   if (this.isRouterOutletRootComponent && this.initialBuildComplete) {
        //     // ---------------------------------------------------------------------
        //     // Called when this ListComponent object is reused by angular.
        //     // Call resetListComponent and build here as ngOnInit and
        //     // ngAfterViewInit will not be called in this scenarios.
        //     // ---------------------------------------------------------------------
        //     this.resetListComponent();
        //     this.showBusyIndicator();
        //     this.build();
        //   }
        //   // setTimeout(() => {
        //   //   appRef.tick();
        //   // });
      } else if (event instanceof NavigationStart) {
        // show busy indicator when leaving a route.
        this.lmBusyIndicatorService.showBusyIndicator();

        // ---------------------------------------------------------------------
        // if starting a new navigation (leaving this route) then save this
        // lists state and personalizations
        // ---------------------------------------------------------------------
        // NOTE: if an access denied error happens then page won't be built.
        // Make sure to only saveState and personalizations if the component
        // is actually built.
        // ---------------------------------------------------------------------
        if (this.initialBuildComplete) {
          // With route reuse enabled this seems to be able to be called from the framework even when the LM-ListComponent is not the component that fired the event.
          // We find it can be the LM-Form.Component. This currently causes tree lists to not be able to restore state properly when route reuse is enabled.
          // It needs to be addressed so code has been left in place that has had some measure of success but was founf to have issues.
          // The List would not load on a reutrn from a form on a tree list only so the fix is applied but further work is needed for it to operate properly.

          // if ((this.lmContextService.isRouteReuse() && this.lmContextService.useNewSpecUrls())
          // && this.currentComponent.getRouteComponent() instanceof LMListComponent) {

        //  if (this.currentComponent.verifySameCurrentCompToRoute(this.currentComponent.getRouteComponent())) {


          // This is not done here in the case of route reuse because all stored routes would run this code since it
          // is route events and fire when the route changes. We onlyt want to call this once when the component is about to be stored
          // so we retrieve in the correct state when the screen is displayed for the user the next time.
          if (!this.lmContextService.isRouteReuse() || (this.lmContextService.isRouteReuse()  && !this.isRouterOutletRootComponent)) {
            this.saveComponentState(true);
          }
        }
      }
    });

    if (this.lmDrillAroundStateService) {
      this.saveDrillStateSubscription = this.lmDrillAroundStateService.saveDrillStateEventSource.subscribe(() => {
        this.saveComponentState();
      });
    }

    if (this.formIsOverlayPOC || this.enableAdHocSearch) {
      this.showOverlayBackButton = this.lmOverlayService.backNavigationArray.length > 0;
      this.overlaySubscription = this.lmOverlayService.overlayComm.subscribe((action: LMOverlayAction) => {
        if (this.lmOverlayService.listOpenOverlayID === this.listSpec?.resourceId) {
          if (action.from === 'overlay') {
            if (action.action === 'refresh') {
              this.runRefresh();
            }
          }
        }
        if (action.from === 'adHocSearch' && !action.adHocActionInfo?.isReopen) {
          this.filterBarFilterFieldCriteria = [];
          this.onSearchClicked(action.adHocActionInfo.fcEvent);
          this.listState.adHocSelectedFields = action.adHocActionInfo.selectedFields;
        }
      });
    }
  }

  /**
   * Sets if this is a rootRouterOutlet (for the case of the header toolbar) or if
   * there is a
   */
  ngOnInit() {
    this.initLogging();

    // -----------------------------------------------------------------
    // Have to use lmContextService.inMingleWidget here since spec
    // is null when this is the root router-outlet component.
    // -----------------------------------------------------------------
    // GenAI Generated code - Start
    // LMWEB-26109: a list rendered inside the flyout overlay must NOT register itself as the route
    // component or claim to be the router-outlet root. The flyout list is created dynamically by
    // LMComponentInjectorService (topLevelOverlayComponent = true) with listSpec loaded asynchronously,
    // so without this exclusion it satisfies !listSpec at ngOnInit and clobbers currentComponent with
    // itself — which makes the banner's getRouteComponent() return the flyout list and route its
    // breadcrumb/navigation dirty check through the flyout, the root of the duplicate unsaved-changes
    // dialog. The flyout's own toolbar/content render off isInOverlay/toolbarAboveList, not this flag.
    if (!this.listSpec && !this.lmContextService.inMingleWidget() && !this.lmContextService.isHideTitlebar()
        && !this.isInOverlay && !this.topLevelOverlayComponent) {
      this.isRouterOutletRootComponent = true;
      this.currentComponent.setRouteComponent(this as Component);
    }
    // GenAI Generated code - End

    this.bannerInRoute = this.lmContextService.isBannerInRoute();
    this.lazyAuditCompare = !this.lmContextService.enableListAuditCompare();

    if (this.isRouterOutletRootComponent) {
      this.route.queryParams.subscribe(params => {
        this.reportListTitle = params.reportListTitle;
      });

      if ( !this.isInOverlay && !this.topLevelOverlayComponent) {
        this.lmOverlayService.routerOutletUnsavedChanges = (info: LMDialogInfo): Observable<boolean> => this.handleUnsavedChanges(info);
      }
    }

    if (this.lmListSpecUtilService.isColumnarView(this.listSpec) || this.lmListSpecUtilService.isCubeView(this.listSpec)) {
      this.uiLoadingIndicatorTimeout = 40000;
    }

    this.showBusyIndicator();
    this.subscribeListEvents();

    this.routeReuseMode = this.lmContextService.isRouteReuse();

    // Attachment list
    this.isAttachmentList = this?.listSpec?.busListSpec?.attachmentListInfo !== undefined;
    this.attachmentListHasCreateAction = this?.listSpec?.busListSpec?.attachmentListInfo?.hasCreateAction;

  }

  ngAfterViewInit() {
    this.lmLoggerService.trace([ this, this.instanceId, 'ngAfterViewInit()' ]);

    if (!this.initialBuildComplete) {
      // not sure how initialBuildComplete would ever be true at this point.
      let listUrl: string;
      if (!this.listSpec) {
        if (this.topLevelOverlayComponent) {
          listUrl = this.overlayUrl;
        } else {
          listUrl = this.router.url;
        }
      }

      setTimeout(() => this.build(listUrl));
    }
  }

  ngOnDestroy() {
    if (!this.topLevelOverlayComponent &&
         this.isRouterOutletRootComponent &&
         this.lmBannerHeaderCompRef &&
         this.lmBannerHeaderCompRef.instance) {
      this.lmBannerHeaderCompRef.instance.toolbarSectionTitle = '';
      this.lmBannerHeaderCompRef.instance.showCalledOutMenuButton = false;
    }

    if (this.backReferenceSub) {
      this.backReferenceSub.unsubscribe();
    }
    if (this.lmContextService.isTrackerEnabled()) {
      this.lmComponentTrackerService.endComponentTracking();
      // clear the viewTracker for this component
      this.lmComponentTrackerService.resetViewTracker();
    }

    // show result set size, archive data, as of date data etc adds mustache
    // This will go through design review for archive and as of date.
    // if (this.isRouterOutletRootComponent && this.listSpec?.busListSpec?.showResultSetSize) {
    if (this.isRouterOutletRootComponent) {
      if (this.lmBannerHeaderCompRef.instance) {
        this.lmBannerHeaderCompRef.instance.mustacheText = null;
      }
    }

    if (this.formIsOverlayPOC) {
      if (!this.isInOverlay &&
          !this.topLevelOverlayComponent &&
           this.listSpec.listType !== 'select' &&
           this.listSpec.listType !== 'helper' &&
           this.lmOverlayService.hasOpenOverlay) {
        this.lmOverlayService.close();
      }
      if (this.overlayShowDetails$) {
        this.overlayShowDetails$.complete();
      }
    }

    this.resetListComponent();

    this.setComponentDestroyed();

    /**
     * Waiting for https://github.com/tc39/proposal-optional-chaining
     * to do this in a more elegant way
     */
    if (this.lmBannerHeaderCompRef &&
      this.lmBannerHeaderCompRef.instance &&
      this.lmBannerHeaderCompRef.instance.sohoHeader) {
      this.lmBannerHeaderCompRef.instance.sohoHeader.removeBackButton();
    }

    /**
     * Only call un-subscribe from routerOutletSubscription on ngOnDestory
     * since it's created in the constructor and is necessary when
     * ListComponent object is being re-used.
     */
    if (this.routerEventsSubscription) {
      this.routerEventsSubscription.unsubscribe();
    }

    if (this.toolbarButtonEventSubscription) {
      this.toolbarButtonEventSubscription.unsubscribe();
    }

    if (this.toolbarSearchEventSubscription) {
      this.toolbarSearchEventSubscription.unsubscribe();
    }

    if (this.toolbarSearchClearedEventSubscription) {
      this.toolbarSearchClearedEventSubscription.unsubscribe();
    }

    if (this.detailFieldsFormModelSub$) {
      this.detailFieldsFormModelSub$.unsubscribe();
    }

    if (this.relatedActonSubscription) {
      this.relatedActonSubscription.unsubscribe();
    }

    if (this.saveDrillStateSubscription) {
      this.saveDrillStateSubscription.unsubscribe();
    }

    if (this.overlaySubscription && this.formIsOverlayPOC) {
      this.overlaySubscription.unsubscribe();
    }

    if (this.toolbarReportAsOfDateUpdateEventSubscription) {
      this.toolbarReportAsOfDateUpdateEventSubscription.unsubscribe();
    }

    // added to try to fix memory leak in IE11 when using the harness
    this.lmBannerHeaderCompRef = null;
    this.toolbarMoreMenuSettings = null;

    this.listEventSubs.forEach((sub: Subscription) => sub.unsubscribe());

    this.destroyer$.next();
    this.destroyer$.complete();
  }

  public getHtmlUrlDocService(): LMHtmlUrlDocService {
    return this.lmHtmlUrlDocService;
  }

  public onAppMenuTriggerEvent(event) {
    this.lmAppComponentService?.getAppComponent()?.handleV3NavComponent();
  }

  expandDrawerSide() {
    if (this.overlayShowDetails$) {
      this.overlayShowDetails$.next(false);
    } else {
      this.lmListEventService.expandDrawerSide();
    }
  }

  public allowPageNavigation(nextState?: RouterStateSnapshot, fromUnifiedMenu?: boolean): Promise<boolean> {
    // GenAI Generated code - Start
    // LMWEB-26109: When a flyout overlay is open, the flyout's single unsaved-changes confirmation is owned
    // by the overlay-close (sidebar) path, not by this component's own dirty check. Whichever component is
    // the route component behind an open flyout must delegate to the overlay guard rather than run its own
    // check — running it too opens a duplicate unsaved-changes dialog for the same content (the Soho layer
    // reuses the already-open modal and returns a SohoModalDialogRef whose internal `modal` is unbound,
    // leaving the visible Yes/No buttons dead). runOverlayGuard fires the single sidebar-owned confirmation
    // and resolves once the user answers: true to leave (flyout closes, navigation proceeds), false to stay.
    // Keyed on hasOpenOverlay (not isInOverlay) so it holds regardless of which route component is active —
    // consistent with the form and page guards. Modeled on the runDrillAroundGuard delegation below.
    // The `!closing` check prevents re-firing on the DeactivateGuard canDeactivate re-entry: runOverlayGuard's
    // resolution triggers navigateByUrl, which re-invokes this method while hasOpenOverlay still reads true
    // (its update is deferred ~10ms for LMWEB-24203). `closing` flips synchronously on close, so the re-entry
    // skips the guard and falls through to the normal (clean) dirty check.
    if (this.lmOverlayService.hasOpenOverlay && !this.lmOverlayService.closing) {
      return this.lmOverlayService.runOverlayGuard();
    }
    // GenAI Generated code - End

    // Skip angular route guard dirty check if it was already done by the unified Portal menu.
    if (this.dirtyCheckComplete) {
      this.dirtyCheckComplete = false;
      return Promise.resolve(true);
    }

    if (this.lmDrillAroundService.drillAroundIsOpen()) {
      return this.lmDrillAroundService.runDrillAroundGuard();
    }

    const hasUnsavedChanges = this.checkSaveRequired(fromUnifiedMenu);

    if (!hasUnsavedChanges) {
      this.dirtyCheckComplete = true;
      this.closeModals();
      return Promise.resolve(true);
    }

    const youMayNavigateSource = new BehaviorSubject<boolean>(false);
    const youMayNavigate: Observable<boolean> = youMayNavigateSource.asObservable();
    const info: LMDialogInfo = { message: Soho.Locale.translate('UnsavedChangesContinuingMsg'), type: LMDialogType.NOYES  };

    if (this.modalNavigationBlocked(fromUnifiedMenu)) {
      // let's just ask if they want to stay,
      // difficult to determine the modal's purpose - it may run an action or it may just return unsaved data
      this.displayNavigationConfirmation().then((continueOn) => {
        if (continueOn) { // leave
          this.dirtyCheckComplete = true;
          this.closeModals();
        }
        youMayNavigateSource.next(continueOn);
        youMayNavigateSource.complete();
      });
    } else {
      this.closeModals();
      this.handleUnsavedChanges(info)
          .pipe(
              tap(continueOn => {
                if (continueOn) {
                  this.dirtyCheckComplete = true;
                  this.closeModals();
                }
                youMayNavigateSource.next(continueOn);
                youMayNavigateSource.complete();
                this.hideBusyIndicator();
              })
          ).subscribe();
    }

    return lastValueFrom(youMayNavigate);
  }

  public initLogging() {
    if (this.lmContextService.isAnyTrackingEnabled()) {
      this.initialAnalyticsComplete = false;
      this.lmLoggerService.time({ id: '>> Total List ' + this.instanceId });
    }
    this.lmLoggerService.trace([ this, this.instanceId, 'ngOnInit()' ]);
  }

  public endLogging(): number {
    const loadTime = this.lmLoggerService.timeEnd('>> Total List ' + this.instanceId, [ this, 'onDataLoaded()', 'end' ]);
    this.sendPageAnalytics(this.route?.routeConfig?.component?.name, loadTime);
    return loadTime;
  }

  public getRouteReuseTemplateLoadTime(): string {
    return this.routeReuseTemplateLoad.toFixed(3);
  }

  public setRouteReuseTemplateLoadTime(loadTime: number) {
    if (this.routeReuseTemplateLoad <= 0) {
      this.routeReuseTemplateLoad = loadTime;
    }
  }

  public getSpeedIncrease(): string {
    const numSpeedIncAmt = (this.routeReuseTemplateLoad / parseInt(this.displayLoadTime()));
    return Number.isNaN(numSpeedIncAmt) ? '0' : numSpeedIncAmt.toFixed(2);
  }

  public onRouteReuseStoring(): void {
    console.log('List Component storing: pause timers, etc. ' + this.listResource.resourceId);
    // Popup menus are create when the menu is screen menu is built. They are put into the dom at the same level as the app itself so they will display on top properly
    // When route reuse is not on the popup menus get destroyed when the high level component is destroyed. Since the component is not destroyed when route reuse is active
    // Those popup menus will be added each time a screen is accessed. The menus continue to work because a new popup menu is created and connected to the action
    // properly. The dom will continue to grow and use memory and test will fail since the lookup of the component is done by data-automation-id it find more then one
    // element and will fail because it does not know which one to click.

      // tim suggested trying to call the destroy on the popup menu items but can't seem to get the component with my tried made.
      // var popupmenu = $('#popupmenu').data('popupmenu');
      // if (popupmenu) {
      //     popupmenu.destroy();
      // }

    document.querySelectorAll('body>.popupmenu-wrapper').forEach(el => el.remove());
    this.saveComponentState(true);
  }

  public onRouteReuseRetrieving(): void {

    this.instanceId = this.lmLoggerService.instanceId;
    this.initLogging();
    this.listUrlInfo = this.lmUrlInfoBuilderService.getListUrlInfoFromHttpUrl(this.router.url);
    this.lmUrlInfoBuilderService.fillOutListUrls(this.listUrlInfo, this.listSpec);

    console.log('List Component retrieving: resume, refresh UI ' + this.listResource.resourceId);
    // Custom logic for retrieving phase
    // This runs before late router events


    // Mask fields on initial load if columns have masked data
    // A user could navigate away from the list and come back
    // route reuse would prevent the columns from being masked after navigating back
    if (this.listSpec?.busListSpec?.displayFields?.some(df => !!df.maskInfo)) {
      this.toggleMask();
    }
  }

  public isRouteActive(): boolean {
    return this.isInstanceRouteActive;
  }

  public hasStoredRoute(): boolean {
    return this.lmRouteReuseCacheService.hasHandle(this.route.snapshot);
  }

  public allowRouteReuseSave(): boolean {
    return this.allowRouteReuseSaveFlag;
  }

  public setAllowRouteReuseSaveFlag(flag: boolean) {
    this.allowRouteReuseSaveFlag = flag;
  }

  public setRouteReuseActive(active: boolean): void {
    // this.routeReuseActive = active;
    if (active) {
      this.currentComponent.setRouteComponent(this as Component);
      if (this.isRouterOutletRootComponent && !this.bannerInRoute) {
        if (this.lmContextService.showBreadcrumbs()) {
          this.addToBreadcrumbs();
        }
      }
      if (!this.routeReuseDataLoading) {
        this.routeReuseDataLoading = true;
        this.setAllowRouteReuseSaveFlag(true);
        const url: string = this.router.url;
        this.listUrlInfo = this.lmUrlInfoBuilderService.getListUrlInfoFromHttpUrl(url);
        this.lmUrlInfoBuilderService.fillOutListUrls(this.listUrlInfo, this.listSpec);

        //  The reloading of the componentState does not fill in the displayAs type.
        //  Here we store it off before reloading it and then put it back in place since the current listn type is the type we will be bringing back
        this.buildListStateKeyParams(true);
        this.loadComponentState();
        this.initializeListState();

        // We force a change detection here to get the sub components to be updated with urlInfo and listState.
        // the ngZone.onStable is called when all the micro task are finish including any change detection tasks.
        // Once that is complete we can load the new data for the route reuse list.
        this.changeDetectorRef.detectChanges();
        const subscription = this.zone.onStable.subscribe(() => {
          this.listContentComponent.resetData();
          this.endLogging();
          // Clean up by unsubscribing immediately after execution
          subscription.unsubscribe();
          // setTimeout(() => {
          //       this.loadComponentState();
          //   }, 1);
        });
      }
    } else {
      // we clear the list here so when the list route is reused we will redisplay the list with  the new data instead of the old and then the new
      // in the case of the tree component the re load does not work properly and some of the fields used in the reload are removed
      // proir to the display and so an error causes the list not to display.
      if (!this.listContentComponent.isType('tree')
      || (this.listContentComponent.isType('tree') && !this.lmContextService.isRouteReuse())) {
        this.listUrlInfo = undefined;
        this.listContentComponent.clearData();
      }
      this.lmComponentTrackerService.resetViewTracker();

    }
  }

  private handleUnsavedChanges(info: LMDialogInfo): Observable<boolean> {
    if (this.performingSaveUnsavedChanges) {
      return of (true);
    }

    return new Observable<boolean>(observer => {
      if (this.isModified()) {
        this.showUnsavedChanges(info).subscribe((response: UnsavedChangesResponse) => {
          if (response === LMDialogButtonKey.YES) {
            this.performingSaveUnsavedChanges = true;
            this.executeSaveAction(AppConstants.STANDARD_SAVE, observer);
          } else if (response === LMDialogButtonKey.NO) {
            this.clearDetailFieldsFormModelCache();
            this.listContentComponent.clearDirty();
            if (this.lmContextService.useListFormOverlay() && !this.topLevelOverlayComponent && !this.isInOverlay) {
              // unsaved changes can happen on a list that is not navigated away from with overlay turned on.
              // make sure to put the data back to what it was
              this.executeRefresh().subscribe();
            }
            observer.next(true);
            observer.complete();
          } else {
            // Cancel. Stay put!
            observer.next(false);
            observer.complete();
          }
        });
      } else {
        observer.next(true);
        observer.complete();
      }
    });
  }

  private checkForUnsavedChanged(actionSpec?: LMActionSpec): Observable<boolean> {    // how is this different than checkSaveRequired
    return new Observable<boolean>(observer => {
      const hasUnsavedChanges = actionSpec && 'DELETE' === actionSpec.type ? this.hasUnsavedChangesForDelete() : this.isModified();

      if (hasUnsavedChanges) {
        this.lmListUtilService.displayPagingConfirmation().subscribe( (okContinue: boolean) => {
          if (okContinue && this.hasDetailFields && this.detailfieldsFormModelCache.length) {
            this.clearDetailFieldsFormModelCache();
          }
          observer.next(okContinue);
          observer.complete();
        });
      } else {
        observer.next(true);
        observer.complete();
      }
    });
  }

  checkSaveRequired(fromUnifiedMenu?: boolean): boolean {
    if (!this.performingSaveUnsavedChanges) {
      return (this.isModified() || this.modalNavigationBlocked(fromUnifiedMenu));
    } else {
      return false;
    }
  }

  modalNavigationBlocked(fromUnifiedMenu?: boolean) {
    if (fromUnifiedMenu) {
      return this.modalOpen();
    } else {
      return this.lmListActionFormDialogService.hasOpenDialog && this.lmListActionFormDialogService.getOpenDialog?.componentDialog?.formComponent?.isModified();
    }
  }

  showBusyIndicator() {
    if (this.lmContextService.useListFormOverlay() && (this.isInOverlay || this.topLevelOverlayComponent)) {
      this.lmOverlayService.busyIndicator(true);
    } else {
      this.lmBusyIndicatorService.showBusyIndicator();
    }
  }

  hideBusyIndicator() {
    if (this.lmContextService.useListFormOverlay() && (this.isInOverlay || this.topLevelOverlayComponent)) {
      this.lmOverlayService.busyIndicator(false);
    } else {
      this.lmBusyIndicatorService.hideBusyIndicator();
    }
  }

  public set toolbarSearchField(toolbarSearchField: LMToolbarSearchField) {
    if (this.isRouterOutletRootComponent && !this.bannerInRoute && !this.toolbarAboveList) {
      this.lmBannerHeaderCompRef.instance.toolbarSearchField = toolbarSearchField;
    } else {
      this._toolbarSearchField = toolbarSearchField;
    }
  }

  public get toolbarSearchField(): LMToolbarSearchField {
    if (this.isRouterOutletRootComponent && !this.bannerInRoute && !this.toolbarAboveList) {
      return this.lmBannerHeaderCompRef.instance.toolbarSearchField;
    } else {
      return this._toolbarSearchField;
    }
  }

  public get contextMenuId(): string {
    return this.lmListSpecUtilService.getContextMenuId(this.listSpec);
  }

  public get contextMenuEvent(): any {
    return this._contextMenuEvent;
  }

  public get displayType(): ListDisplayType {
    return this.listState.displayAs;
  }

  public resetListComponent() {
    if (this.lmListToolbarService) {
      this.lmListToolbarService.reset();
    }

    // this.maxVisibleButtons = null;
    this.toolbarSearchField = null;
    this.listStateKeyParams = null;
    this.listPersonalizationKeyParams = null;

    this.listSpec = undefined;
    this.chartName = undefined;

    this.showSearchForm = false;

    this.url3_5 = undefined;
    this.legacyWebUI = false;

    this.onBeforeContextMenuOpen = null;
    this.onBeforeListToolbarMoreMenuOpen = null;

    // reset the header toolbar if this is the root router-outlet component
    if (this.isRouterOutletRootComponent && !this.bannerInRoute && !this.toolbarAboveList) {
      this.lmListToolbarService.reset();
      this.lmBannerHeaderCompRef.instance.toolbarSearchField = undefined;
      this.lmBannerHeaderCompRef.instance.mustacheText = undefined;
    }

    if (this.pushedBackReferences) {
      this.lmBannerHeaderCompRef.resetBackReferences(false);
      this.pushedBackReferences = false;
    }
  }

  public showPagingBarInDashboardPanel(): boolean {
    // show the paging bar if we are an aggregation chart (displays like a list grid)
    if (this.lmListSpecUtilService.isAggChart(this.listSpec, this.listState)) {
      return true;
    }
    return this.listState.displayAs === AppConstants.LISTVIEWTYPE_LIST
      || this.listState.displayAs === AppConstants.LISTVIEWTYPE_LISTVIEW
      || this.listState.displayAs === AppConstants.LISTVIEWTYPE_IMAGELIST;

  }

  public get hasDetailSections(): boolean {
    return this.lmListSpecUtilService.hasDetailSections(this.listSpec);
  }

  public get isDetailSection(): boolean {
    return this.lmListSpecUtilService.isDetailSection(this.listSpec);
  }

  public get hasStandardDetailSections(): boolean {
    return (this.hasDetailSections && !this.isCardViewWithDetailSections);
  }

  public get isFilterList(): boolean {
    return this.lmListSpecUtilService.isFilterList(this.listSpec);
  }

  public get isCardViewWithDetailSections(): boolean {
    return this.lmListSpecUtilService.isCardViewWithDetailSections(this.listSpec);
  }

  public get isCardViewOnly(): boolean {
    return this.lmListSpecUtilService.isCardViewOnly(this.listSpec);
  }

  public get isGallery(): boolean {
    return this.lmListSpecUtilService.isGallery(this.listSpec);
  }

  public get hasSearchTags(): boolean {
    return this.searchTags.length > 0;
  }

  public get isCubeView(): boolean {
    return this.lmListSpecUtilService.isCubeView(this.listSpec);
  }

  public get isAudit(): boolean {
    return this.lmListSpecUtilService.isAudit(this.listSpec);
  }

  public get implementsAuditCompare(): boolean {
    return this.lmListSpecUtilService.implementsAuditCompare(this.listSpec);
  }

  public get showChangeValuesOnRight(): boolean {
    return this.lmListSpecUtilService.showChangedValuesOnRight(this.listSpec);
  }

  public get hasDetailFields(): boolean {
    // TODO: future - need to check if a card view with detail fields and not allow
    return (
      this.listState.displayAs !== AppConstants.LISTVIEWTYPE_IMAGELIST &&
      this.listState.displayAs !== AppConstants.LISTVIEWTYPE_CHART &&
      this.listState.displayAs !== AppConstants.LISTVIEWTYPE_CALENDAR &&
      !!this.listSpec.busListSpec.detailFieldsSpec
    );
  }

  public get detailFieldsClass() {
    return {
      'detail-fields-below': this.listSpec.busListSpec.hasDetailFieldsBelow && !(this.listState && (this.listState.displayAs === AppConstants.LISTVIEWTYPE_HIERARCHY || this.listState.displayAs === AppConstants.LISTVIEWTYPE_IMAGELIST)),
      'detail-fields-on-side': this.listSpec.busListSpec.hasDetailFieldsOnSide || this.showChangeValuesOnRight
    };
  }

  public get hasChart() {
    return this.listState.displayAs === AppConstants.LISTVIEWTYPE_CHART;
  }

  public get implementsOrgChartView(): boolean {
    return this.listSpec.busListSpec.implementsOrgChartView;
  }

  public allowHorizontalPaging(): boolean {
    return this.lmListSpecUtilService.allowHorizontalPaging(this.listSpec);
  }

  public get hasSearchForm(): boolean {
    if (this.lmListSpecUtilService.allowHorizontalPaging(this.listSpec)) {
      return false;
    }

    return this.lmListUtilService.hasSearchForm(this.listSpec, this.isDashBoardContent);
  }

  public set searchFormOnLeft(notMobile: boolean) {
    const multiPane = this.lmListSpecUtilService.isMultiPanePanelContent(this.listSpec);
    this._searchFormOnLeft = (notMobile && this.lmListUtilService.searchFormOnLeft(this.listSpec)) && !multiPane;
  }

  public get searchFormOnLeft(): boolean {
    return this._searchFormOnLeft;
  }

  public get hasKeyWordSearch(): boolean {
    if (!this.displayToolbar) {
      return false;
    }
    return this.listSpec.busListSpec.keywordSearch !== undefined;
  }

  public get hasScannableKeyword(): boolean {
    if (this.lmContextService.inNativeMobileApp() && this.listSpec.busListSpec.keywordSearch) {
      return this.listSpec.busListSpec.keywordSearch?.scannable;
    }

    return false;
  }

  public get hasKeywordIcons(): boolean {
    if (!this.hasSearchForm && !this.hasScannableKeyword) {
      return false;
    }

    if ((this.hasSearchForm && !this.searchFormIsAlways) || this.hasScannableKeyword) {
      return true;
    }

    return false;
  }

  public get keywordSearchWidth(): string {
    if (this.hasSearchForm && !this.searchFormIsAlways) {
      if (this.hasScannableKeyword) {
        return 'calc(100% - 70px)';
      } else {
        return 'calc(100% - 35px)';
      }
    }

    if (this.hasScannableKeyword) {
      return 'calc(100% - 35px)';
    }

    return '100%';
  }


  public get hasSearchFields(): boolean {
    if (this.listSpec?.busListSpec?.searchForm?.isMobileImplicit) {
      return false;
    }

    return this.lmListSpecUtilService.hasSearchFields(this.listSpec);
  }

  public get searchFormIsAlways(): boolean {
    if (this.listSpec?.busListSpec?.searchForm?.isMobileImplicit) {
      return false;
    }

    return this.listSpec.busListSpec.searchForm?.alwaysDisplaySearch;
  }

  public get searchFormIsInitial(): boolean {
    if (this.listSpec?.busListSpec?.searchForm?.isMobileImplicit) {
      return false;
    }

    return this.listSpec.busListSpec.displaySearch === 'initially';
  }

  public get searchFormIsImplied(): boolean {
    if (this.listSpec?.busListSpec?.searchForm?.isMobileImplicit) {
      return false;
    }

    return (
      this.listSpec.busListSpec.searchForm.useSearchAsFilter === undefined &&
      this.listSpec.busListSpec.displaySearch !== 'initially'
    );
  }

  public get searchFormIsDefault(): boolean {
    if (this.listSpec?.busListSpec?.searchForm?.isMobileImplicit) {
      return false;
    }

    return (
      this.listSpec.busListSpec.searchForm &&
      this.listSpec.busListSpec.searchForm.alwaysDisplaySearch &&
      this.listSpec.busListSpec.displaySearch !== 'initially'
    );
  }

  public get searchFormOptions(): LMFormOptions {
    let alphaCondition = 'contains';
    if(this.listSpec?.busListSpec?.alphaDefaultFilter) {
      alphaCondition = this.listSpec?.busListSpec?.alphaDefaultFilter;
    }
    const displayAdHocSearchButton = this.lmContextService.enableAdhocSearch()
        && !this.lmListSpecUtilService.isColumnarView(this.listSpec)
        && !this.lmListSpecUtilService.isCubeView(this.listSpec);
    const options = {
      disableMaxHeightSearchFormKludge: !this.isCardViewWithDetailSections,
      filterCriteria: this.filterCriteria,
      defaultAlphaFilterCondition: alphaCondition,
      displayAdHocSearchButton
    } as LMFormOptions;
    if (this.listState?.adHocSelectedFields) {
      options.adHocSelectedFields = this.listState.adHocSelectedFields;
    }
    return options;
  }

  public get searchFieldOnCardViewWithDetails(): boolean {
    return this.isCardViewWithDetailSections && (this.hasKeyWordSearch || this.hasSearchFields);
  }

  public get searchTags(): LMListSearchTag[] {
    if (!this.hasSearchForm && this.hasAdHocFilters){ //If the list does not have a search form, only display tags where fc.isAdHoc=true
      return this.lmListUtilService.buildSearchTags(this.filterCriteria.filter((fc) => fc.isAdHoc));
    }
    return this.filterCriteria?.length ? this.lmListUtilService.buildSearchTags(this.filterCriteria) : [];
  }

  public get hasAdHocFilters(): boolean {
    return this.filterCriteria?.length > 0 && this.filterCriteria.some((fc) => fc.isAdHoc);
  }

  public get selectionTags(): LMListSelectionTag[] {
    return this._selectionTags;
  }

  /**
   * IMPORTANT: Should only be called once during the initial build of this component.
   */
  private buildLandmarkPanels() {
    const detailSections = this.listSpec.busListSpec.detailSections;
    if (!detailSections) {
      return;
    }
    this.detailSectionPanels = [];
    for (let i = 0, len = detailSections.length; i < len; i++) {
      const title = detailSections[ i ].title;
      const useTwelveColumn = !!this.listSpec.busListSpec.useTwelveColumnGrid || !!detailSections[ i ].useTwelveColumnGrid;

      const landmarkPanel: LandmarkPanel = {
        id: detailSections[ i ].id,
        automationId: detailSections[ i ].automationId,
        detailSectionName: detailSections[ i ].detailSectionName,
        type: detailSections[ i ].type,
        title: title.resourceValue,
        overviewNavigation: detailSections[ i ].overviewNavigation,
        content: '',
        isVisible: true,
        isValid: true,
        index: i,
        activated: false,
        needsReload: false,
        initialized: false,
        loaded: false,
        reload: false,
        disabled: false,
        hidden: false,
        selected: (this.listState.selectedTabIndex === i),
        useTwelveColumnGrid: useTwelveColumn,
        spanningColumns: useTwelveColumn ? detailSections[ i ].twelveColumnGridSpan : undefined,
        isArchiveData: detailSections[ i ].isArchiveData,
      };

      if (this.listSpec.busListSpec.implementsDashBoardView && !this.listSpec.busListSpec.useTwelveColumnGrid) {
        landmarkPanel.widgetWidth = this.lmSpecService.toWidgetSizeToType(detailSections[i].dashboardViewWidth);
        landmarkPanel.widgetHeight = this.lmSpecService.toWidgetSizeToType(detailSections[i].dashboardViewHeight);
      }

      switch (detailSections[ i ].type) {
        case 'cardview': landmarkPanel.displayFields = detailSections[ i ].displayFields; break;
        case 'instancecountchart': landmarkPanel.formSpec = detailSections[ i ].formSpec; break;
        case 'link': landmarkPanel.url = detailSections[ i ].URL; break;

        case 'standardform':
          landmarkPanel.formSpec = detailSections[ i ].formSpec;
          landmarkPanel.formSpec.disableFieldOptions = landmarkPanel.formSpec.disableFieldOptions || this.listSpec.busListSpec.disableFieldOptions;
          break;

        case 'dashboard':
          landmarkPanel.dashBoardPanes = this.buildPanelsOnDetailsSection(detailSections[ i ]);
          landmarkPanel.dashboardColumns = detailSections[ i ].dashboardColumns;
          break;

        case 'list':
          landmarkPanel.listSpec = detailSections[ i ].listSpec;
          landmarkPanel.filterListSpecs = detailSections[ i ].filterListSpecs;
          landmarkPanel.hasNestedCardViewDetailSections = this.lmListSpecUtilService.isCardViewWithDetailSections(landmarkPanel.listSpec);
          landmarkPanel.implementsManualLoad = detailSections[ i ].implementsManualLoad;
          landmarkPanel.manualLoadInfo = detailSections[ i ].manualLoadInfo;
          break;

        case 'multilist':
          landmarkPanel.sections = detailSections[ i ].sections;
          break;

        default: break;
      }

      this.detailSectionPanels.push(landmarkPanel);
    }
  }

  private buildPanelsOnDetailsSection(detailSection: LMBusDetailSection) {
    const detailSections = detailSection.detailSections;
    const dashBoardPanes: LandmarkPanel[] = [];

    const isVisibleDefault = !this.lazyDashboardConditions;

    if (detailSections) {
      for (let i = 0, len = detailSections.length; i < len; i++) {
        const title = detailSections[ i ].title;

        switch (detailSections[ i ].type) {
          case 'cardview':
            dashBoardPanes.push({
              id: detailSections[ i ].id,
              automationId: detailSections[ i ].automationId,
              title: title.resourceValue,
              content: '',
              isVisible: isVisibleDefault,
              isValid: true,
              index: i,
              initialized: false,
              loaded: false,
              reload: false,
              activated: false,
              needsReload: false,
              disabled: false,
              hidden: false,
              displayFields: detailSections[ i ].displayFields,
              overviewNavigation: detailSections[ i ].overviewNavigation,
              type: detailSections[ i ].type,
              visibility: [ detailSections[ i ].visibility ],
              validity: [ detailSections[ i ].validity ],
              useTwelveColumnGrid: detailSections[ i ].useTwelveColumnGrid,
              spanningColumns: detailSections[ i ].twelveColumnGridSpan
            });
            break;
          case 'list':

            dashBoardPanes.push({
              id: detailSections[ i ].id,
              automationId: detailSections[ i ].automationId,
              title: title.resourceValue,
              content: '',
              isVisible: isVisibleDefault,
              isValid: true,
              index: i,
              initialized: false,
              loaded: false,
              reload: false,
              activated: false,
              needsReload: false,
              disabled: false,
              hidden: false,
              listSpec: detailSections[ i ].listSpec,
              type: detailSections[ i ].type,
              overviewNavigation: detailSections[ i ].overviewNavigation,
              visibility: [ detailSections[ i ].visibility ],
              validity: [ detailSections[ i ].validity ],
              useTwelveColumnGrid: detailSections[ i ].useTwelveColumnGrid,
              spanningColumns: detailSections[ i ].twelveColumnGridSpan,
              detailSectionName: detailSections[ i ].detailSectionName,
              isArchiveData: detailSections[i].isArchiveData
            });
            break;

          case 'standardform':
            dashBoardPanes.push({
              id: detailSections[ i ].id,
              automationId: detailSections[ i ].automationId,
              title: title.resourceValue,
              content: '',
              isVisible: isVisibleDefault,
              isValid: true,
              index: i,
              activated: false,
              needsReload: false,
              initialized: false,
              loaded: false,
              reload: false,
              disabled: false,
              hidden: false,
              formSpec: detailSections[ i ].formSpec,
              type: detailSections[ i ].type,
              overviewNavigation: detailSections[ i ].overviewNavigation,
              visibility: [ detailSections[ i ].visibility ],
              validity: [ detailSections[ i ].validity ],
              useTwelveColumnGrid: detailSections[ i ].useTwelveColumnGrid,
              spanningColumns: detailSections[ i ].twelveColumnGridSpan,
              isArchiveData: detailSections[i].isArchiveData
            });
            break;

          case 'instancecountchart':
            dashBoardPanes.push({
              id: detailSections[ i ].id,
              automationId: detailSections[ i ].automationId,
              title: title.resourceValue,
              content: '',
              isVisible: isVisibleDefault,
              isValid: true,
              index: i,
              activated: false,
              needsReload: false,
              initialized: false,
              loaded: false,
              reload: false,
              disabled: false,
              hidden: false,
              formSpec: detailSections[ i ].formSpec,
              type: detailSections[ i ].type,
              overviewNavigation: detailSections[ i ].overviewNavigation,
              visibility: [ detailSections[ i ].visibility ],
              validity: [ detailSections[ i ].validity ],
              useTwelveColumnGrid: detailSections[ i ].useTwelveColumnGrid,
              spanningColumns: detailSections[ i ].twelveColumnGridSpan
            });
            break;

          case 'link':
            dashBoardPanes.push({
              id: detailSections[ i ].id,
              automationId: detailSections[ i ].automationId,
              title: title.resourceValue,
              url: detailSections[ i ].URL,
              content: '',
              isVisible: isVisibleDefault,
              isValid: true,
              index: i,
              activated: false,
              needsReload: false,
              initialized: false,
              loaded: false,
              reload: false,
              disabled: false,
              hidden: false,
              formSpec: detailSections[ i ].formSpec,
              type: detailSections[ i ].type,
              overviewNavigation: detailSections[ i ].overviewNavigation,
              visibility: [ detailSections[ i ].visibility ],
              validity: [ detailSections[ i ].validity ],
              useTwelveColumnGrid: detailSections[ i ].useTwelveColumnGrid,
              spanningColumns: detailSections[ i ].twelveColumnGridSpan
            });
            break;

          default:
            break;
        }

        if (dashBoardPanes[ i ]) {
          dashBoardPanes[ i ].widgetWidth = this.lmSpecService.toWidgetSizeToType(detailSections[ i ].dashboardViewWidth);
          dashBoardPanes[ i ].widgetHeight = this.lmSpecService.toWidgetSizeToType(detailSections[ i ].dashboardViewHeight);
        }
      }
    }
    return dashBoardPanes;
  }

  onClearSearchCriteria() {
    this.onClearSearchClicked({ event: null, filterCriteria: [] });
  }

  onDataLoaded(listDataResponse: LMListPagingResponse) {
    if ((![ 'load', 'sort', 'filter' ].includes(listDataResponse?.pageOp) && this.listState?.displayAs === 'listView')
        || (this.listState?.displayAs === 'gallery' && listDataResponse?.pageOp != 'load')){
      //special case for listview paging event
      this.setLiveMsgListResultCount(this.listTitle, listDataResponse?.dataViewSet?.data);
      return;
    }
    this.lmLoggerService.trace([ this, this.instanceId, 'onDataLoaded()', this.listComponentId, listDataResponse ]);
    this.hideBusyIndicator();

    // Set scroll position on horizontal scroll component back to beginning
    // Needs to run before buildToolbar()
    if (this.isGallery && this.allowHorizontalPaging()) {
      this.listContentComponent.resetScrollPosition(listDataResponse.dataViewSet.data.length);
    }

    this.disabled = !listDataResponse;
    if (this.disabled) {
      this.clearComponentState();
    }

    this.setMultiSelectedValues();

    if (this.isCardViewWithDetailSections) {
      if (this.hasKeyWordSearch) {
        if (this.listSpec.busListSpec.keywordSearch.label) {
          this.searchPlaceholder = this.lmFormatUtilService.formatMessageRule(this.listSpec.busListSpec.keywordSearch.label, listDataResponse.dataViewSet.header);
        } else {
          this.searchPlaceholder = Soho.Locale.translate('SearchByKeyword');
        }
      } else if (this.hasSearchFields) {
        this.searchPlaceholder = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('SearchByField'),
          this.lmFormatUtilService.formatMessageRule(this.listSpec.busListSpec.searchFields.fields[ 0 ].label, listDataResponse.dataViewSet.header));
      }
    }

    /**
     * todo stop gap for now - This happens when a detail section
     * cannot load data due to multiple upper records being selected.
     * maybe use this to set the list and toolbar to disabled.
     */
    if (listDataResponse && listDataResponse.dataViewSet) {
      if (listDataResponse.searchDataView) {
        // -------------------------------------------------------------------------------
        // this.initialize() has already loaded filterCriteria from list state so at
        // this point we just need to fill out the dataViewSet .searchDataView that was
        // loaded in our initial page.
        // -------------------------------------------------------------------------------
        if (this.drillbackFilterDataView) {
          this.searchFormDataView = this.drillbackFilterDataView;
          this.drillbackFilterDataView = null;
        } else {
          /**
           * If a list has Display Fields and responsive card view ie.. "implicitSearchForMobile()"
           * use the display fields defined on the list for the search form
           * exclude any additional fields from LMDataView, LMBusFormLayoutSpec, LMSpecFields
           */
          if (this.lmListUtilService.implicitSearchForMobile(this.listSpec)) {
            this.buildImplicitSearchForm(listDataResponse);
          } else {
            this.searchFormDataView = listDataResponse.searchDataView;
          }
        }

        if (this.searchInitialValueCriteriaNoFilter) {
          this.fillOutDataViewFromFilterCriteria(this.searchFormDataView, this.searchInitialValueCriteriaNoFilter);
          this.searchInitialValueCriteriaNoFilter = null;
        } else {
          this.fillOutDataViewFromFilterCriteria(this.searchFormDataView, this.listState.filterCriteria);
        }

      }

      /**
       * Build toolbar menus
       * Update toolbar state
       * todo kh - need to handle menu and toolbar when dataViewSet is null.
       * todo kh - This can happen when a dependent list has no fromDataView.
       */
      // todo ppatton both buildToolbar here and updateToolbar in onListRowSelected() are essentially causing the toolbar to update twice.
      this.buildToolbar();

      /**
       * Handle result set size
       */
      this.buildResultSetSize(listDataResponse.dataViewSet);
      this.buildMustacheText(listDataResponse.dataViewSet);

      this.setScreenTitle(listDataResponse.dataViewSet.header);
    } else {
      this.setScreenTitle();
    }
    this.setLiveMsgListResultCount(this.listTitle, listDataResponse?.dataViewSet?.data);

    /**
    * Set the state of the fromResourceId. This will be used
    * to determine if the fromDataView has changed.
    */
    if (this.listSpec.dependentList && this.fromDataView) {
      // --------------------------------------------------------------------
      // Save off the fromDataView resourceId to compare when re-initializing
      // a dependent list. If the fromResourceId's are identical then the
      // list can be run with all other state if valid.
      // For Example: currentPagingUrl, selectedRows, activatedRow
      // --------------------------------------------------------------------
      this.listState.fromResourceId = (this.fromDataView.cubeInfo) ? this.fromDataView.dataViewResId : this.fromDataView.resourceId;
    }

    let needSendBusinessMessage = this.isRouterOutletRootComponent || this.isDrillPointRootComponent;
    if (this.listSpec.listType !== 'select') {
      // -------------------------------------------------------------------------------
      // Don't perform initial row selection on a 'select' list. The row selection
      // will cause the default row to be selected and dismiss the select list. Only
      // the users should initiate a row selection for a select list.
      // -------------------------------------------------------------------------------
      const selectedRow = this.performInitialRowSelection(listDataResponse && listDataResponse.resetSelection);
      if (selectedRow === -1) {
        if (this.lmListSpecUtilService.getSelectionMode(this.listSpec) === 'single') {
          const listRowData: LMListRowData = { idx: selectedRow, data: {}, elem: null };
          const event: LMListSelectionEvent = new LMListSelectionEvent(this, [ listRowData ]);
          this.listRowSelected.emit(event);
        } else {
          const dataGridActivatedRow: LMListRowActivatedEvent = { row: selectedRow, item: {} };
          const event2: LMListRowActivationEvent = new LMListRowActivationEvent(this, dataGridActivatedRow);
          this.listRowActivated.emit(event2);
        }

        if (this.hasDependentData) {
          // Address setting the fromDataView so that detail sections or fields get updated
          if (this.listSpec.busListSpec.detailSections) {
            this.processDetailSections(selectedRow);
          }
          if (this.listSpec.busListSpec.detailFieldsSpec) {
            this.processDetailFields(selectedRow);
          }
        }

        if (!this.listSpec.dependentList) {
          needSendBusinessMessage = true;
        }

        if (this.hasDetailFields && this.detailFieldsFormModel) {
          this.detailFieldsFormModel = undefined;
        }
      }

      // Setup initial detail section display
      this.showDetailSections(selectedRow);

      if (this.listSpec.busListSpec.implementsAuditCompare) {
        this.updateAuditCompare(selectedRow);
      }
    } else {
      let row = this.lmListUtilService.getInitialActivatedRow(this.listSpec, this.listState, this.fromDataView);
      const dataViewSet =  this.listContentComponent.getDataViewSet();
      if (dataViewSet && dataViewSet.data && dataViewSet.data.length) {
        this.performInitialRowSelectionComplete = false;

        // if single select use select vs activate row
        const selectionMode = this.lmListSpecUtilService.getSelectionMode(this.listSpec, this.inSelectListEditMode, this.selectRequestData?.allowMultiSelections);
        if (selectionMode === 'single') {
          if (this.lmContextService.enableMaintainingSelectedRows()) {
            const rowsToBeSelected = this.lmListUtilService.convertResourceIdsToRowIndexes(this.listState.selectedRowsResourceIds, this.getDataViewSet());
            row = (rowsToBeSelected?.length === 1) ? rowsToBeSelected[0] : 0;
          }
          this.listContentComponent.setSelectedRows([ row ], true);
        } else {
          this.listContentComponent.activateRow(row, true);

          if (this.lmContextService.enableMaintainingSelectedRows()) {
            const rowsToBeSelected = this.lmListUtilService.getInitialSelectedRows(this.listSpec, this.listState, this.getDataViewSet(), this.fromDataView);
            if (rowsToBeSelected !== undefined) {
              this.listContentComponent.setSelectedRows(rowsToBeSelected);
            }
          }
        }

        this.performInitialRowSelectionComplete = true;
      }
    }

    if (!this.hasSearchForm) {
      this.listDisplayed.emit(this);
    }

    if (!this.lmListSpecUtilService.isDashBoardContent(this.listSpec)) {
      this.dashboardVisibility = 'visible';
    }

    this.endLogging();
    if (this.isRouterOutletRootComponent) {
      this.sendShortcut();
    }

    if (needSendBusinessMessage) {
      this.sendBusinessContext();
    }

    if (this.listSpec.isHelperList) {
      this.lmHelperListDialogService.updateHelperListButtonState(this.listSpec?.busClassSpec?.actions, listDataResponse?.dataViewSet);
    }
    if (listDataResponse?.stepUpActionResult) {
      this.stepUpActionResult = listDataResponse.stepUpActionResult;
      this.handleStepUpAuthentication(listDataResponse.dataViewSet);
    }

    if (this.isRouterOutletRootComponent && this.lmContextService.inMingleOverlay()) {
      if (this.lmContextService.portalOverlayAutoResize() && !this.stopOverlayAutoResizing) { // full auto resizing
        this.stopOverlayAutoResizing = this.lmPortalOverlaySizingService.startAutoResizing();
      } else { // auto resize on initial load only
        this.lmPortalOverlaySizingService.autoResize();
      }
    }
  }

  private buildImplicitSearchFormSpec(formSpec?: LMFormSpec): void {
    let busFormLayoutSpec: LMBusFormLayoutSpec = this?.listSpec?.busListSpec?.searchForm?.formSpec?.busFormSpec?.busFormLayoutSpec;
    let specFields: LMSpecFields = this?.listSpec?.busListSpec?.searchForm?.formSpec?.busFormSpec?.fields;
    if (formSpec) {
      busFormLayoutSpec = formSpec.busFormSpec?.busFormLayoutSpec;
      specFields = formSpec.busFormSpec?.fields;
    }
    const displayFieldIds: string[] = this.collectDisplayFieldIds();

    if (!busFormLayoutSpec || !specFields || displayFieldIds.length === 0) {
      return;
    }

    // Update ids for BusFormSpec.fields if field is translatable
    Object.keys(specFields ?? {}).forEach((bindId) => {
      const specField: LMSpecField = specFields[bindId];

      if (specField.translatable) {
        const newBindId = `_op_${bindId}_spc_translation_cp_`;
        specField.bindId = newBindId;
        specFields[newBindId] = specField;
      }
    });

    this.listSpec?.busListSpec?.displayFields.forEach(df => {
      if(df.defaultFilterOperator) {
        specFields[df.fieldId].defaultFilterOperator = df.defaultFilterOperator;
      }
    });

    if (busFormLayoutSpec?.layout?.sections) {
      busFormLayoutSpec.layout.sections.forEach(section => {
        if (section.paragraph?.elements) {

          // Update ids for fields if field is translatable
          section.paragraph.elements.forEach((element) => {
              const bindId = element?.field?.bindId;

              if (bindId && specFields[bindId].translatable) {
                element.field.bindId =  `_op_${bindId}_spc_translation_cp_`;
              }
          });

          section.paragraph.elements = this.filterElements(section.paragraph.elements, displayFieldIds);
        }
      });
    }
  }

  private collectDisplayFieldIds(): string[] {
    const displayFieldIds: string[] = [];
    const displayFields: LMListDisplayField[] = this?.listSpec?.busListSpec?.displayFields;

    if (!displayFields || displayFields.length === 0) {
      return;
    }

    displayFields.forEach((displayField: LMListDisplayField) => {

      // Exclude display fields that cannot be filtered (Buttons, CardView, Navigation, etc...)
      if (!displayField.fieldId || !displayField.filterable) {
        return;
      }

      // Check if display field has column visibility
      if (displayField.columnVisibility) {
          if (this.lmConditionUtilService.isValid(displayField.columnVisibility, this.getDataViewSet()?.header)) {
            displayFieldIds.push(displayField.fieldId);
          }
      } else {
        displayFieldIds.push(displayField.fieldId);
      }
    });

    return displayFieldIds;
  }

  private buildImplicitSearchForm(listDataResponse: LMListPagingResponse) {
    const searchDataView: LMDataView = listDataResponse?.searchDataView;
    const fields: LMFields = listDataResponse?.searchDataView?.fields;
    const specFields: LMSpecFields = this?.listSpec?.busListSpec?.searchForm?.formSpec?.busFormSpec?.fields;
    const displayFieldIds: string[] = this.collectDisplayFieldIds();

    if (!specFields || !fields || !searchDataView) {
      return;
    }

    if(displayFieldIds.length > 0) {
      if (fields) {
        searchDataView.fields = this.filterByDisplayFields(fields, displayFieldIds);
      }

      this.searchFormDataView = searchDataView;
    } else {
      // Remove search button from toolbar
      // There are no valid display fields
      // Search form will be empty, search button should be removed
      this.listSpec.busListSpec.searchForm = undefined;
    }
  }

  // Function used to filter fields by displayFieldIds
  private filterByDisplayFields<T>(obj: { [key: string]: T }, displayFieldIds: string[]): { [key: string]: T } {
    return Object.fromEntries(
      Object.entries(obj).filter(([ id ]) => displayFieldIds.includes(id))
    );
  }

  // Filter fields from layout by displayFieldIds
  private filterElements(
    elements: Array<LMFormLayoutElements>,
    displayFieldIds: string[]
  ): Array<LMFormLayoutElements> {
    return elements.filter(element => {
      const fieldId = (element?.field as LMFormLayoutField)?.bindId;
      return !fieldId || displayFieldIds.includes(fieldId);
    });
  }

  private handleStepUpAuthentication(dataViewSet: LMDataViewSet): void {
    if (this.stepUpActionResult.type?.toLowerCase() === 'mfa'
      && this.stepUpActionResult.status && this.stepUpActionResult.status === AppConstants.STATUS_SYSTEM_ERROR) {
      this.lmErrorUtilService.handleError(
        this.stepUpActionResult.message,
        this.stepUpActionResult.details,
        this.stepUpActionResult.status,
        this.stepUpActionResult.message);
      this.stepUpActionResult = undefined;
      return;
    }
    const rows: Array<number> = this.listContentComponent.getSelectedRows();
    if (this.stepUpActionResult.actionSpec.type === AppConstants.ACTION_TYPE_FUNCTION) {
      this.runInstanceAction(this.stepUpActionResult.actionSpec, dataViewSet, rows);
    } else if (this.stepUpActionResult.actionSpec.type === AppConstants.ACTION_TYPE_CREATE) {
      this.runCreateAction(this.stepUpActionResult.actionSpec);
    } else if (this.stepUpActionResult.actionSpec.type === AppConstants.ACTION_TYPE_UPDATE){
      const dataView: LMDataView = this.getDataView(this.selectedRow);
      this.runUpdateAction(this.stepUpActionResult.actionSpec, dataView);
    } else if (this.stepUpActionResult.actionSpec.type === AppConstants.ACTION_TYPE_DELETE) {
      const deleteDataViewList: Array<LMDataView> = [];
      rows.forEach((r: number) => {
        deleteDataViewList.push(this.getDataView(r));
      });
      this.runDeleteAction(this.stepUpActionResult.actionSpec, deleteDataViewList);
    }
  }

  private sendPageAnalytics(componentName: string, loadTime: number): void {
    if (this.isRouterOutletRootComponent) {
      if (this.listSpec.listType === 'select' || this.listSpec.dependentList || this.listSpec.listType === 'helper') {
        return;
      }
      if (!this.initialAnalyticsComplete) {
        this.initialAnalyticsComplete = true;
        // eslint-disable-next-line no-unused-vars
        this.lmComponentTrackerService.endLoadTracking(componentName, this.router.url, this.getComponentInfo(), loadTime);
      }
    }

    this.lmComponentTrackerService.startComponentTracking(this.getComponentInfo(), loadTime);
    this.setRouteReuseTemplateLoadTime(loadTime);
    try {
      this.displayLoadTime.set(loadTime.toFixed(3));
    } catch (e)   {
      console.log("Display Time Not founda: " + e);
    }
  }

  private sendShortcut(): void {
    if (this.listSpec.listType === 'select' || this.listSpec.listType === 'helper') {
      return;
    }
    const shortcutTitle = `${this.listTitle} / ${this.lmContextService.getContext().webAppTitle}`;
    this.lmContextUtilService.enableStandardShortcut(true, shortcutTitle);
  }

  public sendBusinessContext(contextMsgs?: any): void {
    if (this.listSpec.listType === 'select' || this.listSpec.listType === 'filterlist' || this.listSpec.listType === 'helper') {
      return;
    }

    if (!this.listContentComponent) {
      return;
    }

    const dataViewSet: LMDataViewSet = this.getDataViewSet();
    const activatedRow = this.listState.activatedRow > -1 ? this.listState.activatedRow : null;
    const selectedRow = this.listState.selectedRows?.[0] ?? null;
    const activeRow: number = this.lmListSpecUtilService.getSelectionMode(this.listSpec) === 'single' ? selectedRow : (activatedRow ?? selectedRow);

    if (!isNaN(activeRow)) {
      const dataView: LMListDataView  | LMListTreeMoreLink = this.getDataView(activeRow);
      if (dataView?.isTreeMoreLink) {
        // Don't send context messages for the tree more link.  Messages will be
        // sent once the more data is loaded and the row is activated.
        return;
      }
    }

    this.lmContextUtilService.buildContextMessages({
      busFormName: this.listSpec.busListSpec.name,
      busClassName: this.listSpec.busClassSpec.name,
      widgetEventPrefix: AppConstants.RESOURCETYPE_LIST,
      dataObj: dataViewSet,
      rows: this.listState.selectedRows,
      activeRow,
      busContextMessages: this.listSpec.busContextMessages,
      busContextInvocations: this.listSpec.busContextInvocations
    })
      .subscribe((msgObj: any) => {
        if (msgObj.status === AppConstants.STATUS_COMPLETED) {

          if (contextMsgs) {
            msgObj = this.lmContextUtilService.mergeContextMessages({ sourceMsgs: msgObj, addMsgs: contextMsgs });
          }

          if (this.isRouterOutletRootComponent) {
            this.lmContextUtilService.clearAll();
            this.lmContextUtilService.sendContextMessages(msgObj);
          } else {
            this.sendContextMessageEvent.emit(msgObj);
          }
        }
      });
  }

  onBeforeContextMenuOpen = (response: SohoPopupMenuResponseFunction, options: any) => {
    const listStateInfo = this.getStateInfo();

    // no op
    if (listStateInfo.disableAllActions) {
      return;
    }

    let dataView = listStateInfo.selectedDataView ? listStateInfo.selectedDataView : listStateInfo.dataViewSet.data[ 0 ];
    if (!dataView) {
      dataView = listStateInfo.dataViewSet.header;
    }

    const drillPointsParams: DrillPointsParams = {
      dataView,
      fieldId: this.listSpec.busListSpec.id
    };

    const relatedReportParams: RelatedReportParams = {
      sourceResourceUrl: this.listUrlInfo.relatedReportSourceUrl,
      listTitle: this.listTitle
    };

    const personalizeParams: PersonalizeParams = {
      sourceResourceUrl: this.listUrlInfo.reportPersonalizationUrl,
      listStateInfo: this.getStateInfo()
    };

    const userListViewParams: UserListViewMenuParams = {
      userListViewUrl: this.lmUrlUtilService.buildUserListViewFetchUrl(this.listUrlInfo, this.listSpec),
      appliedUserListView: this.listState.userListViewItem?.userListView,
      disableSave: this.listContentComponent.disableSaveInUserListViewMenu(),
    };

    let showDrillAround = false;
    if (this.lmContextService.getContext().disallowNavigations !== false && this.selectedDataViews.length === 1) {
      const selectedDataView = this.selectedDataViews[ 0 ];
      // don't show drill if the row is create inline, or oa sub total row
      // or if not all keys are set (needed for agg tables)
      if (selectedDataView
        && !selectedDataView.someKeysNotFilledOut
        && !selectedDataView.isNewRow
        && !(selectedDataView.isSubtotalView || selectedDataView.isSubtotalSummaryView)
      ) {
        showDrillAround = true;
      }
    }

    const buttons = this.lmListToolbarService.getContextMenu(this.listSpec, listStateInfo, this.listUrlInfo);

    this.lmListToolbarService.buildMoreButtonMenu(this.listSpec, response, options, buttons,
      { drillParams: drillPointsParams, showDrillAround, isContextMenu: true, personalizeParams, relatedReportParams, userListViewParams });
  };

  onBeforeListToolbarMoreMenuOpen = (response: SohoPopupMenuResponseFunction, options: any) => {
    let buttons;
    if (this.bannerInRoute) {
      buttons = this.toolbarComponent.flexMoreButtons;
      if (options.isSubmenu) {
        // if a submenu, then need all the buttons for flex toolbar. This is because a menu button could get overflowed
        // and since it was in the buttonset, it wasn't in the flexMoreButtons
        buttons = this.toolbarComponent.flexButtons;
      }
    } else if (this.isRouterOutletRootComponent && !this.isCardViewWithDetailSections && !this.isCubeView && !this.toolbarAboveList) {
      buttons = this.lmBannerHeaderCompRef.instance.lmToolbarComponent.flexMoreButtons;
      if (options.isSubmenu) {
        // if a submenu, then need all the buttons for flex toolbar. This is because a menu button could get overflowed
        // and since it was in the buttonset, it wasn't in the flexMoreButtons
        buttons = this.lmBannerHeaderCompRef.instance.lmToolbarComponent.flexButtons;
      }
    } else {
      buttons = this.toolbarComponent.flexMoreButtons;
      if (options.isSubmenu) {
        // if a submenu, then need all the buttons for flex toolbar. This is because a menu button could get overflowed
        // and since it was in the buttonset, it wasn't in the flexMoreButtons
        buttons = this.toolbarComponent.flexButtons;
      }
    }

    let showDrillAround = false;
    if (this.lmContextService.getContext().disallowNavigations !== false && this.selectedDataViews.length === 1) {
      const selectedDataView = this.selectedDataViews[ 0 ];
      // don't show drill if the row is create inline, or oa sub total row
      // or if not all keys are set (needed for agg tables)
      if (selectedDataView
        && !selectedDataView.someKeysNotFilledOut
        && !selectedDataView.isNewRow
        && !(selectedDataView.isSubtotalView || selectedDataView.isSubtotalSummaryView)
      ) {
        showDrillAround = true;
      }
    }

    if (options.hasOwnProperty('contextElement')) {
      const listStateInfo = this.getStateInfo();
      let dataView = listStateInfo.selectedDataView ? listStateInfo.selectedDataView : listStateInfo.dataViewSet?.data[ 0 ];
      if (!dataView) {
        dataView = listStateInfo.dataViewSet?.header;
      }

      const drillPointsParams: DrillPointsParams = {
        dataView,
        fieldId:  this.listSpec.busListSpec.id
      };

      const relatedReportParams: RelatedReportParams = {
        sourceResourceUrl: this.listUrlInfo.relatedReportSourceUrl,
        listTitle: this.listTitle
      };

      const personalizeParams: PersonalizeParams = {
        sourceResourceUrl: this.listUrlInfo.reportPersonalizationUrl,
        listStateInfo: this.getStateInfo(),
      };

      const userListViewParams: UserListViewMenuParams = {
        userListViewUrl: this.lmUrlUtilService.buildUserListViewFetchUrl(this.listUrlInfo, this.listSpec),
        appliedUserListView: this.listState.userListViewItem?.userListView,
        disableSave: this.listContentComponent.disableSaveInUserListViewMenu(),
      };

      // eslint-disable-next-line @typescript-eslint/ban-types
      let relatedActionsFunction: (response: AjaxBeforeOpenResponseFunction, options: any) => void;
      if (this.toolbarComponent) {
        relatedActionsFunction = this.toolbarComponent.onBeforeRelatedActionsOpen;
      } else if (this.lmBannerHeaderCompRef.instance.lmToolbarComponent) {
        relatedActionsFunction = this.lmBannerHeaderCompRef.instance.lmToolbarComponent.onBeforeRelatedActionsOpen;
      }

      this.lmListToolbarService.buildMoreButtonMenu(this.listSpec, response, options, buttons, { drillParams: drillPointsParams,
        showDrillAround, isContextMenu: false,  personalizeParams, relatedReportParams, userListViewParams }, relatedActionsFunction);
    } else {
      const responseString = this.lmListToolbarService.buildFirstLevelMoreMenu(this.listSpec, buttons, showDrillAround);
      response(responseString);
    }
  };

  private fillOutDataViewFromFilterCriteria(searchFormDataView: LMDataView, filterCriteria: Array<LMFilterFieldCriteria>): void {
    if (this.listSpec.busListSpec.searchForm === undefined) {
      return;
    }

    // initialize all search form fields to blank so nothing is pre-selected; done only for those fields on
    // the search form; otherwise, it affects condition checking, i.e., visible when, etc.
    const formSpec = this.listSpec.busListSpec.searchForm.formSpec.busFormSpec;
    const layout = formSpec.busFormLayoutSpec.layout;

    // only clear out values for boolean fields. Without this, the blank value on a boolean field isn't selected by default,
    // and it isn't selected when the field is cleared
    this.lmCommonUtilService.getBindIdsFromLayout(layout, formSpec.fields).filter((bindId: string) => formSpec.fields[bindId] && formSpec.fields[bindId].type === 'BOOLEAN')
      .forEach((bindId: string) => this.clearSearchFormDataViewField(bindId, searchFormDataView));

    // then apply filter criteria
    if (filterCriteria && filterCriteria.length > 0) {
      // toolbarSearchField is not set for list view card with detail sections.
      // Use the same method used in initialize to set filter criteria for card view search field.
      if (this.listSpec.busListSpec.keywordSearch) {
        this.buildKeywordSearchFormCriteria(filterCriteria);
      }

      if (this.listSpec.busListSpec.searchFields) {
        this.buildSearchFieldFormCriteria(filterCriteria);
      }

      if (this.toolbarSearchField) {
        const searchCriteria = filterCriteria.filter( criteria => criteria.fieldId === this.toolbarSearchField.fieldId);
        const searchValue = searchCriteria[0] ? searchCriteria[0].value : '';
        this.toolbarSearchField = Object.assign({}, this.toolbarSearchField, { value: searchValue });
      }

      filterCriteria.forEach(item => {
        if (searchFormDataView.fields[ item.fieldId ]) {
          const dvField = searchFormDataView.fields[ item.fieldId ];
          dvField.value = item.value;

          // for a multiselect field, the member fields value needs to be set from the parent value array
          if (item.isMultiselectField && dvField.members) {

            for (let index = 0, len = dvField.members.length; index < len; index++) {
              const dvMember = searchFormDataView.fields[ dvField.members[ index ] ];

              // apply the indexed value from the parent value array
              dvMember.value = (item.value[ index ]) ? item.value[ index ] : '';

              // using non-strict equality to evaluate 0, '0', 0.00, '0.00' as zero, etc
              // eslint-disable-next-line eqeqeq
              const stateValues = item.stateValues.filter(state => state.value == dvMember.value);

              // member field also needs the associated stateValues array for its value
              if (stateValues && stateValues.length > 0) {
                dvMember.stateValues = stateValues;
              }
            }
          } else if (item.isMultiselectField && !dvField.members) {
            // multiselect is a keyfield, so there are no dataview member fields. Push the selected state values into the dvField.stateValues
            dvField.stateValues = [];
            if (Array.isArray(item.value) && Array.isArray(item.stateValues)) {
              item.value.forEach(key => {
                // using non-strict equality to evaluate 0, '0', 0.00, '0.00' as zero, etc
                // eslint-disable-next-line eqeqeq
                const stateValue = item.stateValues.find(option => option.value == key);
                stateValue.selected = true;
                dvField.stateValues.push(stateValue);
              });
            }
          }
        }
      });
    }
  }

  private subscribeListEvents() {
    this.listEventSubs = [
      this.lmListEventService.cancelablePagingEvent$
        .subscribe((e: LMCancelablePagingEvent) => this.onCancellablePagingEvent(e)),

      this.lmListEventService.checkControlEvent$
        .subscribe((checkControlEvent: LMCheckControlEvent) => this.runCheckControlAction(
          checkControlEvent.columnDef,
          checkControlEvent.dataView,
          checkControlEvent.row
        )),

      this.lmListEventService.settingsChangedEvent$
        .subscribe((event: LMListSettingsChangedEvent) => {
          const eventColumns: ListGridColumn[] =
            event.columns.map(column => ({ id: column.id, width: column.width }));
          this.listPersonalization.columns = eventColumns;
        }),

      this.lmListEventService.contextMenuEvent$
        .subscribe((event: LMContextMenuEvent) => this.onContextMenu(event)),

      this.lmListEventService.dataLoadedEvent$
        .subscribe((event: LMListPagingResponse) => this.onDataLoaded(event)),

      this.lmListEventService.fieldChangedEvent$
        .subscribe((event: LMListFieldChangedEvent) => this.onContentModified(event)),

      this.lmListEventService.formButtonEvent$
        .subscribe((event: LMFormButtonEvent) => this.onFormButtonEvent(event)),

      this.lmListEventService.listKeyDownEvent$
        .subscribe((event: LMListKeyDownEvent) => this.onListKeyDown(event)),

      this.lmListEventService.listDragDropEvent$
        .subscribe((event: LMListDragDropEvent) => this.listDragDropEvent.emit(event)),

      this.lmListEventService.listRowActivatedEvent$
        .subscribe((event: LMListRowActivatedEvent) => this.onListRowActivated(event)),

      this.lmListEventService.listRowDeactivatedEvent$
        .subscribe((event: LMListRowActivatedEvent) => this.onListRowDeactivated(event)),

      this.lmListEventService.listRowSelectedEvent$
        .subscribe((event: LMListRowSelectedEvent) => this.onListRowSelected(event)),

      this.lmListEventService.listRowClickedEvent$
        .subscribe((event: LMListRowClickedEvent) => this.onListRowClicked(event)),

      this.lmListEventService.listRowDoubleClickedEvent$
        .subscribe((event: LMListRowClickedEvent) => this.onListRowDoubleClicked(event)),

      this.lmListEventService.listGridBeforePagingEvent$
        .subscribe((event: LMListGridPagingEvent) => this.onListGridBeforePaging(event)),

      this.lmListEventService.listGridAfterPagingEvent$
        .subscribe((event: LMListPagingResponse) => this.onListGridAfterPaging(event)),

      this.lmListEventService.listHierarchyDoubleClickedEvent$
        .subscribe((dataView: LMDataView) => this.runOpenAction(dataView)),

      this.lmListEventService.hierarchyActionMenuItemSelectedEvent$
        .subscribe((event: LMBusActionReference) => this.runToolbarButtonAction(event)),

      this.lmListEventService.listBarCodeClickedEvent$
        .subscribe((event: LMListBarCodeClickedEvent) => this.onListBarCodeClicked(event)),

      this.lmListEventService.listLookupClickedEvent$
        .subscribe((event: LMListLookupClickedEvent) => this.onListLookupClicked(event)),

      this.lmListEventService.listFieldLookupClickedEvent$
        .subscribe((event: LMListFieldLookupClickedEvent) => this.onListFieldLookupClicked(event)),

      this.lmListEventService.listFilterLookupClickedEvent$
        .subscribe((event: LMListFilterLookupClickedEvent) => this.onListFilterLookupClicked(event)),

      this.lmListEventService.listFormOverlayClickedEvent$
        .subscribe((event: LMFormOverlayClickedEvent) => this.onFormOverlayClicked(event)),

      this.lmListEventService.listFilterClearClickedEvent$
        .subscribe((event: LMListFilterClearClickedEvent) => this.onListFilterClearClicked(event)),

      this.lmListEventService.listOpenCompactFormEvent$
        .subscribe((event: LMListOpenCompactFormEvent) => this.openCompactFormDialog(event)),

      this.lmListEventService.uiLinkEvent$
        .subscribe((event: LMUILinkEvent) => this.onUILinkEvent(event)),

      this.lmListEventService.sendContextMessageEvent$
        .subscribe((event: any) => this.onSendContextMessageEvent(event)),

      this.lmListEventService.toolbarButtonEvent$
        .subscribe((event: LMToolbarButtonEvent) => this.onToolbarButtonEvent(event)),

      this.lmListEventService.buildToolbarEvent$.subscribe(() => this.buildToolbar()),

      this.lmListEventService.updateToolbarStateEvent$
        .subscribe(() => this.onUpdateToolbarStateEvent()),

      this.lmListEventService.cubeEvent$
        .subscribe((event: LMCubeEvent) => this.onCubeEvent(event)),

      this.lmListEventService.clearSearchCriteriaEvent$
        .subscribe(() => this.onClearSearchCriteria()),

      this.lmListEventService.busyIndicatorDisplayedEvent$
        .subscribe((event: LMBusyIndicatorDisplayedEvent) => this.busyIndicatorDisplayedEvent.emit(event)),

      this.lmListEventService.updateFilterCriteriaSource$
        .subscribe((filterCriteria: LMFilterFieldCriteria[]) => {
          // Filter event from the list grid filter occurred. Save the filter criteria, and check if there is a value
          // in the toolbar search field
          this.filterBarFilterFieldCriteria = this.lmListUtilService.mergeStickyModifier(filterCriteria, this._columnfilterOperators, this.hasSearchForm);

          // add the default filter operator fields
          const defaultFilterOperatorFieldCriteria = this.listContentComponent.filterCriteriaForDefaultFilter();
          defaultFilterOperatorFieldCriteria.map((defaultFilterCriteria: LMFilterFieldCriteria ) => {
            if (!this.filterBarFilterFieldCriteria.some((filterBarFieldCriteria: LMFilterFieldCriteria) => filterBarFieldCriteria.id === defaultFilterCriteria.id)) {
              this.filterBarFilterFieldCriteria.push(defaultFilterCriteria);
            }
          });

          // delete search form filter criteria that are not from the ad hoc flyout to prevent duplicates
          this.searchFormFilterFieldCriteria = this.searchFormFilterFieldCriteria.filter((fc) => fc.isAdHoc);

          if (this.toolbarSearchField) {
            this.toolbarSearchFieldFilterCriteria =
              this.toolbarSearchField.value ? [ this.getToolbarSearchFilterCriteria() ] : [];
          }
          this.setFilterCriteria();

          const efc = this.filterBarFilterFieldCriteria.filter(criteria => criteria.exportFilterCriteria);
          this.setExportedFilterCriteria(efc);
        }),

      this.lmListEventService.filterOperatorChangedEvent$
        .subscribe((event: LMListFilterOperator) => {
          this._columnfilterOperators.set(event.id, event.operator);
        }),

      this.lmListEventService.initiateDrillAroundEvent$
        .subscribe((event: LMDataView) => {
          this.runDrillAround(event);
        }),

      this.lmListEventService.exitedColumnarAdhocReportMode$
        .subscribe((exit: boolean) => {
          this.onExitedColumnarAdhocReportMode(exit);
        }),

      this.lmListEventService.modelLplChanged$
        .subscribe((previewResponse: LMBuilderUpdatePreviewResponse) => {
          // Emitted after Adhoc columnar aggregation table definition changed in the flyout.
          // Keep the list component spec and model lpl in sync
          this.listSpec = previewResponse.listSpec;
          this.modelLpl = previewResponse.modelLpl;
        }),
    ];
  }

  onFormButtonEvent(formButtonEvent: LMFormButtonEvent) {
    if (this.previewMode) {
      this.lmGlobalUtilService.displayToastMessage(Soho.Locale.translate('PreviewOnly'), Soho.Locale.translate('PreviewOnlyMsg'), AppConstants.TRA_ACTION_COMPLETED);
      return;
    }

    this.lmLoggerService.log([ this, this.instanceId, 'onFormButtonEvent()', formButtonEvent.event ]);

    const row: number = formButtonEvent.row;
    const cell: number = formButtonEvent.cell;
    const columnDef: ListGridColumn = formButtonEvent.columnDef;
    const dataView: LMDataView = formButtonEvent.dataView;
    const event = formButtonEvent.event;

    if (dataView?.doesNotExist) {
      return;
    }

    if (columnDef.displayField.formInvokeName) {
      this.runFormInvoke(columnDef.displayField.formInvokeName, dataView);
    } else if (columnDef.displayField.actionSpec) {
      if (columnDef.displayField.suppressFormOpen) {
        // bypass the check for unsaved changes!!!
        this._runInstanceAction(columnDef.displayField.actionSpec, this.getDataViewSet(), [ row ]);
      } else {
        this.runAction(columnDef.displayField.actionSpec, row);
      }
    } else if (columnDef.displayField.documentResourceId ||
      (columnDef.displayField.buttonRow && columnDef.displayField.buttonRow[ 0 ].documentResourceId)) {
      const drId = columnDef.displayField.documentResourceId ? columnDef.displayField.documentResourceId : columnDef.displayField.buttonRow[ 0 ].documentResourceId;
      const fieldId = columnDef.displayField.fieldId ? columnDef.displayField.fieldId : undefined;
      this.openDocumentResource(drId, dataView, fieldId);
    } else if (columnDef.displayField.buttonSubForm) {
      this.openSubFormDialog(columnDef, row, cell, dataView);
    } else if (columnDef.displayField.type === AppConstants.FORMREFERENCE) {
      this.runFormReference(columnDef.displayField, dataView);
    } else if (columnDef.displayField.type === AppConstants.LISTREFERENCE) {
      this.runListReference(columnDef.displayField.relationResourceId, columnDef.displayField.resourceId, dataView);
    } else if (formButtonEvent.cardButtonActionReference) {
      this.runActionReference(formButtonEvent.cardButtonActionReference);
    } else if (columnDef.displayField?.standardActionName === 'HELPER_LIST') {
      this.runActionReference(this.lmListToolbarService.getStandardToolbarActions().helperList);
    } else {
      this.lmLoggerService.log([ this, this.instanceId, 'unrecognized onFormButtonEvent', event ]);
      return;
    }

    if (event && event.originalEvent) {
      event.originalEvent.preventDefault();
    } else {
      event.preventDefault();
    }
  }

  onUILinkEvent(uiLinkEvent: LMUILinkEvent) {
    if (this.previewMode) {
      this.lmGlobalUtilService.displayToastMessage(Soho.Locale.translate('PreviewOnly'), Soho.Locale.translate('PreviewOnlyMsg'), AppConstants.TRA_ACTION_COMPLETED);
      uiLinkEvent.event?.preventDefault();  // need to stop link in data grids
      return;
    }

    this.lmLoggerService.log([ this, this.instanceId, 'onUILinkEvent()', uiLinkEvent.event ]);
    const columnDef: ListGridColumn = uiLinkEvent.columnDef;
    const dataView: LMDataView = this.listSpec.isTemplateList ?  uiLinkEvent.dataView.dataView : uiLinkEvent.dataView;
    const event = uiLinkEvent.event;

    // Ignore a navigation event from an inline create row
    if (dataView?.isNewRow) {
      return;
    }

    // Ignore a navigation event from a select list.  Will need to reassess when
    // navigations are enabled on a select list dialog when in edit mode.
    if (this.listSpec?.listType === 'select') {
      return;
    }

    // Add fromListResource parameter to the navigation url? LMCLIENT-31792
    // If the navigation is resulting from noDataMessage button, there is no record to lookup.
    // In that case, fromListResource is not needed in the url. Navigation to the form is in create mode.
    const setFromListResource = (uiLinkEvent.options && uiLinkEvent.options.fromNoDataMessageFormButton) ? false : true;
    // if (columnDef && columnDef.displayField && columnDef.displayField.forceLinkForOverlay) {
    //   this.openForcedLink(uiLinkEvent.options.row);
    //
    // } else
    if (uiLinkEvent.navigationParams) {
      let allowOpenInFlyout = false;
      let navigationComponentType = null;
      let openingEvent: LMFormOverlayClickedEvent = null;

      if (uiLinkEvent.columnDef && uiLinkEvent.columnDef.displayField && uiLinkEvent.columnDef.displayField.openInOverlay) {
        allowOpenInFlyout = true;
        navigationComponentType = uiLinkEvent.columnDef.displayField.navigationTargetComponent;
        openingEvent = { row: 0, event };
      }

      this.runLinkNavigation(uiLinkEvent.navigationParams.navigationName, dataView.resourceId, false, '', setFromListResource, allowOpenInFlyout, navigationComponentType, openingEvent);
    } else if (columnDef.displayField.cubeDrill) {
      this.runCubeNavigation(columnDef, dataView);

    } else if (columnDef.displayField.linkNavigation || columnDef.displayField.navigation) {
      const navigationName = (columnDef.displayField.linkNavigation)
        ? columnDef.displayField.linkNavigation : columnDef.displayField.navigation;
      // only run the navigation if it exists in the dataview's navigation array
      if (dataView.navigations.indexOf(navigationName) !== -1) {
        const xtrParameters = this.listSpec.isTemplateList && !dataView.isAlreadyDefined ? { isTemplateView: true } : null;
        const openingEvent: LMFormOverlayClickedEvent = { row: 0, event };
        this.runLinkNavigation(
          navigationName,
          dataView.resourceId,
          false,
          this.lmUrlUtilService.objectToQueryString(xtrParameters),
          setFromListResource,
          columnDef.displayField.openInOverlay,
          columnDef.displayField.navigationTargetComponent,
          openingEvent);

      } else if (uiLinkEvent.options && uiLinkEvent.options.fromDashboard) {
        const compiledUrlTemplate = urltemplate.parse(this.listUrlInfo.navigationUrl);
        const url = compiledUrlTemplate.expand({ resourceId: dataView.resourceId, navigationName });
        if (this.lmContextService.allowFlyoutLinks()) {
          const openingEvent: LMFormOverlayClickedEvent = { row: 0, event };
          this.runLinkNavigation(
            navigationName,
            dataView.resourceId,
            false,
            null,
            setFromListResource,
            columnDef.displayField.openInOverlay,
            columnDef.displayField.navigationTargetComponent,
            openingEvent);
        } else {
          this.lmGlobalUtilService.navigateByUrl(url);
        }
      }
    } else if (columnDef.displayField.httpUrl) {
      const displayField = columnDef.displayField;
      if (this.lmContextService.useListFormOverlay() && !displayField.isLazyUrlRetrieval) {
        if (uiLinkEvent.dataView?.buttonLinksFlyoutInfos?.[displayField.fieldId]) {
          const buttonLinkFlyoutInfo: LMButtonLinkFlyoutInfo = dataView.buttonLinksFlyoutInfos[displayField.fieldId];
          if (buttonLinkFlyoutInfo.openInOverlay) {
            let url: string;
            if (displayField.httpUrl && displayField.httpUrl?.variables && !displayField.httpUrl.hasContext) {
              url = this.lmFormatUtilService.formatMessageRule(displayField.httpUrl, dataView, undefined, false);
            } else if (dataView?.buttonLinks?.[displayField.fieldId]) {
              url = dataView.buttonLinks[displayField.fieldId];
            } else {
              url = this.lmFormatUtilService.formatMessageRule(displayField.httpUrl, dataView, undefined, false);
            }
            if (url.indexOf('web10x=true') > -1) {
              // Add csk parameters to the URL built by WebUrlBuilder
              url = this.lmUrlUtilService.propagateSessionKeys(url, '&');
            }
            if (url && url.length > 0) {
              const openingEvent: LMFormOverlayClickedEvent = { row: 0, event };
              this.openNavigationInOverlay(url, buttonLinkFlyoutInfo.navigationName, buttonLinkFlyoutInfo.navigationTargetComponent, openingEvent);
              event.preventDefault();
              return;
            }
          }
        }
      }
      this.lmFormRequestService.runHttpUrl(
        displayField.httpUrl,
        !!displayField.openExternal,
        !!displayField.isLazyUrlRetrieval,
        displayField.httpUrl?.variables,
        displayField.fieldId,
        dataView,
        this.lmUrlUtilService.buildFormRequestUrl(this.listUrlInfo),
        dataView?.resourceId
      );

    } else if(columnDef.displayField.aggDrill) {
      const resource = new ListResource( { resourceId: columnDef.displayField.resourceId });
      const url = this.lmUrlUtilService.buildUrl({ resource, params: { aggDrill: uiLinkEvent.options.aggDrill, savedFilter: uiLinkEvent.options.savedFilter } });
      this.lmGlobalUtilService.navigateByUrl(url);
    } else if (columnDef.hasDefineLink) {
      // this needs to be the last check, because it is implied!!!
      const openingEvent: LMFormOverlayClickedEvent = { row: 0, event };
      this.runDefineAction(dataView, columnDef.displayField.fieldId, openingEvent);
    } else {
      this.lmLoggerService.log([ this, this.instanceId, 'unrecognized onUILinkEvent', event ]);
      return;

    }
    event.preventDefault();
  }

  private runDefineAction(dataView: LMDataView, fieldId: string, event: any) {
    const listResource = new ListResource({ resourceId: this.listSpec.resourceId });
    const urlOptions: URLOptions = { resource: listResource };
    const listUrl = this.lmUrlUtilService.buildUrl(urlOptions);

    this.lmFormRequestService.getDefineFormUrl(listUrl, fieldId, dataView, dataView?.action).subscribe(
        (response: DefineFormSpecUrlResponse) => {
          if (response.status === 'COMPLETED') {
            this.openDefineInOverlay(response.defineFormUrl, response.defineFormResourceId, event);
          } else if (response.status === 'SYSTEM_EXCEPTION' && response.message.startsWith('Define not yet available when database value')){
            const title = Soho.Locale.translate('DefineOnNonExistentValueTitle');
            const defineField = dataView.fields[fieldId];
            const fieldValue = defineField ? defineField.value : '?';
            const msg = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('DefineOnNonExistentValueMsg'), fieldValue);
            const options: SohoMessageOptions = { title: title, message: msg, showCloseBtn: true };
            this.lmModalWrapperService.message(options).open();
          } else {
            this.lmErrorUtilService.handleError(response.message, response.details, response.status);
          }
        });
  }

  onCubeEvent(event: LMCubeEvent) {
    if (this.previewMode) {
      this.lmGlobalUtilService.displayToastMessage(Soho.Locale.translate('PreviewOnly'), Soho.Locale.translate('PreviewOnlyMsg'), AppConstants.TRA_ACTION_COMPLETED);
      return;
    }

    if ('exporttopdf' === event.eventType) {
      this.runPdfAction(this.lmListToolbarService.getStandardOptionsMenuItems().printToFile);
    } else if ('exporttocsv' === event.eventType) {
      this.runCsvAction(this.lmListToolbarService.getStandardOptionsMenuItems().exportToCSV);
    } else if ('cubesave' === event.eventType) {
      this.executeSaveAction(AppConstants.STANDARD_SAVE);
    } else if ('createreport' === event.eventType) {
      this.runCreateReport();
    } else if ('createreportpersonalization' === event.eventType) {
      this.runListPersonalization((event as LMCreateReportPersonalizationCubeEvent).actionReference);
    } else if ('cubesearch' === event.eventType) {
      this.runToolbarButtonAction((event as LMCubeSearchEvent).actionReference);
    } else if ('applysavedsearch' === event.eventType) {
      this.applyCubeSavedSearch();
    } else if ('filterandperiodoverride' === event.eventType) {
      this.applySearchCriteriaAndOverride();
    }
  }

  private applyCubeSavedSearch() {
    // Doing it here in list component since the search form and search tags all reside in list template.
    // Setting filter criteria will kickstart the process and filterCriteriaChanged will be called on cubeview.
    this.filterCriteria = JSON.parse(JSON.stringify(this.listState.filterCriteria));
  }

  private applySearchCriteriaAndOverride() {
    const filterFields = this.getExportActionFilterCriteria();
    if (filterFields && filterFields.length > 0) {
      this.filterCriteria = JSON.parse(JSON.stringify(filterFields));
    } else {
      this.filterCriteria = [];
    }
    this.listState.filterCriteria = this.filterCriteria;
  }

  /**
   * During phone view, we switch to detail section view
   * from a given record (row) selected
   * @param selectedRow index of the row selected
   */
  private showDetailSections(selectedRow: number) {
    const dataView: LMDataView = this.getDataView(selectedRow);
    const isPhoneView = Soho.breakpoints.isBelow('phone-to-tablet');

    if (!dataView || !isPhoneView) {
      return;
    }

    if (this.isCardViewWithDetailSections && this.listState.showDetails) {
      if (this.lmBannerHeaderCompRef?.instance) {
        this.lmBannerHeaderCompRef.pushBackReference(this.listSpec.busListSpec.id, dataView.representativeText);
        this.pushedBackReferences = true;
      } else if (this.overlayShowDetails$) {
        this.overlayShowDetails$.next(true);
      }
    }
  }

  onListRowClicked(event: LMListRowClickedEvent) {
    // aggregation table-- update changed values if needed.
    if (this.listSpec.busListSpec?.implementsColumnarView
    &&  this.listSpec.busListSpec?.implementsAuditCompare
    &&  this.listSpec.busListSpec?.showChangedValuesOnRight
    &&  this.chartName?.length > 0
    &&  this.listSpec.busListSpec?.charts?.hasOwnProperty(this.chartName)) {
      const chart: LMChartSpec = this.lmListSpecUtilService.getChart(this.listSpec, this.chartName);
      if (chart?.chartType === 'aggregation') {
        this.updateAuditCompare(event.row);
      }
      return;
    }

    if (this.listState.displayAs === 'calendar') {
      return;
    }

    if (this.isSelectListInSelectionMode()) {
      // inform the single select dialog that a selection has occurred when a select list is in select mode
      this.listRowClicked.emit(event);
      return;
    }

    // ---------------------------------------------------------------------
    // if no selection mode and open action is NOT restricted then allow
    // a single click to open a record.
    // ---------------------------------------------------------------------
    if (!this.listSpec.busListSpec.openActionRestricted && !this.lmListSpecUtilService.getSelectionMode(this.listSpec)) {
      const dataView: LMDataView = this.getDataView(event.row);
      this.runOpenAction(dataView);
    }

    // LMWEB-23131
    // (SMARTPHONE ONLY)
    // add single tap to open the form when there is no detail section defined
    if (!this.listSpec.busListSpec.openActionRestricted
      && this.lmContextService.isSmartPhone()
      && !this.lmListSpecUtilService.isCardViewWithDetailSections(this.listSpec)
      && this.listState.displayAs === AppConstants.LISTVIEWTYPE_LISTVIEW
    ) {
      const dataView: LMDataView = this.getDataView(event.row);
      this.runOpenAction(dataView);
    }

    this.listState.showDetails = true;
    this.showDetailSections(event?.row);
    this.listRowClicked.emit(event);

    // In the overlay, collapse the card list to show detail sections
    if (this.overlayShowDetails$ && this.isCardViewWithDetailSections) {
      this.overlayShowDetails$.next(true);
    }
  }

  onListRowDoubleClicked(event: LMListRowClickedEvent): void {
    if (!this.listSpec.busListSpec.openActionRestricted
      && !this.lmListSpecUtilService.isSelectList(this.listSpec)) {
      const dataView: LMDataView = this.getDataView(event.row);
      this.runOpenAction(dataView, true);
    }
    this.listRowDoubleClicked.emit(event);
  }

  onListKeyDown(event: LMListKeyDownEvent) {
    // check if performing keyboard shortcut
    this.onKeyboardShortcut(event);

    if (event instanceof KeyboardEvent) {
      const evt = event as KeyboardEvent;

      if (evt.ctrlKey || evt.altKey || evt.metaKey) {
        return;
      }

      if (evt.key === 'Escape' && this._contextMenuEvent) {
        const targetField = this._contextMenuEvent.currentTarget;
        targetField?.focus();
      }

      this.listKeyDown.emit(event);
    } else {
      if (!this.isInlineCreateEnabled() || !event.e || event.e.type !== 'keydown') {
        return;
      }

      const keyboardEvent = event.e as JQuery.Event;
      if (keyboardEvent.ctrlKey || keyboardEvent.altKey || keyboardEvent.metaKey) {
        return;
      }

      const row = event.args.row;
      const cell = event.args.cell;
      const dataView: LMDataView = this.getDataView(row);

      if (dataView.isNewRow) {
        if (!keyboardEvent.shiftKey) {
          if (keyboardEvent.key === 'F8') {
            // F8 - from any column of the inline create row
            // will save any modified rows, the list is not refreshed
            this.executeSaveAction(AppConstants.STANDARD_TOOLBAR_SAVENEW);
            event.response(false);
          } else if (keyboardEvent.key === 'Tab') {
            // Tab - from the last column of the inline create row
            // will save any modified rows, the list is not refreshed
            const nextCell = this.nextEditableCell(cell);
            if (cell === nextCell) {
              if (!this.performingSaveNewViaHotkey) {
                this.performingSaveNewViaHotkey = true;
                this.executeSaveAction(AppConstants.STANDARD_TOOLBAR_SAVENEW);
                event.response(false);
              }
            }
          } else if (keyboardEvent.key === 'Escape') {
            // Escape - from any column of the inline create row will
            // delete the inline create row, the list is not refreshed
            const deleteDataViewList: Array<LMDataView> = [ dataView ];
            const deleteActionSpec: LMActionSpec = this.lmActionService.getListDeleteAction(this.listSpec.busClassSpec.actions, this.getDataViewSet(), [ AppConstants.INLINE_CREATE_ROW ]);
            this.runDeleteAction(deleteActionSpec, deleteDataViewList, true);
            event.response(false);
          }
        }
      }

      if (keyboardEvent.shiftKey && keyboardEvent.key === 'F8') {
        // Shift + F8 - when initiated from any list cell will copy the selected row to the inline create row
        const copyDataView: LMDataView = this.getDataView(this.selectedRow);
        if (!copyDataView.isNewRow && !copyDataView.isSubtotalView && !copyDataView.isSubtotalSummaryView) {
          this.runCopyRow(this.selectedRow);
          event.response(false);
        }
      }
    }
  }

  onKeyboardShortcut(event: LMListKeyDownEvent) {
    if (this.listSpec.listType === 'select' || this.listSpec.listType === 'helper') {
      return;
    }

    const key = this.lmKeyboardShortcutService.onKeyDown(event);
    if (!key) {
      return;
    }

    switch (key) {
      case LMKeyType.SAVE:
        // Save for a dependent list will be triggered by the root component
        if (this.listSpec.dependentList) {
          return;
        }

        if (this.checkSaveRequired()) {
          this.executeSaveAction(AppConstants.STANDARD_SAVE);
        }
        break;
      case LMKeyType.REFRESH:
        this.runRefresh();
        break;
      case LMKeyType.OPEN:
        const selectedDataViews: Array<LMDataView> = this.selectedDataViews;
        if (selectedDataViews.length === 1) {
          const openDataView: LMListDataView = this.getDataView(this.selectedRow);
          this.runOpenAction(openDataView);

        } else if (!this.listSpec.busListSpec.openActionRestricted && !this.lmListSpecUtilService.getSelectionMode(this.listSpec)) {
          const row = event instanceof KeyboardEvent ? this.getCellFromEvent(event)?.row : -1;
          if (row === -1)
            return;

          // ----------------------------------------------------------------------------------------------------------
          // if no selection mode and open action is NOT restricted then allow
          // a single click to open a record, this happens if the lpl configuratio of list has "disable select in webui"
          // -----------------------------------------------------------------------------------------------------------
          const dataView: LMDataView = this.getDataView(row);
          this.runOpenAction(dataView);
        }
        break;
    }
  }

  onListGridBeforePaging(event: LMListGridPagingEvent): void {
    // console.log('onListGridBeforePaging before');
    const info: LMDialogInfo = { message:  Soho.Locale.translate('UnsavedChangesContinuingMsg'), type: LMDialogType.NOYES };
    this.handleUnsavedChanges(info).subscribe(response => {
      // console.log('onListGridBeforePaging after');
      if (response) {
        this.lmListEventService.listGridContinuePagingEvent(event);
        this.clearDetailFieldsFormModelCache();
      }
    });
  }

  onListGridAfterPaging(event: LMListPagingResponse): void {
    if (this.showMultiSelectTags) {
      // select the rows for the selection tags that are on this page
      this.listContentComponent.multiSelectedValuesChanged();
    }

    if (this.lmListSpecUtilService.isColumnarView(this.listSpec)) {
      this.buildResultSetSize(event.dataViewSet);
    }

    // possibly update record count
    this.buildMustacheText(event.dataViewSet);

    if (this.titleHasMessageRule) {
      this.setScreenTitle(this.getDataViewSet().header);
    }
    this.setLiveMsgListResultCount(this.listTitle, event.dataViewSet?.data);
  }

  onContextMenu(event: LMContextMenuEvent): void {
    if (this.previewMode) {
      return;
    }

    if (this.lmContextService.casualMode()
      || this.listSpec.showAsMingleWidget) {
      // disallow right click when:
      // - in casual mode
      // - in mingle widget.
      return;
    }

    this.lmLoggerService.log([ this, this.instanceId, 'onContextMenu()', event ]);

    // -------------------------------------------------------------
    // Remove any existing popup menu so that the dom markup is
    // completely removed. This is needed before the new menu is
    // built and displayed.
    // -------------------------------------------------------------
    // Check if popupmenus are empty before removing them from the DOM
    // Only look for direct descendants from <body>
    const popupmenus = Array.from(document.querySelectorAll('body > .popupmenu-wrapper'));
    if (popupmenus.length > 0) {
      popupmenus.forEach((popupmenu: Element) => {
        if (popupmenu.childElementCount === 0) {
          popupmenu.remove();
        }
      });
    }

    // -------------------------------------------------------------
    // unselect any other selected rows, select the right click row
    // -------------------------------------------------------------
    const selectionRows: Array<number> = this.listContentComponent.getSelectedRows();

    if (!selectionRows.includes(event.row)) {
      // clear the selection values when in selection mode
      if (this.allowMaintainingSelectedValues && !this.inSelectListEditMode) {
        this.multiSelectedValues = [];
      }

      // then select the right clicked row - the right click menu is based on the selected rows
      this.listContentComponent.unSelectAllRows();
      this.listContentComponent.setSelectedRows([ event.row ], true);
    }
    if (this.isCubeView) {
      const selectedDataView = this.getDataView(this.listContentComponent.getSelectedRow());
      const noOpenAction = this.listSpec.busListSpec.openActionRestricted
        || (selectedDataView && selectedDataView.openFormResId === undefined);
      const noDrillDownAction = !this.listSpec.busListSpec.hasChildHierarchyDims;
      if ( noOpenAction && noDrillDownAction) {
        // If the context menu does not have open action or drill down, do not render it.
        // Returning here will not set the flags and so onbeforecontextmenu will not be fired.
        return;
      }
    }

    // display the browser's context menu when the target is an anchor element with an href specified
    if (event.originalEvent.target && event.originalEvent.target.href) {
      return;
    }

    // -------------------------------------------------------------
    // cause the new right click menu markup to be built, which
    // causes the popup menu to be displayed.
    // -------------------------------------------------------------
    setTimeout(() => {
      event.originalEvent.preventDefault();
      this._contextMenuEvent = event.originalEvent;
      this.displayContextMenu = true;
    });
  }

  // eslint-disable-next-line no-unused-vars
  onCloseContextMenu(event: any) {
    this._contextMenuEvent = null;
    this.displayContextMenu = false;
  }

  onKeyDown(event: SohoDataGridKeyDownEvent) {
    this.lmListEventService.listKeyDownEvent(<LMListKeyDownEvent>(event));
  }

  onContentModified(fieldChangedEvent: LMListFieldChangedEvent) {
    this.lmListToolbarService.updateToolbar(this.listSpec, this.getStateInfo(), this.listUrlInfo);
    this.contentModified.emit(fieldChangedEvent);
  }

  // TODO: gbugauisan TECHNICAL DEBT. sync list dataview to model state cache (list detail field)
  // edge case: when field is included on both display fields and detail fields definition

  // onChartRowSelected(listRowSelectedEvent: LMListRowSelectedEvent) {
  //   this.lmLoggerService.trace([ this, this.instanceId, 'onChartRowSelected()', this.listComponentId, listRowSelectedEvent ]);
  //
  //   if (!listRowSelectedEvent
  //     || listRowSelectedEvent.rows == null
  //     || listRowSelectedEvent.rows.length === 0
  //     || listRowSelectedEvent.rows[ 0 ].idx === -1
  //   ) {
  //     // --------------------------------------------------------
  //     // If the list is actually displayed then save any state
  //     // of row selection when all row selection is cleared.
  //     // --------------------------------------------------------
  //     this.listState.selectedRows = [];
  //     return;
  //   }
  //   this.processRowSelectionEvent(listRowSelectedEvent);
  //   this.chartRowSelected.emit(new LMListSelectionEvent(this, listRowSelectedEvent.rows));
  // }

  onListRowSelected(listRowSelectedEvent: LMListRowSelectedEvent) {
    this.lmLoggerService.trace([ this, this.instanceId, 'onListRowSelected()', this.listComponentId, listRowSelectedEvent ]);

    if (!listRowSelectedEvent
      || listRowSelectedEvent.rows == null
      || listRowSelectedEvent.rows.length === 0
      || listRowSelectedEvent.rows[ 0 ].idx === -1
    ) {
      const selectionMode: SohoDataGridSelectable = this.lmListSpecUtilService.getSelectionMode(this.listSpec);
      if (this.hasDependentData && selectionMode === 'single') {
        // ----------------------------------------------------------------------
        // disallow toggling single selection lists when it has dependentData.
        // ----------------------------------------------------------------------
        this.listContentComponent.setSelectedRows(this.listState.selectedRows, false);
        return;
      }

      this.updateSelectionTags(listRowSelectedEvent);

      this.listState.selectedRows = [];
      this.listState.selectedRowsResourceIds = [];

      // always send event for lookup as it needs to know when a 'deselection' has occurred
      if (this.listSpec.listType === 'select') {
        // re-enable the OK button, if it's been disabled
        // Finding the button via dom lookup until Soho exposes the buttons in a soho modal. https://github.com/infor-design/enterprise-ng/issues/467
        const buttonId = this.lmUniqueIdService.uniqueId([ this.listSpec.busListSpec.id, this.listSpec.busClassSpec.name, LMDialogButtonKey.OK ]);
        // LMCLIENT-30270: error thrown for .querySelector('#' + buttonId) when buttonId begins with a number
        const okButton = this.elementRef.nativeElement.parentElement.parentElement.parentElement.parentElement.parentNode.querySelector('button[id="' + buttonId + '"]');

        if (okButton) {
          // we know we are on a lookup from a list, since we found the okButton. Remove the disabled attribute
          this.renderer.removeAttribute(okButton, 'disabled');
        }

        this.listRowSelected.emit(new LMListSelectionEvent(this, []));
      }

      if (this.listSpec.listType !== 'filterlist' && !this.isCubeView) {
        // performing a setTimeout here to resolve the ExpressionChangedAfterItHasBeenCheckedError that
        // occurs when toggling the Filter button on.
        setTimeout(() => {
          if (this.listSpec) {
            this.lmListToolbarService.updateToolbar(this.listSpec, this.getStateInfo(), this.listUrlInfo);
          }
        }, 1);
      }

      // LMCLIENT-33598: update helper list button state
      if (this.listSpec.isHelperList) {
        this.lmHelperListDialogService.updateHelperListButtonState(this.listSpec?.busClassSpec?.actions, this.getDataViewSet(), this.getStateInfo()?.selectedRows);
      }

      return;
    }
    this.processRowSelectionEvent(listRowSelectedEvent);

    // if multiple rows are selected in a lookup, need to disable the OK button
    if (this.listSpec.listType === 'select') {
      if (!this.selectRequestData?.allowMultiSelections) {
        // Finding the button via dom lookup until Soho exposes the buttons in a soho modal. https://github.com/infor-design/enterprise-ng/issues/467
        const buttonId = this.lmUniqueIdService.uniqueId([ this.listSpec.busListSpec.id, this.listSpec.busClassSpec.name, LMDialogButtonKey.OK ]);
        // LMCLIENT-30270: error thrown for .querySelector('#' + buttonId) when buttonId begins with a number
        const okButton = this.elementRef.nativeElement.parentElement.parentElement.parentElement.parentElement.parentNode.querySelector('button[id="' + buttonId + '"]');

        if (okButton) {
          // we know we are on a lookup from a list, since we found the okButton. Add/Remove the disabled attribute
          if (listRowSelectedEvent.rows.length > 1) {
            this.renderer.setAttribute(okButton, 'disabled', 'true');
          } else {
            this.renderer.removeAttribute(okButton, 'disabled');
          }
        }
      }
    }

    this.listRowSelected.emit(new LMListSelectionEvent(this, listRowSelectedEvent.rows));
  }

  private processRowSelectionEvent(listRowSelectedEvent: LMListRowSelectedEvent) {
    if (this.listSpec.listType !== 'filterlist') {
      // performing a setTimeout here to resolve the ExpressionChangedAfterItHasBeenCheckedError
      // that occurs when a search form is cleared
      setTimeout(() => {
        this.lmListToolbarService.updateToolbar(this.listSpec, this.getStateInfo(), this.listUrlInfo);
      }, 1);
    }

    // LMCLIENT-33598: update helper list button state
    if (this.listSpec.isHelperList) {
      this.lmHelperListDialogService.updateHelperListButtonState(this.listSpec?.busClassSpec?.actions, this.getDataViewSet(), this.getStateInfo()?.selectedRows);
    }

    // ------------------------------------------------------------
    // if single select then listRowActivated is disabled and this
    // event handler should process the detail sections and fields
    // ------------------------------------------------------------
    let needSendBusinessMessage = false;
    const selectionMode: SohoDataGridSelectable = this.lmListSpecUtilService.getSelectionMode(this.listSpec, this.inSelectListEditMode);

    // Additional condition added for chart. We force single selection behavior for a chart used for the selection of records.
    if (selectionMode === 'single' || selectionMode === 'siblings' || (this.displayType === 'chart' && this.listState.displayAs !== 'calendar')) {
      const selectedRow = listRowSelectedEvent.rows[ 0 ].idx;

      if (this.listSpec.busListSpec.detailSections) {
        this.processDetailSections(selectedRow);
      }
      if (this.listSpec.busListSpec.detailFieldsSpec) {
        this.processDetailFields(selectedRow);
      }

      if (this.listSpec.dependentList && this.fromDataView) {
        // send when a row is selected on this list (and
        // not when a row is selected on a related list)
        if (this.listState.fromResourceId === this.fromDataView.resourceId) {
          const [ selectedRowResourceId = "" ] = this.lmListUtilService.convertRowIndexesToResourceIds([ selectedRow ], this.getDataViewSet());
          if (this.listState.selectedRowsResourceIds === undefined || !this.listState.selectedRowsResourceIds.includes(selectedRowResourceId)) {
            if (this.listState.displayAs !== 'chart' && this.listState.displayAs !== 'calendar' && !this.listSpec.busListSpec.implementsCubeView) {
              needSendBusinessMessage = true;
            }
          }
        }
      } else {
        needSendBusinessMessage = true;
      }
    }

    if (this.listSpec.busListSpec.showChangedValuesOnRight) {
      this.updateAuditCompare(listRowSelectedEvent.rows[0].idx);
    }

    this.updateSelectionTags(listRowSelectedEvent);

    this.listState.selectedRows = this.listContentComponent.getSelectedRows();
    this.listState.selectedRowsResourceIds = this.lmListUtilService.convertRowIndexesToResourceIds(this.listState.selectedRows, this.getDataViewSet());
    if (needSendBusinessMessage) {
      this.sendBusinessContext();
    }
  }

  onListRowActivated(event: LMListRowActivatedEvent) {
    this.lmLoggerService.log([ this, this.instanceId, 'onListRowActivated()', event ]);

    const activatedRow = event.row;
    const selectedItem = event.item;
    const [ activatedRowResourceId = "" ] = this.lmListUtilService.convertRowIndexesToResourceIds([ activatedRow ], this.getDataViewSet());

    if (this.listSpec.busListSpec.detailSections) {
      this.processDetailSections(activatedRow);
    }

    let needSendBusinessMessage = false;
    if (this.listSpec.dependentList && this.fromDataView) {
      if (this.listSpec.listType !== 'multipane') {
        needSendBusinessMessage = true;
      } else {
        // send when user has activated a row and not when
        // a dependent multipane list is initially loaded
        if (this.listState.fromResourceId === this.fromDataView.resourceId
          && (this.listState.activatedRowResourceId === undefined || activatedRowResourceId !== this.listState.activatedRowResourceId)) {
          needSendBusinessMessage = true;
        }
      }
    } else {
      needSendBusinessMessage = true;
    }
    needSendBusinessMessage = (selectedItem && (selectedItem.isSubtotalView || selectedItem.isSubtotalSummaryView))
      ? false : needSendBusinessMessage;

    this.listState.activatedRow = activatedRow;
    this.listState.activatedRowResourceId = activatedRowResourceId;

    // Need to put it here after the list state activatedRow has been set,
    // this is needed when setting the form model cache for detail field
    if (this.listSpec.busListSpec.detailFieldsSpec) {
      this.processDetailFields(activatedRow);
    }

    if (needSendBusinessMessage) {
      this.sendBusinessContext();
    }
    this.listRowActivated.emit(new LMListRowActivationEvent(this, event));

    // -------------------------------------------------------------------
    // check performInitialRowSelectionComplete so that the
    // performInitialRow selection has a chance to set selection from
    // saved state
    // -------------------------------------------------------------------
    if (this.performInitialRowSelectionComplete) {
      if (!event.sourceIsPagingEvent) {
        // when maintaining selected rows do not unselect other rows
        const unselectOtherRows = !this.maintainSelectedRows(activatedRow);
        this.syncSelectedToActivated(activatedRow, unselectOtherRows);
      }
    }
  }

  maintainSelectedRows(row: number): boolean {
    // are selection tags configured to be maintained
    if (this.showMultiSelectTags) {
      return true;
    }

    if (this.lmContextService.enableMaintainingSelectedRows()) {
      // is the row a totaling row or a more link row
      const dataView: LMListDataView | LMListTreeMoreLink = this.getDataView(row);
      return !!(dataView?.subtotalLabel || dataView?.isTreeMoreLink);
    }

    return false;
  }

  processDetailSections(row: number) {
    const dataView: LMListDataView | LMListTreeMoreLink = this.getDataView(row);
    if (dataView?.isNewRow || dataView?.isTreeMoreLink) {
      return;
    }

    // When save is run in the flyout, it calls refresh on the opening list. In this case, the
    // same record stays selected so we will keep the flyout open. If the selected data view
    // resourceId has changed (or the new row has no resourceId, e.g. a subtotal/summary row),
    // then close the flyout.
    const newResourceId = dataView?.resourceId;
    if (!newResourceId || this.selectedDataView?.resourceId !== newResourceId) {
      this.closeFlyoutIfOpen();
    }

    this.selectedDataView = dataView;

    this.processDetailSectionsForCubeView();
    // ---------------------------------------------------------
    // Update fromDataView on detail sections and dashboards
    // ---------------------------------------------------------
    // Commenting out the following if block.
    // If a list implements dashboard view, there will be a cardview and detail sections, but no display fields.
    // The detail sections will be processed the same way as any other list type - Akila.
    // if (this.listSpec.busListSpec.implementsDashBoardView) {
    //   // ---------------------------------------------------------
    //   // Update tab labels on detail sections
    //   // ---------------------------------------------------------
    //   let displayFields = this.listSpec.busListSpec.displayFields;
    //   for (let i = 0, len = displayFields.length; i < len; i++) {
    //     if (displayFields[ i ].title && displayFields[ i ].title.variables) {
    //       this.panels[ i ].title = this.lmFormatUtilService.formatMessageRule(this.lmContextService.getContext(), displayFields[ i ].title, selectedDataView);
    //     }
    //   }
    //   this.dashboardViewComponent.fromDataView = selectedDataView;
    // } else {
    // ---------------------------------------------------------
    // Update tab labels on detail sections
    // ---------------------------------------------------------
    const detailSections = this.listSpec.busListSpec.detailSections;
    this.hasContextCardView = !!this.listSpec.busListSpec.contextCardView;

    this.updateDetailSections(detailSections, this.detailSectionPanels, this.selectedDataView);

    // if (this.dashboardViewComponent || this.detailSectionsComponent) {
    //   (this.listSpec.busListSpec.implementsDashBoardView)
    //     ? this.dashboardViewComponent.fromDataView = selectedDataView
    //     : this.detailSectionsComponent.fromDataView = selectedDataView;
    // }
  }

  processDetailSectionsForCubeView() {
    if (this.lmListSpecUtilService.isCubeView(this.listSpec) && this.selectedDataView) {
      const cubeDataViewSet = this.getDataViewSet();
      // UITest detail section examples do not have reporting basis or child hierarchy dimensions yet.
      // 1. Build Extra info with information that are available in all cube views
      this.selectedDataView.cubeInfo.extraInfo = {
        periodKey: cubeDataViewSet.cubeInfo.periodKey,
        cubeNm: this.listSpec.busListSpec.name,
      };
      if (cubeDataViewSet.cubeInfo.pivotView) {
        this.selectedDataView.cubeInfo.extraInfo.pivotView = cubeDataViewSet.cubeInfo.pivotView;
      } else if (this.listSpec.cubeOptions.pivotViews?.length > 0) {
        let pivot;
        pivot = this.listSpec.cubeOptions.pivotViews.find((p) => p.default !== undefined && p.default);
        if (!pivot) {
          pivot = this.listSpec.cubeOptions.pivotViews[0];
        }
        this.selectedDataView.cubeInfo.extraInfo.pivotView = pivot.name;
      }
      if (cubeDataViewSet.cubeInfo.columnView) {
        this.selectedDataView.cubeInfo.extraInfo.columnView = cubeDataViewSet.cubeInfo.columnView;
      } else if(this.listSpec.cubeOptions.columnViews?.length > 0) {
        let columnView;
        columnView = this.listSpec.cubeOptions.columnViews.find((c) => c.default !== undefined && c.default);
        if (!columnView) {
          columnView = this.listSpec.cubeOptions.columnViews[0];
        }
        this.selectedDataView.cubeInfo.extraInfo.columnView = columnView.name;
      }
      // 2. ExtraInfo will have the following top dimensions and context, if child hierarchy dimensions are present (or reporting basis is set)
      if (this.listState.cubeOverrides && cubeDataViewSet.cubeInfo.reportingBasis) {
        this.selectedDataView.cubeInfo.extraInfo = Object.assign({}, this.selectedDataView.cubeInfo.extraInfo, {
          reportingBasis: cubeDataViewSet.cubeInfo.reportingBasis,
          topNodeDims: this.listState.cubeOverrides.topDimensions,
        });
      }
      if (cubeDataViewSet.cubeInfo.topContextFields) {
        this.selectedDataView.cubeInfo.extraInfo = Object.assign({}, this.selectedDataView.cubeInfo.extraInfo, { topContextFields: this.getDataViewSet().cubeInfo.topContextFields });
      }
      // For any other cube with periodView/periodViewPeriods and detail sections
      // 3. ExtraInfo will have period view and period view period.
      const hasPeriodViews = this.listSpec.cubeOptions.periods && this.listSpec.cubeOptions.periods.length > 0;
      const pvPeriods = cubeDataViewSet.cubeInfo.pvPeriods;
      const hasPvPeriods = pvPeriods && pvPeriods.length > 0;
      if (hasPeriodViews && hasPvPeriods) {
        this.selectedDataView.cubeInfo.extraInfo = Object.assign({}, this.selectedDataView.cubeInfo.extraInfo,
          { periodView: cubeDataViewSet.cubeInfo.periodView,
            pvPeriodIdx: (this.listState.cubeOverrides?.periodViewPeriod) ? this.listState.cubeOverrides.periodViewPeriod : 0 });

        this.selectedDataView.cubeInfo.extraInfo2 = { pvPeriods, };
        this.lmLoggerService.log([ this, this.instanceId, 'LMListComponent:processDetailSectionsForCubeView:pvPeriods - ', this.selectedDataView.cubeInfo.extraInfo2.pvPeriods.length ]);
      }
    }
  }

  updateDetailSections(specList: Array<LMBusDetailSection>, panelList: Array<LandmarkPanel>, dataView: LMDataView, titlesOnly = false) {
    for (let i = 0, len = specList.length; i < len; i++) {
      const spec = specList[i];
      const panel = panelList.find(p => p.id === spec.id);

      // need to check for panel because the dashboard detail section implementation
      // does not support all types yet, such as URLPanels
      if (panel) {
        this.updateDetailSection(spec, panel, dataView, titlesOnly);

        if (spec.detailSections && panel.dashBoardPanes) {
          // if lazyDashboardConditions then updateDetailSections titlesOnly flag should be true.
          // The visiblity conditions will be evaluated in LMDetailSectionsComponent
          this.updateDetailSections(spec.detailSections, panel.dashBoardPanes, dataView, this.lazyDashboardConditions);
        }

        if (this.dashboardViewComponent) {
          this.dashboardViewComponent.panelVisibilityUpdateTimeStamp = Date.now();
        }
      }
    }
    // todo spec-url-refactor - seems to be unused.
    // panelList = Object.assign([], panelList);
  }

  updateDetailSection(detailSectionsSpec: LMBusDetailSection, panel: LandmarkPanel, dataView: LMDataView, titleOnly = false) {
    if (detailSectionsSpec.title && detailSectionsSpec.title.variables) {
      panel.title = this.lmFormatUtilService.formatMessageRule(detailSectionsSpec.title, dataView);
    }

    if (titleOnly) {
      return;
    }

    if (detailSectionsSpec && detailSectionsSpec.visibility) {
      panel.hidden = !this.lmConditionUtilService.isValid([ detailSectionsSpec.visibility ], dataView);
    }

    if (detailSectionsSpec && detailSectionsSpec.validity) {
      panel.isValid = this.lmConditionUtilService.isValid([ detailSectionsSpec.validity ], dataView);
    }
  }

  processDetailFields(row: number) {
    if (row === -1 || this.isDashBoardContent) {
      this.detailFieldsFormModel = undefined;
      return;
    }

    // previous record state processing
    if (this.selectedDataView) {
      const previousRecordResourceId = this.selectedDataView.resourceId;
      const previousRecordModelCache = this.detailfieldsFormModelCache.find(model=> model.id === previousRecordResourceId);

      if (previousRecordModelCache) {
        if (this.detailFieldsFormModel?.isDirty) {
          previousRecordModelCache.cache = { ...this.detailFieldsFormModel.getCache() };
          this.syncDetailFieldsFormModelAndListDataviews(false);
        } else {
          // if model never gets dirty, remove from cache to save memory
          this.clearDetailFieldsFormModelCache([ this.selectedDataView ]);
        }
      }

      if (this.detailFieldsFormModel) {
        this.detailFieldsFormModel.clearModelState();
      }

      //unsubscribe previous subscription if there's any (when user fires save, refresh, pagination etc...)
      if (this.detailFieldsFormModelSub$) {
        this.detailFieldsFormModelSub$.unsubscribe();
      }
    }

    // start processing current record
    const resourceId = this.getDataView(row)?.resourceId;
    const modelCache = this.detailfieldsFormModelCache.find(state => state.id === resourceId);

    this.selectedDataView = modelCache ? modelCache.dataView : this.getDataView(row);

    if (this.selectedDataView) {
      if (this.detailFieldsFormModel) {
        this.detailFieldsFormModel.setData(this.selectedDataView);
      } else {
        this.detailFieldsFormModel = this.createFormModel(this.selectedDataView);
      }
    }

    this.processDetailFieldsFormModelCache(row);
    this.subscribeToDetailFieldsFormModelChanges();

    this.listState.previousActivatedRow = row;
  }

  onListRowDeactivated(event: LMListRowActivatedEvent) {
    const rowActivatedEvent: LMListRowActivationEvent = new LMListRowActivationEvent(this, event);
    this.listRowDeactivated.emit(rowActivatedEvent);
  }

  onPanelDataUpdated(event: LMListTransactionEvent) {
    // let the top most component call refresh!
    if (this.isRouterOutletRootComponent) {
      const request = new LMRefreshRequest();
      request.originatingSourceId = event?.eventSource?.listId;
      this.executeRefresh(request).subscribe();
    }
    this.listTransactionEvent.emit(event);
  }

  onSendContextMessageEvent(event: any) {
    if (this.previewMode) {
      return;
    }
    this.sendBusinessContext(event);
  }

  onUpdateToolbarStateEvent() {
    if (this.listSpec.busListSpec.toolbar) {
      this.lmListToolbarService.updateToolbar(this.listSpec, this.getStateInfo(), this.listUrlInfo);
    }

    if (!this.isRouterOutletRootComponent) {
      this.contentModified.emit();
    }
  }

  // eslint-disable-next-line no-unused-vars
  public onLMNotificationEvent(event: LMNotificationEvent) {
    this.cancelPagingRequest();
  }

  cancelPagingRequest() {
    if (this.cancelPagingNotifier$) {
      this.cancelPagingNotifier$.next(AppConstants.THREAD_INTERRUPTED_BY_USER);
      this.cancelPagingNotifier$.complete();
    }
  }

  onCancellablePagingEvent(e: LMCancelablePagingEvent) {
    if (e.state === 'started') {
      this.cancelPagingNotifier$ = e.cancelablePagingNotifier;
    }

    this.showCancellableNotification = e.state === 'waiting';
    if (this.lmNotificationComponent) {
      this.lmNotificationComponent.isVisible = this.showCancellableNotification;
    }
  }

  onBarCodeClick = (event?: LMListBarCodeClickedEvent) => {

    if (this.lmContextService.inNativeMobileApp() && !this.lmContextService.isMobileDevice()) {
      const test = '';
      this.processBarCodeClick(test, event);
    } else {
      this.lmContextUtilService.showQRCodeScanner().subscribe((response: LMBarCodeData) => {
        if (response?.data) {
          this.processBarCodeClick(response?.data);
        }
      });
    }
  };

  processBarCodeClick = (scanResults: string, event?: LMListBarCodeClickedEvent) => {
    const lmScannableFieldInfo: LMModelFieldInfo = this.lmGlobalUtilService.callScannableParse(scanResults);
    if (event) {
      if (scanResults) {
        const sohoLookup = event.lookup;
        sohoLookup.element.val(scanResults);
        sohoLookup.element.focus();
      }
    } else {
      this.listViewSearchFieldValue = scanResults;
      this.buildListViewSearchFieldCriteria();
    }
  };

  public contextScanMenuClicked($event) {

    if ($event.args) {
      const menuElement = $event.args[ 0 ];
      const menuId = menuElement.getAttribute('id');

      if (menuId === 'ScanEvent') {
        this.onBarCodeClick(this.lmListBarCodeEvent);
      }

      if (menuId === 'SelectEvent') {
        this.lmListEventService.listLookupClickedEvent(this.lmListBarCodeEvent);
      }
    }
  }

  public onCloseContextScanMenu(event: any) {
    this._contextScanMenuEvent = null;
    this.showScanOptionsContextMenu = false;
  }

  public get contextScanMenuId(): string {
    return this.scanMenuId + '_ContextMenu';
  }

  public get contextScanMenuEvent(): any {
    return this._contextScanMenuEvent;
  }

  onListBarCodeClicked(event: LMListBarCodeClickedEvent) {
    this.scanMenuId = event.column.displayField.columnId;

    if (event.column.displayField.scannable) {
      if (event.column.displayField.selectable) {
        this.zone.run(() => {
          setTimeout(() => {
            if (event.triggerButtonEvent) {
              event.triggerButtonEvent.originalEvent.preventDefault();
              this._contextScanMenuEvent = event.triggerButtonEvent.originalEvent;
              this.showScanOptionsContextMenu = true;
              this.lmListBarCodeEvent = event;
            }
          });
        });
      } else {
        this.onBarCodeClick(event);
      }
    }
  }

  onListLookupClicked(event: LMListLookupClickedEvent) {
    if (this.throttleLookupClickEvent(event)) {
      return;
    }

    if (this.lmContextService.useSingleSelectList()) {
      this.showSelectListDialog(event);
    } else {
      this.showClassicSelectListDialog(event);
    }
  }

  private throttleLookupClickEvent(event: LMListLookupClickedEvent): boolean {
    const columnId = event?.column?.displayField?.columnId;

    if (this.lookupSelectThrottleId && this.lookupSelectThrottleId === columnId) {
      return true;
    }

    this.lookupSelectThrottleId = columnId;

    setTimeout( () => { this.lookupSelectThrottleId = null; }, 500);
    return false;
  }

  private showSelectListDialog(event: LMListLookupClickedEvent) {
    const dataView = event.dataView ? event.dataView : this.getDataViewSet().header;
    const selectListUrl = event.selectListUrl;
    const sourceField = event.sourceField;
    const sohoLookup = event.lookup;
    const targetField = event.targetField;
    const columnLabel = event.column.name || '';
    const column = event.column;

    this.lmSpecService.getListSpec(selectListUrl).subscribe((listSpecResponse: LMListSpecResponse) => {
      this.lmLoggerService.log([ this, this.instanceId, 'getListSpec() completed', listSpecResponse ]);

      const listSpec = listSpecResponse.listSpec;
      const listUrlInfo = listSpecResponse.listUrlInfo;

      const className = (listSpec.busListSpec.searchForm === undefined  && !listSpec.busListSpec.implementsTreeView)
        ? 'lm-lookup-modal datagrid-default-modal-width' : 'datagrid-default-modal-width';

      const title = (columnLabel.trim().length > 0)
        ? this.lmFormatUtilService.formatMessage(Soho.Locale.translate('SelectTitle'), columnLabel)
        : Soho.Locale.translate('Select');

      // allowing multiple selections for a field is only allowed from the filter row
      const allowMultiSelections = column.displayField.allowMultiSelections
        && !event.dataView
        && !listSpec.busListSpec.implementsRepresentativeImageView;

      // fields that allow multiple selections maintain the selected values
      const maintainSelectedValues = allowMultiSelections
        && this.lmContextService.enableMaintainingSelectedValues()
        && !this.lmListSpecUtilService.isCardViewOnly(listSpec);

      const selectRequestData: SelectRequestData = {
        viewType: 'list',
        viewName: this.listSpec.busListSpec.name,
        dataView,
        allowMultiSelections,
        maintainSelectedValues
      };

      if (this.listSpec.userFolder) {
        selectRequestData.userFolder = this.listSpec.userFolder;
      }

      if (maintainSelectedValues) {
        const editTitle = (columnLabel.trim().length > 0)
          ? this.lmFormatUtilService.formatMessage(Soho.Locale.translate('EditTitle'), columnLabel)
          : Soho.Locale.translate('Edit');

        const selectedValuesData: SelectedValuesData = {
          selectedValues: (sohoLookup.element[0] as HTMLInputElement).value,
          fieldId: sourceField,
          type: column.displayField.type,
          decSize: column.displayField.decSize,
          precision: column.displayField.decSize,
          selectTitle: title,
          editTitle
        };
        selectRequestData.selectedValuesData = selectedValuesData;
      }

      this.lmSelectDialogService.showSelectListDialog({
        listUrlInfo,
        listSpec,
        title,
        sourceField,
        className,
        selectRequestData
      }).pipe(
        first()) // causes the subscription to complete after its messaged the first time
        .subscribe((selectResponse: LMSelectResponse) => {
          this.lmLoggerService.log([ this, this.instanceId, 'showSelectListDialog()', selectResponse ]);
          if (selectResponse?.status === AppConstants.STATUS_COMPLETED && selectResponse.dataViews) {
            let value = '';
            let selectedValue = '';
            if (maintainSelectedValues) {
              selectResponse.multiSelectedValues.forEach((item, index, array) => {
                selectedValue = '' + item.formattedValue;
                selectedValue = selectedValue.includes(AppConstants.MULTI_SEARCH_TERM_DELIMITER) ? `"${selectedValue}"` : selectedValue;
                const delimiter = (index === array.length -1) ? '' : AppConstants.MULTI_SEARCH_TERM_DELIMITER;
                value += `${selectedValue}${delimiter}`;
              });
            } else if (allowMultiSelections) {
              selectResponse.dataViews.forEach((selectedDataView, index, array) => {
                selectedValue = '' + selectedDataView.fields[sourceField].value;
                selectedValue = selectedValue.includes(AppConstants.MULTI_SEARCH_TERM_DELIMITER) ? `"${selectedValue}"` : selectedValue;
                const delimiter = (index === array.length -1) ? '' : AppConstants.MULTI_SEARCH_TERM_DELIMITER;
                value += `${selectedValue}${delimiter}`;
              });
            } else {
              const selectedDataView: LMDataView = selectResponse.dataViews[0];
              value = selectedDataView.fields[sourceField].value as string;
            }

            this.zone.run(() => {
              sohoLookup.element.val(value);
              sohoLookup.element.focus();
            });

            if (targetField && dataView.fields.hasOwnProperty(targetField)) {
              dataView.fields[targetField].value = value;
            }
          } else if (selectResponse?.status === AppConstants.STATUS_CANCEL) {
            this.zone.run(() => {
              sohoLookup.element.focus();
            });
          }
        }
        );
    },
    (error: any) => {
      this.lmBusyIndicatorService.hideBusyIndicator();
      this.lmLoggerService.log([ this, this.instanceId, 'showSelectListDialog() error', error ]);
    });
  }

  // TODO: Remove the following and its supporting methods once we now longer support classic lookup selection
  private showClassicSelectListDialog(event: LMListLookupClickedEvent) {
    const dataView = event.dataView ? event.dataView : this.getDataViewSet().header;
    const selectListUrl = event.selectListUrl;
    const sourceField = event.sourceField;
    const sohoLookup = event.lookup;
    const targetField = event.targetField;
    const columnLabel = event.column.name || '';

    this.lmSpecService.getListSpec(selectListUrl).subscribe((listSpecResponse: LMListSpecResponse) => {
      const listUrlInfo = listSpecResponse.listUrlInfo;
      const listSpec = listSpecResponse.listSpec;
      const title = (columnLabel.trim().length > 0)
        ? this.lmFormatUtilService.formatMessage(Soho.Locale.translate('SelectTitle'), columnLabel)
        : Soho.Locale.translate('Select');

      const cancelButtonId = this.lmUniqueIdService.uniqueId([ listSpec.busListSpec.name, sourceField, LMDialogButtonKey.CANCEL ]);
      const okButtonId = this.lmUniqueIdService.uniqueId([ listSpec.busListSpec.name, sourceField, LMDialogButtonKey.OK ]);

      const buttonIds = {
        ok: okButtonId,
        cancel: cancelButtonId
      };

      // TODO: need to correctly format the id here for list
      const buttons: SohoModalButton[] = [
        {
          id: buttonIds.cancel,
          text: Soho.Locale.translate(LMDialogButtonKey.CANCEL),
          click: (e, modal) => {
            this.lmBusyIndicatorService.hideBusyIndicator();
            modal.close(true);
          },
        },
        {
          id: buttonIds.ok,
          text: Soho.Locale.translate(LMDialogButtonKey.OK),
          isDefault: true,
          // eslint-disable-next-line no-unused-vars
          click: (e, modal) => {
            this.handleLookupSelection(sourceField, sohoLookup, dataView, targetField);
          }
        }
      ];

      // If the list spec has search form, it is either displayed initially or the user will click on search icon to open up.
      // In either case, do not set the height of the modal. The search form and the list together should be in auto height.
      // Also in the case of tree view, do not want to set the modal with overflow:hidden. As the nodes are expanded, we should be able to scroll.
      const className = (listSpec.busListSpec.searchForm === undefined  && !listSpec.busListSpec.implementsTreeView)
        ? 'lm-lookup-modal datagrid-default-modal-width' : 'datagrid-default-modal-width';
      this.dialog = this.lmModalWrapperService
        .modal(LMListLookupDialogComponent, { fullsize: 'responsive', noRefocus: true })
        .buttons(buttons)
        .title(title)
        .autoFocus(false)
        .cssClass(className)
        .open()
        .apply((lookupDialog: LMListLookupDialogComponent) => {
          lookupDialog.listUrlInfo = listUrlInfo;
          lookupDialog.listSpec = listSpec;
          lookupDialog.selectRequestData = {
            viewType: 'list',
            viewName: this.listSpec.busListSpec.name,
            dataView
          };

          lookupDialog.buttonIds = buttonIds;

          lookupDialog.titleChanged.pipe(first()).subscribe(newTitle => {
            this.dialog.title(newTitle);
          });

          // need to listen for all occurrences as will get a row selection for a 'deselection'
          this.listLookupSelectionSubscription =
              lookupDialog.lookupSelection.subscribe((lookupEvent: LMListLookupSelectionEvent) => {
                this.listLookupSelectionEvent = lookupEvent;
              });

          lookupDialog.navigatingToolbarEvent.pipe(first()).subscribe(() => {
            this.dialog.close();
          });
        })
      // eslint-disable-next-line no-unused-vars
        .afterClose(result => {
          if (this.listLookupSelectionSubscription) {
            this.listLookupSelectionSubscription.unsubscribe();
            this.listLookupSelectionSubscription = null;
          }

          this.listLookupSelectionEvent = null;
          this.dialog = null;
        });
    },
    (error: any) => {
      this.lmLoggerService.log([ this, this.instanceId, 'LMListLookupDialog error', error ]);
    });
  }

  public turnOnSelectEditMode(turnOn: boolean): void {
    this.inSelectListEditMode = turnOn;

    this.adjustSingleSelectTitle();
    if (this.selectRequestData?.allowMultiSelections) {
      this.adjustMultiSelectKeyFieldButtons();
    } else {
      this.adjustSingleSelectButtons();
    }

    this.lmListToolbarService.updateToolbar(this.listSpec, this.getStateInfo(), this.listUrlInfo);
    this.changeDetectorRef.detectChanges();
  }

  private adjustSingleSelectButtons() {
    const buttonSet = this.elementRef.nativeElement.closest('.modal-content').querySelector('.modal-buttonset');
    buttonSet.style.display = (this.inSelectListEditMode) ? '' : 'none';
  }

  private adjustMultiSelectKeyFieldButtons() {
    const buttons = this.elementRef.nativeElement.closest('.modal-content').querySelector('.modal-buttonset').children;

    const doneEditingButton = buttons[0] as HTMLElement;
    doneEditingButton.style.display = (this.inSelectListEditMode) ? '' : 'none';
    doneEditingButton.style.visibility = (this.inSelectListEditMode) ? 'visible' : 'hidden';

    const cancelButton = buttons[1] as HTMLElement;
    cancelButton.style.display = (this.inSelectListEditMode) ? 'none' : '';
    cancelButton.style.visibility = (this.inSelectListEditMode) ? 'hidden' : 'visible';

    const okButton = buttons[2] as HTMLElement;
    okButton.style.display = (this.inSelectListEditMode) ? 'none' : '';
    okButton.style.visibility = (this.inSelectListEditMode) ? 'hidden' : 'visible';
  }

  private adjustSingleSelectTitle() {
    if (this.allowMaintainingSelectedValues) {
      const title = this.elementRef.nativeElement.closest('.modal-content').querySelector('.modal-title') as HTMLElement;
      title.innerHTML = (this.inSelectListEditMode)
        ? this.selectRequestData.selectedValuesData.editTitle
        : this.selectRequestData.selectedValuesData.selectTitle;
    }
  }

  onListFieldLookupClicked(event: LMListFieldLookupClickedEvent) {
    this.showBusyIndicator();
    const sohoLookup = event.lookup;
    const lplFieldInfo = event.lplFieldInfo;
    let businessClass: string;

    if (lplFieldInfo.isRelatedField) {

      if (!event.dataView) {
        event.dataView = this.getDataViewSet().header;
      }

      const businessClassFld = event.dataView.fields[lplFieldInfo.busClassName];
      businessClass = !businessClassFld ? '' : businessClassFld.value as string;
    } else {
      businessClass = lplFieldInfo.busClassName;
    }

    if (!businessClass) {
      this.lmModalWrapperService
        .message()
        .message(Soho.Locale.translate('BusinessClassIsRequiredErrorMessage'))
        .title(Soho.Locale.translate('ValidationError'))
        .showCloseBtn(true)
        .open();
      this.hideBusyIndicator();
      return;
    }

    const options: LMFieldPickerSelectOptions = {
      view:                  this.lmFieldPickerService.createFieldPickerView(lplFieldInfo),
      businessClass,
      enableOperatorBuilder: this.lmFieldPickerService.fieldPickerOperatorsEnabled(lplFieldInfo),
      includeAuditFields:    this.lmFieldPickerService.includesAuditFields(lplFieldInfo),
      validPeriods:          lplFieldInfo.validPeriods,
    };

    let url = `${this.lmUrlUtilService.getBaseUrl()}/config/All`;
    url = this.lmUrlUtilService.propagateSessionKeys(url, '?');

    this.lmFieldValidatorService.fieldIsValid(sohoLookup.element.val().toString(), options.businessClass, null, url).pipe(
      switchMap((response: LMValidateFieldResponse) => this.lmFieldPickerService.openFieldPickerDialog(options, this.listUrlInfo.fieldLookUpUrl, this.placeHolder, response?.uiFieldSpec, response?.operatorInfo)),
    ).subscribe((response: LMFieldPickerSelectResponse) => {
      if (response) {
        const value = response.fieldName;
        sohoLookup.element.val(value);
        sohoLookup.element.focus();
      } else {
        this.lmBusyIndicatorService.hideBusyIndicator();
      }
    });
  }

  private handleLookupSelection(sourceField: string, sohoLookup: SohoLookupStatic, sourceDataView: LMDataView, targetField: string) {
    if (this.listLookupSelectionEvent) {
      const result: Array<any> = this.listLookupSelectionEvent.rows;
      if (result && Array.isArray(result) && result.length > 0) {
        const dataViewLookup: LMDataView = result[ 0 ].data;
        const value = dataViewLookup.fields[ sourceField ].value as string;

        this.zone.run(() => {
          sohoLookup.element.val(value);
          sohoLookup.element.focus();
        });

        if (targetField && sourceDataView.fields.hasOwnProperty(targetField)) {
          sourceDataView.fields[ targetField ].value = value;
        }
      }
    }

    this.dialog.close();
  }

  // eslint-disable-next-line no-unused-vars
  onListFilterClearClicked(event: LMListFilterClearClickedEvent) {
    this.listState.codeBlockFilterCriteria = [];
    if (this.listState.codeBlockFilterDataView) {
      delete this.listState.codeBlockFilterDataView;
    }

    const conditions: Array<SohoDataGridFilterCondition> = this.listContentComponent.sohoFilterConditions;
    const filterEvent: LMListGridPagingEvent = { pageOp: 'filter', sohoDataGridEvent: { conditions } };
    this.onListGridBeforePaging(filterEvent);
  }

  onListFilterLookupClicked(event: LMListFilterLookupClickedEvent) {
    const sohoFilterLookup = event.filterLookup;
    const column = event.column;

    const fieldId = column.displayField.fieldId;
    const columnDef = this.listContentComponent.columnById(column.displayField.id);
    const dataView = this.getDataViewSet().header;

    const originalCompoundFieldLayout: LMCompoundFieldLayout = {
      bindId: fieldId,
      delimiter: dataView.fields[fieldId].delimiter,
      label: column.displayField.label,
      type: 'compactFormatByForm'
    };

    const busFormSpec = JSON.parse(JSON.stringify(this.listSpec.busListSpec));
    busFormSpec.codeBlockFieldId = columnDef.id;
    busFormSpec.fields[fieldId].layout = column.displayField.layout;

    const compactFormName = this.listSpec.busListSpec.name + '_compactGroupFilterForm';
    const compactFormResourceId = this.listSpec.busClassSpec.name + '.' + compactFormName;
    const compactFormSpec: LMFormSpec = {
      isImplicit: true,
      resourceId: compactFormResourceId,
      busClassSpec: this.listSpec.busClassSpec,
      busFormSpec,
      selectViewType: 'list',
      formElementId: compactFormName,
    };

    const formOptions = (this.listState.codeBlockFilterCriteria && this.listState.codeBlockFilterCriteria.length > 0)
      ? { filterCriteria: this.listState.codeBlockFilterCriteria }
      : {};

    const compactFormUrlInfo = this.lmUrlInfoBuilderService.getFormUrlInfoFromFormSpec(compactFormSpec);
    const inputFilterValue = sohoFilterLookup.element.val().toString();
    const compactFormDataView = this.getCompactFormDataView(inputFilterValue, compactFormSpec, column.displayField.layout);

    this.lmCompactFormDialogService.promptCompactFormDialog({
      placeholder: this.modalPlaceholder,
      fieldId,
      title: column.displayField.label,
      layout: column.displayField.layout,
      formUrlInfo: compactFormUrlInfo,
      formSpec: compactFormSpec,
      dataView: compactFormDataView,
      specFields: busFormSpec.fields,
      originalCompoundFieldLayout,
      formType: LMFormType.SEARCH,
      model: null,
      formOptions
    }).pipe(
      first()) // causes the subscription to complete after its messaged the first time
      .subscribe(
        (result: LMCompactFormResult) => {
          if (result.result === LMCompactFormDialogResult.RESPONSE_OK) {
            this.lmLoggerService.log(result.result);
            this.listState.codeBlockFilterCriteria = [];
            let displayValue = '';

            if (result.filterCriteria.length === 0) {
              delete this.listState.codeBlockFilterDataView;
            } else {
              this.listState.codeBlockFilterDataView = this.getPristineCompactFormDataView(compactFormSpec, column.displayField.layout);
            }

            result.filterCriteria.forEach((filterCriteria, index, array) => {
              this.listState.codeBlockFilterDataView.fields[filterCriteria.fieldId].value = filterCriteria.value;
              this.listState.codeBlockFilterCriteria.push(filterCriteria);

              const searchTag = this.lmListUtilService.filterCriteriaToSearchTag(filterCriteria);
              displayValue += searchTag.label + ' ' + searchTag.tag + (index !== (array.length - 1) ? '; ' : '');
            });

            this.listState.codeBlockFilterCriteria.map((filterCriteria) => {
              filterCriteria.compactFormDisplayValue = displayValue;
            });

            sohoFilterLookup.element.val(displayValue).trigger('change').focus();

            const conditions: Array<SohoDataGridFilterCondition> = this.listContentComponent.sohoFilterConditions;
            const filterEvent: LMListGridPagingEvent = { pageOp: 'filter', sohoDataGridEvent: { conditions } };
            if (!this.lmListUtilService.isAutoFilterEnabled()) {
              return;
            }
            this.onListGridBeforePaging(filterEvent);
          }
        }
      );
  }

  onFormOverlayClicked(event: LMFormOverlayClickedEvent) {
    if (this.previewMode) {
      this.lmGlobalUtilService.displayToastMessage(Soho.Locale.translate('PreviewOnly'), Soho.Locale.translate('PreviewOnlyMsg'), AppConstants.TRA_ACTION_COMPLETED);
      return;
    }

    this.openForcedLink(event);
  }

  private getCompactFormDataView(filterValue: string, formSpec: LMFormSpec, layout: LMFormLayout): LMDataView {
    if (filterValue !== '' && this.listState.codeBlockFilterDataView) {
      return JSON.parse(JSON.stringify(this.listState.codeBlockFilterDataView));
    }
    return this.getPristineCompactFormDataView(formSpec, layout);
  }

  private getPristineCompactFormDataView(formSpec: LMFormSpec, layout: LMFormLayout): LMDataView {
    const compactFormDataView = JSON.parse(JSON.stringify(this.getDataViewSet().header));
    this.lmCommonUtilService.clearCodeBlockDataViewFields(formSpec, layout, compactFormDataView);
    return compactFormDataView;
  }

  public onToolbarSearchEvent() {
    // toolbar search event happening. Get the value from the toolbar search field, then check to see if there is a
    // search form or filter bar to also get the values for
    this.closeFlyoutIfOpen();

    this.toolbarSearchFieldFilterCriteria = [ this.getToolbarSearchFilterCriteria() ];
    this.buildFilterCriteriaFromSearchForm();
    if (this.searchFormFilterFieldCriteria === null) {
      // A field was required on the search form, and wasn't given a value. Don't execute the search and make sure
      // the search form is shown
      this.showSearchForm = true;
      return;
    }
    this.buildFilterCriteriaFromFilterBar();
    this.setFilterCriteria();
  }

  private buildFilterCriteriaFromSearchForm() {
    if (this?.hasSearchForm && this?.searchFormComponent?.formContentComponent?.searchFormComponent) {
      // safety, there shouldn't be filter bar criteria when there is a search form
      this.filterBarFilterFieldCriteria = [];
      this.searchFormFilterFieldCriteria = this.searchFormComponent.formContentComponent.searchFormComponent.getFilterCriteria();

      const efc = this.searchFormFilterFieldCriteria.filter(criteria => criteria.exportFilterCriteria);
      this.setExportedFilterCriteria(efc);
    }
  }

  private buildFilterCriteriaFromFilterBar() {
    let filterBarConditions = [];
    if (!this.hasSearchForm && this.listState && this.listState.isFilterBarOpened) {
      // safety, there shouldn't be a search form when there is a filter bar - with the exception of ad hoc search criteria
      if (!this.searchFormFilterFieldCriteria.some((fc) => fc.isAdHoc)) {
        this.searchFormFilterFieldCriteria = [];
      }
      if (this.listContentComponent.hasFilterConditions) {
        filterBarConditions = this.listContentComponent.lmFilterCriteria;
      }
    }
    this.filterBarFilterFieldCriteria = filterBarConditions || [];

    const efc = this.filterBarFilterFieldCriteria.filter(criteria => criteria.exportFilterCriteria);
    this.setExportedFilterCriteria(efc);
  }

  onUpdateReportAsOfDateEvent() {
    this.lmAsOfDateService.promptAsOfDateDialog(this.setAsOfDatePlaceholder)
        .pipe(first())
        .subscribe((result: ApplicationMenuAsOfDateResult) => {
          if (result.status !== ApplicationMenuAsOfDateDialogStatus.RESPONSE_OK) {
            return;
          }
          this.lmLoggerService.log(result.date);
          this.reportAsOfDate = this.lmFormatUtilService.yyyymmddToData(result.date);
          this.lmListEventService.reportAsOfDateUpdateEvent(this.reportAsOfDate);
        });
  }
  private getToolbarSearchFilterCriteria(): LMFilterFieldCriteria {
    // Remember any changes here need to be reflected to buildListViewSearchFieldCriteria method!
    const filterFieldCriteria: LMFilterFieldCriteria = {
      fieldId:            this.toolbarSearchField.fieldId,
      operator:           (this.toolbarSearchField.textSearchable ? 'startsWith' : 'contains') as LMFilterFieldOperator,
      value:              this.toolbarSearchField.value,
      label:              this.toolbarSearchField.label,
      displayValue:       this.toolbarSearchField.value,
      isKeywordSearch:    true,
      disableTranslationFiltering: this.toolbarSearchField.disableTranslationFiltering,
      textSearchable:     this.toolbarSearchField.textSearchable
    };

    return filterFieldCriteria;
  }

  public onListViewSearchFieldEvent() {
    this.buildListViewSearchFieldCriteria();
  }

  onFieldEvent(event: LMFieldEvent) {
    if (event.eventType === 'FilterOperatorEvent') {
      this.filterOperatorChanged(event as LMFilterOperatorEvent);
    } else if ('GenAIEvent' === event.eventType) {
      const genAIEvent = event as LMGenAIEvent;
      this.openGenAPromptIDialog(genAIEvent.fieldId, genAIEvent.fieldLabel);
    }
  }

  private filterOperatorChanged(event: LMFilterOperatorEvent) {
    const filterOp = event.operator;
    const fieldId = event.fieldId;

    this._filterOperators.set(fieldId, filterOp);
  }

  public openGenAPromptIDialog(fieldId: string, fieldLabel: string): void {
    const date = null;

    const urlCompiledTemplate = urltemplate.parse(this.listUrlInfo.genAIPromptUrl);
    const url = urlCompiledTemplate.expand({ resourceId: this.listUrlInfo.resource.resourceId });

    this.lmGenAIPromptDialogService.promptGenAIDialog(url, fieldId, this.detailFieldsFormModel, fieldLabel)
    .pipe(first())
    .subscribe((result: GenAIPromptDialogResult) => {
      if (result.status !== GenAIPromptDialogStatus.RESPONSE_OK) {
        return;
      }
      this.lmLoggerService.log(result.generated);
      this.detailFieldsFormModel.updateModelFromGenAI(result.dataView, result.model, result.fieldId, result.generated);
    });
  }

  private buildListViewSearchFieldCriteria() {
    if (this.listViewSearchFieldValue) {
      let fieldId: string;
      let label: string;
      let operator: LMFilterFieldOperator;

      let disableTranslationFiltering = false;
      if (this.hasKeyWordSearch) {
        label = this.lmFormatUtilService.formatMessageRule(this.listSpec.busListSpec.keywordSearch.label, this.getDataViewSet().header);
        fieldId = this.listSpec.busListSpec.keywordSearch.fieldId;
        operator = (this.listSpec.busListSpec.keywordSearch.textSearchable ? 'startsWith' : 'contains') as LMFilterFieldOperator;
        if (this.listSpec.busListSpec.keywordSearch.disableTranslationFiltering) {
          disableTranslationFiltering = true;
        }
      } else if (this.hasSearchFields) {
        fieldId = this.listSpec.busListSpec.searchFields.fields[0].fieldId;
        label = this.lmFormatUtilService.formatMessageRule(this.listSpec.busListSpec.searchFields.fields[ 0 ].label, this.getDataViewSet().header);
        operator = 'contains' as LMFilterFieldOperator;
      }

      const filterFieldCriteria: LMFilterFieldCriteria = {
        fieldId,
        operator,
        value: this.listViewSearchFieldValue,
        label,
        displayValue: this.listViewSearchFieldValue,
        isKeywordSearch: true,
        disableTranslationFiltering
      };

      this.toolbarSearchFieldFilterCriteria = [ filterFieldCriteria ];
    } else {
      this.toolbarSearchFieldFilterCriteria = [];
    }

    // Will NOT have a toolbarSearchField when the list is a
    // cardview with detail sections.  the affordance is not in the toolbar
    if (this.toolbarSearchField) {
      if (this.hasKeyWordSearch) {
        if (this.toolbarSearchField.fieldId === this.listSpec.busListSpec.keywordSearch.fieldId) {
          this.toolbarSearchField.value = this.listViewSearchFieldValue;
        }

      } else if (this.hasSearchFields) {
        if (this.toolbarSearchField.fieldId === this.listSpec.busListSpec.searchFields.fields[0].fieldId) {
          this.toolbarSearchField.value = this.listViewSearchFieldValue;
        }
      }
    }

    // There may also be a search form, take the search form values into account when creating the filterCriteria
    this.buildFilterCriteriaFromSearchForm();

    this.setFilterCriteria();
  }

  /**
   * On toolbar search clear just reset the toolbar search field
   */
  public onToolbarSearchClearedEvent() {
    this.closeFlyoutIfOpen();

    this.clearToolbarSearchField();
    this.listViewSearchFieldValue = '';

    const keywordFieldId: string = this.getToolbarSearchFieldId();
    if (keywordFieldId) {
      this.clearSearchFormField(keywordFieldId);   // only clear what was selected
    }
    this.keywordSearchTagOnlyCleared = true;

    const hasRemainingCriteria: boolean =
        this.searchFormFilterFieldCriteria?.length > 0 ||
        this.filterBarFilterFieldCriteria?.length > 0;

    if (!this.lmListUtilService.isUseAsSearchTargetList(this.listSpec) || hasRemainingCriteria) {
      this.setFilterCriteria();
    } else {
      this.clearFilterCriteria();
      this.clearToolbarSearchField();
      this.reopenSearchFormAfterClearedSearchTags();
    }
  }


  private getToolbarSearchFieldId(): string | undefined {
    const busListSpec = this.listSpec?.busListSpec;

    if (busListSpec?.keywordSearch) {
      return busListSpec.keywordSearch.fieldId;
    }

    return busListSpec?.searchFields?.fields?.[0]?.fieldId;
  }


  public onCubeSearchOpenLookup(event: LMFieldEvent) {
    const evt: LMCubeSearchOpenLookupEvent = event as LMCubeSearchOpenLookupEvent;
    this.listContentComponent.cubeSearchOpenLookup(evt.field, this.searchFormDataView);
  }

  public onAdHocClicked(event?: any) {
    if (this.lmOverlayService.isOpening) {
      return;
    }
    this.lmOverlayService.isOpening = true;

    if (this.adHocModel && this.adHocImplicitFormSpec) { //Case: Ad Hoc Search has been opened previously

      this.updateAdHocModel();
      this.openAdHocOverlayPanel(event);

    } else { //Case: first time opening Ad Hoc Search
      const url = this.lmUrlUtilService.buildUrl({ resource: this.listUrlInfo.resource as any });
      this.lmFormRequestService.getImplicitSearchFormForAdHoc(url)
      .subscribe((result: any) => {
        if (result && result.status === AppConstants.STATUS_COMPLETED) {
          this.lmLoggerService.log([ this, this.instanceId, 'onAdHocClicked()', event ]);

          this.adHocImplicitFormSpec = result.formSpec;
          this.buildImplicitSearchFormSpec(this.adHocImplicitFormSpec);
          this.buildAdHocModel();
          this.openAdHocOverlayPanel(event);
        } else {
          //TODO Nscheel - error handling
          this.lmOverlayService.isOpening = false;
        }
      });
    }
  }

  private openAdHocOverlayPanel(event?: any) {
    this.lmOverlayService.open({
      open: true,
      isNavigation: true,
      resourceId: this.listSpec.busClassSpec.name,
      replaceCurrentContent: true,
      navigationType: 'adhocSearch',
      insideOverlayNav: false,
      event: {
        event: event,
        row: 0
      },
      adHocSearchInfo: {
        model: this.adHocModel,
        formSpec: this.adHocImplicitFormSpec,
        formOptions: this.searchFormOptions,
        specFields: this.adHocImplicitFormSpec.busFormSpec.fields,
        layout: this.adHocImplicitFormSpec.busFormSpec.busFormLayoutSpec.layout,
        listUrlInfo: this.listUrlInfo,
      }
    });
  }

  private buildAdHocModel() {
    const modelOptions: LMModelOptions = {
      formUrlInfo: this.lmUrlInfoBuilderService.getFormUrlInfoFromFormSpec(this.adHocImplicitFormSpec),
      formSpec: this.adHocImplicitFormSpec,
      drillAroundMode: false
    };
    this.adHocModel = new LMModel(this.lmModelServiceAdapter, modelOptions );
    this.adHocModel.populate(this.adHocImplicitFormSpec.busFormSpec.fields);
    const header: LMDataView = this.getDataViewSet().header;
    this.adHocModel.setData(header, { isAdHocImplicit: true } );
    this.updateAdHocModel();
  }

  private updateAdHocModel() {
    //loop through filter criteria, get from model using getField, update value and filter type
    if (this.filterCriteria) {
      for (let i = 0; i < this.filterCriteria.length; i++) {
        const fc = this.filterCriteria[i];
        const mf = this.adHocModel.getField(fc.fieldId);
        if (mf){
          mf.value = fc.value;
          mf.filterCriteria = fc;
        }
      }
    }
  }

  public onSearchClicked(event: LMFilterEvent) {
    this.closeFlyoutIfOpen();

    this.previousSearchFormFilterFieldCriteria = this.searchFormFilterFieldCriteria;
    this.searchFormFilterFieldCriteria = this.lmListUtilService.mergeStickyModifier(event.filterCriteria || [], this._filterOperators, this.hasSearchForm);
    const prevFcHasAdHoc = this.previousSearchFormFilterFieldCriteria.some((fc) => fc.isAdHoc);
    const fcHasAdHoc = this.searchFormFilterFieldCriteria.some((fc) => fc.isAdHoc);
    // scenario where user clicks Search on 'always display' search form instead of opening the AdHoc panel via Filters or Refine
    if(this.searchFormIsAlways && prevFcHasAdHoc && !fcHasAdHoc)
      this.fixAdHocFields();
    const efc = this.searchFormFilterFieldCriteria.filter((criteria: LMFilterFieldCriteria) => criteria.exportFilterCriteria);
    this.setExportedFilterCriteria(efc);

    if (this.toolbarSearchField) {
      this.toolbarSearchFieldFilterCriteria =
        this.toolbarSearchField.value ? [ this.getToolbarSearchFilterCriteria() ] : [];
    }

    this.buildSearchFormFilterCriteria();

    if (!this.searchFormIsAlways && this.hasSearchTags) {
      this.showSearchForm = false;
    }

    // In the overlay, switch back to showing the card list after search
    if (this.overlayShowDetails$ && this.isCardViewWithDetailSections && this.listState.showDetails) {
      this.overlayShowDetails$.next(false);
    }
  }

  private buildSearchFormFilterCriteria() {
    // Search is clicked on the search form (or enter is pressed in a search form field), check if there is also a
    // keyword search to take into account when building filter criteria
    if (this.toolbarSearchField) {
      this.toolbarSearchFieldFilterCriteria =
        this.toolbarSearchField.value ? [ this.getToolbarSearchFilterCriteria() ] : [];
    } else if (this.isCardViewWithDetailSections && this.listViewSearchFieldValue && this.listViewSearchFieldValue !== '') {
      this.buildListViewSearchFieldCriteria();
      return;
    }

    this.setFilterCriteria();
  }

  private fixAdHocFields() {
    // Used to retain ad hoc filters when the search is re-run from outside the ad hoc flyout
    this.previousSearchFormFilterFieldCriteria.forEach(prevCriteria => {
      const matchIndex = this.searchFormFilterFieldCriteria.findIndex(fc => fc.fieldId === prevCriteria.fieldId && prevCriteria.isAdHoc);
      if (matchIndex > -1 && this.searchFormFilterFieldCriteria[matchIndex].value === '') {
        this.searchFormFilterFieldCriteria[matchIndex] = prevCriteria;
      }
    });
  }

  public onFilterButtonClicked() {
    this.showSearchForm = !this.showSearchForm;
  }

  /**
   * On search form clear search reset all search field including the
   * toolbar search field.
   */
  // eslint-disable-next-line no-unused-vars
  public onClearSearchClicked(event: LMFilterEvent) {
    this.closeFlyoutIfOpen();

    // clear the toolbarSearchField
    if (this.listState && this.listState.filterCriteria && this.lmListUtilService.hasFilterCriteria(this.listState.filterCriteria)) {
      // actually clearing some filter criteria, block the search from until data is returned
      this.showBusyIndicator();
    }
    this.toolbarSearchFieldFilterCriteria = [];
    this.filterBarFilterFieldCriteria = [];

    //Only remove ad hoc filters from filter bar criteria
    // this.filterBarFilterFieldCriteria = this.filterBarFilterFieldCriteria.filter((fc) => !fc.isAdHoc);

    if (((this.toolbarSearchField && this.toolbarSearchField?.value !== '') || this.listViewSearchFieldValue)
    &&  (this.hasSearchTags && this.searchTags.length === 1)) {
      this.keywordSearchTagOnlyCleared = true;
    }

    if (this.toolbarSearchField) {
      this.toolbarSearchField = Object.assign({}, this.toolbarSearchField, { value: '' });
    }

    if (this.listState.filterCriteria) {
      delete this.listState.filterCriteria;
      this.fillOutDataViewFromFilterCriteria(this.searchFormDataView, []);
    }
    if (this.listState.adHocSelectedFields) {
      delete this.listState.adHocSelectedFields;
    }

    // searchDataView should have been updated by the search form
    this.searchFormFilterFieldCriteria = [];

    // clear keyword search
    this.listViewSearchFieldValue = '';

    delete this.listState.activatedRow;
    delete this.listState.activatedRowResourceId;

    this.clearFilterCriteria();
    this.clearSearchForm();
  }

  private clearFilterCriteria(): void {
    this.filterCriteria = null;
    this.exportFilterCriteria = null;
    // save the current filterCriteria in listState.
    this.listState.filterCriteria = this.filterCriteria;
    if (this.listState.userListViewItem) {
      this.listContentComponent.clearUserListView();
    }
  }

  /**
   * Merge the toolbar and search form filter criteria. this.filterCriteria is
   * bound as input down into the LMListGridComponent. It will pick up the changed
   * filterCriteria input and run the filter.
   */
  private setFilterCriteria(): void {
    // concat arrays using spread (...) operator
    this.filterCriteria = [ ... this.toolbarSearchFieldFilterCriteria, ... this.searchFormFilterFieldCriteria, ... this.filterBarFilterFieldCriteria ];

    this.reopenSearchFormAfterClearedSearchTags();

    // save the current filterCriteria in listState.
    this.listState.filterCriteria = this.filterCriteria;
    if (this.filterCriteria?.length === 0 && this.listState.userListViewItem) {
      this.listContentComponent.clearUserListView();
    }
  }

  // Used by template
  public onSearchTagRemoved(removedSearchTag: LMListSearchTag) {
    this.closeFlyoutIfOpen();

    const fieldId: string = removedSearchTag.id;
    this.keywordSearchTagOnlyCleared = false;

    // -------------------------------------------------------------
    // if removed tag is for the toolbar searchField
    // -------------------------------------------------------------
    if (this.listSpec.busListSpec.keywordSearch || this.listSpec.busListSpec.searchFields) {
      const targetFieldId = this.listSpec.busListSpec.keywordSearch ? this.listSpec.busListSpec.keywordSearch.fieldId : this.listSpec.busListSpec.searchFields[0].fieldId;
      if (targetFieldId === fieldId) {
        this.clearToolbarSearchField();
        this.keywordSearchTagOnlyCleared = true;
      }
    }

    // -------------------------------------------------------------
    // if removed tag is for the list view searchField
    // -------------------------------------------------------------
    if (this.listViewSearchFieldValue && this.listSpec.busListSpec.keywordSearch.fieldId === fieldId) {
      this.listViewSearchFieldValue = '';
      this.keywordSearchTagOnlyCleared = true;
    }

    this.clearSearchFormField(fieldId);
    if(this.hasAdHocFilters)
      this.clearAdHocField(fieldId);

    // -------------------------------------------------------------
    // Rebuild the filterCriteria that controls the filtering of
    // the lm-list-grid.component.
    // -------------------------------------------------------------
    if (this.lmListUtilService.isUseAsSearchTargetList(this.listSpec) &&
        this.toolbarSearchFieldFilterCriteria?.length === 0 &&
        this.searchFormFilterFieldCriteria?.length === 0) {
      // make sure filterCriteria is set to null or undefined when a use as search with no filter criteria. This is so
      // the correct page size will be calculated in the initialPage() methods
      this.onClearSearchTags();
    } else {
      this.setFilterCriteria();
    }
  }

  onClearSearchTags() {
    this.closeFlyoutIfOpen();
    this.onClearSearchCriteria();

    if (!this.lmListUtilService.isUseAsSearchTargetList(this.listSpec)) {
      // only call setFilterCriteria if it is a use as filter list. This is because setFilterCriteria will set
      // filterCriteria to an empty array instead of null/undefined. We need the filterCriteria to be null/undefined
      // to calculate the correct pageSize for use as search lists in initialPage()
      this.setFilterCriteria();
    }

    this.reopenSearchFormAfterClearedSearchTags();
  }

  onRefineFilter() {
    if (this.hasAdHocFilters) {
      if (this.hasSearchForm) {
        this.lmOverlayService.overlayComm.next({
          from: 'adHocSearch',
          adHocActionInfo: {
            isReopen: true,
          }
        });
      } else {
        this.onAdHocClicked();
      }

    } else {
      this.runSearch();
    }
  }

  private reopenSearchFormAfterClearedSearchTags() {
    if (!this.hasSearchTags) {
      // Reopening the search form after all search tags are removed. This is for https://jira.lawson.com/browse/LMCLIENT-22303
      // unless the only search tag removed is the keyword search and useSearchAsFilter is true

      if (this.listSpec.busListSpec.searchForm?.useSearchAsFilter) {
        if (this.listSpec.busListSpec.searchForm && !this.keywordSearchTagOnlyCleared) {
          this.showSearchForm = true;
        }
      } else {
        if (this.listSpec.busListSpec.searchForm) {
          this.showSearchForm = true;
        }
      }
    } else {
      if (this.listSpec.busListSpec.searchForm && !this.listSpec.busListSpec.searchForm.alwaysDisplaySearch) {
        // search tags exist, don't show the search form
        this.showSearchForm = false;
      }
    }
  }

  private clearSearchForm() {
    if (!this.hasSearchForm) {
      return;
    }

    this.searchFormFilterFieldCriteria = [];

    // Make sure to only clear out the values of the search fields
    const formSpec = this.listSpec.busListSpec.searchForm.formSpec.busFormSpec;
    const layout = formSpec.busFormLayoutSpec.layout;

    const searchFieldIds: string[] = this.lmCommonUtilService.getBindIdsFromLayout(layout, formSpec.fields);

    // ------------------------------------------------------------------------
    // Set the searchDataView field value to blank
    // ------------------------------------------------------------------------
    searchFieldIds.forEach(fieldId => {
      this.clearSearchFormDataViewField(fieldId, this.searchFormDataView);
    });

    // ------------------------------------------------------------------------
    // copy the searchFormDataView to a new object to force change detection
    // ------------------------------------------------------------------------
    this.searchFormDataView = Object.assign({}, this.searchFormDataView);

    // if not use search as filter, then when the search criteria is cleared
    // the list will be empty. If result set size was displaying, remove it
    if (!this.listSpec?.busListSpec?.searchForm?.useSearchAsFilter && this.getDataViewSet()?.recordCount) {
      // Take archive or as of date into account. if dataviewset is undefined, mustache related to archive may be set when search is cleared.
      this.buildMustacheText(undefined);
    }
  }

  private removeDrillBackFilterCriteria() {
    if (this.hasDFCParameters()) {
      const url = this.lmUrlUtilService.removeFilterCriteria(this.router.url);
      this.location.replaceState(this.lmUrlUtilService.toRelativeUrl(url));
    }
  }

  private clearSearchFormDataViewField(fieldId: string, searchFormDataView: LMDataView) {
    // ---------------------------------------------------------------------------
    // clears the searchFormDataView field value and member values if available and reset filter types
    // ---------------------------------------------------------------------------

    const modelField = this.searchFormComponent?.model.getField(fieldId);
    if (modelField) {
      const prevMode = modelField.filterType === 'inRange' ? 'range' : 'standard';
      if (prevMode === 'range') {
        modelField.clearState.next(true);
      }
    }

    if (searchFormDataView?.fields?.[ fieldId ]) {
      if (searchFormDataView.fields[ fieldId ].members) {
        searchFormDataView.fields[ fieldId ].value = '';
        // iterate member fields to clear the value and if available, the stateValues property
        searchFormDataView.fields[ fieldId ].members.forEach( key => {
          searchFormDataView.fields[ key ].value = '';

          if (searchFormDataView.fields[ key ].stateValues) {
            searchFormDataView.fields[ key ].stateValues = undefined;
          }
        });
      } else {
        searchFormDataView.fields[ fieldId ].value = '';
      }
    }
  }

  private clearToolbarSearchField() {
    // -------------------------------------------------------------
    // reset the toolbar search field criteria
    // -------------------------------------------------------------
    this.toolbarSearchFieldFilterCriteria = [];

    // -------------------------------------------------------------
    // clear the toolbar search field. in order for change detection
    // to work create a new toolbarSearchField object.
    // the field may not exist if the list is a cardview with detail sections
    // in that case the search field is not on the toolbar
    // -------------------------------------------------------------

    if (this.toolbarSearchField) {
      this.toolbarSearchField = Object.assign({}, this.toolbarSearchField, { value: '' });
    }
  }

  private clearSearchFormField(fieldId: string) {
    // -------------------------------------------------------------
    // reset the search form filterCriteria array.
    // -------------------------------------------------------------
    this.searchFormFilterFieldCriteria = this.searchFormFilterFieldCriteria.filter(
      (filterCriteria: LMFilterFieldCriteria) => fieldId !== filterCriteria.fieldId);

    // ------------------------------------------------------------------------
    // Set the searchDataView field value to blank for the removedSearchTag.
    // ------------------------------------------------------------------------
    this.clearSearchFormDataViewField(fieldId, this.searchFormDataView);

    // ------------------------------------------------------------------------
    // copy the searchFormDataView to a new object to force change detection
    // ------------------------------------------------------------------------
    this.searchFormDataView = Object.assign({}, this.searchFormDataView);
  }



  private clearAdHocField(fieldId: string) {
    this.listState.adHocSelectedFields = this.listState.adHocSelectedFields?.filter(
      (field: LMAdHocSelectedField) => fieldId !== field.id);
    this.filterBarFilterFieldCriteria = this.filterBarFilterFieldCriteria?.filter(
      (filterCriteria: LMFilterFieldCriteria) => fieldId !== filterCriteria.fieldId);
  }

  private build(listUrl: string | undefined): void {
    NgZone.assertInAngularZone();

    if (this.componentDestroyed) {
      // ------------------------------------------------------------------------------------
      // Sometimes we can get here when a dependent list component has been destroyed.
      // The issue seems to happen when moving very quickly between screens that contain
      // dependent lists. This only seems to occur when the router.url has already switched
      // from one page to the another page component that both have dependent lists. The
      // router.url at this point is set to one of the page urls and not a list url.
      // I suspect this only happens during e2e testing that can move between screens
      // quickly.
      // Now getting the url from the router in ngAfterViewInit and passing it in here.
      // This seems to ensure that I get the correct list url.
      // - See https://jira.infor.com/browse/LMWEB-18041
      // ------------------------------------------------------------------------------------
      // component is destroyed so do not continue this function.
      // ------------------------------------------------------------------------------------
      return;
    }

    this.lmLoggerService.trace([ this, this.instanceId, 'build()' ]);

    if (this.isRouterOutletRootComponent && !this.lmContextService.inMingleOverlay() && !(this.isInOverlay || this.topLevelOverlayComponent)) {
      if (!this.bannerInRoute) {
        this.lmBannerHeaderCompRef.instance.fullPageScroll = false;
      }
    }

    /*
     * listSpec is king. If a list spec is passed in as Input() then that
     * take precedence over the url.
     */
    if (!listUrl) {
      // listUrlInfo does not have urlParams when it is on a page pane or form pane. This can cause issues like
      // https://inforwiki.atlassian.net/browse/LMWEB-20034, so be aware when making down stream calls to
      // this.listUrlInfo.urlParams
      this.checkInitialSearchCriteria().subscribe(value => {
        if (this.hasChartVisibilityFields()) {
          this.checkForChartVisibilityFields().subscribe(value => {
            this.listSpecLoaded();
          });
        } else {
          this.listSpecLoaded();
        }
      });
    } else {
      this.loadListSpec(listUrl);
    }

    // For helper list dialog, need t listen to OK clicks
    if (this.helperListOptions && this.helperListOptions.helperListDialog$) {
      this.helperListOptions.helperListDialog$
        // Do not do first here. This subscription will be active until dialog is closed.
        // The dialog service will complete and close this subject.
        .subscribe((actionDlgResult: LMHelperListDialogResult) => {
          if (actionDlgResult.result === LMHelperListDialogResultCode.HELPER_LIST_DIALOG_OK) {
            const rows: Array<number> = this.listContentComponent.getSelectedRows();
            this.runInstanceAction(actionDlgResult.helperListAction.actionSpec, this.getDataViewSet(), rows, null,
              this.helperListOptions.contextDataView, actionDlgResult.helperListAction.actionFieldMap);
          }
        });
    }
  }

  /**
   * Lazily builds and returns the LMListStateKeyParams object.
   * @returns
   */
  private buildListStateKeyParams(rebuildStateKey = false): LMListStateKeyParams {
    if (!this.listStateKeyParams || rebuildStateKey) {
      const routeResourceId = this.lmUrlUtilService.getRouteResource().resourceId;
      this.listStateKeyParams = this.lmStateHelperService.buildListStateKeyParams(routeResourceId, this.listUrlInfo, this.listSpec);
    }

    return this.listStateKeyParams;
  }

  private buildListPersonalizationKeyParams(): LMListPersonalizationKeyParams {
    if (!this.listPersonalizationKeyParams) {
      this.listPersonalizationKeyParams = new LMListPersonalizationKeyParams();
      this.listPersonalizationKeyParams.prefix = this.elementRef.nativeElement.id;
      this.listPersonalizationKeyParams.dataArea = this.lmContextService.getContext().urlPdlOrDa;
      this.listPersonalizationKeyParams.resourceId = this.listUrlInfo.resource.resourceId;
      this.listPersonalizationKeyParams.actorId = this.lmContextService.getContext().actorId;

      if (this.listUrlInfo.sourceResource) {
        this.listPersonalizationKeyParams.contextResourceId = this.listUrlInfo.sourceResource.resourceId;
      }

      if (this.lmContextService.getAsOfDate()) {
        this.listStateKeyParams.asOfDate = this.lmContextService.getAsOfDate();
      }

      if (this.listUrlInfo.isArchiveData) {
        this.listPersonalizationKeyParams.isArchiveData = true;
       }
    }

    return this.listPersonalizationKeyParams;
  }

  private loadListSpec(listUrl: string): void {
    this.lmLoggerService.trace([ this, this.instanceId, 'loadListSpec()', 'listUrl: ' + listUrl ]);

    this.lmSpecService.getListSpec(listUrl).subscribe((response: LMListSpecResponse | LMSystemException) => {
      this.lmLoggerService.trace([ this, this.instanceId, 'getListSpec() completed', response ]);

      if ((response as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR) {
        this.hideBusyIndicator();
        const statusText = (response as LMSystemException).statusText;
        const details = (response as LMSystemException).details;
        this.lmErrorUtilService.handleError(statusText, details);
        return;
      }

      this.listUrlInfo = (response as LMListSpecResponse).listUrlInfo;
      this.listSpec = (response as LMListSpecResponse).listSpec;

      // The WebApp should be loaded, this is to ensure that MenuSecurity data
      // is on the client before panel visibility is processed
      // use the webApp in the url, timing issue potential is using webApp set in context service see LMWEB-24377
      const webApp = this.lmUrlUtilService.getWebAppNameFromUrl(listUrl);

      this.lmWebAppService.getWebAppMenuSpec(webApp).subscribe(value => {
        this.checkInitialSearchCriteria().subscribe(value => {
          if (this.hasChartVisibilityFields()) {
            this.checkForChartVisibilityFields().subscribe(value => {
              this.listSpecLoaded();
            });
          } else {
            this.listSpecLoaded();
          }
        });
      });
    },
    (error: any) => {
      this.hideBusyIndicator();
      this.lmErrorUtilService.handleUnexpectedError(error, this.modalPlaceholder);
    });
  }

  private checkForDrillbackFilterCriteria(): Observable<boolean> {
    // Assume don't have valid drillback filter criteria. Meaning go
    // on checking for default user list view or for initial value rules
    // Also used by bar code search scan from a menu layout.
    let keepGoing = true;


    // Unable to use this.listUrlInfo since its specific to this list and will not
    // have the drillback filter criteria parameters on the urls
    const selectedPanel = this.lmUrlUtilService.getUrlParam(this.router.url, 'selectedPanel');
    if (selectedPanel) {
      // If the format of id changes, this will need to be updated.
      if (!this.listSpec.busListSpec.id.includes(`_${selectedPanel}_`)) {
        return of(keepGoing);
      }
      // Only supporting a list found in a panel on a composite form or on a page.
      // Not supporting any other list type. Such as a dashboard, detailsectionlists, multilist, or
      // multipane lists.
      if (this.listSpec.listType !== 'default' && this.listSpec.listType !== 'formlist') {
        return of(keepGoing);
      }
    } else {
      if (!this.isRouterOutletRootComponent) {
        return of(keepGoing);
      }
    }

    const filterCriteria = this.convertDFCParamsToFilterCriteria();
    if (!filterCriteria || filterCriteria.length === 0) {
      return of(keepGoing);
    }

    const filterSpecFields = this.convertFilterParamsToSpecField(filterCriteria);
    if (!filterSpecFields || filterSpecFields.length === 0) {
      return of(keepGoing);
    }

    const listResource = new ListResource({ resourceId: this.listSpec.resourceId });
    const urlOptions: URLOptions = { resource: listResource };
    const url = this.lmUrlUtilService.buildUrl(urlOptions);

    return new Observable<boolean>(observer => {

      this.lmFormRequestService.getSearchDrillbackValues(url, filterCriteria).subscribe(response => {
        if (response.status !== 'Exception' && response.data) {
          const criteria = this.buildDrillbackCriteria(filterCriteria, filterSpecFields, response.data);
          if (criteria?.length > 0) {
            this.drillbackFilterCriteria = criteria;
            this.drillbackFilterDataView = response.data;
          }
        }
        // Have a valid drillback filter criteria. Meaning do not check for default
        // user list or for initial value rules since drillback filter criteria
        // supersedes those.
        keepGoing = false;
        observer.next(keepGoing);
        observer.complete();
      });
    });
  }

  private convertDFCParamsToFilterCriteria(): LMFilterFieldCriteria[] {
    const filterCriteria = [];

    if (this.hasDFCParameters()) {
      const fcParams: Params = this.lmUrlUtilService.getPrefixedParams(decodeURI(this.router.url), 'dfc.');
      const keys = Object.keys(fcParams);
      keys.forEach(key => {
        filterCriteria.push(this.lmUrlUtilService.buildFilterCriteria(key, fcParams[key]));
      });
    }
    this.removeDrillBackFilterCriteria(); // once applied to filterCriteria remove from the url.

    return filterCriteria;
  }

  private convertFilterParamsToSpecField(filterCriteria: LMFilterFieldCriteria[]): LMSpecField[] {
    const filterSpecFields = [];
    let specFields;

    if (this.listSpec.busListSpec.searchForm) {
      specFields = this.listSpec.busListSpec.searchForm.formSpec?.busFormSpec?.fields;
    } else {
      specFields = this.listSpec.busListSpec.fields;
    }

    filterCriteria.forEach(fc => {
      if (specFields.hasOwnProperty(fc.fieldId) && !filterSpecFields.includes(specFields[fc.fieldId])) {
        filterSpecFields.push(specFields[fc.fieldId]);
      }
    });

    return filterSpecFields;
  }

  private buildDrillbackCriteria(filterCriteria: LMFilterFieldCriteria[], specFields: LMSpecField[], dataView: LMDataView): Array<LMFilterFieldCriteria> {
    const criteria: LMFilterFieldCriteria[] = [];

    if (specFields?.length > 0) {
      const fields = dataView.fields;

      specFields.forEach(specField => {

        const fieldFilterCriteria = filterCriteria.find(fc => fc.fieldId === specField.bindId);
        if (fields.hasOwnProperty(specField.bindId) && fieldFilterCriteria) {
          const fieldId = specField.bindId;
          let operator: LMFilterFieldOperator = fieldFilterCriteria.operator;
          const field: LMField = fields[fieldId];
          const label: string = this.lmFormatUtilService.formatMessageRule(specField.label, dataView);
          const value: any = (fieldFilterCriteria.value.length > 1) ? fieldFilterCriteria.value : fieldFilterCriteria.value.toString();
          let displayValue = '';

          if (specField?.isBusClassContextField) {
            operator = undefined;
          }

          if (specField.stateValues) {
            displayValue = this.lmFormatUtilService.stateLabelToText(specField.stateValues, value);
          } else if (specField.hasUserDefinedStates) {
            displayValue = field.stateValues ? this.lmFormatUtilService.stateLabelToText(field.stateValues, value) : value;
          } else if (specField.type === AppConstants.BOOLEAN) {
            displayValue = value ? Soho.Locale.translate('Yes') : Soho.Locale.translate('No');
          } else {
            const transformOptions: LMTransformOptions = {
              precision: field.precision,
              decSize: specField.decSize,
            };
            displayValue = this.lmFormatUtilService.toDisplayValue(value, specField.type, transformOptions);
          }

          const filterField: LMFilterFieldCriteria = {
            operator,
            fieldId,
            value,
            label,
            displayValue,
            isCompactFormatField: specField.compactFormat,
            isBusClassContextField: specField.isBusClassContextField,
            isMultiselectField: specField.isMultiselect,
            stateValues: specField.isMultiselect ? specField.stateValues : (specField.hasUserDefinedStates ? field.stateValues : undefined),
          };
          criteria.push(filterField);
        }
      });
    }

    return criteria;
  }

  private checkInitialSearchCriteria(): Observable<boolean> {

    if (this.hasListState()) {
      // not first load
      return of(true);
    }

    return this.checkForDrillbackFilterCriteria().pipe(
      flatMap((keepGoing) => {
        if (keepGoing) {
          return this.checkForDefaultUserListView().pipe(
            flatMap((keepGoing) => {
              if (keepGoing) {
                return this.checkForSearchInitialValues();
              } else {
                return of(true);
              }
            }),
            catchError((error) => {
              this.lmLoggerService.log([ this, this.instanceId, 'Failed to fetch default UserListView.', error ]);
              return of(true);
            })
          );
        }
      }),
      catchError((error) => {
        this.lmLoggerService.log([ this, this.instanceId, 'Failed to apply drillback filter criteria', error ]);
        return of(true);
      })
    );
  }

  private checkForChartVisibilityFields(): Observable<boolean> {

    if (this.hasListState()) {
      // not first load
      return of(true);
    }

    return new Observable(observer => {
      const reqFields = this.getChartVisibilityFields();
      let requestUrl = urltemplate.parse(this.lmUrlUtilService.buildFormRequestUrl(this.listUrlInfo));
      requestUrl = requestUrl.expand({
        resourceId: this.listSpec.busClassSpec.name,
      });

      this.lmFormRequestService.getFieldValues(requestUrl, reqFields).pipe(
        first(),
        catchError(error => {
          this.lmLoggerService.error(error);
          return throwError(error || 'Internal Server Error');
        })
      ).subscribe(response => {
        if (response.status === 'Completed') {
          const fields: LMDataView = { fields: response.fields };
          this.chartVisibilityFields = fields;
          observer.next(true);
          observer.complete();
        } else if (response.status === 'Exception') {
          this.lmErrorUtilService.handleError(response?.message, response?.details, response.status);
        }
      });
    });
  }

  public hasChartVisibilityFields(): boolean {
    const reqFields = this.getChartVisibilityFields();
    if (reqFields?.length > 0) {
      return true;
    }
    return false;
  }

  private getChartVisibilityFields(): Array<string> {
    const visibilityFields = [];
    for (const key in this.listSpec.busListSpec?.charts) {
      if (this.listSpec.busListSpec?.charts[key]?.visibility) {
        visibilityFields.push(this.listSpec.busListSpec?.charts[key]?.visibility.fieldId);
      }
    }
    return visibilityFields;
  }

  private fetchChartVisibilityFields(): Observable<boolean> {

    return new Observable(observer => {
      const reqFields = this.getChartVisibilityFields();
      let requestUrl = urltemplate.parse(this.lmUrlUtilService.buildFormRequestUrl(this.listUrlInfo));
      requestUrl = requestUrl.expand({
        resourceId: this.listSpec.busClassSpec.name,
      });

      this.lmFormRequestService.getFieldValues(requestUrl, reqFields).pipe(
        first(),
        catchError(error => {
          this.lmLoggerService.error(error);
          return throwError(error || 'Internal Server Error');
        })
      ).subscribe(response => {
        if (response.status === 'Completed') {
          const fields: LMDataView = { fields: response.fields };
          this.chartVisibilityFields = fields;
          observer.next(true);
          observer.complete();
        } else if (response.status === 'Exception') {
          this.lmErrorUtilService.handleError(response?.message, response?.details, response.status);
        }
      });
    });
  }

  private checkForDefaultUserListView(): Observable<boolean> {
    if (!this.lmContextService.showUserListView()
        || !this.lmListSpecUtilService.hasUserListViewForList(this.listSpec)) {
      return of(true);
    }
    this.lmLoggerService.trace([ this, this.instanceId, 'checkForDefaultUserListView()' ]);
    const urlSpecifiedUserList = this.listUrlInfo.urlParams ? this.listUrlInfo.urlParams['userListView'] : null;
    if (urlSpecifiedUserList) { // If User List specified in URL, it should act as the default
      return new Observable<boolean>(observer => {
        const url = this.lmUrlUtilService.buildUserListViewFetchUrl(this.listUrlInfo, this.listSpec);
        const lk = 'UserListView[ByViewListActor](' + this.listSpec.busClassSpec.name + ',' + this.listSpec.busListSpec.name + ',' + this.lmContextService.getActorId() + ')';
        this.lmConfigurationService.fetchUserListViews(url, lk).subscribe((response: LMUserListViewResponse) => {
          if (response.savedViews?.length > 0) {
            for (const savedView of response.savedViews) {
              if (savedView.userListView === urlSpecifiedUserList) {
                this.defaultUserListViewItem = savedView;
                break;
              }
            }
          }
          observer.next(!this.defaultUserListViewItem);
          observer.complete();
        });
      });
    } else {
      return new Observable<boolean>(observer => {
        const url = this.lmUrlUtilService.buildUserListViewFetchUrl(this.listUrlInfo, this.listSpec);
        this.lmConfigurationService.getDefaultUserListView(url).subscribe((response: LMUserListViewDefaultResponse) => {
          if (response.hasDefaultView) {
            this.defaultUserListViewItem = response.defaultView;
          }

          observer.next(!response.hasDefaultView);
          observer.complete();
        });
      });
    }
  }

  private checkForSearchInitialValues(): Observable<boolean> {
    // if (this.lmListUtilService.isUseAsSearchTargetList(this.listSpec)) {
    //   return of(true);
    // }

    const initialValueSpecs: Array<LMSpecField> = this.buildSearchInitialValues();

    if (!initialValueSpecs || initialValueSpecs.length === 0) {
      return of(true);
    }
    const listResource = new ListResource({ resourceId: this.listSpec.resourceId });
    const urlOptions: URLOptions = { resource: listResource };
    const url = this.lmUrlUtilService.buildUrl(urlOptions);

    return new Observable<boolean>(observer => {

      this.lmFormRequestService.getSearchInitialValues(url).subscribe(response => {
        if (response.status !== 'Exception') {
          const criteria = this.buildSearchInitialValueCriteria(initialValueSpecs, response);
          if (criteria?.length > 0) {
            if (this.lmListUtilService.isUseAsSearchTargetList(this.listSpec)) {
              this.searchInitialValueCriteriaNoFilter = criteria;
            } else {
              this.searchInitialValueCriteria = criteria;
            }

          }
        }
        observer.next(true);
        observer.complete();
      });
    });
  }

  private buildSearchInitialValues(): Array<LMSpecField> {
    const initialValueSpecs = [];
    let specFields;

    if (this.listSpec.busListSpec.searchForm) {
      specFields = this.listSpec.busListSpec.searchForm.formSpec?.busFormSpec?.fields;
    } else {
      specFields = this.listSpec.busListSpec.fields;
    }

    if (this.listSpec.busListSpec.searchForm) {
      // eslint-disable-next-line guard-for-in
      for (const specFieldsKey in specFields) {
        const specField = specFields[specFieldsKey];
        if (specField.configuration?.init) {
          initialValueSpecs.push(specField);
        }
      }
    }

    if (this.listSpec.busListSpec.requiredSearchParameters?.length > 0) {
      this.listSpec.busListSpec.requiredSearchParameters.forEach(rsp => {
        if (rsp.initialValue && specFields.hasOwnProperty(rsp.fieldId) && !initialValueSpecs.includes(specFields[rsp.fieldId])) {
          initialValueSpecs.push(specFields[rsp.fieldId]);
        }
      });
    }

    return initialValueSpecs;
  }

  private buildSearchInitialValueCriteria(initialValueSpecs: Array<LMSpecField>, response: LMListSearchInitialValueResponse): Array<LMFilterFieldCriteria> {
    const criteria: Array<LMFilterFieldCriteria> = [];

    if (response.data && initialValueSpecs?.length > 0) {
      const dataView = response.data;
      const fields = dataView.fields;

      initialValueSpecs.forEach(specField => {

        if (fields.hasOwnProperty(specField.bindId)) {
          const fieldId = specField.bindId;
          let operator: LMFilterFieldOperator = 'equals';
          const field: LMField = fields[fieldId];
          const label: string = this.lmFormatUtilService.formatMessageRule(specField.label, dataView);
          const value: any = field.value;
          let displayValue = '';

          if (specField?.isBusClassContextField) {
            operator = undefined;
          }

          if (specField.stateValues) {
            displayValue = this.lmFormatUtilService.stateLabelToText(specField.stateValues, value);
          } else if (specField.hasUserDefinedStates) {
            displayValue = field.stateValues ? this.lmFormatUtilService.stateLabelToText(field.stateValues, value) : value;
          } else if (specField.type === AppConstants.BOOLEAN) {
            displayValue = value ? Soho.Locale.translate('Yes') : Soho.Locale.translate('No');
          } else {
            const transformOptions: LMTransformOptions = {
              precision: field.precision,
              decSize: specField.decSize,
            };
            displayValue = this.lmFormatUtilService.toDisplayValue(field.value, specField.type, transformOptions);
          }

          const filterField: LMFilterFieldCriteria = {
            operator,
            fieldId,
            value,
            label,
            displayValue,
            isCompactFormatField: specField.compactFormat,
            isBusClassContextField: specField.isBusClassContextField,
            isMultiselectField: specField.isMultiselect,
            stateValues: specField.isMultiselect ? specField.stateValues : undefined,
          };
          criteria.push(filterField);
        }
      });
    }

    return criteria;
  }

  private listSpecLoaded(): void {
    this.lmLoggerService.trace([ this, this.instanceId, 'listSpecLoaded()', this.listSpec ]);
    this.lazyDashboardConditions = this.lmContextService.lazyConditionsOnNestedDashBoardDetailSections() && !this.listSpec.busListSpec.implementsDashBoardView;

    this.lmFormatterService.listSpec = this.listSpec;
    const bannerPersonalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();
    const appDisplay = bannerPersonalization.appDisplay;
    const unsupportedPattern = this.doesSpecContainUnsupported4_0Patterns(this.listSpec);

    if (this.lmContextService.useListFormOverlay()) {
      this.allowOverlayInteractions = !this.topLevelOverlayComponent && !this.isInOverlay && !this.listSpec.isHelperList && this.listSpec.listType !== 'select';
    }

    if (this.inDrillAroundMode()) {
      this.listSpec.drillAroundMode = true;
    }
    this.setLegacyVariables(unsupportedPattern, appDisplay, this.lmContextService, this.lmHtmlPageUtilService);

    // this is an override to the url used for url3_5 in the case that there is an unsupported pattern(quad chart) but also not the router outlet root
    if (!this.isRouterOutletRootComponent && this.unsupportedPattern && this.legacyWebUI) {
      const chartName = (this.listSpec?.busListSpec?.defaultChartName && this.listSpec?.busListSpec?.defaultChartName.length > 0)
        ? ('.' + this.listSpec?.busListSpec?.defaultChartName) : '';

      this.url3_5 = this.listUrlInfo.initialDataUrl.split('?')[0] + chartName + "?csk.hidetitlebar=true&csk.hidemenubar=true&csk.3x=true";
    }

    if (this.lmBannerHeaderCompRef?.instance && this.lmBannerHeaderCompRef.instance.is3_5 !== undefined) {
      this.lmBannerHeaderCompRef.instance.is3_5 = (this.url3_5 && this.url3_5.length > 0) ? true : false;
    }
    // ------------------------------------------------------------------------
    // can set to true here since the build method will have provided all
    // that's needed to continue building the component.
    // ------------------------------------------------------------------------
    this.initialBuildComplete = true;

    if (this.hasSearchForm) {

      if (this.lmListUtilService.implicitSearchForMobile(this.listSpec)) {
        this.buildImplicitSearchFormSpec();
      }

      this.searchFormSpec = this.listSpec.busListSpec.searchForm.formSpec;
      this.searchTagsIdPrefix = this.searchFormSpec.busFormSpec.name;
      this.searchTagsAutomationIdPrefix = this.searchFormSpec.automationId;

      if (this.lmListSpecUtilService.isCubeView(this.listSpec)) {
        this.searchFormSpec.busFormSpec.subFormType = AppConstants.FORMSUBTYPE_CUBESEARCHFORM;
      }
      this.searchFormSpec.showSearchFormOnLeft = this.lmListUtilService.searchFormOnLeft(this.listSpec);
      this.searchFormUrlInfo = this.lmUrlInfoBuilderService.getFormUrlInfoFromFormSpec(this.searchFormSpec);
    } else {
      this.searchTagsIdPrefix = this.listSpec.busListSpec.name + 'ImplicitSearch';
      this.searchTagsAutomationIdPrefix = this.listSpec.busListSpec.automationId + 'ImplicitSearch';
    }

    if (this.hasDetailFields && !this.hasDetailSections && !this.implementsOrgChartView) {
      // pass along if disable field options was set on the list, so the detail fields will have their field options
      // surpressed
      if (this.listSpec && this.listSpec.busListSpec && this.listSpec.busListSpec.disableFieldOptions) {
        this.listSpec.busListSpec.detailFieldsSpec.formSpec.disableFieldOptions = true;
      }
      this.detailFieldsFormSpec = this.listSpec.busListSpec.detailFieldsSpec.formSpec;
      this.detailFieldsFormUrlInfo = this.lmUrlInfoBuilderService.getFormUrlInfoFromFormSpec(this.detailFieldsFormSpec);

      if (this.listSpec?.busListSpec?.detailFieldsSpec?.formSpec?.busFormSpec?.busFormLayoutSpec?.layout) {
        this.detailFieldsFormLayout = this.listSpec.busListSpec.detailFieldsSpec.formSpec.busFormSpec.busFormLayoutSpec.layout;
      }

      if (this.listSpec?.busListSpec?.detailFieldsSpec?.formSpec?.busFormSpec?.fields) {
        this.detailFieldsSpecFields = this.listSpec.busListSpec.detailFieldsSpec.formSpec.busFormSpec.fields;
      }
    }

    if (this.listSpec?.busListSpec?.showDetailSectionsOnSide) {
      this.showListDetailOnSide = true;

      if (this.listSpec.busListSpec.detailSectionListWidth) {
        this.responsive.observe([
          Breakpoints.XSmall,
          Breakpoints.Small
        ]).subscribe(result => {
          if (result.matches) {
            // This means that the viewport is less than the small break point above, so remove the classes
            // so the detail sections go under the list
            this.zone.runOutsideAngular(() => {
              setTimeout(() => {
                const mainList = this.elementRef.nativeElement.querySelector('.main-list-side');
                const detailContent = this.elementRef.nativeElement.querySelector('.detail-content-side');
                if (mainList && detailContent) {
                  mainList.style.width = '';
                  detailContent.style.width = '';
                }
                this.showListDetailOnSide = false;
              });
            });
          } else {
            this.showListDetailOnSide = true;
            if (this.listSpec.busListSpec.detailSectionListWidth) {
              this.zone.runOutsideAngular(() => {
                setTimeout(() => {
                  const mainList = this.elementRef.nativeElement.querySelector('.main-list-side');
                  const detailContent = this.elementRef.nativeElement.querySelector('.detail-content-side');
                  if (mainList && detailContent) {
                    mainList.style.width = this.listSpec.busListSpec.detailSectionListWidth + '%';
                    detailContent.style.width = this.listSpec.busListSpec.detailSectionContentWidth + '%';
                  }
                });
              });
            }
          }
        });
      }
    }

    this.initialize();

    // ------------------------------------------------------------------------
    // TODO: ppatton akila make this better -
    // Perhaps the sohoxi dialog changes we want will fix this.
    // jira.infor.com/browse/SOHO-6800
    // jira.infor.com/browse/SOHO-6800
    // ------------------------------------------------------------------------
    // Calling change detection here so that lists that are in dialogs
    // will display. Perhaps a better way would be for the dialog to
    // message the list for it to detect changes. Or perhaps it can mark
    // the whole lm-list for check.
    // ------------------------------------------------------------------------
    if (this.listSpec.listType === 'select'
      || this.listSpec.listType === 'helper') {
      // CHANGE DETECTION
      this.changeDetectorRef.detectChanges();
    }

    // Handles drawer's state transition during phone view to
    // properly toggle between the cardview and its detail section
    if ((this.isInOverlay || this.topLevelOverlayComponent) && this.isCardViewWithDetailSections) {
      // In the overlay, start with the card list visible (showDetails = false)
      // and switch to details when a card is clicked.

      // LMWEB-25280: Card view lists with detail sections that contain a filter list
      // should start collapsed in the flyout, so the detail sections (e.g. TA workflow
      // columns) are visible on initial load instead of the card list taking full width.
      const hasDetailSectionWithFilterList = this.listSpec.busListSpec.detailSections?.some(
        (ds: any) => ds.filterListSpecs && ds.filterListSpecs.length > 0
      );
      const initialShowDetails = hasDetailSectionWithFilterList || !!this.listState.showDetails;

      this.overlayShowDetails$ = new Subject<boolean>();
      this.showDetails$ = this.overlayShowDetails$.pipe(
        startWith(initialShowDetails),
        distinctUntilChanged(),
        tap((showDetails: boolean) => {
          this.listState.showDetails = showDetails;
        })
      );
      // In the overlay, the collapsed strip should show when details are visible
      this.drawerCollapse$ = this.showDetails$;

      // Listen for collapse events from child components (e.g. lm-list-view collapse button)
      this.listEventSubs.push(
        this.lmListEventService.drawerCollapse$.subscribe((collapsed: boolean) => {
          this.overlayShowDetails$.next(collapsed);
        })
      );
    } else {
      if (this.isCardViewWithDetailSections) {
        this.showDetails$ = this.lmBannerHeaderCompRef.backReferenceChanges$.pipe(
          map((ref: BackReferenceChange) => {
            // no longer in phone view
            if (ref.action === 'reset') {
              return false;
            }

            const listSpecId = this.listSpec.busListSpec.id;
            const isThisList = ref.backReference.id === listSpecId;
            // navigate backwards (back to parent cardview)
            if (ref.action === 'pop') {
              return isThisList ? false : this.listState.showDetails;
            }
            // navigate forward (go to details)
            if (ref.action === 'push') {
              return isThisList ? true : this.listState.showDetails;
            }
          }),
          startWith(!!this.listState.showDetails),
          distinctUntilChanged(),
          tap((showDetails: boolean) => {
            this.listState.showDetails = showDetails;
          })
        );
      }
    }

    if (this.lmContextService.isBannerInRoute() && !this.lmContextService.isApplicationMenuV3()) {
      this.connectAppMenuButtonTrigger();
    }

    // Check window size after inital load if search form on left
    if (this.lmListUtilService.searchFormOnLeft(this.listSpec)) {
      this.onResize();
    }
  }

  public getExportActionFilterCriteria(): Array<LMFilterFieldCriteria> {
    if (this.listViewSearchFieldValue) {
      let fieldId: string;
      let label: string;
      let operator: LMFilterFieldOperator;

      if (this.hasKeyWordSearch) {
        label = this.lmFormatUtilService.formatMessageRule(this.listSpec.busListSpec.keywordSearch.label, this.getDataViewSet().header);
        fieldId = this.listSpec.busListSpec.keywordSearch.fieldId;
        operator = (this.listSpec.busListSpec.keywordSearch.textSearchable ? 'startsWith' : 'contains') as LMFilterFieldOperator;

      } else if (this.hasSearchFields) {
        fieldId = this.listSpec.busListSpec.searchFields.fields[0].fieldId;
        label = this.lmFormatUtilService.formatMessageRule(this.listSpec.busListSpec.searchFields.fields[ 0 ].label, this.getDataViewSet().header);
        operator = 'contains' as LMFilterFieldOperator;
      }

      const filterFieldCriteria: LMFilterFieldCriteria = {
        fieldId,
        operator,
        value: this.listViewSearchFieldValue,
        label,
        displayValue: this.listViewSearchFieldValue,
        isKeywordSearch: true
      };
      this.toolbarSearchFieldFilterCriteria = [ filterFieldCriteria ];
    } else if (this.toolbarSearchField) {
      this.toolbarSearchFieldFilterCriteria =
        this.toolbarSearchField.value ? [ this.getToolbarSearchFilterCriteria() ] : [];
    }

    if (this.hasSearchForm) {
      this.buildFilterCriteriaFromSearchForm();
    } else {
      this.buildFilterCriteriaFromFilterBar();
    }

    // Grab all the filter fields, and make sure they are not marked as export filter criteria, so we can add
    // the export filter criteria later. If we don't do this for a main list, then the fc isn't set on the URL
    // and the PDF/CSV isn't filtered properly
    const fc = JSON.parse(JSON.stringify([ ... this.toolbarSearchFieldFilterCriteria, ... this.searchFormFilterFieldCriteria, ... this.filterBarFilterFieldCriteria ]));
    fc.forEach((ff: LMFilterFieldCriteria) => ff.exportFilterCriteria = false);

    return [ ... fc, ... this.exportFilterCriteria ];
  }

  private buildSearchFormCriteria(filterCriteria: Array<LMFilterFieldCriteria>) {
    if (filterCriteria) {
      const keywordFieldId = this.listSpec.busListSpec.keywordSearch ? this.listSpec.busListSpec.keywordSearch.fieldId : null;
      const searchFieldId = this.listSpec.busListSpec.searchFields ? this.listSpec.busListSpec.searchFields.fields[0].fieldId : null;
      const searchCriteria = filterCriteria.filter(criteria => criteria.fieldId !== keywordFieldId && criteria.fieldId !== searchFieldId );
      const exportCriteria = searchCriteria.filter(criteria => criteria.exportFilterCriteria);
      this.setExportedFilterCriteria(exportCriteria);
      if (!this.hasSearchForm) {
        this.filterBarFilterFieldCriteria = searchCriteria;
        this._columnfilterOperators = new Map<string, string>(filterCriteria?.map( filterOperator => [ filterOperator.id, filterOperator.operator ]));
      } else {
        this.searchFormFilterFieldCriteria = searchCriteria;
        this._filterOperators = new Map<string, string>(filterCriteria?.map( filterOperator => [ filterOperator.fieldId, filterOperator.operator ]));
      }
    }
  }

  private buildKeywordSearchFormCriteria(filterCriteria: Array<LMFilterFieldCriteria>) {
    if (filterCriteria) {
      const keywordFieldId = this.listSpec.busListSpec.keywordSearch.fieldId;
      const searchCriteria = filterCriteria.filter( criteria => criteria.fieldId === keywordFieldId);
      this.toolbarSearchFieldFilterCriteria = searchCriteria;
      this.listViewSearchFieldValue = searchCriteria[0] ? searchCriteria[0].value : '';
    }
  }

  private buildSearchFieldFormCriteria(filterCriteria: Array<LMFilterFieldCriteria>) {
    if (filterCriteria) {
      const searchFieldId = this.listSpec.busListSpec.searchFields.fields[0].fieldId;
      const searchCriteria = filterCriteria.filter( criteria => criteria.fieldId === searchFieldId);
      this.toolbarSearchFieldFilterCriteria = searchCriteria;
      this.listViewSearchFieldValue = searchCriteria[0] ? searchCriteria[0].value : '';
    }
  }

  /**
   * Method to initialize any variables after the listSpec has been loaded.
   */
  private initialize(): void {
    // todo ppatton fix duplicate calls to loadComponentState
    // dependent lists call loadComponentState in the `@Input() set fromDataView()`. I'd like
    // to just stop this one from being called when this.listSpec.dependentList but I'm concerned
    // about the code just after this where we use listState to build filter criteria. It seems
    // that when we loadListState in the fromDataView input we may have to include the handling
    // of the filter criteria as well?
    // Or is there a different kind of list state for filtering where the filter is preserved
    // no matter what the fromDataView is set to. Which would actually be a really cool feature.
    // - Phillip 4/11/18
    this.loadComponentState();

    if (this.listState && this.listState.chartName === 'NewAdhocReport') {
      // TODO: Reset the adhoc chart definition
      this.listState.displayAs = AppConstants.LISTVIEWTYPE_LIST;
      this.listState.chartName = undefined;
      this.listState.adhocReportMode = false;
      if (this.listState.columnarOptions) {
        delete this.listState.columnarOptions.useModelLpl;
      }
      // The search form may or may not exist.
      this.listState.filterCriteria = undefined;
    }
    if (this.listState && this.listState.filterCriteria) {
      // -------------------------------------------------------------------------
      // after loadComponentState set the filterCriteria right away from state
      // so that it has a chance to make it down to the list impls w/o running
      // a filterPage back end operation. The initialPage will take care of that.
      // -------------------------------------------------------------------------

      this.buildSearchFormCriteria(this.listState.filterCriteria);

      if (this.listSpec.busListSpec.keywordSearch) {
        this.buildKeywordSearchFormCriteria(this.listState.filterCriteria);
      }

      if (this.listSpec.busListSpec.searchFields) {
        this.buildSearchFieldFormCriteria(this.listState.filterCriteria);
      }

      this._filterCriteria = [ ... this.toolbarSearchFieldFilterCriteria, ... this.searchFormFilterFieldCriteria, ... this.filterBarFilterFieldCriteria ];
    } else {
      this._filterCriteria = null;
    }

    // toolbar already appends '_toolbar' to the so removing adding it here for v2.
    // need to keep it for v1 in order to not break current usage.
    this.screenId = this.listSpec.busListSpec.id;
    this.screenAutomationId = this.listSpec.busListSpec.automationId;

    this.contextMenuAttributes = [
      { name: 'data-automation-id', value: `lm-${this.screenAutomationId}-context-menu` }
    ];

    // -------------------------------------------------------------------------
    // Setup toolbar service observable to build and update the toolbar state.
    // When any call to the service modifies it's internal toolbar buttons
    // then this will get messaged and the lists toolbar will be updated
    // with the new buttons through an angular template sync pipe
    // display toolbar above the list if card view with list details
    // -------------------------------------------------------------------------
    this.lmListToolbarService.setSecondaryToolbarOptions([]);

    if (this.isRouterOutletRootComponent && !this.bannerInRoute && !this.isCardViewWithDetailSections && !this.isCubeView) {
      if (this.lmBannerHeaderCompRef?.instance) {
        this.lmBannerHeaderCompRef.instance.screenId = this.screenId;
        this.lmBannerHeaderCompRef.instance.screenAutomationId = this.screenAutomationId;

        if (!this.toolbarAboveList) {
          this.lmBannerHeaderCompRef.instance.toolbarMoreSettings = this.toolbarMoreMenuSettings;
          this.lmBannerHeaderCompRef.instance.toolbarButtons = this.lmListToolbarService.getToolbarButtonsObservable();
          if (this.lmContextService.isSmartPhone() && this.listSpec && this.listSpec.busListSpec && this.listSpec.busListSpec.toolbar && this.listSpec.busListSpec.toolbar.length > 0 && this.listSpec.busListSpec.calledOutActionsOnly)
            this.lmBannerHeaderCompRef.instance.showCalledOutMenuButton = true;
        } else {
          this.toolbarButtons = this.lmListToolbarService.getToolbarButtonsObservable();
          if (this.lmContextService.useListFormOverlay()) {
            this.overlayButtons = this.lmListToolbarService.getOverlayToolbarButtonsObservable();
          }

          if (this.lmContextService.isSmartPhone() && this.listSpec && this.listSpec.busListSpec && this.listSpec.busListSpec.toolbar && this.listSpec.busListSpec.toolbar.length > 0 && this.listSpec.busListSpec.calledOutActionsOnly)
            this.showCalledOutMenuButton = true;
        }
      }
    } else {
      this.toolbarButtons = this.lmListToolbarService.getToolbarButtonsObservable();
      if (this.lmContextService.useListFormOverlay()) {
        this.overlayButtons = this.lmListToolbarService.getOverlayToolbarButtonsObservable();
      }
      if (!this.isRouterOutletRootComponent) {
        if (this.lmContextService.isSmartPhone() && this.listSpec && this.listSpec.busListSpec && this.listSpec.busListSpec.toolbar && this.listSpec.busListSpec.toolbar.length > 0 && this.listSpec.busListSpec.calledOutActionsOnly)
          this.showCalledOutMenuButton = true;
      }

      if (this.isRouterOutletRootComponent && !this.bannerInRoute) {
        if (this.isCardViewWithDetailSections) {
          // -----------------------------------------------------------------------------------------------------
          // if this card list has detail sections then place the save and refresh buttons on the header toolbar
          // instead of in the card lists toolbar. This way it's more clear to the user that refresh and save are
          // meant for the entire screen.
          // -----------------------------------------------------------------------------------------------------
          this.lmListToolbarService.setSecondaryToolbarOptions([ AppConstants.STANDARD_SAVE, AppConstants.STANDARD_TOOLBAR_REFRESH ]);
          this.lmBannerHeaderCompRef.instance.toolbarButtons = this.lmListToolbarService.getSecondaryToolbarButtonsObservable();
          this.lmBannerHeaderCompRef.instance.screenId = this.screenId + '_secondary';
          this.lmBannerHeaderCompRef.instance.screenAutomationId = this.screenAutomationId + '-secondary';

        } else if (this.isCubeView) {
          // ------------------------------------------------------------------------
          // if cube view then clear the header toolbar because the toolbar will
          // be over each component in the cube view (list and chart).
          // ------------------------------------------------------------------------
          this.lmBannerHeaderCompRef.instance.toolbarButtons = observableOf([]);
          this.lmBannerHeaderCompRef.instance.screenId = this.screenId;
          this.lmBannerHeaderCompRef.instance.screenAutomationId = this.screenAutomationId;
        }
      }
    }

    this.listResource = new ListResource({ resourceId: this.listSpec.resourceId });

    this.listComponentId = this.listSpec.busListSpec.id + '_list';

    /**
     * If not set from outside the component as input (i.e. page pane interaction) then see if this
     * list has detail sectiosn. If so set the hasDependData to true so mixed selection mode will be
     * set.
     */
    if (!this.hasDependentData) {
      this.hasDependentData = this.hasDetailSections;
    }

    // since people can set csk.displayType, and have a listState already saved,
    // sometimes the responsive card view wouldn't be seen when being tested
    // on desktop. Just always set to listView if on mobile and resposive card view
    // defined
    if (this.isResponsiveCardView()) {
      this.listState.displayAs = AppConstants.LISTVIEWTYPE_LISTVIEW;
    }

    if (this.chartVisibilityFields !== undefined) {
      this.listState.chartVisibilityFields = this.chartVisibilityFields;
    }

    // If listState doesn't have a displayAs set, set it
    this.initializeListState();

     // when to show the search form
    //     1. When LPL is always display
    //     2. When LPL is display initial
    //     3. When LPL is not use as filter, show the search form if it has one
    //     4. If have search tags (so a search has previously been done), don't show unless always display
    if (this.listSpec.busListSpec.searchForm) {
      if (this.hasSearchTags) {
        this.showSearchForm = this.searchFormIsAlways;
      } else {
        this.showSearchForm = (this.searchFormIsAlways || this.searchFormIsInitial || this.searchFormIsImplied);
      }
    }

    this.buildLandmarkPanels();
  }

  private initializeListState() {
    if (!this.listState.displayAs) {
        if (this.isCubeView) {
            this.listState.displayAs = 'cubeView';
        } else if (this.lmListSpecUtilService.hasVisibleCharts(this.listSpec, this.listState)) {
            const chart = this.lmListSpecUtilService.getFirstVisibleChart(this.listSpec, this.listState);
            this.chartName = chart?.id;
            const chartType = chart?.chartType;
            if (chartType === 'calendar') {
                this.listState.displayAs = AppConstants.LISTVIEWTYPE_CALENDAR;
                this.listState.chartName = this.chartName;
            } else if (this.listResource.chartName) {
                this.listState.displayAs = AppConstants.LISTVIEWTYPE_CHART;
                this.chartName = this.listResource.chartName;
                this.listState.chartName = this.chartName;
            } else if (this.lmListSpecUtilService.isDefaultChartValid(this.listSpec, this.listState)) {
                this.listState.displayAs = AppConstants.LISTVIEWTYPE_CHART;
                this.chartName = this.listSpec.busListSpec.defaultChartName;
                this.listState.chartName = this.chartName;
            } else if (this.listSpec.busListSpec.showChartsOnly) {
                this.listState.displayAs = 'chart';
                this.listState.chartName = this.chartName;
            } else if (!(this.listSpec.busListSpec.defaultChartName) && this.listSpec.busListSpec.implementsGalleryView) {
                this.listState.displayAs = AppConstants.LISTVIEWTYPE_GALLERY;
            } else {
                this.listState.displayAs = AppConstants.LISTVIEWTYPE_LIST;
                this.chartName = undefined;
            }
        } else if (
            this.listSpec.busListSpec &&
            this.listSpec.busListSpec.implementsTreeView &&
            !this.listSpec.busListSpec.implementsOrgChartView
        ) {
            this.listState.displayAs = AppConstants.LISTVIEWTYPE_TREE;
        } else if (this.listSpec.busListSpec && this.listSpec.busListSpec.implementsRepresentativeImageView) {
            this.listState.displayAs = AppConstants.LISTVIEWTYPE_IMAGELIST;
        } else if (
            this.listSpec.busListSpec &&
            this.listSpec.busListSpec.implementsOrgChartView
        ) {
            this.listState.displayAs = AppConstants.LISTVIEWTYPE_HIERARCHY;
        } else if (this.displayAsListView()) {
            this.listState.displayAs = AppConstants.LISTVIEWTYPE_LISTVIEW;
        } else if (this.listSpec.listType === 'filterlist') {
            this.listState.displayAs = AppConstants.LISTVIEWTYPE_FILTERLIST;
        } else if (this.isGallery) {
            this.listState.displayAs = AppConstants.LISTVIEWTYPE_GALLERY;
        } else {
            this.listState.displayAs = AppConstants.LISTVIEWTYPE_LIST;
            this.chartName = undefined;
        }
    } else {
        // restore the chartName if loading from listState.
        if (this.lmListSpecUtilService.hasVisibleCharts(this.listSpec, this.listState)) {
            const chart = this.lmListSpecUtilService.getFirstVisibleChart(this.listSpec, this.listState);
            this.chartName = chart?.id;
            const chartType = chart?.chartType;
            if (this.listState.displayAs === 'chart' || this.listState.displayAs === 'calendar') {
                // Safety - if no chartName then try on of the other defaults
                if (this.chartValidation()) {
                    this.chartName = this.listState.chartName;
                }
            } else if (chartType === 'calendar') {
                this.listState.displayAs = AppConstants.LISTVIEWTYPE_CALENDAR;
                this.listState.chartName = this.chartName;
            } else if (this.listState.displayAs === 'list') {
                if (this.listSpec.busListSpec.showChartsOnly) {
                    this.listState.displayAs = 'chart';
                    this.listState.chartName = this.chartName;
                } else {
                    delete this.listState.chartName;
                    this.chartName = undefined;
                }
            }
        }
    }

      // LMWEB-87 - commenting this out as it's causing issues with non 'list's: for example: tree, imageList, listView, etc..
      //  one example of this is filtering on a tree list, opening a record, and then navigating back. In that case
      //  displayAs changes from 'tree' to 'list' and that causes a lm-list-grid.component to get created instead of a
      //  lm-list-tree.component. This causes issues with filtering in that case.
      // else {
      //   this.listState.displayAs = 'list';
      //   delete this.listState.chartName;
      // }

      // Check if a default display type has been saved to RoamingUIProfile
      const context = this.lmContextService.getContext();
      const webProfile = context.roamingUIProfile ? context.roamingUIProfile : {};

      if (this.listSpec.busListSpec.implementsGalleryView && webProfile?.galleryDefaultDisplayTypes?.length > 0) {
          webProfile.galleryDefaultDisplayTypes.forEach((galleryDefaultDisplayType) => {
              if (galleryDefaultDisplayType.listComponentId === this.listComponentId) {
                  this.listState.displayAs = galleryDefaultDisplayType.displayAs;
              }

              if (this.displayAsListView() && this.listState.displayAs !== AppConstants.LISTVIEWTYPE_GALLERY) {
                  this.listState.displayAs = AppConstants.LISTVIEWTYPE_LISTVIEW;
              }
          });
      }
  }

  private displayAsListView(): boolean {
    return (this.isCardViewWithDetailSections
      || this.isCardViewOnly
      || this.isResponsiveCardView())
      && this.listSpec.listType !== 'filterlist'
      && !this.isGallery;
  }

  private chartValidation(): boolean {
    if (!this.listState.chartName) {
      return false;
    }

    const chart: LMChartSpec = this.lmListSpecUtilService.getChart(this.listSpec, this.listState.chartName);
    if (chart === undefined) {
      return false;
    }

    return this.lmListSpecUtilService.isChartValid(this.listSpec, this.listState.chartName, this.listState);
  }

  private isResponsiveCardView() {
    return this.listSpec.busListSpec.responsiveCardView && this.lmContextService.isMobileDevice();
  }

  private buildToolbar() {
    if (this.listSpec.listType === 'filterlist' || this.isCubeView) {
      return;
    }

    this.lmLoggerService.trace([ this, this.instanceId, 'buildToolbar()' ]);

    // if (!this.isCardViewWithDetailSections) {
    //   // -----------------------------------------------------------------------
    //   // toolbarSearchField is not used when this list is a cardview list with
    //   // detail sections. Instead listViewSearchFieldValue is used.
    //   // -----------------------------------------------------------------------
    //   this.toolbarSearchField = this.lmListToolbarService.getToolbarSearchField(this.listSpec);
    // }
    // todo ppatton temporary until ed coyle fixes up the toolbar maxVisibleButtons property.
    // once that happens then uncomment out the code above.

    // Only build searchField if searchField doesn't already exist and not a cardview with a detail section
    if (this.bannerInRoute && !this.toolbarSearchField && ( this.listSpec && this.listSpec.busListSpec && this.listSpec.busListSpec.keywordSearch !== undefined )) {
      this.toolbarSearchField = Object.assign({}, this.toolbarSearchField, { value: '' });
    }
    if (!this.isCardViewWithDetailSections && !(this.toolbarSearchField) && ( this.listSpec && this.listSpec.busListSpec && this.listSpec.busListSpec.keywordSearch !== undefined )) {
      this.toolbarSearchField = this.lmListToolbarService.getToolbarSearchField(this.listSpec);
      // set the value to the saved filter criteria value
      if (this.listState.filterCriteria) {
        this.listState.filterCriteria.filter((fc: LMFilterFieldCriteria) => fc.fieldId === this.toolbarSearchField.fieldId)
          .map((fc: LMFilterFieldCriteria) => this.toolbarSearchField.value = fc.value);
      }
    }

    this.lmListToolbarService.buildToolbarButtons(this.listSpec, this.getStateInfo(), this.listUrlInfo);

    /*
     * If the toolbar is on the header for this component then use the
     * headerToolbarAdapter service to set the HeaderToolbarTarget to
     * 'this' and pass in the toolbarOptions explicitly.
     */
    if (this.isRouterOutletRootComponent && !this.bannerInRoute) {
      // Unsubscribe to all the toolbar eventemitters in banner header, since we were getting duplicate
      // subscriptions whenever the toolbar was rebuilt (in an onDataLoaded call)
      this.unsubscribeToBannerEvents();

      // map outputs from the toolbar in the banner header
      if (!this.lmContextService.inMingleOverlay()) {
        this.subscribeToBannerEvents();
      }
    }

    if (this.listSpec.busListSpec.implementsGalleryView) {
      this.lmRoamingUIProfileService.setGalleryDeafaultDisplayType({
        listComponentId: this.listComponentId,
        displayAs: this.listState.displayAs
      }).subscribe(
        (results: RoamingUIProfileResponse) => {
          if (results.status === RoamingUIProfileResult.COMPLETED) {
            this.lmLoggerService.log('RoamingUIProfile Updated');
          } else {
            this.lmLoggerService.log('Warning: RoamingUIProfile NOT Updated');
            console.log('Default list for implementsGalleryView not updated', results.status);
          }
        });
    }
  }

  private buildResultSetSize(dataViewSet: LMDataViewSet) {
    if (!dataViewSet) {
      return;
    }

    let recordCountFormatted: string;
    let pageCountFormatted: string;

    if (this.lmListSpecUtilService.isColumnarView(this.listSpec)
      &&  !!dataViewSet) {
      const recordCount = dataViewSet.columnarInfo.recordCountForHeader;
      const lastRefreshed = dataViewSet.columnarInfo.lastRefreshed;
      let pageCount = dataViewSet.pagingInfo.pageSize;
      const isReplicationInProgress = dataViewSet.columnarInfo.isReplicationInProgress;
      const isNotReplicated = dataViewSet.columnarInfo.isNotReplicated;
      const replicationName = dataViewSet.columnarInfo.replicationName;

      if (dataViewSet.columnarInfo.hasColumnarTotals) {
        pageCount = pageCount - 1;
      }

      if (pageCount > +recordCount) {
        pageCount = +recordCount;
      }

      recordCountFormatted = this.lmFormatUtilService.numericToDisplay(recordCount,
        { displayZero: true, displayThousandsCharacter: true });
      pageCountFormatted = this.lmFormatUtilService.numericToDisplay(pageCount,
        { displayZero: true, displayThousandsCharacter: true });

      let columnarResultText = '';
      if (pageCount > -1 && +recordCount > 0) {
        columnarResultText = recordCountFormatted = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('ResultsOf'),
          [ recordCountFormatted ]);
      }

      if (lastRefreshed) {
        if (columnarResultText !== '') {
          columnarResultText = columnarResultText + ' - ';
        }

        const formattedLastRefreshedTime: string = this.lmFormatUtilService.timestampToDisplay(lastRefreshed, null);
        columnarResultText = columnarResultText + this.lmFormatUtilService.formatMessage(Soho.Locale.translate('ColumnarLastRefresh'), [ formattedLastRefreshedTime ]);
        if (isReplicationInProgress)
          columnarResultText += ' - ' + Soho.Locale.translate('ReplicationInProgress');
      }

      if (!isReplicationInProgress && isNotReplicated) {
        this.columnarSubTitle = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('NoReplicationData'), [ replicationName ]);
      } else {
        this.columnarSubTitle = columnarResultText;
      }

    }
  }

  private buildMustacheText(dataViewSet: LMDataViewSet) {
    const mustacheDisplay: string[] = [];
    if (this.listSpec?.busListSpec?.personalization) {
      mustacheDisplay.push(Soho.Locale.translate('IsPersonalized'));
    }
    if (!dataViewSet) {
      // DataViewSet may not be available in some cases such as manual load.
      if (this.isListDisplayingArchiveDataLocally()) {
        mustacheDisplay.push(Soho.Locale.translate('DisplayingArchiveData'));
      }
    } else {
      if (this.isListDataFromArchive()) {
        mustacheDisplay.push(Soho.Locale.translate('DisplayingArchiveData'));
      }

      let resultSetText = '';
      if (this.listSpec.busListSpec.showResultSetSize) {
        this.showResultSet = true;

        const recordCount = dataViewSet.recordCount;

        const recordCountFormatted = this.lmFormatUtilService.numericToDisplay(recordCount,
          { displayZero: true, displayThousandsCharacter: true });


        if (recordCount >= 0) {
          if (dataViewSet.pagingInfo?.pageSize === 0 && dataViewSet.data?.length === 0 && !this.listSpec.busListSpec.searchForm.useSearchAsFilter) {
            // Pagesize 0 means we are on load and are not "use as filter" case. Don't show anything
            this.showResultSet = false;
            return;
          }
          if (this.listState?.filterCriteria?.length > 0) {
            resultSetText = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('ResultSetSizeResults'), [ recordCountFormatted ]);
          } else {
            resultSetText = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('ResultSetSizeRecordCount'), [ recordCountFormatted ]);
          }
        } else {
          resultSetText = Soho.Locale.translate('ResultSetSizeNotAvailable');
        }
        if (resultSetText.length > 0) {
          mustacheDisplay.push(resultSetText);
        }
      }
    }

    if (this.listSpec.busListSpec.userFolderAsOfDate || (this.lmContextService.getAsOfDate() && !this.listSpec.busClassSpec?.disableAsOfDate)) {
      // show as of date in mustache if it is an as of date report, global as of date AND disableasofdate = false
      const date = this.reportAsOfDate || this.lmContextService.getAsOfDate() || this.listSpec.busListSpec.userFolderAsOfDate;
      const formattedDate = this.lmFormatUtilService.yyyymmddToDisplay(date, { forceToPattern: Soho.Locale.calendar().dateFormat.long });

      if (formattedDate) {
        const userFolderAsOfDateFormatted = Soho.Locale.translate('CreateReportAsOfDateLabel') + ' ' + formattedDate;
        mustacheDisplay.push(userFolderAsOfDateFormatted);
        if(this.listSpec.userFolder) {
          if (this.isRouterOutletRootComponent && !this.lmContextService.inMingleOverlay()) {
            this.lmBannerHeaderCompRef.instance.isReportAsOfDate = true;
          } else {
            this.isReportAsOfDate = true;
          }

          if(this.reportAsOfDate) {
            if (this.isRouterOutletRootComponent && !this.lmContextService.inMingleOverlay()) {
              this.lmBannerHeaderCompRef.instance.isReportAsOfDateChanged = true;
            } else {
              this.isReportAsOfDateChanged = true;
            }
          } else {
            if (this.isRouterOutletRootComponent && !this.lmContextService.inMingleOverlay()) {
              this.lmBannerHeaderCompRef.instance.isReportAsOfDateChanged = false;
            } else {
              this.isReportAsOfDateChanged = false;
            }
          }
        }
      }
    }

    // if (this.adhocReportMode) {
    //   const adhocLabel = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('AdhocReport'), []);
    //   mustacheDisplay.push(adhocLabel);
    // }

    if (this.isRouterOutletRootComponent && !this.lmContextService.inMingleOverlay()) {
      this.lmBannerHeaderCompRef.instance.mustacheText = mustacheDisplay.join(' | ');
    } else {
      this.mustacheText = mustacheDisplay.join(' | ');
    }
  }

  private unsubscribeToBannerEvents() {
    if (this.toolbarButtonEventSubscription) {
      this.toolbarButtonEventSubscription.unsubscribe();
    }

    if (this.toolbarSearchEventSubscription) {
      this.toolbarSearchEventSubscription.unsubscribe();
    }

    if (this.toolbarSearchClearedEventSubscription) {
      this.toolbarSearchClearedEventSubscription.unsubscribe();
    }

    if (this.toolbarReportAsOfDateUpdateEventSubscription) {
      this.toolbarReportAsOfDateUpdateEventSubscription.unsubscribe();
    }
  }

  private subscribeToBannerEvents() {
    this.toolbarButtonEventSubscription = this.lmBannerHeaderCompRef.instance.toolbarButtonEvent.subscribe((toolbarButtonEvent: LMToolbarButtonEvent) => {
      this.onToolbarButtonEvent(toolbarButtonEvent);
    });

    // eslint-disable-next-line no-unused-vars
    this.toolbarSearchEventSubscription = this.lmBannerHeaderCompRef.instance.toolbarSearchEvent.subscribe((toolbarSearchEvent: LMFilterEvent) => {
      this.onToolbarSearchEvent();
    });

    // eslint-disable-next-line no-unused-vars
    this.toolbarSearchClearedEventSubscription = this.lmBannerHeaderCompRef.instance.toolbarSearchClearedEvent.subscribe((toolbarSearchEvent: LMFilterEvent) => {
      this.onToolbarSearchClearedEvent();
    });

    // @ts-ignore
    this.toolbarReportAsOfDateUpdateEventSubscription = this.lmBannerHeaderCompRef.instance.updateReportAsOfDateEvent.subscribe(() => {
      this.onUpdateReportAsOfDateEvent();
    });
  }

  private disallowActions(): boolean {
    // If Archive mode is set globally or locally, double check the DVS to make sure it is not overridden by a config param
    if (this.getDataViewSet()) {
      if (this.isListDataFromArchive()) {
        return true;
      }
    }
    // If data is not loaded, because of say, manual load, check the spec for archive mode
    if (this.getDataViewSet() === undefined && this.listSpec.busListSpec.userFolderArchiveReport !== undefined) {
      return true;
    }
    // Check if as of date is set on a report
    return (this.listSpec.busListSpec.userFolderAsOfDate !== undefined && this.listSpec.busListSpec.userFolderAsOfDate > 0);
  }

  private getStateInfo(): LMListStateInfo {
    const stateInfo: LMListStateInfo = {
      dataViewSet: this.getDataViewSet(),
      savedSearches: this.listContentComponent.savedSearches,
      selectedDataView: this.getDataView(this.listContentComponent.getSelectedRow()),
      selectedRows: this.selectedRows,
      isModified: this.isModified(),
      searchFormDisplayed: this.showSearchForm,
      isFilterBarOpened: !!this.listState.isFilterBarOpened,
      isUpdatable: this.lmListSpecUtilService.allowUpdate(this.listSpec) || this.lmListSpecUtilService.implementsInlineCreate(this.listSpec),
      disallowActions: this.disallowActions(),
      inlineCreateEnabled: this.isInlineCreateEnabled(),
      inlineCreateModified: this.isInlineCreateModified(),
      createWithinEnabled: this.isCreateWithinEnabled(),
      isRootComponent: this.isRouterOutletRootComponent,
      isListInPagePane: this.listInPagePaneTab,
      inAdhocReportMode: this.adhocReportMode,
      fromDataView: this.fromDataView,
      specialActions: this.specialActions,
      displayAs: this.listState.displayAs,
      disableAllActions: this.listSpec && this.listSpec.busListSpec && this.listSpec.busListSpec.disableAllActions,
      suppressStandardToolbar: this.listSpec && this.listSpec.busListSpec && this.listSpec.busListSpec.suppressStandardToolbar,
      calledOutActionsOnly: this.listSpec && this.listSpec.busListSpec && this.listSpec.busListSpec.calledOutActionsOnly,
      listIdPrefix: this.listSpec.busListSpec.id,
      isSelectListInSelectionMode: this.isSelectListInSelectionMode(),
      isSelectListInEditMode: this.inSelectListEditMode,
      chartName: this.listState.chartName,
      chartVisibilityFields: this.listState.chartVisibilityFields,
      hasFilterCriteria: !!this.listState.filterCriteria?.length,
      userListViewItem: this.listState.userListViewItem,
      disableSaveInUserListViewMenu: this.listContentComponent.disableSaveInUserListViewMenu(),
      galleryViewState: {
        isScrollStartPromise: this.listContentComponent.scrollIsStartPromise(),
        isScrollEndPromise: this.listContentComponent.scrollIsEndPromise()
      },
      isInOverlay: this.topLevelOverlayComponent,
      isArchiveData: this.listUrlInfo ? this.listUrlInfo.isArchiveData: undefined,
      hasTextSearchableFilterCriteria: this.hasTextSearchableFilterCriteria()
    };

    return stateInfo;
  }

  private hasTextSearchableFilterCriteria(): boolean {
    if (this.listSpec.busListSpec?.showInRelevanceOrder) {
      return this.listState.filterCriteria?.some(criteria => criteria?.textSearchable && criteria.value != '') || false;
    }
    return false;
  }

  private setScreenTitle(dataView?: LMDataView) {
    if (this.disabled) {
      // -------------------------------------------------------------------------
      // If disabled then check to see if title has variables. If not just show
      // the resourceValue for the title.
      // -------------------------------------------------------------------------
      // if there are variables and the list is disabled, blank out the title
      // todo ppatton maybe show XXX, 999, ###... for variables based on type
      //  {0} ({1,number,#} Results) XXXXX (#) Results
      // -------------------------------------------------------------------------
      const hasNoVariables = (!this.listSpec.busListSpec.title.variables || this.listSpec.busListSpec.title.variables.length === 0);
      this.listTitle = hasNoVariables ? this.listSpec.busListSpec.title.resourceValue : ' ' ;
    } else {
      this.listTitle = dataView
        ? this.lmFormatUtilService.formatMessageRule(this.listSpec.busListSpec.title, dataView, this.listSpec.busListSpec.fields)
        : this.listSpec.busListSpec.title.resourceValue;
      this.titleHasMessageRule = this.listSpec.busListSpec?.title?.variables?.length !== 0;
    }

    if (this.topLevelOverlayComponent) {
      this.overlayTitle = this.listTitle;
    }

    if (this.lmListSpecUtilService.isColumnarView(this.listSpec)) {
      if (this.listState.chartName) {
        const chart: LMChartSpec = this.lmListSpecUtilService.getChart(this.listSpec, this.listState.chartName);
        if (chart) {
          const chartSpec = JSON.parse(JSON.stringify(chart));
          this.listTitle = this.lmFormatUtilService.formatMessageRule(chartSpec.title, dataView);
        }
      }
    }

    // using override title only if list title is blank
    if (this.overrideListTitle && (this.listTitle.trim().length === 0 || this.previewMode)) {
      this.listTitle = this.overrideListTitle;
    }

    if (this.listSpec.busListSpec
      && this.listSpec.busListSpec.displayAmountRelative
      && this.listSpec.busListSpec.displayAmountRelative.displayShowInTitle) {
      if (this.listSpec.busListSpec.displayAmountRelative.displayInThousands) {
        this.listTitle += ` (${Soho.Locale.translate('DisplayInThousands')})`;
      } else if (this.listSpec.busListSpec.displayAmountRelative.displayInMillions) {
        this.listTitle += ` (${Soho.Locale.translate('DisplayInMillions')})`;
      }
    }

    if (this.isRouterOutletRootComponent) {
      if (this.reportListTitle) {
        const title = Soho.Locale.translate('ReportsListTitle');
        this.listTitle = this.lmFormatUtilService.formatMessage(title, this.reportListTitle);
      }
      if (this.isRouterOutletRootComponent && !this.bannerInRoute && !this.lmContextService.inMingleOverlay() && !this.topLevelOverlayComponent) {
        this.lmBannerHeaderCompRef.instance.toolbarSectionTitle = this.listTitle;
        if (this.lmContextService.showBreadcrumbs()) {
          this.addToBreadcrumbs();
        }
      }
    }

    this.updateDatagridAriaLabel(this.listTitle);

    this.titleChanged.emit(this.listTitle);
  }

  private addToBreadcrumbs() {
    if (!this.listState.breadcrumbsByCategory) {
      this.listState.breadcrumbsByCategory = {};
    }
    const category = this.getBreadcrumbCategory();
    let breadcrumbId = this.listState.breadcrumbsByCategory[category] ? this.listState.breadcrumbsByCategory[category] : undefined;
    breadcrumbId = this.lmBannerHeaderCompRef.updateBreadcrumbs({
      id: breadcrumbId,
      category: category,
      busClass: this.listSpec.busClassSpec.name,
      specName: this.listSpec.busListSpec.name,
      userFolder: this.listSpec.userFolder,
      type: 'LIST',
      title: this.listTitle,
      routeUrl: this.router.url
    });
    this.listState.breadcrumbsByCategory[category] = breadcrumbId;
    this.saveComponentState();
  }

  private getBreadcrumbCategory(): string {
    // if the request for he current component initiated in a custom homepage
    if (this.listUrlInfo?.urlParams && AppConstants.CUSTOMHP in this.listUrlInfo?.urlParams && this.listUrlInfo?.urlParams[AppConstants.CUSTOMHP] === 'true') {
      return this.lmBannerHeaderCompRef.getCurrentCategory();
    }
    // Portal drillback or favorite
    if (this.lmContextService.isPortalNavigation()) {
      return 'PORTAL';
    }
    let category = this.getBreadcrumbMenuResourceCategory();
    if (category?.trim().length > 0) {
      return category;
    }
    let addUrlParam = true;
    if (this.listUrlInfo?.urlParams && this.listUrlInfo.urlParams[ AppConstants.BREADCRUMB_URL_PARAM ]) {
      category = this.listUrlInfo.urlParams[ AppConstants.BREADCRUMB_URL_PARAM ];
      addUrlParam = false;
    }
    if (!category) {
      category = this.lmBannerHeaderCompRef.getCurrentCategory();
    }
    if (addUrlParam) {
      const url = this.router.url + ((this.router.url.indexOf('?') > -1) ? '&' : '?') + AppConstants.BREADCRUMB_URL_PARAM + '=' + category;
      this.location.replaceState(this.lmUrlUtilService.toRelativeUrl(url, true, true));
    }
    return category;
  }
  private getBreadcrumbMenuResourceCategory(): string {
    let category: string;
    if (this.listUrlInfo.sourceResource?.resourceType === 'menu') {
      category = this.lmContextService.getWebApp() + '.' + this.listUrlInfo.sourceResource.resourceId;
    }
    return category;
  }
  public get displayFullHeight(): boolean {
    return (this.listContentComponent && this.listContentComponent.isType('chart'));
  }

  public get displayListContainerFullHeight() {
    return (this.displayFullHeight && !this.hasStandardDetailSections);
  }

  public get listResource(): ListResource {
    return this.listResourceImpl;
  }

  public set listResource(listResource: ListResource) {
    this.listResourceImpl = listResource;
  }

  private fixedEncodeURIComponent(str: string) {  // tslint:disable-line
    return encodeURIComponent(str).replace(/[!'()*]/g, (c) =>
      '%' + c.charCodeAt(0).toString(16));
  }

  // ---------------------------------------------------
  // EVENT HANDLERS
  // ---------------------------------------------------
  public onTitleChanged(event: any) {
    const titleChanged = event.detail;
    this.lmBannerHeaderCompRef.instance.toolbarSectionTitle = titleChanged.newTitle;
  }

  public onPanelContentDisplayed(event: LMContentDisplayedEvent) {
    this.panelContentDisplayed.emit(event);

    this.dashboardVisibility = 'visible';
  }

  onDrillAroundEvent(event: LMDrillAroundEvent) {
    const dataView =  this.getDataView(this.getSelectedRow());
    const request: LMDrillAroundRequest = { dataView };

    this.lmDrillAroundService.fetchDrillAroundPoints(request).subscribe(response => {
      const detail: LMDrillAroundDetail = {
        type: 'record',
        dataView: dataView,
        drillActions: response?.drillPoints
      };
      event.chain.unshift(detail);
      this.drillAroundEvent.emit(event);
    });
  }

  public onContextMenuItemSelected(menuItemEvent: SohoPopupMenuEvent) {
    this.lmLoggerService.trace([ this, this.instanceId, 'onContextMenuItemSelected()', this.listComponentId, menuItemEvent ]);

    let actionReference: LMBusActionReference;
    let actionSpec: LMActionSpec;
    let hasActionForm: boolean;

    if (menuItemEvent.args[ 0 ].dataset.actionReference) {
      actionReference = JSON.parse(menuItemEvent.args[ 0 ].dataset.actionReference);
    }

    if (menuItemEvent.args[ 0 ].dataset.actionSpec) {
      actionSpec = JSON.parse(menuItemEvent.args[ 0 ].dataset.actionSpec);
    }

    if (menuItemEvent.args[ 0 ].dataset.hasActionForm) {
      hasActionForm = menuItemEvent.args[ 0 ].dataset.hasActionForm === 'true';
    }

    const selectedDataViews: Array<LMDataView> = this.selectedDataViews;
    if (actionReference.type === 'cube') {
      this.listContentComponent.onContextMenuItemSelected(actionReference, (selectedDataViews.length === 1) ? selectedDataViews[0] : undefined);
    } else {
      // LMWEB-25295 Addressing the gap in implementation. Related actions did not work in a context menu. 
      // runToolbarButtonAction does not have actionSpec and hasActionForm as parameters. It only runs drill around.
      // Mimicking how onToolbarButtonEvent handles relation actions. To run relatedAction, only one record is selected.
      if (selectedDataViews.length === 1) {
        this.runToolbarButtonAction(actionReference, selectedDataViews[0], actionSpec, hasActionForm);
      } else {
        this.runToolbarButtonAction(actionReference);
      }
    }
  }

  public onToolbarButtonEvent(toolbarButtonEvent: LMToolbarButtonEvent) {
    if (this.previewMode && AppConstants.STANDARD_TOOLBAR_SEARCH !== toolbarButtonEvent?.actionReference?.id) {
      this.lmGlobalUtilService.displayToastMessage(Soho.Locale.translate('PreviewOnly'), Soho.Locale.translate('PreviewOnlyMsg'), AppConstants.TRA_ACTION_COMPLETED);
      return;
    }

    this.lmLoggerService.trace([ this, this.instanceId, 'onToolbarButtonEvent()', this.listComponentId, toolbarButtonEvent ]);

    if (this.isGallery) {
      if (toolbarButtonEvent?.actionReference?.type === LMToolbarActionTypeEnum.GALLERY_NEXT) {
        this.listContentComponent.scrollNext();
        this.lmListToolbarService.updateGalleryToolbarState(this.getStateInfo());
        return;
      }

      if (toolbarButtonEvent?.actionReference?.type === LMToolbarActionTypeEnum.GALLERY_PREVIOUS) {
        this.listContentComponent.scrollPrevious();
        this.lmListToolbarService.updateGalleryToolbarState(this.getStateInfo());
        return;
      }

      if (toolbarButtonEvent?.actionReference?.type === LMToolbarActionTypeEnum.VIEW_ALL) {
        this.lmGlobalUtilService.navigateByUrl(this.getComponentInfo().listUrl);
        return;
      }
    }

    if (!toolbarButtonEvent.actionReference) {
      return;
    }

    if (toolbarButtonEvent.actionReference.isSpecialAction && !toolbarButtonEvent.actionReference.isMatrixFormNav) {
      const specialToolbarButtonEvent = {
        event: toolbarButtonEvent.event as JQuery.Event,
        actionReference: toolbarButtonEvent.actionReference,
        actionSpec: toolbarButtonEvent.actionSpec,
        list: this
      };
      this.specialActionToolbarButtonEvent.emit(specialToolbarButtonEvent);
      return;
    }
    // Open search in a Dialog
    if (this.displaySearchInDialog && toolbarButtonEvent.actionReference.id === AppConstants.STANDARD_TOOLBAR_SEARCH) {
      this.openSearchFormDialog();
    }

    if (toolbarButtonEvent.actionReference.type === 'cube'
      && toolbarButtonEvent.actionReference.id === AppConstants.CUBE_TOOLBAR_PERIODVIEWPERIODS + toolbarButtonEvent.actionReference.index) {
      this.switchCubeDetailSectionPeriodViewPeriod(toolbarButtonEvent.actionReference);
    }

    // An external-busclass called-out Create (action is BusinessClass.Create) is emitted as a
    // related action with a relBusClass and a CREATE actionSpec. Detect it from actionSpec.type
    // and dispatch it to its own handler, so it does not fall through to
    // runRelatedAction/runActionReference/runDrillAction, which would crash on a null relActionUrl.
    // See LMWEB-25175.
    if (
      toolbarButtonEvent.actionReference &&
      toolbarButtonEvent.actionReference.type === AppConstants.BUTTON_TYPE_RELATED &&
      this.lmListToolbarService.isRelatedBusClassCreate(toolbarButtonEvent.actionReference)
    ) {
      this.runRelatedBusClassCreateAction(toolbarButtonEvent.actionReference);
      return;
    }

    if (
      toolbarButtonEvent.actionReference &&
      toolbarButtonEvent.actionReference.type === AppConstants.BUTTON_TYPE_RELATED
      && toolbarButtonEvent.actionSpec
    ) {
      this.runRelatedAction(toolbarButtonEvent.actionReference, toolbarButtonEvent.actionSpec, toolbarButtonEvent.hasActionForm, toolbarButtonEvent.dataViewSet);
      return;
    } else if (toolbarButtonEvent.actionReference.type === AppConstants.BUTTON_TYPE_BUSTASK) {
      this.runBusinessTaskAction(toolbarButtonEvent.actionReference);
      return;
    }

    this.runActionReference(toolbarButtonEvent.actionReference, toolbarButtonEvent);
  }

  private switchCubeDetailSectionPeriodViewPeriod(actionReference: LMBusActionReference) {
    if (this.lmListSpecUtilService.isDetailSection(this.listSpec) && this.fromDataView?.cubeInfo) {
      // Reset the currentPageUrl to rebuild the dataurl with the new period view period index.
      this.fromDataView.cubeInfo.extraInfo = Object.assign({}, this.fromDataView.cubeInfo.extraInfo, { pvPeriodIdx: actionReference.index });
      this.lmUrlUtilService.copyCubeParamsForDetailSection(this.listUrlInfo, this.fromDataView);
      if (this.listState) {
        this.listState.currentPageUrl = undefined;
      }
      // Detail Section emits the event
      this.cubeDetailSectionPVPeriodEvent.emit(new LMCubeDetailSectionPVPeriodEvent(this, actionReference.index));
      // This is similar to runRefresh, but runRefresh does not return an observable. Update the toolbar after refresh, since
      // list data grid does not fire onDataLoaded event. Switching period view period requires the toolbar to be updated with
      // the new selection.
      const info: LMDialogInfo = { message: Soho.Locale.translate('UnsavedChangesContinuingMsg'), type: LMDialogType.NOYES };

      this.handleUnsavedChanges(info).subscribe(response => {
        if (response) {
          this.executeRefresh().subscribe(() => {
            this.lmListToolbarService.updateToolbar(this.listSpec, this.getStateInfo(), this.listUrlInfo);
          });
        }
      });
    }
  }

  public onCubeDetailSectionPVPeriodEvent(event: LMCubeDetailSectionPVPeriodEvent) {
    // Cube view handles the event to update its state.
    // Period view and period view period index are stored in the state.
    // It is required to restore state after the user returns back from cube drill.
    this.listState.cubeOverrides = Object.assign({}, this.listState.cubeOverrides, { periodViewPeriod: event.pvPeriodIdx });
  }

  public onSearchFormDisplayed() {
    this.listDisplayed.emit(this);
  }

  /**
   * Run an external-busclass called-out Create by navigating to a Create on relBusClass. The host
   * upper-level context keys ride along via the contextSessionKeys that buildActionRedirectUrl
   * merges into the redirect url. This intentionally shares nothing with runRelatedAction, which
   * resolves and runs an action against the current busclass. See LMWEB-25175.
   */
  private runRelatedBusClassCreateAction(actionReference: LMBusActionReference) {
    this.showBusyIndicator();

    const actionRedirectUrl = this.lmUrlUtilService.buildActionRedirectUrl(this.listUrlInfo, false, true);
    const createActionRedirectUrl = urltemplate.parse(actionRedirectUrl).expand({
      resourceId: actionReference.relBusClass,
      actionName: actionReference.name
    });

    this.lmNavigationService.runCreateActionNavigation(createActionRedirectUrl);
  }

  private runRelatedAction(
    actionReference: LMBusActionReference,
    actionSpec: LMActionSpec,
    hasActionForm: boolean,
    dataViewSet?: LMDataViewSet
  ) {
    this.showBusyIndicator();
    if (!actionSpec.hasParameters && actionSpec.type === AppConstants.ACTION_TYPE_CREATE) {
      // Exclude contextResourceId if coming from a related create action
      const actionRedirectUrl = this.lmUrlUtilService.buildActionRedirectUrl(this.listUrlInfo, false, true);
      const createActionRedirectUrlTemplate = urltemplate.parse(actionRedirectUrl);

      const createActionRedirectUrl = createActionRedirectUrlTemplate.expand({
        resourceId:        (dataViewSet) ? dataViewSet.header.resourceId : actionReference.resourceId,
        actionName:        actionSpec.name
      });

      this.lmNavigationService.runCreateActionNavigation(createActionRedirectUrl);
    } else {
      const parsedUrlTemplate = urltemplate.parse(this.listUrlInfo.relActionUrl);
      const relatedActionUrl = parsedUrlTemplate.expand({
        resourceId: (dataViewSet) ? dataViewSet.header.resourceId : actionReference.resourceId,
        actionName: actionSpec.name,
        formName:   actionSpec.formName ? actionSpec.formName : actionSpec.name
      });

      const resourceId: string = actionSpec.type === AppConstants.ACTION_TYPE_CREATE
        ? (dataViewSet) ? dataViewSet.header.resourceId : actionReference.resourceId : actionReference.resourceId;
      this.relatedActonSubscription = this.lmFormTransactionService.runRelatedAction(
        relatedActionUrl,
        actionSpec,
        { actionName: actionSpec.name, hasActionForm },
        resourceId
      ).subscribe((actionResult: LMActionFormDialogResult) => {
        if (actionResult.result === LMActionFormDialogResultCode.ACTION_FORM_DIALOG_SAVED) {
          const result = actionResult.transactionStateResult.getTransactionResult();
          // Success

          if (!result.actionSpec?.suppressCompletionMessage) {
            const title = result?.actionSpec?.label;
            const message = result.message;
            this.lmGlobalUtilService.displayToastMessage(title, message, AppConstants.TRA_ACTION_COMPLETED);
          }

          if (result?.isCompletionNavigation && result?.redirectUrl) {
            this.lmNavigationService.runNavigation(result.redirectUrl);
          }
        } else if (actionResult.result === LMActionFormDialogResultCode.ACTION_FORM_DIALOG_OPENERROR) {
          // TODO: needs better error handling
          this.hideBusyIndicator();
          this.lmErrorUtilService.handleError(actionResult.openError.message, actionResult.openError.details, actionResult.openError.status);
        }
      });
    }
  }

  private runRefreshColumnarData() {
    const url =  this.lmUrlUtilService.buildUrl(this.lmUrlUtilService.buildRefreshColumnarDataUrlOptions());
    const actionName = this.lmUrlUtilService.getUrlParam(url, 'action');

    this.lmSpecService.getFormSpec(url).subscribe((response: LMFormSpecResponse | LMSystemException) => {
          const formUrlInfo = (response as LMFormSpecResponse).formUrlInfo;
          const formSpec = (response as LMFormSpecResponse).formSpec;
          const actionSpec: LMActionSpec = formSpec.busClassSpec.actions ?
              formSpec.busClassSpec.actions.find(a => a.name === actionName) : formSpec.busClassSpec.actionSpec;

          const urlCompiledTemplate = urltemplate.parse(formUrlInfo.initialDataUrl);
          const url = urlCompiledTemplate.expand({ resourceId: formSpec.resourceId, actionName });

          this.lmListActionFormDialogService.getActionFormDialogDataView(url).subscribe((res: any) => {
            const formDataView: LMDataView = res;
            formDataView.fields['BusinessClassToRefresh'].value = this.listSpec.busClassSpec.name;
            formDataView.fields['ColumnarList'].value = this.listSpec.busListSpec.name;

            if (formDataView.status === AppConstants.STATUS_COMPLETED) {
              this.lmListActionFormDialogService.runActionFormDialog(formUrlInfo, formSpec, formDataView, actionSpec, null)
                  .subscribe((result: LMActionFormDialogResult) => {
                    if (result.result === LMActionFormDialogResultCode.ACTION_FORM_DIALOG_SAVED) {
                      const actionResult = result.transactionStateResult.completedTransactionList[0];

                      if (!actionResult.actionSpec?.suppressCompletionMessage) {
                        const title = '';
                        const message = actionResult.message;
                        this.lmGlobalUtilService.displayToastMessage(title, message, AppConstants.TRA_ACTION_COMPLETED);
                      }

                      if (result.transactionStateResult.isSuccess()) {
                        if (actionResult.isCompletionNavigation && actionResult.redirectUrl) {
                          this.lmNavigationService.runNavigation(actionResult.redirectUrl);
                        } else {
                          const request = new LMRefreshRequest();
                          request.originatingSourceId = this.listSpec.busListSpec.name;
                          this.executeRefresh(request).subscribe();
                        }
                      }
                    }
                  });
            } else {
              this.lmLoggerService.error(res);
              this.lmErrorUtilService.handleError(res.message, res.details, res.status, res.statusText);
            }
          });
        });
  }
  private runBusinessTaskAction(actionReference: LMBusActionReference) {
    const bustaskUrl = this.lmUrlUtilService.buildBusinessTaskUrl(this.listUrlInfo, actionReference);
    if (!actionReference.relBusTaskDlg && !actionReference.willRunAsynchronous) {
      this.lmGlobalUtilService.navigateByUrl(bustaskUrl);
      return;
    } else {
      this.lmSpecService.getFormSpecFromDialogActionUrl(bustaskUrl)
      .subscribe((formResponse: LMFormSpecResponse) => {
        const formUrlInfo = formResponse.formUrlInfo;
        const formSpec = formResponse.formSpec;
        // const keyedResource = new KeyedResource({ resourceId: actionReference.relBusTask + '.' + actionReference.relBusTaskForm});

        const actionSpec: LMActionSpec = formSpec.busClassSpec.actions.find(a => a.name === actionReference.name);
        const urlCompiledTemplate = urltemplate.parse(formUrlInfo.initialDataUrl);
        const url = urlCompiledTemplate.expand({ resourceId: actionReference.relBusTask, actionName: actionSpec.name });
        this.lmListActionFormDialogService.getActionFormDialogDataView(url).pipe(first()).subscribe((responseDV: any) => {

          const formDataView: LMDataView = responseDV;
          if (formDataView.status !== AppConstants.STATUS_COMPLETED) {
            this.lmLoggerService.error(responseDV);
            this.lmErrorUtilService.handleError(responseDV.message, responseDV.details, responseDV.status, responseDV.statusText);
            return;
          }
          if (actionReference.willRunAsynchronous && !actionReference.relBusTaskDlg) {
            // Need to open as a schedule view
            this.lmApplicationMenuTransactionService.runMenuAction(formUrlInfo.transactionUrl, formSpec.busClassSpec, actionSpec, formDataView, null).subscribe(
                transactionState => {

                  this.lmBusyIndicatorService.hideBusyIndicator();

                  if (transactionState.isError) {
                    this.lmErrorUtilService.handleError(
                        transactionState.response.message,
                        transactionState.response.details,
                        transactionState.response.status,
                        transactionState.response.message);
                  } else if (transactionState.isCanceled) {
                    // What to do?
                  } else {
                    const result: LMActionResult = transactionState.getTransactionResult();

                    if (transactionState.isSuccess()) {
                      if (!result.actionSpec?.suppressCompletionMessage) {
                        const title = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('ActionCompletedSuccessfully'), [ result.actionSpec.label ]);
                        const message = result.message || Soho.Locale.translate('ActionSuccessful');
                        this.lmGlobalUtilService.displayToastMessage(title, message, AppConstants.TRA_ACTION_COMPLETED);
                      }
                    } else {
                      this.lmErrorUtilService.handleError(
                          result.message,
                          result.details,
                          result.status,
                          result.message);
                    }

                    if (transactionState.actionFormDialogSaved && result.isCompletionNavigation && result.redirectUrl) {
                      this.lmNavigationService.runNavigation(result.redirectUrl);
                    }
                  }
                });
          } else {
            this.lmListActionFormDialogService.runActionFormDialog(formUrlInfo, formSpec, formDataView, actionSpec, null)
                .subscribe((actionFormDialogResult: LMActionFormDialogResult) => {
                  if (actionFormDialogResult.result === LMActionFormDialogResultCode.ACTION_FORM_DIALOG_SAVED) {
                    // The view exception and errors will be prompted before the dialog closes.
                    // So just print the success message here after the dialog closes
                    const transactionState: LMTransactionState = actionFormDialogResult.transactionStateResult;
                    const actionResult: LMActionResult = actionFormDialogResult.transactionStateResult.getTransactionResult();

                    if (!actionResult.actionSpec?.suppressCompletionMessage) {
                      this.lmGlobalUtilService.displayToastMessage(actionSpec.label, actionResult.message, AppConstants.TRA_ACTION_COMPLETED);
                    }

                    if (transactionState.isSuccess()) {
                      if (actionResult.isCompletionNavigation && actionResult.redirectUrl) {
                        this.lmNavigationService.runNavigation(actionResult.redirectUrl);
                      }
                    }
                  }
                });
          }
        });
      });
    }
  }

  private runActionReference(actionReference: LMBusActionReference, toolbarEvent?: LMToolbarButtonEvent): void {
    // DPB adding cardViewFormButtonSpec to handle busform button pushes from a list -- Phillip thinking of better architecture solution.

     if (this.lmContextService.isRouteReuse() && this.isRouteActive() === false) {
       return;
     }
    const selectedRow = actionReference.row !== undefined ? actionReference.row : this.getSelectedRow();
    let dataView: LMDataView = this.getDataView(selectedRow);
    // If toolbar is in a card view it can have links
    if (actionReference.type.toUpperCase() === AppConstants.NAVIGATION) {
      let xtrParameters;
      if (actionReference.isMatrixFormButton) {
        xtrParameters = this.buildMatrixColumnItems();
      }
      toolbarEvent?.event?.preventDefault();
      dataView = actionReference.isListUiLink && !actionReference.isMatrixFormButton ? this.getDataViewSet().header : dataView;

      // handle if card view and open in flyout panel
      let openInFlyout = false;
      let flyoutNavType = null;
      let flyoutOriginatingEvent: LMFormOverlayClickedEvent = null;
      const flyoutEnabled = this.lmContextService.allowFlyoutLinks();
      if (flyoutEnabled && actionReference.cardViewFormButtonSpec) {
        if (actionReference.cardViewFormButtonSpec.openInOverlay) {
          openInFlyout = true;
          flyoutNavType = actionReference.cardViewFormButtonSpec.navigationTargetComponent;
          flyoutOriginatingEvent = {
            event: toolbarEvent.event,
            row: selectedRow
          };
        }
      }
      this.runLinkNavigation(actionReference.navigation, dataView.resourceId, actionReference.showAsPdf, xtrParameters, null, openInFlyout, flyoutNavType, flyoutOriginatingEvent);
    } else if (actionReference.cardViewFormButtonSpec) {
      this.runCardViewButton(actionReference, dataView);
    } else  if (actionReference.type === AppConstants.BUTTON_TYPE_FORMINVOKE) {
      dataView = actionReference.isListFormInvoke ? this.getDataViewSet().header : dataView;
      this.runFormInvoke(actionReference.name, dataView);
    } else if (actionReference.type === AppConstants.BUTTON_TYPE_HTTPURL) {
      dataView = actionReference.isListUiLink ? this.getDataViewSet().header : dataView;
      this.runUILinkHttpUrl(actionReference, dataView);
    } else {
      this.runToolbarButtonAction(actionReference);
    }
  }

  private runFormReference(displayField: LMListDisplayField, dataView: LMDataView): void {
    const formIsUrlTemplate = urltemplate.parse(displayField.formIsUrl);
    const formIsUrl = formIsUrlTemplate.expand({
      resourceId: dataView.resourceId,
      sourceResourceType: 'list',
      sourceResourceId: this.listResource.resourceId
    });
    this.lmGlobalUtilService.navigateByUrl(formIsUrl);
  }

  private runListReference(relationResourceId: string, resourceId: string, dataView: LMDataView): void {
    const listResource = new ListResource({
      resourceId
    });

    const args = { resourceId: relationResourceId, dataView };
    const contextResource = new RelationResource(args, relationResourceId);

    const url = this.lmUrlUtilService.buildUrl({ resource: listResource, contextResource });
    this.lmGlobalUtilService.navigateByUrl(url);
  }

  private buildMatrixColumnItems(): string {
    // TODO 3.x is building a different resource for panel action
    // the action is marked differently 'isMatrixFormNav'
    const matrixColumns: string[] = this.buildMatrixColumnItemArray();
    return matrixColumns.join('&');
  }

  private buildMatrixColumnItemArray(): string[] {
    const matrixColumns: string[] = [];
    this.getSelectedRows().forEach(row => {
      const columnDataView = this.getDataView(row);
      // const listResource = { resourceId: columnDataView.resourceId, listName: this.listSpec.busListSpec.name };
      matrixColumns.push(this.lmUrlUtilService.objectToQueryString({ item: columnDataView.resourceId }));
    });
    return matrixColumns;
  }

  private runCardViewButton(actionReference: LMBusActionReference, dataView: LMDataView): void {
    const cardViewFormButtonSpec = actionReference.cardViewFormButtonSpec;
    if (cardViewFormButtonSpec.documentResourceId) {
      // TODO: LMWEB-19598 - Set context in the url for archive or asofdate
      this.openDocumentResource(cardViewFormButtonSpec.documentResourceId, dataView, cardViewFormButtonSpec.fieldId);
      // TODO: Sarah handle lazy url in cardview
      // } else if (actionReference.isLazyUrlRetrieval && cardViewFormButtonSpec.hasHttpUrl) {
    //   // this.lmFormRequestService.handleLazyUrl();
    } else if (cardViewFormButtonSpec.httpUrl) {
      const option: string = (cardViewFormButtonSpec.openExternal) ? 'external' : '';
      let url: string = this.lmFormatUtilService.formatMessageRule(cardViewFormButtonSpec.httpUrl, dataView);

      // When getting a http url/linkback that returns a navigation, we need to handle
      // by calling runNavigation instead of navigate. This will prevent the navigation
      // url from replacing the current lmclient route.
      // see LMCLIENT-35609.
      let resource: KeyedResource;
      try {
        //getRouteResource will throw an error if the url cannot be parsed.
        resource = this.lmUrlUtilService.getRouteResource(url);
      } catch (e)   {
        //noop
      }
      //copied from lm-navigation.component
      if (resource?.resourceType === 'navigation') {
        if (cardViewFormButtonSpec.openExternal !== undefined && !cardViewFormButtonSpec.openExternal) {
          url = this.setGlobalModeOnNavigation(url);
        } else {
          // TODO: LMWEB-19598 - Set context in the url for archive or asofdate
        }
        this.lmNavigationService.runNavigation(url, undefined, { openNewTab: cardViewFormButtonSpec.openExternal });
      } else {
        // TODO: LMWEB-19598 - Set context in the url for archive or asofdate
        this.lmGlobalUtilService.navigate(url, null, option);
      }
    } else if (cardViewFormButtonSpec.formInvokeName) {
      this.runFormInvoke(cardViewFormButtonSpec.formInvokeName, dataView);
    } else {
      this.runToolbarButtonAction(actionReference, dataView);
    }
  }

  public openSearchFormDialog() {
    // TODO: looks like this was being prototyped; needs to have completion on the button id; use LMDialogButtonKey and
    // Soho.Locale.translate()
    const buttons = [
      {
        // id: this.lmUniqueIdService.uniqueId([]),
        text: 'clear',
        click: (e, modal) => {
          modal.isCancelled = true;
          modal.close(true);
        }
      },
      {
        // id: this.lmUniqueIdService.uniqueId([]),
        text: 'Search',
        click: (e, modal) => {
          modal.close(true);
        }, validate : false, isDefault: true
      }
    ];

    this.dialog = this.lmModalWrapperService
      .modal(LMListSearchFormDialogComponent, { fullsize: 'responsive' })
      .title('Search Form')
      .buttons(buttons)
      .apply((dialogComponent) => {
        dialogComponent.formSpec = this.listSpec.busListSpec.searchForm.formSpec;
        dialogComponent.initDataView = this.searchFormDataView;
        dialogComponent.formOptions = this.searchFormOptions;
        dialogComponent.searchButtonClicked.subscribe((event: LMFilterEvent) => {
          this.onSearchClicked(event);
        });
      })
      .open();
  }

  private runToolbarButtonAction(actionReference: LMBusActionReference, selectedDataView?: LMDataView, actionSpec?: LMActionSpec, hasActionForm?: boolean): void {
    if (this.previewMode && AppConstants.STANDARD_TOOLBAR_SEARCH !== actionReference?.id) {
      this.lmGlobalUtilService.displayToastMessage("Preview Mode", "Actions are not available", AppConstants.TRA_ACTION_COMPLETED);
      return;
    }

    const row = actionReference.row > -1 ? actionReference.row : null;
    let dataView: LMDataView;
    switch (actionReference.type) {
      case AppConstants.BUTTON_TYPE_ACTION:
      case AppConstants.FORMBUTTON: // todo khollenbeck dboehm this doens't seem right, shouldn't this be BUTTON_TYPE_FORMBUTTON? - Phillip 3/4/2020
      case AppConstants.BUTTON_TYPE_FORMBUTTON:
        if (actionReference.isMatrixFormNav) {
          const urlParams: LMUrlParams = { ... this.lmContextService.getContext().contextSessionKeys } as LMUrlParams;
          urlParams.list = this.listResource.resourceId;
          let url = LMUrlUtilService.buildUrl2(this.listUrlInfo.basePath, 'form', actionReference.formResource, urlParams);
          // TODO buildUrl2 seems to be incorrectly appending multi items in the query string, need to check!!!
          url = this.lmUrlUtilService.appendToQueryString(url, this.buildMatrixColumnItems());
          this.lmGlobalUtilService.navigateByUrl(url);
        } else {
          let actionSpec: LMActionSpec = this.listSpec.busClassSpec.actions[actionReference.index];
          if (!actionSpec) {
            if (!actionReference.cardViewFormButtonSpec || !actionReference.cardViewFormButtonSpec.actionSpec) {
              this.lmLoggerService.log([ this, this.instanceId, 'runToolbarButtonAction() > invalid action index: ' + actionReference.index ]);
              return;
            }
            actionSpec = actionReference.cardViewFormButtonSpec.actionSpec;
          }
          if (actionReference.suppressFormOpen) {
            // bypass handle unsaved changes
            const rows: Array<number> = (row) || row === 0 ? [ row ] : this.listContentComponent.getSelectedRows();
            this._runInstanceAction(actionSpec, this.getDataViewSet(), rows);
          } else {
            this.runAction(actionSpec, row, actionReference.id);
          }
        }
        break;
      case AppConstants.BUTTON_TYPE_STANDARD_ACTION:
      case AppConstants.BUTTON_TYPE_HELPERLIST:
        this.runStandardAction(actionReference);
        break;
      case AppConstants.RESOURCETYPE_LIST:
        this.listState.displayAs = 'list';
        this.listState.chartName = undefined;
        // The first view option switches back to the plain list (no chart). Clear the
        // component-level chartName too, otherwise it stays pointing at the previously
        // selected chart and leaks into downstream consumers (e.g. CSV export chartNames).
        this.chartName = undefined;
        this.listState.displayAsChanged = true;
        break;
      case AppConstants.RESOURCETYPE_HIERARCHY:
        this.listState.displayAs = 'hierarchy';
        break;
      case AppConstants.RESOURCETYPE_TREE:
        this.listState.displayAs = 'tree';
        break;
      case AppConstants.RESOURCETYPE_GALLERY:
        this.listState.displayAs = 'gallery';
        break;
      case AppConstants.BUTTON_TYPE_CHART:
        this.listState.displayAs = 'chart';
        this.chartName = actionReference.id;
        this.listState.chartName = this.chartName;
        break;
      case AppConstants.BUTTON_TYPE_CALENDAR:
        this.listState.displayAs = 'calendar';
        this.chartName = actionReference.id;
        this.listState.chartName = this.chartName;
        break;
      case AppConstants.BUTTON_TYPE_RELATED:
        // GenAI Generated code - Start
        // A foreign-busclass called-out Create (action is BusinessClass.Create, LMWEB-25175) is a
        // related-type button but is a direct Create navigation, not a drill/related-records menu.
        // Route it to its own handler so it does not fall into runDrillAction (null relActionUrl).
        if (this.lmListToolbarService.isRelatedBusClassCreate(actionReference)) {
          this.runRelatedBusClassCreateAction(actionReference);
          break;
        }
        // GenAI Generated code - End
        // LMWEB-25295. Adding the missing handlers, AI Implementation is incomplete.
          if (actionSpec) {
            // It is not possible to infer the actionSpec based on actionReference.index since it is a related action
            // use the passed in actionSpec and hasActionForm.
            this.runRelatedAction(actionReference, actionSpec, hasActionForm);
            break;
          }
        this.runDrillAction(actionReference);
        break;
      case AppConstants.BUTTON_TYPE_BUSTASK:
        this.runBusinessTaskAction(actionReference);
        break;
      case AppConstants.BUTTON_TYPE_PROCESSFLOW:
        const rows: Array<number> = (row) || row === 0 ? [ row ] : this.listContentComponent.getSelectedRows();
        this.runProcessFlowAction(actionReference.id, rows);
        break;
      case AppConstants.BUTTON_TYPE_NAVIGATION:
        dataView = actionReference.isListUiLink ? this.getDataViewSet().header : selectedDataView;
        this.runLinkNavigation(actionReference.navigation, dataView.resourceId, false);
        break;
      case AppConstants.BUTTON_TYPE_HTTPURL:
        dataView = actionReference.isListUiLink ? this.getDataViewSet().header : selectedDataView;
        this.runUILinkHttpUrl(actionReference, dataView);
        break;
      case AppConstants.BUTTON_TYPE_PERSONALIZE:
        this.runListPersonalization(actionReference);
        break;
      case AppConstants.BUTTON_TYPE_FORMINVOKE:
        dataView = actionReference.isListFormInvoke ? this.getDataViewSet().header : selectedDataView;
        this.runFormInvoke(actionReference.name, dataView);
        break;
      case AppConstants.BUTTON_TYPE_SUBFORM:
        this.openSubFormFromToolbarDialog(actionReference, selectedDataView);
        break;
    }
  }

  private runDrillAction(actionReference: LMBusActionReference) {
    // let relActionUrl = this.lmUrlUtilService.buildRelatedMenuActionUrl(this.listUrlInfo, actionReference);
    // if (!this.lmContextService.useNewSpecUrls()) {
    //   this.lmUrlInfoBuilderService.compareSpecUrls(this.listUrlInfo, this.listSpec.busListSpec.name + '.relActionUrl', actionReference.relActionUrl, relActionUrl);
    //   relActionUrl = actionReference.relActionUrl;
    // }

    // -----------------------------------------------------------------
    // this drill point actionReference.relActionUrl is lazily retrieved
    // and not part of the form spec. No need to build the drill url on
    // the client side.
    // -----------------------------------------------------------------
    let relActionUrl = actionReference.relActionUrl;
    // Get drill spec fails without csk archive mode set
    // TODO: LMWEB-20292 - The new drill component requires this parameter as well
    if (this.listSpec.busListSpec.userFolderArchiveReport) {
      //redirectUrl in the response will have the csk set already.
      relActionUrl = this.lmUrlUtilService.updateUrlParams(relActionUrl, { 'csk.archivemode': true });
    } else if (this.listSpec.busListSpec.userFolderAsOfDate) {
      // TODO: LMWEB-20291 - Pass as of date in url?
    }
    this.showBusyIndicator();
    this.lmSpecService.getDrillSpec(relActionUrl).subscribe(response => {
      if (response.redirectUrl) {
        if (response.redirectUrl.indexOf('output=pdf') > -1) {
          this.hideBusyIndicator();
          this.lmGlobalUtilService.navigate(response.redirectUrl, null, 'external');

        } else if (response.redirectUrl.indexOf('/document/') > -1) {
          this.lmGlobalUtilService.navigate(response.redirectUrl);

        } else if (this.listSpec.listType === 'select') {
          // If a drill around is happening from a select list (for example, a
          // list on a lookup), open the link in a new tab and maintain the
          // state of the initial page. https://jira.lawson.com/browse/LMCLIENT-23976
          this.lmUrlUtilService.openExternalUrl(response.redirectUrl);
          // TODO: LMWEB-19598 - Can you flip to see archive data in select list
        } else {
          let url = response.redirectUrl;
          url = this.setGlobalModeOnNavigation(url);
          this.lmGlobalUtilService.navigateByUrl(url);
        }
      }
    },
    error => {
      this.hideBusyIndicator();
      this.lmErrorUtilService.handleUnexpectedError(error, this.modalPlaceholder);
    });
  }

  private runDrillAround(dataView: LMDataView) {
    const request: LMDrillAroundRequest = { dataView };

    // initiate drillAround navigation in drill window
    if (this.inDrillAroundMode()) {
      this.lmDrillAroundService.fetchDrillAroundPoints(request).subscribe(response => {
        if (response?.drillPoints?.length > 0) {
          const detail: LMDrillAroundDetail = {
            type: 'record',
            dataView: dataView,
            drillActions: response?.drillPoints
          };

          const event: LMDrillAroundEvent = {
            chain: [ detail ]
          };

          this.drillAroundEvent.emit(event);
        } else {
          // don't add to the drill tree if there is no drills!
          this.lmModalWrapperService
            .message()
            .message(Soho.Locale.translate('NoDrillsAvailable'))
            .title(AppConstants.DRILL_AROUND_LABEL)
            .showCloseBtn(true)
            .open();
        }
      });

      return;
    }

    // initiate the drillAround in application window
    if (this.lmContextService.drillAroundEnabled()) {
      this.lmDrillAroundService.fetchDrillAroundPoints(request).subscribe(response => {
        this.lmDrillAroundService.runDrillAround(response);
        // if (response?.drillPoints?.length > 0) {
        //   this.lmBusyIndicatorService.hideBusyIndicator();
        //   this.lmDrillAroundService.openDrillAroundDialog(response.dataView, response.drillPoints);
        // } else {
        //   // don't open the drill modal if there are no drills!
        //   this.sohoMessageService
        //     .message()
        //     .message(Soho.Locale.translate('NoDrillsAvailable'))
        //     .title(AppConstants.DRILL_AROUND_LABEL)
        //     .showCloseBtn(true)
        //     .open();
        // }
      });
    }
  }

  private runAction(actionSpec: LMActionSpec, row: number = null, actionReferenceId: string = null) {
    switch (actionSpec.type) {
      case AppConstants.ACTION_TYPE_CREATE:
      case AppConstants.ACTION_TYPE_IMPORT:
        if (this.listSpec.busListSpec?.attachmentListInfo?.hasAttachment
        && this.listSpec.busListSpec?.attachmentListInfo?.hasCreateAction
        && this.listSpec.busListSpec.attachmentListInfo?.actionSpec?.name === actionSpec.name) {
          this.attachmentListFileInput.element.nativeElement.click();
        } else {
          this.runCreateAction(actionSpec);
        }
        break;

      case AppConstants.ACTION_TYPE_CREATE_WITHIN:
        // this.runCreateWithinAction(action);
        break;

      case AppConstants.ACTION_TYPE_UPDATE:
      case AppConstants.ACTION_TYPE_AUDIT_OVERRIDE:
      case AppConstants.ACTION_TYPE_AUDIT_UPDATE:
      case AppConstants.ACTION_TYPE_CHANGE_EFFECTIVEDATE:
        row = (row !== null) ? row : this.selectedRow;
        const dataView: LMDataView = this.getDataView(row);
        this.runUpdateAction(actionSpec, dataView, actionReferenceId);
        break;

      case AppConstants.ACTION_TYPE_DELETE:
        const deleteRows: Array<number> = (row !== null) ? [ row ] : this.listContentComponent.getSelectedRows();
        const deleteDataViewList: Array<LMDataView> = [];
        deleteRows.forEach((r: number) => {
          deleteDataViewList.push(this.getDataView(r));
        });
        this.runDeleteAction(actionSpec, deleteDataViewList);
        break;

      case AppConstants.ACTION_TYPE_FUNCTION:
      case AppConstants.ACTION_TYPE_AUDIT_DELETE:
        const rows: Array<number> = (row) || row === 0 ? [ row ] : this.listContentComponent.getSelectedRows();
        this.runInstanceAction(actionSpec, this.getDataViewSet(), rows);
        break;

      case AppConstants.ACTION_TYPE_SET:
        this.runSetAction(actionSpec);
        break;

      case AppConstants.NOOP:
        // DO NOTHING..
        break;

      default:
        this.lmLoggerService.log([ this, this.instanceId, 'invalid action type: ' + actionSpec ]);

    }
  }

  private runSetAction(actionSpec: LMActionSpec) {
    const info: LMDialogInfo = { message:  Soho.Locale.translate('UnsavedChangesContinuingMsg'), type: LMDialogType.NOYES };
    this.handleUnsavedChanges(info).subscribe(response => {
      if (response) {
        // ActionControllerAction throws a run time exception if set action does not have parameters
        // There is no form to display in that case and action can be run directly or scheduled.
        if (actionSpec.hasParameters && this.lmContextService.isActionSpecRefactorOn()) {
          this._runSetAction2(actionSpec);
          return;
        }
        this._runSetAction(actionSpec);
      }
    });
  }

  private _runSetAction(actionSpec: LMActionSpec) {
    const listContext: LMListContext = {
      listUrlInfo: this.listUrlInfo,
      listSpec:    this.listSpec
    };

    this.showBusyIndicator();
    this.lmListTransactionService.runSetAction(listContext, actionSpec, undefined, this.getDataViewSet()).subscribe(
      (transactionState: LMTransactionState) => {
        this.hideBusyIndicator();
        if (transactionState.isError) {
          this.lmErrorUtilService.handleError(
            transactionState.response.message,
            transactionState.response.details,
            transactionState.response.status,
            transactionState.response.message);
        } else if (transactionState.isCanceled) {
          // TODO: noop
        } else if (transactionState.isFinished) {
          // Set Action will only have one transaction
          const result: LMActionResult = transactionState.completedTransactionList[ 0 ];
          const message = result.message || '';
          const title = (transactionState.isSuccess()) ? result.actionSpec.label : '';

          this.lmGlobalUtilService.displayToastMessage(title, message, AppConstants.TRA_ACTION_COMPLETED);

          // refreshing the list to be compatible with 3.5, even though an action may
          // have been scheduled or the action may take sevaral seconds to complete
          this.executeRefresh().subscribe();
        }
      });
  }

  private _runSetAction2(actionSpec: LMActionSpec) {
    const listContext: LMListContext = {
      listUrlInfo: this.listUrlInfo,
      listSpec:    this.listSpec
    };

    this.showBusyIndicator();
    const dataViewSet = this.getDataViewSet();
    const createActionUrl = this.lmListTransactionService.createActionRedirectUrl(listContext, actionSpec, dataViewSet, [ dataViewSet.header ]);

    this.lmSpecService.getRedirectUrl(createActionUrl, listContext.stepUpActionResult).subscribe(redirectResponse => {
      // getRedirectUrl response is not typed, unfortunately.

      // It will return redirect url from action controller. It may be mfaUrl, if action is privileged
      // Or if stepUpActionResult is available, it is action result after mfa code is verified. In that case, the redirect url in the stepUpActionResult is the form url to go to.
      if (((redirectResponse as LMSystemException) as LMSystemException)
        && ((redirectResponse as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR
          || (redirectResponse as LMSystemException).status === AppConstants.STATUS_UNAUTHORIZED)) {
        const rResponse = redirectResponse as LMSystemException;
        this.lmErrorUtilService.handleError(rResponse.message, rResponse.details, rResponse.status, rResponse.message);
        return;
      }

      const lmActionInfo: LMActionInfo = { actionName: actionSpec.name, hasActionForm: redirectResponse.hasActionForm, redirectUrl: redirectResponse.redirectUrl };
      this.lmListTransactionService.runSetAction(listContext, actionSpec, lmActionInfo, dataViewSet).subscribe(
        (transactionState: LMTransactionState) => {
          this.hideBusyIndicator();
          if (transactionState.isError) {
            this.lmErrorUtilService.handleError(
              transactionState.response.message,
              transactionState.response.details,
              transactionState.response.status,
              transactionState.response.message);
          } else if (transactionState.isCanceled) {
            // TODO: noop
          } else if (transactionState.isFinished) {
            // Set Action will only have one transaction
            const result: LMActionResult = transactionState.completedTransactionList[ 0 ];
            const message = result.message || '';
            const title = (transactionState.isSuccess()) ? result.actionSpec.label : '';

            this.lmGlobalUtilService.displayToastMessage(title, message, AppConstants.TRA_ACTION_COMPLETED);

            // refreshing the list to be compatible with 3.5, even though an action may
            // have been scheduled or the action may take sevaral seconds to complete
            this.executeRefresh().subscribe();
          }
        });
    });
  }
  // // this is just doing a save action, instead of shoosing the default action the action is specified in an action is or form button
  // private runSuppressOpenAction(actionSpec: LMActionSpec, dataViewSet: LMDataViewSet, dataViewList: LMDataView[], suppressRefresh?: boolean) {
  //   const listContext: LMListContext = {
  //     listUrlInfo: this.listUrlInfo,
  //     listSpec:    this.listSpec
  //   };
  //   if (this.stepUpActionResult) {
  //     listContext.stepUpActionResult = this.stepUpActionResult;
  //     this.stepUpActionResult = undefined;
  //   }
  //
  //   this.lmListTransactionService.runInstanceAction(listContext, actionSpec, dataViewSet, dataViewList).subscribe(
  //     (transactionState: LMTransactionState) => {
  //
  //       this.lmBusyIndicatorService.hideBusyIndicator();
  //
  //       if (transactionState.isError) {
  //         this.lmErrorUtilService.handleError(
  //           transactionState.response.message,
  //           transactionState.response.details,
  //           transactionState.response.status,
  //           transactionState.response.message);
  //       } else if (transactionState.isCanceled) {
  //
  //       } else if (transactionState.isFinished) {
  //         const resultList = transactionState.completedTransactionList;
  //         let successes = 0;
  //         let failures = 0;
  //         let cancelledRT = 0;
  //         const adjustment = this.isInlineCreateModeOn() ? 0 : 1;
  //         let title = '';
  //         let message = '';
  //         const updateMap: Map<number, LMActionResult> = new Map<number, LMActionResult>();
  //         const transactionSize = resultList.length;
  //
  //         for (let i = 0; i < transactionSize; i++) {
  //           const result: LMActionResult = resultList[ i ];
  //           let dataViewId = result.dataView.id;
  //           if (dataViewId === undefined && result.dataView.resourceId) {
  //               // find the dataView using the resourceId
  //             const dataView = dataViewList.find( dv => dv.resourceId === result.dataView.resourceId);
  //             dataViewId = dataView?.id;
  //           }
  //           const key = (dataViewId === -1) ? 0 : dataViewId - adjustment;
  //           message = result.message || '';
  //           updateMap.set(key, result);
  //
  //             // todo odd use of terniary operation, consider refactoring
  //             // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  //           AppConstants.STATUS_COMPLETED === result.status ? successes++ :
  //             (AppConstants.CONFIRMATION_REQUIRED === result.status) ? cancelledRT++ : failures++;
  //         }
  //
  //           // todo this code is duplicated in some of the transaction functions. any way to consolidate any of this?
  //         let toastId = '';
  //         if (transactionSize !== 1) {
  //           if (successes === transactionSize) {
  //               // all transactions succeeded
  //             title = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('TransactionCompleteSuccess'), successes);
  //             message = transactionState.allRequestsSuccessfulForSameReason() ? message : '';
  //             toastId = AppConstants.TRA_ACTION_COMPLETED;
  //           } else if (failures === transactionSize) {
  //               // all transactions failed
  //             title = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('TransactionCompleteFailure'), failures);
  //             message = transactionState.allRequestsFailedForSameReason() ? message : '';
  //             toastId = AppConstants.TRA_ACTION_FAILED;
  //           } else if (cancelledRT === transactionSize) {
  //               // all transactions runtime confirmation cancelled
  //             message = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('TransactionCompleteCancelledRT'), cancelledRT);
  //             toastId = AppConstants.TRA_ACTION_CANCELED;
  //           } else {
  //               // some transactions succeeded and some failed
  //             message = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('TransactionCompleteResults'), [ successes, failures, cancelledRT ]);
  //             toastId = AppConstants.TRA_ACTION_PARTIALLY_COMPLETED;
  //           }
  //         } else {
  //           toastId = AppConstants.TRA_ACTION_COMPLETED;
  //         }
  //
  //         if (cancelledRT === 0 || transactionSize !== 1) {
  //           if (!resultList[0].actionSpec?.suppressCompletionMessage) {
  //             this.lmGlobalUtilService.displayToastMessage(title, message, toastId);
  //           }
  //         }
  //
  //         if (transactionSize === 1 && failures === 0 && cancelledRT === 0
  //               && resultList[0].isCompletionNavigation && resultList[0].redirectUrl) {
  //           const formPagingInfo: LMPagingInfo = this.buildFormPagingInfo(this.getDataViewSet(), resultList[0].dataView);
  //           this.lmNavigationService.runNavigation(resultList[0].redirectUrl, formPagingInfo);
  //           return;
  //         } else if (failures === 0 && cancelledRT === 0) {
  //             // need to refresh and wait!, Issue when a composite form is single panel and
  //             // the single panel switches to another panel. https://jira.lawson.com/browse/LMCLIENT-27540
  //             // The component listState is corrupted because of a race condition.
  //           if (!suppressRefresh) {
  //             this.executeRefresh().subscribe();
  //           } else {
  //             updateMap.forEach((result: LMActionResult, key: number) => {
  //               // when running an actionForm, the dataView.id (key) is lost if the transaction is successful.
  //               // Should be ok for an instance action because the row should be dirty
  //               if (!isNaN(key)) {
  //                 this.listContentComponent.updateDataViewTransaction(key, result.status, result.message);
  //               }
  //             });
  //           }
  //           const listTransactionEvent: LMListTransactionEvent = new LMListTransactionEvent(this, resultList);
  //           this.listTransactionEvent.emit(listTransactionEvent);
  //         } else {
  //           updateMap.forEach((result: LMActionResult, key: number) => {
  //               // when running an actionForm, the dataView.id (key) is lost if the transaction is successful.
  //               // Should be ok for an instance action because the row should be dirty
  //             if (!isNaN(key)) {
  //               this.listContentComponent.updateDataViewTransaction(key, result.status, result.message);
  //             }
  //           });
  //
  //           this.lmListToolbarService.updateToolbar(this.listSpec, this.getStateInfo(), this.listUrlInfo);
  //         }
  //       }
  //     });
  // }

  public runInstanceAction(actionSpec: LMActionSpec,
    dataViewSet: LMDataViewSet,
    rows: Array<number>,
    observer?: Observer<boolean>,
    contextDataView?: LMDataView,
    actionFieldMap?: LMActionFieldMap,
    dragdropTargetView?: LMDataView) {

    const info: LMDialogInfo = { message:  Soho.Locale.translate('UnsavedChangesContinuingMsg'), type: LMDialogType.NOYES };
    this.handleUnsavedChanges(info).subscribe(response => {
      if (response) {
        this._runInstanceAction(actionSpec, dataViewSet, rows, observer, contextDataView, actionFieldMap, dragdropTargetView);
      }
    });
  }

  public runLPLEditorDialog() {
    // Need verbose comments since there are so many things happening here
    type ListLPLResult = { lpl: string, title: string };
    let dialog: LMListPersonalizationEditLPLDialogResponse = null;

    // 1. Fetch User List LPL
    this.lmConfigurationService
      .getUserListLPL<ListLPLResult>(this.listUrlInfo.reportPersonalizationUrl, this.listSpec.userFolder)
      .pipe(
        takeUntil(this.destroyer$), // do this, this is the cleanest way to cleanup if there are multiple subs in the component
        switchMap((result: ListLPLResult) => {
          // 2. Process user list lpl result and Open LPL Editor
          if (result) {
            const title = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('ListPersonalizationEditLPLDialogTitle'), result.title ?? this.listUrlInfo.resource.uiResourceName);
            const validationOptions: LMEditorValidationOptions = {
              businessClass: 'ConfigEntity', // need ConfigEntity for LPL Editor inline validation to work
              independent: true,
              specName: this.listUrlInfo.resource.busClassName,
              type: "list"
            };
            return this.lmReportPersonalizationDialogService.openLPLEditorDialog(title, result.lpl, validationOptions);
          }
          return of(EMPTY);
        }),
        switchMap((dialogResponse: LMListPersonalizationEditLPLDialogResponse) => {
          dialog = dialogResponse;
          // 3 Process edit LPL dialog response
          if (dialog.status === LMDialogButtonKey.SAVE) {
            if (dialog.hasChanges) {
              // 3.1.a If LPL has changes, validate and save
              return this.lmConfigurationService.saveUserListLPL(this.listUrlInfo.reportPersonalizationUrl, dialog.lpl, this.listSpec.userFolder);

            } else {
              // 3.1.b If no changes, just close the modal to save resources
              // (better yet disable save but need hack since we are accessing the conponent directly)
              dialog.closeLPLEditorDialog();
            }
          } else if (dialog.status === LMDialogButtonKey.CANCEL) {
            // 3.2.a If cancel and LPL has changes, show warning
            if (dialog.hasChanges) {
              const info: LMDialogInfo = { message: Soho.Locale.translate('DiscardUnsavedChangesMsg')  };
              this.showUnsavedChanges(info)
                .pipe(takeUntil(this.destroyer$))
                .subscribe((response: UnsavedChangesResponse) => {
                  if (response === LMDialogButtonKey.YES) {
                    dialog.closeLPLEditorDialog();
                  }
              });
            } else {
              // 3.2.b If cancel and no LPL changes, just close the modal
              dialog.closeLPLEditorDialog();
            }
          }
          return of(EMPTY);
        }),
      )
      .subscribe((saveUserListLPLResponse: LMLplValidationResponse) => {
        // 4 Process save user list reponse
          if (saveUserListLPLResponse.lplStatus === 'LPL_VALID') {
            // 4.1.a If valid, close modal and refresh list
            dialog.closeLPLEditorDialog();
            this.lmGlobalUtilService.displayToastMessage("", Soho.Locale.translate('ListPersonalizationIsCreatedMessage'));
            this.router.navigateByUrl(this.router.url);
          } else if (saveUserListLPLResponse.lplStatus === 'LPL_INVALID') {
            // 4.1.b If invalid, show validation error
            const buttons = [
              {
                id: this.lmUniqueIdService.uniqueId([ 'ValidationError', LMDialogButtonKey.OK ]),
                text: Soho.Locale.translate(LMDialogButtonKey.OK),
                isDefault: true,
                click: (e, modal) => {
                  modal.close(true);
                }
              }
            ];
            this.lmModalWrapperService
              .message()
              .message(`<span> ${saveUserListLPLResponse.message} </span>`)
              .title(Soho.Locale.translate('ValidationError'))
              .buttons(buttons)
              .open();
          }
      });
  }

  private _runInstanceAction(actionSpec: LMActionSpec,
    dataViewSet: LMDataViewSet,
    rows: Array<number>,
    observer?: Observer<boolean>,
    contextDataView?: LMDataView,
    actionFieldMap?: LMActionFieldMap,
    dragdropTargetView?: LMDataView) {

    // LMWEB-23042 - When attempting to run a herlper list action with no rows selected.
    if (rows.length === 0) {
      return;
    }

    const listContext: LMListContext = {
      listUrlInfo: this.listUrlInfo,
      listSpec:    this.listSpec
    };
    if (this.stepUpActionResult) {
      listContext.stepUpActionResult = this.stepUpActionResult;
      this.stepUpActionResult = undefined;
    }

    // rows is passed in because checkControl event on a row also calls this method
    const dataViewList: LMDataView[] = [];
    rows.forEach((row: number) => {
      const dataView: LMListDataView | LMListTreeMoreLink = this.getDataView(row);
      // LMCLIENT-28640 - Let's not perform actions on "more" link or totals dvs.
      if (!(dataView.isTreeMoreLink ||
        dataView.isSubtotalView ||
        dataView.isSubtotalSummaryView)) {
        dataViewList.push(dataView);
      }
    });

    if (this.lmContextService.isActionSpecRefactorOn()) {
      this._runInstanceAction2(listContext, actionSpec, dataViewSet, rows, dataViewList, observer, contextDataView, actionFieldMap, dragdropTargetView);
      return;
    }
    this.showBusyIndicator();

    this.lmListTransactionService.runInstanceAction(listContext, actionSpec, undefined, dataViewSet, dataViewList, contextDataView, actionFieldMap, dragdropTargetView).subscribe(
      (transactionState: LMTransactionState) => {

        this.hideBusyIndicator();
        this.handleInstanceActionResults(dataViewList, transactionState);
        if (observer) {
          observer.next(transactionState.isSuccess());
          observer.complete();
        }
      });
  }

  private handleInstanceActionResults(dataViewList: LMDataView[], transactionState: LMTransactionState) {
    if (transactionState.isError) {
      this.lmErrorUtilService.handleError(
        transactionState.response.message,
        transactionState.response.details,
        transactionState.response.status,
        transactionState.response.message);
    } else if (transactionState.isCanceled) {
      // TODO: noop
    } else if (transactionState.isFinished) {
      // helper lists need to inform the target list that the transaction
      if (this.helperListOptions && this.helperListOptions.helperListDialog$) {
        this.helperListOptions.helperListDialog$.next({
          result: LMHelperListDialogResultCode.HELPER_LIST_ACTION_FORM_DIALOG_SAVED
        });
      }
      if (transactionState.redirectUrlToGuestReg) {
        // Go to guest action is form
        this.lmGlobalUtilService.navigateByUrl(transactionState.redirectUrlToGuestReg);
        return;
      }
      const resultList = transactionState.completedTransactionList;
      let successes = 0;
      let failures = 0;
      let cancelledRT = 0;
      const adjustment = this.isInlineCreateModeOn() ? 0 : 1;
      let title = '';
      let message = '';
      const updateMap: Map<number, LMActionResult> = new Map<number, LMActionResult>();
      const transactionSize = resultList.length;

      for (let i = 0; i < transactionSize; i++) {
        const result: LMActionResult = resultList[ i ];
        let dataViewId = result.dataView.id;
        if (dataViewId === undefined && result.dataView.resourceId) {
          // find the dataView using the resourceId
          const dataView = dataViewList.find( dv => dv.resourceId === result.dataView.resourceId);
          dataViewId = dataView?.id;
        }
        const key = (dataViewId === -1) ? 0 : dataViewId - adjustment;
        message = result.message || '';
        updateMap.set(key, result);

            // todo odd use of terniary operation, consider refactoring
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            AppConstants.STATUS_COMPLETED === result.status ? successes++ :
              (AppConstants.CONFIRMATION_REQUIRED === result.status) ? cancelledRT++ : failures++;
          }

      // todo this code is duplicated in some of the transaction functions. any way to consolidate any of this?
      let toastId = '';
      if (transactionSize !== 1) {
        if (successes === transactionSize) {
          // all transactions succeeded
          title = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('TransactionCompleteSuccess'), successes);
          message = transactionState.allRequestsSuccessfulForSameReason() ? message : '';
          toastId = AppConstants.TRA_ACTION_COMPLETED;
        } else if (failures === transactionSize) {
          // all transactions failed
          title = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('TransactionCompleteFailure'), failures);
          message = transactionState.allRequestsFailedForSameReason() ? message : '';
          toastId = AppConstants.TRA_ACTION_FAILED;
        } else if (cancelledRT === transactionSize) {
          // all transactions runtime confirmation cancelled
          message = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('TransactionCompleteCancelledRT'), cancelledRT);
          toastId = AppConstants.TRA_ACTION_CANCELED;
        } else {
          // some transactions succeeded and some failed
          message = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('TransactionCompleteResults'), [ successes, failures, cancelledRT ]);
          toastId = AppConstants.TRA_ACTION_PARTIALLY_COMPLETED;
        }
      } else {
        toastId = AppConstants.TRA_ACTION_COMPLETED;
      }

      if (cancelledRT === 0 || transactionSize !== 1) {
        if (!resultList[0].actionSpec?.suppressCompletionMessage) {
          this.lmGlobalUtilService.displayToastMessage(title, message, toastId);
        }
      }

      // single transaction that was completed successfully with an oncomplete navigation!
      if (transactionSize === 1 && failures === 0 && cancelledRT === 0
        && resultList[0].isCompletionNavigation && resultList[0].redirectUrl) {
        const formPagingInfo: LMPagingInfo = this.buildFormPagingInfo(this.getDataViewSet(), resultList[0].dataView);
        this.lmNavigationService.runNavigation(resultList[0].redirectUrl, formPagingInfo);
        return;
      }

      if (failures === 0 && cancelledRT === 0) {                            // not errors or cancels!!!
        // need to refresh and wait!, Issue when a composite form is single panel and
        // the single panel switches to another panel. https://jira.lawson.com/browse/LMCLIENT-27540
        // The component listState is corrupted because of a race condition.
        this.executeRefresh().subscribe();
        const listTransactionEvent: LMListTransactionEvent = new LMListTransactionEvent(this, resultList);
        this.listTransactionEvent.emit(listTransactionEvent);
      } else if (failures > 0){                                           // at least one failed transcation!!!
        updateMap.forEach((result: LMActionResult, key: number) => {
          // when running an actionForm, the dataView.id (key) is lost if the transaction is successful.
          // Should be ok for an instance action because the row should be dirty
          if (!isNaN(key)) {
            this.listContentComponent.updateDataViewTransaction(key, result.status, result.message);
          }
        });

        this.lmListToolbarService.updateToolbar(this.listSpec, this.getStateInfo(), this.listUrlInfo);
      }
    }
  }

  private _runInstanceAction2(listContext: LMListContext,
    actionSpec: LMActionSpec,
    dataViewSet: LMDataViewSet,
    rows: Array<number>,
    dataViewList: LMDataView[],
    observer?: Observer<boolean>,
    contextDataView?: LMDataView,
    actionFieldMap?: LMActionFieldMap,
    dragdropTargetView?: LMDataView) {
    // To support csk.actionrefactor toggle, use the local variable to build action redirect url.
    // listTransactionService.runInstanceAction and runDeleteAction converts the dataview to target for template list
    const dataViewListForActionRedirectUrl = (this.listSpec.isTemplateList) ? dataViewList.map(dataView => dataView.dataView) : dataViewList;

    const instanceActionUrl = this.lmListTransactionService.createActionRedirectUrl(listContext, actionSpec, dataViewSet, dataViewListForActionRedirectUrl);
    this.lmSpecService.getRedirectUrl(instanceActionUrl, listContext.stepUpActionResult).subscribe(redirectResponse => {
      // getRedirectUrl response is not typed, unfortunately.

      // It will return redirect url from action controller. It may be mfaUrl, if action is privileged
      // Or if stepUpActionResult is available, it is action result after mfa code is verified. In that case, the redirect url in the stepUpActionResult is the form url to go to.
      if (((redirectResponse as LMSystemException) as LMSystemException)
        && ((redirectResponse as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR
          || (redirectResponse as LMSystemException).status === AppConstants.STATUS_UNAUTHORIZED)) {
        const rResponse = redirectResponse as LMSystemException;
        this.lmErrorUtilService.handleError(rResponse.message, rResponse.details, rResponse.status, rResponse.message);
        return;
      }

      if(redirectResponse.mfaUrl) {
        this.lmGlobalUtilService.navigate(redirectResponse.mfaUrl);
        // window.location.href = redirectResponse.mfaUrl;
        return;
      }

      this.showBusyIndicator();
      const lmActionInfo: LMActionInfo = { actionName: actionSpec.name, hasActionForm: redirectResponse.hasActionForm, redirectUrl: redirectResponse.redirectUrl };

      this.lmListTransactionService.runInstanceAction(listContext, actionSpec, lmActionInfo, dataViewSet, dataViewList, contextDataView, actionFieldMap, dragdropTargetView).subscribe(
        (transactionState: LMTransactionState) => {

          this.hideBusyIndicator();
          this.handleInstanceActionResults(dataViewList, transactionState);
          if (observer) {
            observer.next(transactionState.isSuccess());
            observer.complete();
          }
        });
    });
  }

  private runStandardAction(actionReference: LMBusActionReference): void {
    switch (actionReference.id) {
      case AppConstants.STANDARD_TOOLBAR_EDITMODE:
        this.turnOnSelectEditMode(!this.inSelectListEditMode);
        break;

      case AppConstants.STANDARD_TOOLBAR_INLINECREATE:
        this.turnOnInlineCreateMode(true);
        break;

      case AppConstants.STANDARD_TOOLBAR_CREATEWITHIN:
      case AppConstants.STANDARD_TOOLBAR_CREATE:
        const createActionSpec: LMActionSpec = this.lmActionService.getDefaultCreateAction(this.listSpec.busClassSpec.actions, this.getDataViewSet().header.actionIndexes);
        if (this.listSpec.busListSpec?.attachmentListInfo?.hasAttachment
        && this.listSpec.busListSpec?.attachmentListInfo?.hasCreateAction
        && this.listSpec.busListSpec.attachmentListInfo?.actionSpec?.name === createActionSpec.name) {
          this.attachmentListFileInput.element.nativeElement.click();
        } else {
          this.runCreateAction(createActionSpec, AppConstants.STANDARD_TOOLBAR_CREATEWITHIN === actionReference.id);
        }
        break;

      case AppConstants.STANDARD_TOOLBAR_OPEN:
        const openDataView: LMListDataView = this.getDataView(this.selectedRow);
        this.runOpenAction(openDataView);
        break;

      case AppConstants.STANDARD_TOOLBAR_UPDATE:
        const updateDataView: LMDataView = this.getDataView(this.selectedRow);
        const updateActionSpec: LMActionSpec = this.lmActionService.getDefaultUpdateAction(this.listSpec.busClassSpec.actions, updateDataView.actionIndexes);
        this.runUpdateAction(updateActionSpec, updateDataView, actionReference.id);
        break;

      case AppConstants.STANDARD_TOOLBAR_DELETE:
        const deleteDataViewList: Array<LMDataView> = this.selectedDataViews;
        const deleteActionSpec: LMActionSpec = this.lmActionService.getListDeleteAction(this.listSpec.busClassSpec.actions, this.getDataViewSet(), this.selectedRows);
        this.runDeleteAction(deleteActionSpec, deleteDataViewList);
        break;

      case AppConstants.STANDARD_TOOLBAR_REFRESH:
        this.runRefresh();
        break;

      case AppConstants.STANDARD_TOOLBAR_PRINTTOFILE:
      case AppConstants.STANDARD_TOOLBAR_EXPORTPDF:
        this.runPdfAction(actionReference);
        break;

      case AppConstants.STANDARD_TOOLBAR_EXPORTCSV:
        this.runCsvAction(actionReference);
        break;

      case AppConstants.STANDARD_TOOLBAR_GENAISUMMARIZE:
        this.runGenAISummarize(actionReference);
        break;

      case AppConstants.STANDARD_TOOLBAR_VIEWACTION:
        break;

      case AppConstants.STANDARD_TOOLBAR_HELPERLIST:
        this.runHelperAction(this.fromDataView, actionReference.index || 0);
        break;

      case AppConstants.STANDARD_TOOLBAR_PERSONALIZE:
        this.runListPersonalization(actionReference);
        break;

      case AppConstants.STANDARD_TOOLBAR_CREATEREPORT:
        this.runCreateReport();
        break;

      case AppConstants.STANDARD_TOOLBAR_ADHOCREPORT:
        // Is there a chart displayed and is it an aggregation chart
        if (this.chartName !== undefined) {
          const chart = this.lmListSpecUtilService.getChart(this.listSpec, this.chartName);
          if (chart && chart.chartType === 'aggregation') {
            this.adhocReportMode = true;
            this.openAdhocReportOverlay = true;
            this.chartName = chart.id;
            this.listState.adhocReportMode = this.adhocReportMode;
            this.listState.displayAs = 'chart';
            this.listState.chartName = this.chartName;
            break;
          }
        }

        // Build a new aggregation chart for this list.
        // If the list does not implement columnar view, add it. Also check if search form is defined
        this.buildAdhocAggChartForList();
        break;

      case AppConstants.STANDARD_TOOLBAR_EXITADHOCREPORT:
        // Throw away the list state info
        // navigate back to the list
        this.adhocReportMode = false;
        this.openAdhocReportOverlay = false;
        this.lmContextService.setClearNextPageState(true, false);
        // this.lmGlobalUtilService.navigateByUrl(this.listUrlInfo.httpUrl);
        this.lmGlobalUtilService.navigateByUrl(window.location.href);
        break;

      case AppConstants.STANDARD_TOOLBAR_DOWNLOAD:
        if (this.listSpec.busListSpec.attachmentListInfo && !this.listSpec.busListSpec.attachmentListInfo.disableDownload) {
          this.runDownload(actionReference, this.selectedDataViews, this.listSpec.busListSpec.attachmentListInfo.attachment);
          this.lmListToolbarService.updateToolbar(this.listSpec, this.getStateInfo(), this.listUrlInfo);
        }
        break;

      case AppConstants.STANDARD_TOOLBAR_SEARCH:
        this.runSearch();
        this.lmListToolbarService.updateToolbar(this.listSpec, this.getStateInfo(), this.listUrlInfo);
        break;

      case AppConstants.STANDARD_TOOLBAR_ADHOCFILTER:
        this.onAdHocClicked();
        break;


      case AppConstants.STANDARD_TOOLBAR_RUNFILTER:
        this.listContentComponent.applyFilter();
        break;

      case AppConstants.STANDARD_TOOLBAR_CLEARFILTER:
        this._columnfilterOperators = new Map<string, string>();
        this.clearFilterCriteria();
        this.listContentComponent.clearFilter();
        break;

      case AppConstants.STANDARD_TOOLBAR_SORT_ORDER_ASCENDING:
        const sortOrderAscending: LMListSortOrder = {
          sortOrderName: this.getDataViewSet().pagingInfo.sortOrderName,
          isAscending: true
        };
        const ascendingInfo: LMDialogInfo = { message:  Soho.Locale.translate('UnsavedChangesContinuingMsg'), type: LMDialogType.NOYES };
        this.handleUnsavedChanges(ascendingInfo).subscribe(response => {
          if (response) {
            this.sortOrder = sortOrderAscending;
            this.listContentComponent.sort(this.sortOrder);
          }
        });
        break;

      case AppConstants.STANDARD_TOOLBAR_SORT_ORDER_DESCENDING:
        const sortOrderDescending: LMListSortOrder = {
          sortOrderName: this.getDataViewSet().pagingInfo.sortOrderName,
          isAscending: false
        };
        const descendingInfo: LMDialogInfo = { message:  Soho.Locale.translate('UnsavedChangesContinuingMsg'), type: LMDialogType.NOYES };
        this.handleUnsavedChanges(descendingInfo).subscribe(response => {
          if (response) {
            this.sortOrder = sortOrderDescending;
            this.listContentComponent.sort(this.sortOrder);
          }
        });
        break;

      case AppConstants.STANDARD_TOOLBAR_SORT_ORDER_MENUITEM:
        const sortOrderName: LMListSortOrder = {
          sortOrderName: actionReference.name,
          isAscending: this.getDataViewSet().pagingInfo.isAscending
        };
        const info: LMDialogInfo = { message:  Soho.Locale.translate('UnsavedChangesContinuingMsg'), type: LMDialogType.NOYES };
        this.handleUnsavedChanges(info).subscribe(response => {
          if (response) {
            this.sortOrder = sortOrderName;
            this.listContentComponent.sort(this.sortOrder);
          }
        });
        break;

      case AppConstants.STANDARD_SAVE:
      case AppConstants.STANDARD_TOOLBAR_SAVENEW:
      case AppConstants.STANDARD_TOOLBAR_SAVEOVERLAY:
        this.executeSaveAction(actionReference.id);
        break;

      case AppConstants.STANDARD_TOOLBAR_COPYROW:
        this.runCopyRow(this.selectedRow);
        break;

      case AppConstants.STANDARD_TOOLBAR_VIEWAUDIT:
      case AppConstants.STANDARD_TOOLBAR_VIEWFULLAUDIT:
        const selectedDataView: LMListDataView = this.getDataView(this.selectedRow);
        this.runAuditLogAction(selectedDataView,
          actionReference.id === AppConstants.STANDARD_TOOLBAR_VIEWAUDIT ? 'viewAudit' : 'viewFullAudit');
        break;
      case AppConstants.STANDARD_TOOLBAR_AUDITCOMPARE:
        this.showAuditCompareModal();
        break;
      case AppConstants.STANDARD_TOOLBAR_DRILLAROUND_BUTTON:
        const drillDataView: LMListDataView = this.getDataView(this.selectedRow);
        this.runDrillAround(drillDataView);
        break;
      case AppConstants.STANDARD_TOOLBAR_RELATEDREPORT_MORE:
      case AppConstants.STANDARD_TOOLBAR_RELATEDREPORT:
        // ------------------------------------------------------------------------------
        // this relation report actionReference.relActionUrl is lazily retrieved
        // and not part of the form spec. No need to build the drill url on
        // the client side.
        // ------------------------------------------------------------------------------
        this.lmContextService.setClearNextPageState(true, false);
        this.lmGlobalUtilService.navigateByUrl(actionReference.relActionUrl);
        break;
      case AppConstants.ACTION_TYPE_AUDIT_DELETE:
      case AppConstants.ACTION_TYPE_AUDIT_UPDATE:
      case AppConstants.ACTION_TYPE_CHANGE_EFFECTIVEDATE:
      case AppConstants.ACTION_TYPE_AUDIT_OVERRIDE:
        this.runAuditAction(this.lmActionService.getActionIndexesByType(this.listSpec.busClassSpec.actions, actionReference.id));
        break;
      case AppConstants.STANDARD_TOOLBAR_USERLISTVIEW:
        const savedSearchState = actionReference.searchState;
        this.listState.userListViewItem = actionReference.userListViewItem;
        this.filterCriteria = savedSearchState.filters;
        this.sortOrder = savedSearchState.sortOrder;
        if (!this.hasSearchForm && !this.listState.isFilterBarOpened) {
          this.showFilter = true;
          this.listState.isFilterBarOpened = true;
        }
        break;
      case AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_SAVE:
        if (!this.getStateInfo().hasFilterCriteria) {
          return;
        }
        const searchStateSave = {
          filters: this.getExportActionFilterCriteria(),
          sortOrder: this.listState.sortOrderCriteria
        };
        const lvItem = this.listState.userListViewItem;
        if (lvItem?.subscribedTo && lvItem?.canModify) { // If subscription, confirmation required
          this.lmConfirmationMessageService.promptConfirmationMessage({
            message: Soho.Locale.translate('SavedSearchSaveConfirmation'),
            okToAll: false
          }).subscribe((confirmationResult: number) => {
            if (confirmationResult === ConfirmationDialogResult.CONFIRMATION_OK) {
              this.listState.userListViewItem.tConfirmed = true;
              this.lmSavedSearchService.runSave({
                userListViewItem: this.listState.userListViewItem,
                searchState: searchStateSave,
                listSpec: this.listSpec,
                listUrlInfo: this.listUrlInfo
              }).subscribe((result: LMUserListViewResult) => {
                if (result.success) {
                  this.listState.userListViewItem = result.userListViewItem;
                  this.lmListToolbarService.updateToolbar(this.listSpec, this.getStateInfo(), this.listUrlInfo);
                }
              });
            }
          });
        } else {
          this.lmSavedSearchService.runSave({
            userListViewItem: this.listState.userListViewItem,
            searchState: searchStateSave,
            listSpec: this.listSpec,
            listUrlInfo: this.listUrlInfo
          }).subscribe((result: LMUserListViewResult) => {
            if (result.success) {
              this.listState.userListViewItem = result.userListViewItem;
              this.lmListToolbarService.updateToolbar(this.listSpec, this.getStateInfo(), this.listUrlInfo);
            }
          });
        }
        break;
      case AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_SAVEAS:
        if (!this.getStateInfo().hasFilterCriteria) {
          return;
        }
        const searchStateSaveAs = {
          filters: this.getExportActionFilterCriteria(),
          sortOrder: this.listState.sortOrderCriteria
        };

        this.lmSavedSearchService.runSaveAs({
          name: this.listState.userListViewItem?.name,
          searchState: searchStateSaveAs,
          listSpec: this.listSpec,
          listUrlInfo: this.listUrlInfo
        }).subscribe((result: LMUserListViewResult) => {
          if (result.success) {
            this.listState.userListViewItem = result.userListViewItem;
            this.lmListToolbarService.updateToolbar(this.listSpec, this.getStateInfo(), this.listUrlInfo);
          }
        });
        break;
      case AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_CLEAR:
        if (this.listState.userListViewItem) {
          if (this.hasSearchForm) {
            this.onClearSearchCriteria();
          } else {
            this.filterBarFilterFieldCriteria = [];
            this.toolbarSearchFieldFilterCriteria = [];
            this.setFilterCriteria();
          }
        }
        break;
      case AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_MANAGE:
        this.lmSavedSearchService.openManageDialog(this.listSpec.busClassSpec.name, this.listSpec.busListSpec.name, this.listTitle,
          this.lmContextService.getActorId(), this.listSpec.userFolder ? this.listSpec.userFolder : '').subscribe();
        break;
      case AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_LIBRARY:
        this.lmSavedSearchService.openLibraryDialog(this.listSpec.busClassSpec.name, this.listSpec.busListSpec.name, this.listTitle,
            this.lmContextService.getActorId(), this.listSpec.userFolder ? this.listSpec.userFolder : '').subscribe();
        break;
      case AppConstants.STANDARD_TOOLBAR_ADDTAG:
        this.openAddTagDialog();
        break;
      case AppConstants.STANDARD_TOOLBAR_REFRESHCOLUMNARDATA:
        this.runRefreshColumnarData();
        break;
      case AppConstants.STANDARD_TOOLBAR_CLOSEOVERLAY:
        this.lmOverlayService.close();
        break;
      case AppConstants.STANDARD_TOOLBAR_DETAILSOVERLAY:
        this.lmOverlayService.openFullPage();
        break;
      // [1](LMWEB-24737)
      case AppConstants.STANDARD_TOOLBAR_HIDE_SHOW_MASK:
        this.toggleMask();
        break;
    }
  }

  // [1](LMWEB-24737)
  private toggleMask(): void {
    if (!this.listContentComponent || !this.listContentComponent.listGrid?.sohoDataGridComponent) {
      return;
    }

    const columns = this.listContentComponent.getColumns();
    if (!columns) {
      return;
    }

    for (const col of columns) {
      if (col.revealTextSettings) {
        const initialState = col.revealTextSettings.initialState;
        if (initialState === 'hide') {
          col.revealTextSettings.initialState = 'show';
        }

        if (initialState === 'show') {
          col.revealTextSettings.initialState = 'hide';
        }
      }
    }

    const columnGroups = this.listContentComponent.listGrid.sohoDataGridComponent.getColumnGroups();
    this.listContentComponent.listGrid.sohoDataGridComponent.updateColumns(columns, columnGroups);
  }

  private onExitedColumnarAdhocReportMode(exit: boolean) {
    this.openAdhocReportOverlay = false;
    // this.listState.adhocReportMode = false;
    // this.adhocReportMode = false;
  }
  private buildAdhocAggChartForList() {
    this.lmBuilderService.getAdhocColumnarPersonalizeSpec(this.listResource, this.listSpec.userFolder).subscribe({
      next: (v) =>      { this.handleAdhocColumnarResponse(v);  },
      error: (e) =>     { this.lmErrorUtilService.handleUnexpectedError(e);  },
      complete: () =>   {  }
    });
  }

  private handleAdhocColumnarResponse(previewData: LMBuilderUpdatePreviewResponse) {
    const clonedListSpec: LMListSpec = previewData.listSpec;
    const modelLpl: string = previewData.modelLpl;
    const chart = this.lmListSpecUtilService.getChart(clonedListSpec, 'NewAdhocReport');
    function aggFieldToAdhocAggField(f: LMAggField, index: number): LMAdhocAggField {
      const af: LMAdhocAggField = f as LMAdhocAggField;
      af.index = index;
      af.added = true;
      return af;
    }
    const dimensions: LMAdhocAggField[] = chart.aggFields.filter((f) => !f.isTotal)
                            .map((f, index) => aggFieldToAdhocAggField(f, index));
    const measures: LMAdhocAggField[] = chart.aggFields.filter(f => f.isTotal)
                          .map((f, index) => aggFieldToAdhocAggField(f, index));
    chart.aggFields = [ ...dimensions, ...measures ];

    // 1. Add the dimension and measures overrides in list state object
    if (!this.listState.columnarOptions)
      this.listState.columnarOptions = {};
    this.listState.columnarOptions.useModelLpl = true;

    if (!this.hasSearchForm) {
      // The new list spec will have an implicit search form. Drop filter criteria before switching to aggregation table.
      // This will force the agg chart to rebuild the url instead of using the currentPageUrl with first and last view keys
      this.listState.filterCriteria = [];
    }

    // 2. Switch to columnar chart and send the initial load including the post payload of dimensions and measures for model lpl
    this.listSpec = clonedListSpec;
    this.modelLpl = modelLpl;

    // 3. Set search form spec and url info for form to initialize
    this.searchFormSpec = this.listSpec.busListSpec.searchForm.formSpec;
    this.searchFormSpec.showSearchFormOnLeft = this.lmListUtilService.searchFormOnLeft(this.listSpec);
    this.searchFormUrlInfo = this.lmUrlInfoBuilderService.getFormUrlInfoFromFormSpec(this.searchFormSpec);

    // 4. Switch to aggregation table. Use dimension and measure overrides to fetch data in aggregation chart component
    this.adhocReportMode = true;
    this.openAdhocReportOverlay = true;
    this.chartName = chart.id;
    this.listState.adhocReportMode = this.adhocReportMode;
    this.listState.displayAs = 'chart';
    this.listState.chartName = this.chartName;
  }

  private runDownload(actionReference: LMBusActionReference, selectedDataViews: LMDataView[], fieldId?: string): void {
    selectedDataViews.forEach((selectedDataView) => {
      const documentResource = new DocumentResource({
        resourceId: selectedDataView.resourceId,
        fieldName: fieldId
      }, '');

      const fileName = selectedDataView.fields[fieldId].linkValue;
      const url: string = this.lmUrlUtilService.buildUrl({ resource: documentResource });
      this.attachmentListDownload.element.nativeElement.setAttribute('href', url);
      this.attachmentListDownload.element.nativeElement.setAttribute('download', fileName);
      this.attachmentListDownload.element.nativeElement.click();
    });
  }

  private runSearch() {
    if (this.hasSearchForm) {
      this.showSearchForm = !this.showSearchForm || this.listState.drawerCollapsed;
    } else {
      if (this.listState.isFilterBarOpened) {
        // Retain the current filterCriteria into listState as previousFilterCriteria. Will be used
        // by the tree to determine whether a filter should occur when the filter row is closed.
        this.listState.previousFilterCriteria = this.listState.filterCriteria;

        this._columnfilterOperators = new Map<string, string>();
      }
      this.showFilter = !this.hasSearchForm && !this.listState.isFilterBarOpened;
    }
    this.listState.isFilterBarOpened = !this.hasSearchForm && !this.listState.isFilterBarOpened;

    if (this.listState.drawerCollapsed) {
      this.expandDrawerSide();
    }
  }

  private runAuditAction(actionSpecs: Array<LMActionSpec>) {
    const actionSpec = actionSpecs?.length > 0 ? actionSpecs[0] : undefined;
    if (actionSpec.auditCorrection && !this.listSpec.busListSpec.openActionRestricted) {
      // Rich client runs redirect action for audit correction (change effective date, cancel or audit delete)
      // The redirect action picks up only the first selected dataview to process.
      const dataView = this.getDataView(this.selectedRow);
      if (dataView.actionMeta && dataView.actionMeta[ actionSpec.name ] !== undefined) {
        this.runRedirectAction(dataView, actionSpec);
        return;
      }
    }
    this.runAction(actionSpecs ? actionSpecs[0] : undefined);
  }

  private runProcessFlowAction(actionReferenceId: string, rows: Array<number>) {
    const dataViewList: LMDataView[] = [];
    rows.forEach((row: number) => {
      dataViewList.push(this.getDataView(row));
    });

    // Get the process flow action
    const dataView = dataViewList[0];
    const processFlowAction: LMProcessFlowAction = dataView.processFlowActions.find(pfAction => pfAction.name === actionReferenceId);

    if (processFlowAction) {
      // let actionSpec = this.lmActionService.getDefaultUpdateAction(this.listSpec.busClassSpec.actions, dataView.actionIndexes, true);
      this.lmBusyIndicatorService.showBusyIndicator();
      const listContext: LMListContext = {
        listUrlInfo: this.listUrlInfo,
        listSpec: this.listSpec
      };

      this.lmListTransactionService.runProcessFlowAction(listContext, processFlowAction, dataViewList, this.getDataViewSet()).subscribe(
        (transactionState: LMTransactionState) => {
          if (transactionState.isError) {
            this.lmErrorUtilService.handleError(
              transactionState.response.message,
              transactionState.response.details,
              transactionState.response.status,
              transactionState.response.message);
          } else if (transactionState.isCanceled) {
            // DPB what to do
          } else if (transactionState.isFinished) {
            const resultList = transactionState.completedTransactionList;
            let successes = 0;
            let failures = 0;
            let cancelledRT = 0;
            let title = '';
            let message = '';
            const updateMap: Map<number, LMActionResult> = new Map<number, LMActionResult>();
            const transactionSize = resultList.length;

            for (let i = 0; i < transactionSize; i++) {
              const result: LMActionResult = resultList[ i ];
              message = result.message || '';
              updateMap.set(result.dataView.id - 1, result); // No inline create in process flow

              // todo odd use of terniary operation, consider refactoring
              // eslint-disable-next-line @typescript-eslint/no-unused-expressions
              AppConstants.STATUS_COMPLETED === result.status ? successes++ :
                (AppConstants.CONFIRMATION_REQUIRED === result.status) ? cancelledRT++ : failures++;
            }

            let toastId = '';

            if (transactionSize !== 1) {
              if (successes === transactionSize) {
                // all transactions succeeded
                title = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('TransactionCompleteSuccess'), successes);
                message = transactionState.allRequestsSuccessfulForSameReason() ? message : '';
                toastId = AppConstants.TRA_ACTION_COMPLETED;
              } else if (failures === transactionSize) {
                // all transactions failed
                title = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('TransactionCompleteFailure'), failures);
                message = transactionState.allRequestsFailedForSameReason() ? message : '';
                toastId = AppConstants.TRA_ACTION_FAILED;
              } else if (cancelledRT === transactionSize) {
                // all transactions runtime confirmation cancelled
                message = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('TransactionCompleteCancelledRT'), cancelledRT);
                toastId = AppConstants.TRA_ACTION_CANCELED;
              } else {
                // some transactions succeeded and some failed
                message = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('TransactionCompleteResults'), [ successes, failures, cancelledRT ]);
                toastId = AppConstants.TRA_ACTION_PARTIALLY_COMPLETED;
              }
            } else {
              toastId = AppConstants.TRA_ACTION_COMPLETED;
            }

            if (cancelledRT === 0 || transactionSize !== 1) {
              this.lmGlobalUtilService.displayToastMessage(title, message, toastId);
            }

            if ( failures === 0 && cancelledRT === 0) {
              this.executeRefresh().subscribe();
              // TODO: Is this needed?
              // let listTransactionEvent: LMListTransactionEvent = new LMListTransactionEvent(this, resultList);
              // this.listTransactionEvent.emit(listTransactionEvent);
            } else {
              // Some are approved and some are not. How do you remove the successful ones? The user has to refresh.
              updateMap.forEach((result: LMActionResult, key: number) => {
                // when running an actionForm, the dataView.id (key) is lost if the transaction is successful.
                // Should be ok for an instance action because the row should be dirty
                if (!isNaN(key)) {
                  this.listContentComponent.updateDataViewTransaction(key, result.status, result.message);
                }
              });

              this.lmListToolbarService.updateToolbar(this.listSpec, this.getStateInfo(), this.listUrlInfo);
            }
            this.lmBusyIndicatorService.hideBusyIndicator();
          }
        });
    }
  }

  private showAuditCompareModal() {
    if (this.lazyAuditCompare) {
      this._showAuditCompareModalLazy();
    } else {
      const dataset = this.createCompareDialogData(this.getDataViewSet().auditCompareInfo, this.listContentComponent.getSelectedRows());
      this._showAuditCompareModal(dataset);
    }
  }

  private _showAuditCompareModal(dataset: LMAuditCompareChangedValues[]): void {
    // Create the row data
    const dialogId = 'CompareLog';

    // Create modal button
    const buttons = [
      {
        id: this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.CLOSE ]),
        text: Soho.Locale.translate(LMDialogButtonKey.CLOSE),
        click: (e, modal) => {
          modal.close(true);
        },
        isDefault: true,
      }
    ];

    const attributes: SohoAttributesArray = [ {
      name: 'data-automation-id',
      value: `lm-audit-compare-modal`
    } ];

    const options: SohoModalOptions = {
      fullsize: 'responsive',
      attributes
    };


    // Show the dialog button
    this.dialog = this.lmModalWrapperService
      .modal(LMAuditLogCompareDialogComponent, options)
      .title(Soho.Locale.translate(dialogId))
      .buttons(buttons)
      .apply((dialogComponent) => {
        dialogComponent.dataset = dataset;
      })
      .open();
  }

  private _showAuditCompareModalLazy(): void {
    const selectedRows = this.listContentComponent.getSelectedRows();
    if (selectedRows.length !== 2) {
      this.lmErrorUtilService.handleUnexpectedError(new Error('Invalid number of rows selected'));
      return;
    }

    const dataView1: LMDataView = this.getDataView(selectedRows[0]);
    const dataView2: LMDataView = this.getDataView(selectedRows[1]);
    if (!dataView1 || !dataView2) {
      this.lmErrorUtilService.handleUnexpectedError(new Error('Invalid data views'));
      return;
    }

    // I don't think the cancelOutstandingAuditCompareViewRequest call is needed
    // here as the busy indicator will block input until the modal is displayed.
    // this.cancelOutstandingAuditCompareViewRequest();
    this.lmBusyIndicatorService.showBusyIndicator();

    this.auditCompareViewSubscription = this.getAuditCompareViewsLazy(selectedRows).subscribe({
      next: ([ auditView1, auditView2 ]) => {
        if (auditView1.status === 'COMPLETED' && auditView2.status === 'COMPLETED') {
          const changedValues = this.createCompareDialogDataLazy(auditView1.auditCompareInfo, auditView1, auditView2, selectedRows);
          this.lmBusyIndicatorService.hideBusyIndicator();
          this._showAuditCompareModal(changedValues);
        } else {
          const error = auditView1.status !== 'COMPLETED' ? (auditView1 as any) : (auditView2 as any);
          this.lmBusyIndicatorService.hideBusyIndicator();
          this.lmErrorUtilService.handleError(error.message, error.details, error.status, error.message);
        }
      },
      error: (error: any) => {
        this.lmBusyIndicatorService.hideBusyIndicator();
        this.lmErrorUtilService.handleUnexpectedError(error);
      }
    });
  }

  private updateAuditCompare(selectedRow: number): void {
    if (this.lazyAuditCompare) {
      this._updateAuditCompareLazy(selectedRow);
    } else {
      this._updateAuditCompare(selectedRow);
    }
  }

  private _updateAuditCompareLazy(selectedRow: number) {
    const selectedRows = this.getSelectedRows();
    if (selectedRows.length === 2) {
      this._processMultipleAuditCompareViewsLazy(selectedRows);

    } else if (selectedRows.length > 2) {
      this.auditComparePanelComponent.changedValues = [];
      this.auditComparePanelComponent.emptyMessageTitle = Soho.Locale.translate('AuditCompareUnableToCompare');
      this.auditComparePanelComponent.isColumnarAuditOutOfSyncWarning = false;

    } else {
      this._processSingleAuditCompareViewLazy(selectedRow);
    }
  }

  private _processMultipleAuditCompareViewsLazy(selectedRows: Array<number>) {
    // Input validation
    if (!selectedRows || selectedRows.length !== 2) {
      return throwError(() => new Error('Invalid selection: Exactly 2 rows required'));
    }

    const dataView1: LMDataView = this.getDataView(selectedRows[0]);
    const dataView2: LMDataView = this.getDataView(selectedRows[1]);
    if (!dataView1 || !dataView2) {
      this.lmErrorUtilService.handleUnexpectedError(new Error('Invalid data views'));
      return;
    }

    this.cancelOutstandingAuditCompareViewRequest();
    this.auditComparePanelComponent.showBusyIndicator = true;

    this.auditCompareViewSubscription = this.getAuditCompareViewsLazy(selectedRows).subscribe({
      next: ([ auditView1, auditView2 ]) => {
        if (this.getSelectedRows()?.length != 2) {
          // Potential issue here when a user quickly selects more than 2 records but the call to the back end comes
          // back after the 3rd row is selected. That will cause the changeValues for the 2 selected records
          // to display in the audit compare panel.
          // Fix is to make sure there are still only 2 rows selected once the data comes back from the
          // server
          return;
        }
        if (auditView1.status === 'COMPLETED' && auditView2.status === 'COMPLETED') {
          const changedValues = this.createCompareDialogDataLazy(auditView1.auditCompareInfo, auditView1, auditView2, selectedRows);
          this.auditComparePanelComponent.changedValues = changedValues;
          this.auditComparePanelComponent.title = Soho.Locale.translate('AuditCompareComparingSelected');
          this.auditComparePanelComponent.emptyMessageTitle = Soho.Locale.translate('AuditCompareNoDifference');
          this.auditComparePanelComponent.isColumnarAuditOutOfSyncWarning = false;
          this.auditComparePanelComponent.showBusyIndicator = false;
        } else {
          const error = auditView1.status !== 'COMPLETED' ? (auditView1 as any) : (auditView2 as any);
          this.auditComparePanelComponent.showBusyIndicator = false;
          this.auditComparePanelComponent.changedValues = [];
          this.auditComparePanelComponent.emptyMessageTitle = error.message;
          // this.lmErrorUtilService.handleError(error.message, error.details, error.status, error.message);
        }
      },
      error: (error: any) => {
        this.auditComparePanelComponent.showBusyIndicator = false;
        this.auditComparePanelComponent.changedValues = [];
        this.auditComparePanelComponent.emptyMessageTitle = error.message;
        this.lmErrorUtilService.handleUnexpectedError(error);
      }
    });
  }
  // GenAI Generated code - Start
  // used genAI to improve optimization
  private getAuditCompareViewsLazy(selectedRows: Array<number>): Observable<LMAuditCompareView[]> {
    const dataView1: LMDataView = this.getDataView(selectedRows[0]);
    const dataView2: LMDataView = this.getDataView(selectedRows[1]);

    if (!dataView1 || !dataView2) {
      return throwError(() => new Error('Unable to retreive DataViews for the given selected indexes'));
    }

    // If both views already have data, return immediately
    if (dataView1.auditCompareView && dataView2.auditCompareView) {
      return of([ dataView1.auditCompareView, dataView2.auditCompareView ]);
    }

    const auditCompareUrlRaw = this.lmUrlUtilService.buildAuditCompareUrl(this.listUrlInfo);
    const auditCompareUrlTemplate = urltemplate.parse(auditCompareUrlRaw);

    // Create requests array
    const requests: Observable<LMDataView>[] = [];

    if (!dataView1.auditCompareView) {
      const url1 = auditCompareUrlTemplate.expand({ resourceId: dataView1.resourceId });
      requests.push(this.http.get<LMDataView>(url1));
    }

    if (!dataView2.auditCompareView) {
      const url2 = auditCompareUrlTemplate.expand({ resourceId: dataView2.resourceId });
      requests.push(this.http.get<LMDataView>(url2));
    }

    // AmazonQ recommended the of([]) as a fall back even if there will
    // always be something in the requests array. It considers
    // this defensive coding against unexpected scenarios, even if
    // they're theoretically impossible in the current implementation
    // return (requests.length ? forkJoin(requests) : of([])).pipe(
    return forkJoin(requests).pipe(
      map(responses => {
        let index = 0;
        if (!dataView1.auditCompareView && responses[index]) {
          dataView1.auditCompareView = responses[index++];
        }
        if (!dataView2.auditCompareView && responses[index]) {
          dataView2.auditCompareView = responses[index];
        }
        return [ dataView1.auditCompareView, dataView2.auditCompareView ];
      }),
      catchError(error => {
        this.lmErrorUtilService.handleUnexpectedError(error);
        return throwError(() => error);
      })
    );
  }
  // GenAI Generated code - End

  private _processSingleAuditCompareViewLazy(selectedRow: number): void {
    const dataView: LMDataView = this.getDataView(selectedRow);

    // safety, this can happen if the list returns no data.
    // one example is if "use as filter" is not used and the list is supposed
    // to come up initially with no data.
    // when that happens call processAuditCompareValuesLazy with null values to clear any audit compare
    // values in the audit compare panel.
    if (!dataView) {
      this.processAuditCompareValuesLazy(null, null);
      return;
    }

    if (dataView.auditCompareView && dataView.auditCompareView.auditCompareInfo) {
      this.processAuditCompareValuesLazy(dataView.auditCompareView.auditCompareInfo, dataView.auditCompareView);
      return;
    }

    // process url
    const auditCompareUrlRaw = this.lmUrlUtilService.buildAuditCompareUrl(this.listUrlInfo);
    const auditCompareUrlTemplate = urltemplate.parse(auditCompareUrlRaw);
    let auditCompareUrl = auditCompareUrlTemplate.expand({
      resourceId: dataView.resourceId,
      listName: this.listUrlInfo.resource.uiResourceName
    });

    const lastRefreshed = this.getDataViewSet()?.columnarInfo?.lastRefreshed;
    if (lastRefreshed) {
      auditCompareUrl = this.lmUrlUtilService.updateUrlParams(auditCompareUrl, { 'lastrefreshed': lastRefreshed });
    }

    this.cancelOutstandingAuditCompareViewRequest();
    this.auditComparePanelComponent.showBusyIndicator = true;

    this.auditCompareViewSubscription = this.http.get(auditCompareUrl).subscribe({
      next: (auditCompareView: LMAuditCompareView) => {
        if (auditCompareView.status === 'COMPLETED') {
          if (this.lmLoggerService.cskLog === 1) {
            // --------------------------------------------------------------------------
            // checking to make sure that we are setting the correct audit compare view
            // on the dataView in the dataView set.
            // --------------------------------------------------------------------------
            // unfortunately the set names for the 2 resourceIds don't match because the
            // auditCompareView has [AuditLog.<SetName>] where the dataView from the list
            // doesn't include it.
            // --------------------------------------------------------------------------
            const auditCompareResourceId = auditCompareView.resourceId.replace('[AuditLog.', '[');
            if (dataView.resourceId !== auditCompareResourceId) {
              console.warn('dataView and auditCompareView mismatch', [
                { key: 'dataView.resourceId', value: dataView.resourceId },
                { key: 'auditCompareResourceId', value: auditCompareResourceId }
              ]);
            }
          }

          dataView.auditCompareView = auditCompareView;
          this.processAuditCompareValuesLazy(auditCompareView.auditCompareInfo, auditCompareView);
          this.auditComparePanelComponent.showBusyIndicator = false;

        } else {
          const error = (auditCompareView as any);
          this.auditComparePanelComponent.showBusyIndicator = false;
          this.auditComparePanelComponent.changedValues = [];
          this.auditComparePanelComponent.emptyMessageTitle = error.message;
          // this.lmErrorUtilService.handleError(error.message, error.details, error.status, error.statusText);
        }
      },
      error: (error: any) => {
        this.auditComparePanelComponent.showBusyIndicator = false;
        this.auditComparePanelComponent.changedValues = [];
        this.auditComparePanelComponent.emptyMessageTitle = error.message;
        this.lmErrorUtilService.handleUnexpectedError(error);
      }
    });
  }

  private cancelOutstandingAuditCompareViewRequest(): void {
    if (this.auditCompareViewSubscription && !this.auditCompareViewSubscription.closed) {
      // ----------------------------------------------------------------
      // If a call to the back end is still out then we want to
      // unsubscribe from it to cancel the client side processing
      // of the http client request.
      // ----------------------------------------------------------------
      this.lmLoggerService.log([ this, this.instanceId, 'cancelOutstandingAuditCompareRequest(): auditCompareSubscription is still open, unsubscribing...' ]);
      this.auditCompareViewSubscription.unsubscribe();
    }
  }

  /**
   * For lazy compare I need to pass in the result of the back end call,
   * which is an audit compare data view.
   * @private
   */
  private processAuditCompareValuesLazy(auditCompareInfo: LMAuditCompareInfos, auditCompareView: LMAuditCompareView): void {
    const changedValues: Array<LMAuditCompareChangedValues> = [];

    if (this.auditComparePanelComponent && auditCompareInfo && auditCompareView) {
      const keys = Object.keys(auditCompareInfo);
      keys.forEach(key => {
        const fld = auditCompareView.fields[ key ];
        const info = auditCompareInfo[ key ];
        if (fld && fld.oldValue !== undefined && fld.value !== fld.oldValue && !fld?.members) {
          const transformOptions: LMTransformOptions = {
            precision: fld?.precision,
            decSize: fld?.precision
          };
          changedValues.push(
            {
              FieldName: info.label ? info.label : key,
              FromValue: this.lmFormatUtilService.toDisplayValue(fld.oldValue, info.type, transformOptions),
              ToValue: this.lmFormatUtilService.toDisplayValue(fld.value, info.type, transformOptions),
              IsRichText: fld.isRichText ? fld.isRichText : false
            });
        }
      });
    }
    this.auditComparePanelComponent.changedValues = changedValues;
    this.auditComparePanelComponent.title = Soho.Locale.translate('ChangedValues');
    this.auditComparePanelComponent.emptyMessageTitle = auditCompareView ? Soho.Locale.translate('AuditCompareNoChanges') : Soho.Locale.translate('AuditCompareNoRecordSelected');
    this.auditComparePanelComponent.isColumnarAuditOutOfSyncWarning = auditCompareView?.isColumnarAuditOutOfSyncWarning || false;
  }

  /**
   * For lazy compare I need to pass in the result of the back end call,
   * which are the audit compare data views.
   * @private
   */
  private createCompareDialogDataLazy(auditCompareInfo: LMAuditCompareInfos, row1DataView: LMDataView, row2DataView: LMDataView, selectedRows: number[]): LMAuditCompareChangedValues[] {
    const changedValues = [];

    const [ row1Index, row2Index ] = selectedRows;
    const row1AudSeq = this.getAuditSequence(row1DataView);
    const row2AudSeq = this.getAuditSequence(row2DataView);

    const useAuditSequence = ((row1AudSeq !== -1) && (row2AudSeq !== -1)) || (row1AudSeq !== row2AudSeq);
    const index1 = (useAuditSequence) ? row1AudSeq : row1Index;
    const index2 = (useAuditSequence) ? row2AudSeq : row2Index;

    const dataViewNew = index1 < index2 ? row2DataView : row1DataView;
    const dataViewOld = index1 < index2 ? row1DataView : row2DataView;

    const keys = Object.keys(dataViewOld.fields);
    keys.forEach(key => {
      const dataViewNewValue = dataViewNew.fields[key].value;
      const dataViewOldValue = dataViewOld.fields[key].value;
      if (dataViewOldValue !== dataViewNewValue) {
        const auditCompareData = auditCompareInfo[key];
        const auditCompareDataType = auditCompareData && auditCompareData.type ? auditCompareData.type : 'Editor';
          const precision = dataViewNew.fields[key]?.precision ?? dataViewOld.fields[key]?.precision ?? undefined;
          const transformOptions: LMTransformOptions = {};
            if (precision !== undefined) {
               transformOptions.precision = precision;
               transformOptions.decSize = precision;
            }
        changedValues.push({
          FieldName: this.lmFieldUtilService.decodeFieldName(key),
          Label: auditCompareData ? auditCompareData.label : '',
          FromValue: this.lmFormatUtilService.toDisplayValue(dataViewOldValue, auditCompareDataType, transformOptions),
          ToValue: this.lmFormatUtilService.toDisplayValue(dataViewNewValue, auditCompareDataType, transformOptions)
        });
      }
    });

    return changedValues;
  }

  // -----------------------------------------------------------
  // NON LAZY AUDIT COMPARE FUNCTIONS
  // -----------------------------------------------------------

  private _updateAuditCompare(selectedRow: number) {
    const selectedRows = this.getSelectedRows();
    if (selectedRows.length === 2) {
      const changedValues = this.createCompareDialogData(this.getDataViewSet().auditCompareInfo, this.listContentComponent.getSelectedRows());
      this.auditComparePanelComponent.changedValues = changedValues;
      this.auditComparePanelComponent.title = Soho.Locale.translate('AuditCompareComparingSelected');
      this.auditComparePanelComponent.emptyMessageTitle = Soho.Locale.translate('AuditCompareNoDifference');
      this.auditComparePanelComponent.isColumnarAuditOutOfSyncWarning = false;
    } else if (selectedRows.length > 2) {
      this.auditComparePanelComponent.changedValues = [];
      this.auditComparePanelComponent.emptyMessageTitle = Soho.Locale.translate('AuditCompareUnableToCompare');
      this.auditComparePanelComponent.isColumnarAuditOutOfSyncWarning = false;
    } else {
      this.processAuditCompareValues(selectedRow);
    }
  }

  private processAuditCompareValues(row: number) {
    const changedValues: Array<LMAuditCompareChangedValues> = [];
    const dataViewSet = this.getDataViewSet();
    const auditCompareInfo = dataViewSet?.auditCompareInfo;
    const selectedDataView: LMDataView = this.getDataView(row);

    if (this.auditComparePanelComponent && selectedDataView && auditCompareInfo) {
      const keys = Object.keys(auditCompareInfo);
      keys.forEach(key => {
        const fld = selectedDataView.fields[ key ];
        const info = auditCompareInfo[ key ];
        if (fld && fld.oldValue !== undefined && fld.value !== fld.oldValue && !fld?.members) {
          const transformOptions: LMTransformOptions = {
            precision: fld?.precision,
            decSize: fld?.precision
          };
          changedValues.push(
            {
              FieldName: info.label ? info.label : key,
              FromValue: this.lmFormatUtilService.toDisplayValue(fld.oldValue, info.type, transformOptions),
              ToValue: this.lmFormatUtilService.toDisplayValue(fld.value, info.type, transformOptions),
              IsRichText: fld.isRichText ? fld.isRichText : false
            });
        }
      });
    }
    this.auditComparePanelComponent.changedValues = changedValues;
    this.auditComparePanelComponent.title = Soho.Locale.translate('ChangedValues');
    this.auditComparePanelComponent.emptyMessageTitle = selectedDataView ? Soho.Locale.translate('AuditCompareNoChanges') : Soho.Locale.translate('AuditCompareNoRecordSelected');
    this.auditComparePanelComponent.isColumnarAuditOutOfSyncWarning = selectedDataView?.isColumnarAuditOutOfSyncWarning || false;
  }

  private createCompareDialogData(auditCompareInfo: LMAuditCompareInfos, selectedRows: Array<number>): LMAuditCompareChangedValues[] {
    const changedValues = [];
    const [ row1Index, row2Index ] = selectedRows;
    const row1DataView = this.getDataView(row1Index);
    const row2DataView = this.getDataView(row2Index);
    const row1AudSeq = this.getAuditSequence(row1DataView);
    const row2AudSeq = this.getAuditSequence(row2DataView);

    const useAuditSequence = ((row1AudSeq !== -1) && (row2AudSeq !== -1)) || (row1AudSeq !== row2AudSeq);
    const index1 = (useAuditSequence) ? row1AudSeq : row1Index;
    const index2 = (useAuditSequence) ? row2AudSeq : row2Index;

    const dataViewNew = index1 < index2 ? row2DataView : row1DataView;
    const dataViewOld = index1 < index2 ? row1DataView : row2DataView;

    const keys = Object.keys(dataViewOld.fields);
    keys.forEach(key => {
      const dataViewNewValue = dataViewNew.fields[key].value;
      const dataViewOldValue = dataViewOld.fields[key].value;
      if (dataViewOldValue !== dataViewNewValue) {
        const auditCompareData = auditCompareInfo[key];
        const auditCompareDataType = auditCompareData && auditCompareData.type ? auditCompareData.type : 'Editor';
        changedValues.push({
          FieldName: this.lmFieldUtilService.decodeFieldName(key),
          Label: auditCompareData ? auditCompareData.label : '',
          FromValue: this.lmFormatUtilService.toDisplayValue(dataViewOldValue, auditCompareDataType),
          ToValue: this.lmFormatUtilService.toDisplayValue(dataViewNewValue, auditCompareDataType)
        });
      }
    });

    return changedValues;
  }

  private getAuditSequence(dataView: LMDataView): LMFieldValue {
    const key = `${dataView?.busClassName}_audit_sequence`;
    return dataView?.fields[key]?.value || -1;
  }

  public runAuditLogAction(dataView: LMListDataView, auditType: string): void {
    const auditActionRedirectUrlTemplate = urltemplate.parse(this.listUrlInfo.viewAuditLogRedirectUrl);
    let auditActionRedirectUrl = auditActionRedirectUrlTemplate.expand({
      resourceId: dataView.resourceId,
      actionName: auditType,
      contextResourceId: this.getDataViewSet().header.resourceId,
    });

    auditActionRedirectUrl = this.setGlobalModeOnNavigation(auditActionRedirectUrl);
    this.lmGlobalUtilService.navigateByUrl(auditActionRedirectUrl);
    // this.lmNavigationService.runNavigation(auditActionRedirectUrl)

  }

  public canRefresh(): boolean {
    return this.lmListToolbarService.hasToolbarAction(AppConstants.STANDARD_TOOLBAR_REFRESH);
  }

  // LmComponent should call this method when the user asks to refresh data.
  // It should NOT be called by components to refresh the list
  public runRefresh() {
    // console.log('list runRefresh: ' + this.listSpec.busListSpec.name);
    const info: LMDialogInfo = { message: Soho.Locale.translate('UnsavedChangesContinuingMsg'), type: LMDialogType.NOYES };

    this.handleUnsavedChanges(info).subscribe(response => {
      if (response) {
        this.executeRefresh().subscribe();
      }
    });
  }

  private executeRefresh(request?: LMRefreshRequest): Observable<boolean> {
    // console.log('list refresh: ' + this.listSpec.busListSpec.name);
    if (!this.listContentComponent) {
      // safety in case the list is newly created and a refresh is called but the
      // listContentComponent ChildView is till not hooked up. This can happen with
      // a compform with a single list-panel that has visibility changed due to an
      // instance action on the main composite form.
      return of(true);
    }

    if (this.listId === request?.originatingSourceId) {
      // console.log('list refresh canceled: ' + this.listSpec.busListSpec.name);
      return of(true);
    }

    return new Observable<boolean>(observer => {
      const hardRefresh: boolean = !request || !request.originatingSourceId;  // hard refresh means the user initiated the refresh, else we are refreshing to update data after a transaction
      const refreshCalls: Observable<boolean>[] = [];
      const isListModified = this.listContentComponent?.isModified();
      const isDetailSectionModified = this.detailSectionsComponent?.isModified();

      if (hardRefresh || !isListModified ) {
        refreshCalls.push(this.listContentComponent.refresh());
      }

      if (this.detailSectionsComponent && (hardRefresh || !isDetailSectionModified)) {
        refreshCalls.push(this.detailSectionsComponent.refresh(request));
      }

      // eslint-disable-next-line no-unused-vars
      forkJoin(refreshCalls).subscribe(value => {
        if (this.hasDetailFields && this.detailfieldsFormModelCache.length) {
          this.clearDetailFieldsFormModelCache();
        }
        observer.next(true);
        observer.complete();
      });
    });
  }

  // ---------------------------------------------------------------------------
  // todo dpb was hoping to have an interface more like this: - Phillip 1/31/18
  // runSaveAction(isSaveAndNew = false): Observable<boolean>) {}
  // more like how refresh is.
  // ---------------------------------------------------------------------------
  public runSaveAction(actionReferenceId: string, callBack: Observer<boolean>, skipToast?: boolean) {
    if (this.performingSaveUnsavedChanges && callBack) {
      callBack.next(true);
      callBack.complete();
      return;
    }
    this.executeSaveAction(actionReferenceId, callBack, skipToast);
  }

  private executeSaveAction(actionReferenceId: string, callBack?: Observer<boolean>, skipToast?: boolean): void {
    if (this.previewMode) {
      this.lmGlobalUtilService.displayToastMessage(Soho.Locale.translate('PreviewOnly'), Soho.Locale.translate('PreviewOnlyMsg'), AppConstants.TRA_ACTION_COMPLETED);
      return;
    }
    /*
     known issues
     1. save involving two different action specs may no work because the
     confirmation exception and response required rules run against the first
     actionSpec found.  This may happen when an inline create and update is performed
     in a single transaction.
     */

    if (this.hasDetailFields && this.detailFieldsFormModel?.isDirty) {
      this.syncDetailFieldsFormModelAndListDataviews(true);
    }

    // Commit changes to the grid
    this.commitCellEdit();

    const isModified = this.isModified();
    // TODO: DPB if list has detail field (side or bottom) then check if they are modified then mark isModified true

    if (!isModified) {
      this.performingSaveUnsavedChanges = false;
      return;
    }

    if (this.hasDetailSections && this.detailSectionsComponent && this.detailSectionsComponent.isModified()) {
      this.detailSectionsComponent.runSaveAction().subscribe((continueOn: boolean) => {
        if (continueOn && this.listContentComponent.isModified()) {
          this.runSave(actionReferenceId, callBack, skipToast);
        } else {
          this.performingSaveUnsavedChanges = false;
          if (callBack) {
            callBack.next(continueOn);
            callBack.complete();
          }
        }
      });
    } else if (this.dashboardViewComponent && this.dashboardViewComponent.isModified()) {
      this.dashboardViewComponent.runSaveAction().subscribe((continueOn: boolean) => {
        if (continueOn && this.listContentComponent.isModified()) {
          this.runSave(actionReferenceId, callBack, skipToast);
        } else {
          this.performingSaveUnsavedChanges = false;
          if (callBack) {
            callBack.next(continueOn);
            callBack.complete();
          }
        }
      });
    } else {
      this.runSave(actionReferenceId, callBack, skipToast);
    }
  }

  private runSave(actionReferenceId: string, callBack: Observer<boolean>, skipToast?: boolean, multiPartFields?: LMMultiPartFields) {
    this.showBusyIndicator();

    let dirtyDataViews: LMDataView[] = [];
    if (this.listSpec.busListSpec.attachmentListInfo && multiPartFields) {
      dirtyDataViews =  this.createAttachmentCreateDataView(multiPartFields);
    } else {
      dirtyDataViews = this.listContentComponent.getDirtyRows(true);
    }
    const listContext: LMListContext = {
      listUrlInfo: this.listUrlInfo,
      listSpec: this.listSpec
    };

    this.lmListTransactionService.runSaveAction(listContext, this.getDataViewSet(), dirtyDataViews, multiPartFields).subscribe(
      (transactionState: LMTransactionState) => {

        this.performingSaveUnsavedChanges = false;
        this.performingSaveNewViaHotkey = false;
        this.hideBusyIndicator();

        if (transactionState.isError) {
          this.lmErrorUtilService.handleError(
            transactionState.response.message,
            transactionState.response.details,
            transactionState.response.status,
            transactionState.response.message);

          if (callBack) {
            callBack.next(false);
            callBack.complete();
          }
        } else if (transactionState.isCanceled) {
          if (callBack) {
            callBack.next(false);
            callBack.complete();
          }
        } else {
          const resultList = transactionState.completedTransactionList;
          let successes = 0;
          let failures = 0;
          let cancelledRT = 0;
          const adjustment = this.isInlineCreateModeOn() ? 0 : 1;
          let message = '';
          const updateMap: Map<number, LMActionResult> = new Map<number, LMActionResult>();
          const transactionSize = resultList.length;

          for (let i = 0; i < transactionSize; i++) {
            const result: LMActionResult = resultList[ i ];
            const key = (+result.dataView.id === -1) ? 0 : result.dataView.id - adjustment;
            message = (result.status !== AppConstants.CONFIRMATION_REQUIRED && result.message?.length > 0) ? result.message : '';
            updateMap.set(key, result);

        // todo odd use of terniary operation, consider refactoring
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        AppConstants.STATUS_COMPLETED === result.status ? successes++ :
          (AppConstants.CONFIRMATION_REQUIRED === result.status) ? cancelledRT++ : failures++;
      }

          // Summarize the transaction result. Also handle the situation were a result message
          // is not provided for a single tranaction.
          const allTransactionsSucceeded = successes === transactionSize;
          let toastId;
          if (transactionSize !== 1 || (transactionSize === 1 && message.length === 0)) {
            if (allTransactionsSucceeded) {
              // all transactions succeeded
              message = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('SaveActionCompleteRowsSaved'), successes);
              toastId = AppConstants.TRA_ACTION_COMPLETED;
              if (this.hasDetailFields && this.detailfieldsFormModelCache.length) {
                this.clearDetailFieldsFormModelCache();
              }
            } else if (failures === transactionSize) {
              // all transactions failed
              message = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('SaveActionCompleteRowsFailed'), failures);
              toastId = AppConstants.TRA_ACTION_FAILED;
            } else if (cancelledRT === transactionSize) {
              // all transactions runtime confirmation cancelled
              message = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('SaveActionCompleteRowsCancelledRT'), cancelledRT);
              toastId = AppConstants.TRA_ACTION_CANCELED;
            } else {
              // some transactions succeeded and some failed
              message = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('SaveActionCompleteResults'), [ successes, failures, cancelledRT ]);
              toastId = AppConstants.TRA_ACTION_PARTIALLY_COMPLETED;
              if (this.hasDetailFields && this.detailfieldsFormModelCache.length) {
                const dataViews = [ ...resultList.filter(result => result.status === 'COMPLETED').map(result => result.dataView) ];
                this.clearDetailFieldsFormModelCache(dataViews);
              }
            }
          } else {
            toastId = AppConstants.TRA_ACTION_COMPLETED;
          }

          if (!(skipToast && allTransactionsSucceeded)) {
            this.lmGlobalUtilService.displayToastMessage('', message, toastId);
          }

          const isSpeedEntryMode = AppConstants.STANDARD_TOOLBAR_SAVENEW === actionReferenceId;

          // refresh the list if there is no error and not in speedEntryMode
          if (failures === 0 && !isSpeedEntryMode) {
            this.turnOnInlineCreateMode(false);
            this.listContentComponent.clearDirty();
            // eslint-disable-next-line no-unused-vars
            this.refresh().subscribe(refreshDone => {
              // console.log('Save refresh finished');
              if (callBack) {
                callBack.next(transactionState.isSuccess() && !transactionState.isCanceled);
                callBack.complete();
              }
              const listTransactionEvent: LMListTransactionEvent = new LMListTransactionEvent(this, resultList);
              this.listTransactionEvent.emit(listTransactionEvent);

              if (this.lmContextService.useListFormOverlay() && this.lmOverlayService.hasOpenOverlay) {
                if (this.isInOverlay || this.topLevelOverlayComponent) {
                  // in the overlay, tell the opening list to refresh
                  this.lmOverlayService.overlayComm.next({ from: 'overlay', action: 'refresh' });
                } else {
                  // is the open list, tell the overlay to refresh
                  this.lmOverlayService.overlayComm.next({ from: 'openingList', action: 'refresh' });
                }
              }
            });
          } else if (this.listSpec.busListSpec.attachmentListInfo && multiPartFields) {
            this.refresh().subscribe(refreshDone => {
              if (callBack) {
                callBack.next(transactionState.isSuccess() && !transactionState.isCanceled);
                callBack.complete();
              }
              const listTransactionEvent: LMListTransactionEvent = new LMListTransactionEvent(this, resultList);
              this.listTransactionEvent.emit(listTransactionEvent);
            });
          } else {
            updateMap.forEach((result: LMActionResult, key: number) => {
              if (result.status === AppConstants.STATUS_COMPLETED) {
                // console.log('updating dataview' + result.dataView.resourceId);
                this.listContentComponent.updateDataView(key, result.dataView);
              }
              // console.log('updating transaction' + result.dataView.resourceId + ' status:' + result.status + ' msg:' + result.message);
              this.listContentComponent.updateDataViewTransaction(key, result.status, result.message);
            });

            if (failures === 0) {
              if (isSpeedEntryMode) {
                const inlineCreateDataView = resultList[ 0 ].dataView;
                this.updateDataViewSetForSpeedEntry(inlineCreateDataView);
                this.addInlineCreateDataView();

                const selectionMode = this.lmListSpecUtilService.getSelectionMode(this.listSpec, !this.isSelectListInSelectionMode(), this.selectRequestData?.allowMultiSelections);
                if (selectionMode === 'single') {
                  this.listContentComponent.setSelectedRows([ AppConstants.INLINE_CREATE_ROW ], true);
                } else {
                  this.listContentComponent.activateRow(AppConstants.INLINE_CREATE_ROW, true);
                }

                if (!this.isRouterOutletRootComponent) {
                  const listTransactionEvent: LMListTransactionEvent = new LMListTransactionEvent(this, resultList);
                  this.listTransactionEvent.emit(listTransactionEvent);
                }
              } else {
                this.turnOnInlineCreateMode(false);
              }
            }
            this.lmListToolbarService.updateToolbar(this.listSpec, this.getStateInfo(), this.listUrlInfo);
            // let the form panel or master list know if save was successful
            if (callBack) {
              callBack.next(transactionState.isSuccess() && !transactionState.isCanceled);
              callBack.complete();
            }

            if (this.lmOverlayService.hasOpenOverlay && !this.isInOverlay) {
              this.lmOverlayService.overlayComm.next({ from: 'openingList', action: 'refresh' });
            }
          }
        }
      });
  }

  private updateDataViewSetForSpeedEntry(inlineCreateDataView: LMDataView) {
    const dataViewSet: LMDataViewSet = this.getDataViewSet();

    // Soho datagrid is adding properties to the dataView to maintain
    // selected and rowactivated states that need to be merged.
    const oldDataView = dataViewSet.data[AppConstants.INLINE_CREATE_ROW];
    const newDataView = { ...oldDataView, ...inlineCreateDataView };
    delete newDataView.isNewRow;
    dataViewSet.data[AppConstants.INLINE_CREATE_ROW] = newDataView;

    for (let i = 0, len = dataViewSet.data.length; i < len; i++ ) {
      const dataView: LMDataView = this.getDataView(i);
      dataView.id = i + 1;
    }
  }

  private isInlineCreateModeOn(): boolean {
    if (!this.isInlineCreateEnabled()) {
      return false;
    }

    const dataViewSet = this.getDataViewSet();
    if (!dataViewSet || dataViewSet.data.length <= 0) {
      return false;
    }

    const dataView = dataViewSet.data[ AppConstants.INLINE_CREATE_ROW ];
    return (dataView && dataView.isNewRow);
  }

  public turnOnInlineCreateMode(turnOn: boolean): void {

    if (!this.isInlineCreateEnabled()) {
      return;
    }

    if (!this.isInlineCreateModeOn() && !turnOn) {
      return;
    }

    if (this.isInlineCreateModeOn() && turnOn) {
      // put focus in the inline create row
      return;
    }

    if (turnOn) {
      this.addInlineCreateDataView();
    } else {
      this.removeInlineCreateDataView();
    }
  }

  private addInlineCreateDataView(): void {

    if (!this.isInlineCreateEnabled()) {
      return;
    }

    this.listContentComponent.addDataView(this.createInlineDataView(), AppConstants.INLINE_CREATE_ROW);
  }

  private removeInlineCreateDataView(): void {

    if (!this.isInlineCreateEnabled()) {
      return;
    }

    this.listContentComponent.listGrid.removeRow(AppConstants.INLINE_CREATE_ROW);
  }

  private isInlineCreateDataViewDirty(): boolean {
    const dirtyDataViews = this.listContentComponent.getDirtyRows(true);
    return (dirtyDataViews.length > 0 && dirtyDataViews[ AppConstants.INLINE_CREATE_ROW ].isNewRow);
  }

  private runCopyRow(sourceRow: number): void {
    if (!this.isInlineCreateEnabled()) {
      return;
    }

    if (this.isInlineCreateModeOn()) {
      if (sourceRow <= AppConstants.INLINE_CREATE_ROW) {
        return;
      }

      if (this.isInlineCreateDataViewDirty()) {
        // const deleteDataViewList: Array<LMDataView> = [ this.getDataView(AppConstants.INLINE_CREATE_ROW) ];
        const deleteActionSpec: LMActionSpec = this.lmActionService.getListDeleteAction(this.listSpec.busClassSpec.actions, this.getDataViewSet(), [ AppConstants.INLINE_CREATE_ROW ]);

        this.checkForUnsavedChanged(deleteActionSpec).subscribe((continueOn: boolean) => {  // DPB needs to be adressed
          if (continueOn) {
            this.removeInlineCreateDataView();
            this.addInlineCreateDataView();
            this.copyRowValues(sourceRow, AppConstants.INLINE_CREATE_ROW);
          }
        });
      } else {
        this.copyRowValues(sourceRow, AppConstants.INLINE_CREATE_ROW);
      }
    } else {
      this.turnOnInlineCreateMode(true);
      this.copyRowValues(sourceRow + 1, AppConstants.INLINE_CREATE_ROW);
    }
  }

  private copyRowValues(sourceRow: number, targetRow: number) {
    const sourceDataView: LMDataView = this.getDataView(sourceRow);
    const targetDataView: LMDataView = this.getDataView(targetRow);
    const columns: Array<ListGridColumn> = this.listContentComponent.getColumns();

    if (targetDataView === null) {
      this.lmLoggerService.warn([ this, this.instanceId, 'Copy Row failed because target dataview not found: row number = ' + targetRow ]);
      return;
    }

    if (sourceDataView === null) {
      this.lmLoggerService.warn([ this, this.instanceId, 'Copy Row failed because source dataview not found: row number = ' + sourceRow ]);
      return;
    }

    const targetFields = Object.keys(targetDataView.fields);

    for (let i = 0, l = targetFields.length; i < l; i++) {
      const fieldId = targetFields[ i ];
      const targetField = targetDataView.fields[ fieldId ];

      if (!this.lmListUtilService.isFieldCopyable(fieldId, targetField, targetDataView)) {
        continue;
      }

      const displayField = this.listSpec.busListSpec.displayFields.find( field => field.fieldId === fieldId);
      if (displayField && (displayField.isSymbolicKey || displayField.isPartOfRelativeKey || displayField.uiProtected)) {
        continue;
      }

      const sourceField = sourceDataView.fields[ fieldId ];

      if (!sourceField) {
        this.lmLoggerService.warn([ this, this.instanceId, 'Copy Row failed because source field not found: fieldId = ' + fieldId ]);
      } else {
        if (displayField) {
          const data = { originalVal: targetField.value, value: sourceField.value, isDirty: true };
          const columnIndex = columns.findIndex(column => column.id.startsWith(displayField.columnId + '_'));
          this.listContentComponent.setDirtyIndicator(targetRow, columnIndex, true, data);
        }
        targetField.value = sourceField.value;
      }
    }

    // reflect that the row is dirty and render the cell changes
    this.listContentComponent.rowStatus(targetRow, 'in-progress', Soho.Locale.translate('RowDataChanged'));

    this.lmListToolbarService.updateToolbar(this.listSpec, this.getStateInfo(), this.listUrlInfo);

    // let the form or page know that the list is modified
    if (!this.isRouterOutletRootComponent) {
      this.updateToolbarStateEvent.emit();
    }
  }

  public getCellFromEvent(event: KeyboardEvent) {
    const eventTarget = event.target as HTMLElement;
    const tr = eventTarget.closest('tr') as HTMLElement;
    if (!tr) {
      return null;
    }
    const rowIndex: number = +tr.getAttribute('aria-rowindex') - 1;

    const td = eventTarget.closest('td') as HTMLElement;
    if (!td) {
      return null;
    }
    const columnIndex: number = +td.getAttribute('aria-colindex') - 1;

    return { row: rowIndex, column: columnIndex };
  }

  private createInlineDataView(): LMDataView {
    const newRow: LMDataView = JSON.parse(JSON.stringify(this.getDataViewSet().header));
    const inlineCreateDataView: LMDataView = JSON.parse(JSON.stringify(this.getDataViewSet().inlineCreateDataView));
    const inlineCreateFields = Object.keys(inlineCreateDataView.fields);

    // move fields in the inlineCreate dataView to the header dataView
    for (let i = 0, l = inlineCreateFields.length; i < l; i++) {
      const fieldId = inlineCreateFields[ i ];
      const targetField = inlineCreateDataView.fields[ fieldId ];
      newRow.fields[ fieldId ] = targetField;
    }

    // Need to use the resourceId from the header, else we may not have the correct info in creation if it's depending
    // on info from a relation
    newRow.resourceId = this.getDataViewSet().header.resourceId;
    newRow.id = -1;
    newRow.isNewRow = true;

    // LMCLIENT-28493: need to populate dataView with the create action
    newRow.action = inlineCreateDataView.action;

    // add the first delete action (that doesn't have parameters) to the inlineCreate dataView
    const deleteActionSpecs: Array<LMActionSpec> = this.lmActionService.getActionIndexesByType(this.listSpec.busClassSpec.actions, AppConstants.ACTION_TYPE_DELETE);
    const deleteActionSpec = deleteActionSpecs.find(actionSpec => !actionSpec.hasParameters && !newRow.actionIndexes.some(action => action === actionSpec.index));
    if (deleteActionSpec) {
      newRow.actionIndexes.push(deleteActionSpec.index);
    }
    return newRow;
  }

  private isInlineCreateEnabled(): boolean {
    if (this.lmContextService.isDataModificationNotAllowed()
      || this.listSpec.busListSpec.userFolderArchiveReport !== undefined
      || this.listSpec.busListSpec.userFolderAsOfDate !== undefined) {
      return false;
    }
    if (this.listSpec.busListSpec.implementsInlineCreate
      && this.listSpec.listType !== 'select'
      && this.listSpec.listType !== 'dashboard'
      && this.listSpec.listType !== 'helper'
      && this.listContentComponent.isType('list')
      && this.getDataViewSet()
    ) {
      const busClassActionSpecs = this.listSpec.busClassSpec.actions;
      const listViewAction = this.getDataViewSet().header.actionIndexes;
      return !!this.lmActionService.getDefaultCreateAction(busClassActionSpecs, listViewAction);
    } else {
      return false;
    }
  }

  private isInlineCreateModified(): boolean {
    if (!this.isInlineCreateModeOn()) {
      return false;
    }

    return this.isInlineCreateDataViewDirty();
  }

  private createAttachmentCreateDataView(multipartFields: LMMultiPartFields): Array<LMDataView> {
    const addAllAttachments: Array<LMDataView> = [];

    const newAttachment: LMDataView = JSON.parse(JSON.stringify(this.getDataViewSet().header));
    const createDVTemplate: LMDataView = JSON.parse(JSON.stringify(this.getDataViewSet().attachmentCreateDataView));
    const createDVTemplateFields = Object.keys(createDVTemplate.fields);

    createDVTemplateFields.filter(fld => !newAttachment.fields[fld])
      .map(addFld => {
        newAttachment.fields[addFld] = createDVTemplate.fields[addFld];
      });

    newAttachment.id = -1;
    newAttachment.isNewRow = true;

    // LMCLIENT-28493: need to populate dataView with the create action
    newAttachment.action = createDVTemplate.action;

    // add the first delete action (that doesn't have parameters) to the inlineCreate dataView
    const deleteActionSpecs: Array<LMActionSpec> = this.lmActionService.getActionIndexesByType(this.listSpec.busClassSpec.actions, AppConstants.ACTION_TYPE_DELETE);
    const deleteActionSpec = deleteActionSpecs.find(actionSpec => !actionSpec.hasParameters && !newAttachment.actionIndexes.some(action => action === actionSpec.index));
    if (deleteActionSpec) {
      newAttachment.actionIndexes.push(deleteActionSpec.index);
    }
    // Push attachment field title and mimetype into the dataview
    Object.keys(multipartFields).forEach((key, i) => {
      const dv: LMDataView = JSON.parse(JSON.stringify(newAttachment));
      const file: File = multipartFields[key] as File;
      const multiPartFileField = dv.fields[this.listSpec.busListSpec.attachmentListInfo.attachment + '_prd_File'];
      if (multiPartFileField) {
        const title = dv.fields[multiPartFileField.docTitleFieldId];
        if (title) {
          title.value = file.name;
        }
        const mimeType =  dv.fields[multiPartFileField.mimeTypeFieldId];
        if (mimeType) {
          mimeType.value = file.type;
        }
      }

      addAllAttachments.push(dv);
    });
    return addAllAttachments;
  }

  private hasUnsavedChangesForDelete(): boolean {
    // are all dirty rows also selected?
    const adjustment = this.isInlineCreateModeOn() ? 0 : 1;
    // let stateInfo: LMListStateInfo = this.getStateInfo();
    if (this.isModified) {
      // lets only prompt to save changes if a dirty row is not been selected to be deleted!
      const selectedRows: Array<number> = this.listContentComponent.getSelectedRows();
      const dirtyRows: Array<LMDataView> = this.listContentComponent.getDirtyRows(true);

      for (let i = 0, len = dirtyRows?.length; i < len; i++) {
        const dataView: LMDataView = dirtyRows[ i ];
        const rowId = dataView.isNewRow ? 0 : dataView.id - adjustment;
        if (selectedRows.indexOf(rowId) === -1) {
          return true;
        }
      }
      return false;
    } else {
      return false;
    }
  }

  private isCreateWithinEnabled(): boolean {
    if (this.lmContextService.isDataModificationNotAllowed()
      || this.listSpec.busListSpec.userFolderArchiveReport !== undefined
      || this.listSpec.busListSpec.userFolderAsOfDate !== undefined) {
      return false;
    }

    // must be a tree or org chart
    if (!this.listSpec.busListSpec.implementsTreeView && !this.listSpec.busListSpec.implementsOrgChartView) {
      return false;
    }

    // can't be child hierarchy
    if (this.listSpec.busClassSpec.implementsChildHierarchy) {
      return false;
    }

    // must be able to find the default dataViewSet.header create action
    if (!this.lmActionService.getDefaultCreateAction(this.listSpec.busClassSpec.actions, this.getDataViewSet().header.actionIndexes)) {
      return false;
    }

    // must have only one selected row as that's what we'll use to do the create within.
    const selectedRows: Array<number> = this.listContentComponent.getSelectedRows();
    // must be able to find the selected dataView
    const dataView = selectedRows.length === 1 ? this.listContentComponent.getSelectedTreeDataView() : null;
    if (!dataView) {
      return false;
    }

    // if treeViewInfo is not specified then return true (it's valid)
    const treeViewInfo = this.listSpec.busListSpec.treeViewInfo;
    if (treeViewInfo && treeViewInfo.disableCreateWithin) {

      // if disableCreateWithin is conditional then evaluate the condition to determine validity
      if (treeViewInfo && treeViewInfo.disableCreateWithinWhen) {
        return !this.lmConditionUtilService.isValid([ treeViewInfo.disableCreateWithinWhen ], dataView);
      }

      return false;
    }

    return true;
  }

  public attachmentListFileInputChange() {
    const files: Array<File|Blob> = Array.from(this.attachmentListFileInput.element.nativeElement.files);
    this.runAddAttachment(files);
  }

  public onFilesDropped(dataTransfer: DataTransfer) {
    if (!this.isAttachmentList && !this.attachmentListHasCreateAction) {
      return;
    }

    const files: FileList = dataTransfer.files;
    this.runAddAttachment(files);
  }

  private runAddAttachment(files: Array<File|Blob>|FileList) {
    const actionSpec = this.listSpec.busListSpec.attachmentListInfo?.hasCreateAction ? this.listSpec.busListSpec.attachmentListInfo.actionSpec : undefined;
    if (actionSpec && files?.length > 0) {
      if (files.length > AppConstants.ATTACHMENTLIST_MAXFILES) {
        const message = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('AttachmentListMaxFilesCheck'), files.length);
        const title = Soho.Locale.translate('FileUploadProgress');
        this.lmErrorUtilService.handleViewException({ message, title });
        return;
      }
      const multipartFields: LMMultiPartFields = { };
      for (let i = 0; i < files.length; i++) {
        multipartFields[this.listSpec.busListSpec.attachmentListInfo.attachment + '_row' + i] = files[i];
      }
      // Checking hasActionForm is ok here since ListViewBuilder builds the actionSpec.hasActionForm based on the new API to get the form when actionSpec refactor is on
      if (actionSpec.hasParameters || actionSpec.hasActionForm) {
        this.runCreateAction(actionSpec, false, multipartFields);
      } else {
        // runSave checks for SAVEANDNEW and Browse is a create action
        this.runSave(AppConstants.STANDARD_TOOLBAR_CREATE, null, false, multipartFields);
      }
    }
  }

  /**
   * Runs the create action for the BusActionReference for the current dataViewSet.
   * @param actionReference - the actionReference of the action to open the create form with.
   */
  public runCreateAction(actionSpec: LMActionSpec, createWithin?: boolean, multiPartFields?: LMMultiPartFields): void {

    if (this.isInlineCreateEnabled()
      &&  this.listSpec.busListSpec.allowFormCreate === undefined
      &&  actionSpec.type !== AppConstants.ACTION_TYPE_IMPORT) {
      // IMPORT actions are being pass into this method too. Disallow
      // inline create when action is an IMPORT action.
      this.turnOnInlineCreateMode(true);
      return;
    }

    // -------------------------------------------------------------------
    // get actionSpec and verify it's valid
    // -------------------------------------------------------------------
    const actions = this.listSpec.busClassSpec.actions;
    const actionIndex = this.getDataViewSet().header.actionIndexes;
    if (!this.lmActionService.isValidAction(actionSpec, actions, actionIndex, actionSpec.type, false)) {
      throw 'Cannot run Create Action: \'' + actionSpec.name + '\' is not a valid create action.';
    }

    const listContext: LMListContext = {
      listUrlInfo: this.listUrlInfo,
      listSpec:    this.listSpec
    };
    const contextResourceId = createWithin ? this.listContentComponent.getSelectedTreeDataView().resourceId : this.getDataViewSet().header.resourceId;

    if (this.lmContextService.isActionSpecRefactorOn()) {
      this.runCreateAction2(listContext, actionSpec, this.getDataViewSet(), contextResourceId, multiPartFields);
      return;
    }
    if (actionSpec.hasActionForm || actionSpec.hasParameters) {
      this.lmBusyIndicatorService.showBusyIndicator();

      if (this.stepUpActionResult) {
        listContext.stepUpActionResult = this.stepUpActionResult;
        this.stepUpActionResult = undefined;
      }

      let dataViewList: LMDataView[];
      if (this.listSpec.busListSpec.attachmentListInfo?.hasCreateAction && multiPartFields) {
        dataViewList = this.createAttachmentCreateDataView(multiPartFields);
      }
      this.lmListTransactionService.runCreateAction(listContext, actionSpec, undefined, this.getDataViewSet(), contextResourceId, dataViewList, multiPartFields).subscribe(
        (transactionState: LMTransactionState) => {

          // this.lmBusyIndicatorService.hideBusyIndicator(); // Will be closed by dialog service.

          if (transactionState.isError) {
            this.lmBusyIndicatorService.hideBusyIndicator(); // Dialog may not be up to hide the indicator.
            this.lmErrorUtilService.handleError(
              transactionState.response.message,
              transactionState.response.details,
              transactionState.response.status,
              transactionState.response.message);
          } else if (transactionState.isCanceled) {
            // TODO: noop
          } else if (transactionState.isFinished) {
            const resultList = transactionState.completedTransactionList;
            const result = transactionState.getTransactionResult();

            if (result.status === AppConstants.STATUS_COMPLETED) {
              if (result.message.length > 0 && !result.actionSpec?.suppressCompletionMessage) {
                this.lmGlobalUtilService.displayToastMessage(actionSpec.label, result.message, AppConstants.TRA_ACTION_COMPLETED);
                this.notifyHandCodedTransactionComplete(contextResourceId, transactionState);
              }

              if (result.isCompletionNavigation && result.redirectUrl) {
                const formPagingInfo: LMPagingInfo = this.buildFormPagingInfo(this.getDataViewSet(), result.dataView);
                this.lmNavigationService.runNavigation(result.redirectUrl, formPagingInfo);
              } else {
                this.executeRefresh().subscribe();
                const listTransactionEvent: LMListTransactionEvent = new LMListTransactionEvent(this, resultList);
                this.listTransactionEvent.emit(listTransactionEvent);
              }
            } else {
              if (result.message.length > 0) {
                this.lmGlobalUtilService.displayToastMessage(actionSpec.label, result.message, AppConstants.TRA_ACTION_FAILED);
              }
            }
          }
        });
    } else {
      // Attachment Lists - This path does not support creating multiple records for an attachment list
      // It will bring up a form to create a single record, even if the list implements attachment list.
      if (this.stepUpActionResult) {
        const redirectUrl = (this.lmContextService.inMingleWidget())
          ? this.stepUpActionResult.redirectUrl : this.lmUrlUtilService.toRelativeUrl(this.stepUpActionResult.redirectUrl, true, true);
        this.stepUpActionResult = undefined;
        this.lmGlobalUtilService.navigateByUrl(redirectUrl);
        return;
      }

      // todo akila ppatton maf allow next/prev on a form when the create form completes????
      const formPagingInfo: LMPagingInfo = null;
      // let formPagingInfo: LMPagingInfo = this.getDataViewSet().pagingInfo);
      // let formPagingInfo: LMPagingInfo = this.buildFormPagingInfo(this.getDataViewSet(), dataView);
      const createActionRedirectUrlTemplate = urltemplate.parse(this.listUrlInfo.actionRedirectUrl);
      const createActionRedirectUrl = createActionRedirectUrlTemplate.expand({
        resourceId:        this.getDataViewSet().header.resourceId,
        actionName:        actionSpec.name,
        contextResourceId
      });

      if (this.listSpec.listType === 'select'
        || this.listSpec.listType === 'helper') {
        const options = this.lmContextService.usePortalTabs() ? { openNewPortalTab: true } : { openNewTab: true };
        this.lmNavigationService.runNavigation(createActionRedirectUrl, formPagingInfo, options);
      } else {
        if (this.isInOverlay || this.topLevelOverlayComponent) {
          this.runCreateUpdateOpenInOverlay(createActionRedirectUrl, null, 'create');
        } else {
          this.lmNavigationService.runCreateActionNavigation(createActionRedirectUrl);
        }
      }
    }
  }

  private runCreateAction2(
    listContext: LMListContext,
    actionSpec: LMActionSpec,
    dataViewSet: LMDataViewSet,
    contextResourceId: string,
    multiPartFields?: LMMultiPartFields
  ) {
    const createActionUrl = this.lmListTransactionService.createActionRedirectUrl(listContext, actionSpec, dataViewSet, [ dataViewSet.header ], contextResourceId);
    if (this.stepUpActionResult) {
      listContext.stepUpActionResult = this.stepUpActionResult;
      this.stepUpActionResult = undefined;
    }

    this.lmSpecService.getRedirectUrl(createActionUrl, listContext.stepUpActionResult).subscribe(redirectResponse => {
      // getRedirectUrl response is not typed, unfortunately.

      // It will return redirect url from action controller. It may be mfaUrl, if action is privileged
      // Or if stepUpActionResult is available, it is action result after mfa code is verified. In that case, the redirect url in the stepUpActionResult is the form url to go to.
      if (((redirectResponse as LMSystemException) as LMSystemException)
        && ((redirectResponse as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR
          || (redirectResponse as LMSystemException).status === AppConstants.STATUS_UNAUTHORIZED)) {
        const rResponse = redirectResponse as LMSystemException;
        this.lmErrorUtilService.handleError(rResponse.message, rResponse.details, rResponse.status, rResponse.message);
        return;
      }

      if(redirectResponse.mfaUrl) {
        this.lmGlobalUtilService.navigate(redirectResponse.mfaUrl);
        // window.location.href = redirectResponse.mfaUrl;
        return;
      }

      if (actionSpec.hasParameters || redirectResponse.hasActionForm) {
        const lmActionInfo: LMActionInfo = { actionName: actionSpec.name, hasActionForm: redirectResponse.hasActionForm, redirectUrl: redirectResponse.redirectUrl };

        this.lmBusyIndicatorService.showBusyIndicator();

        let dataViewList: LMDataView[];
        if (this.listSpec.busListSpec.attachmentListInfo?.hasCreateAction && multiPartFields) {
          dataViewList = this.createAttachmentCreateDataView(multiPartFields);
        }
        this.lmListTransactionService.runCreateAction(listContext, actionSpec, lmActionInfo, this.getDataViewSet(), contextResourceId, dataViewList, multiPartFields).subscribe(
          (transactionState: LMTransactionState) => {

            // this.lmBusyIndicatorService.hideBusyIndicator(); // Will be closed by dialog service.

            if (transactionState.isError) {
              this.lmBusyIndicatorService.hideBusyIndicator(); // Dialog may not be up to hide the indicator.
              this.lmErrorUtilService.handleError(
                transactionState.response.message,
                transactionState.response.details,
                transactionState.response.status,
                transactionState.response.message);
            } else if (transactionState.isCanceled) {
              // TODO: noop
            } else if (transactionState.isFinished) {
              const resultList = transactionState.completedTransactionList;
              const result = transactionState.getTransactionResult();

              if (result.status === AppConstants.STATUS_COMPLETED) {
                if (result.message.length > 0 && !result.actionSpec?.suppressCompletionMessage) {
                  this.lmGlobalUtilService.displayToastMessage(actionSpec.label, result.message, AppConstants.TRA_ACTION_COMPLETED);
                  this.notifyHandCodedTransactionComplete(contextResourceId, transactionState);
                }

                if (result.isCompletionNavigation && result.redirectUrl) {
                  const formPagingInfo: LMPagingInfo = this.buildFormPagingInfo(this.getDataViewSet(), result.dataView);
                  this.lmNavigationService.runNavigation(result.redirectUrl, formPagingInfo);
                } else {
                  this.executeRefresh().subscribe();
                  const listTransactionEvent: LMListTransactionEvent = new LMListTransactionEvent(this, resultList);
                  this.listTransactionEvent.emit(listTransactionEvent);
                }
              } else {
                if (result.message.length > 0) {
                  this.lmGlobalUtilService.displayToastMessage(actionSpec.label, result.message, AppConstants.TRA_ACTION_FAILED);
                }
              }
            }
          });
      } else {
        let redirectUrl = (this.lmContextService.inMingleWidget())
          ? redirectResponse.redirectUrl : this.lmUrlUtilService.toRelativeUrl(redirectResponse.redirectUrl, true, true);

        if (this.listSpec.listType === 'select'
          || this.listSpec.listType === 'helper') {
          redirectUrl = this.lmUrlUtilService.encodeParens(redirectUrl);
          if (this.lmContextService.usePortalTabs()) {
            this.lmContextUtilService.openPortalTab(redirectUrl);
          } else {
            this.lmUrlUtilService.openExternalUrl(redirectUrl);
          }
        } else {
          if (this.isInOverlay || this.topLevelOverlayComponent) {
            if (!this.lmOverlayService.isOpening) {
              this.lmOverlayService.isOpening = true;
              this.lmOverlayService.open({
                open: true,
                url: redirectUrl,
                listOpenedId: this.listSpec.resourceId,
                resourceId: '',
                isNavigation: true,
                navigationName: 'create',
                replaceCurrentContent: this.lmOverlayService.hasOpenOverlay,
                navigationType: 'form',
                insideOverlayNav: true
              });
            }
          } else {
            this.lmGlobalUtilService.navigateByUrl(redirectUrl);
          }
        }
      }
    });
  }

  /**
   * Runs the standard open action navigation
   * @param dataView - the dataView to run the actionUrl against
   */
  private runOpenAction(dataView: LMDataView, fromDoubleClick = false) {
    if (this.previewMode) {
      this.lmGlobalUtilService.displayToastMessage(Soho.Locale.translate('PreviewOnly'), Soho.Locale.translate('PreviewOnlyMsg'), AppConstants.TRA_ACTION_COMPLETED);
      return;
    }

    // If tree list get selected tree dataview
    if (
      this.listSpec.busListSpec.implementsTreeView &&
      this.listContentComponent.getSelectedTreeDataView() &&
      !this.listSpec.busListSpec.implementsOrgChartView
    ) {
      dataView = this.listContentComponent.getSelectedTreeDataView();
    }

    if (this.listSpec.busListSpec.openActionRestricted && !this.inDrillAroundMode()) {
      throw 'open action is restricted'; // safety
    }

    if (dataView.isSubtotalView || dataView.isSubtotalSummaryView) {
      return; // For Total rows, we do not run update action
    }

    const isTreeMoreLink = (<LMListDataView>dataView)?.isTreeMoreLink;
    if (dataView.isNewRow || isTreeMoreLink) {
      // Unable to open an inline create row or a more tree link row.
      return;
    }

    if (this.isCubeView && !dataView.openFormResId) {
      // The record can be opened only if the dimension is a key field dimension.
      // The property is set based on the dimension type.
      return;
    }

    if (this.inDrillAroundMode()) {
      this.runDrillAround(dataView);
      return;
    }

    if (dataView.redirectAction) {
      this.runRedirectAction(dataView);
      return;
    }

    let validFormRef: BusListSpecForm;
    if (this.listSpec.busListSpec.formRefs) {
      // const navs: Array<BusListSpecForm> = this.listSpec.busListSpec.formRefs.filter(formRef => formRef.type === 'nav');
      if (this.listSpec.busListSpec.formRefs?.length > 0) {
        // Check for a valid navigation
        for (const ref of this.listSpec.busListSpec.formRefs) {
          if (ref.validity === undefined) {
            validFormRef = ref;
            break;
          }
          if (ref.type === 'nav' && dataView.navigations.indexOf(ref.name) === -1) {
            // The navigations themselves will have validity conditions. If they are not valid, continue
            continue;
          }
          // Evaluate validity condition defined in ListDefinition for 'form is ..' or 'form navigation is ..'
          if (this.lmConditionUtilService.isValid([ ref.validity ], dataView)) {
            validFormRef = ref;
            break;
          }
        }
        if (validFormRef && validFormRef.type === 'nav') {
          // Last parameter - is fromListResource required?
          this.runLinkNavigation(validFormRef.name, dataView.resourceId, false, undefined, false, false);
          return;
        }
      }
    }

    // ValidFormRef is only used to determine if the form is an action form.
    this._runOpenAction(dataView, validFormRef, fromDoubleClick);
  }

  private _runOpenAction(dataView: LMDataView, formRef?: BusListSpecForm, fromDoubleClick = false) {
    /**
     * Start the busy indicator and place code to process the
     * route change or dialog in a timeout so the busy indicator
     * will display.
     */

    setTimeout(() => {
      let openActionRedirectUrlTemplate;
      let openActionRedirectUrl;

      // TODO ListTemplatePattern this will need to change because the form needs the dataView for navigation, next and previous will not
      // work properly when navigating to the form
      let updateActionForm = false;
      let actionName = AppConstants.ACTION_OPEN;

      // Opening a record in template list will not participate in action refactor code
      if (this.listSpec.isTemplateList) {
        const templateDataView = dataView.dataView;
        if (templateDataView.isAlreadyDefined) {
          openActionRedirectUrlTemplate = urltemplate.parse(this.listUrlInfo.openActionRedirectUrl);
          openActionRedirectUrl = openActionRedirectUrlTemplate.expand({
            resourceId: templateDataView.resourceId,
            contextResourceId: this.listResource.resourceId,
            actionName
          });
        } else {
          const createAction = this.lmActionService.getDefaultCreateAction(this.listSpec.busClassSpec.actions, templateDataView.actionIndexes);
          openActionRedirectUrlTemplate = urltemplate.parse(this.listUrlInfo.actionRedirectUrl);
          openActionRedirectUrl = openActionRedirectUrlTemplate.expand({
            resourceId: templateDataView.resourceId,
            actionName: createAction.name,
            contextResourceId: templateDataView.resourceId,
          });
        }
      } else {
        // If 'open action is <action>' in list definition opens an action form or the first valid update opens an action form,
        // run with it. It will override the formref in List definition 'form is <FormName>'.
        // When action refactor is on, leave actionName as _open. Action controller will find the update action spec.
        // The logic to override the formref is also in the servlet since with action refactor on, the form to open will be determined later.
        if (!this.lmContextService.isActionSpecRefactorOn()) {
          const updateActionSpec: LMActionSpec = this.lmActionService.getDefaultUpdateAction(this.listSpec.busClassSpec.actions, dataView.actionIndexes, true, true);
          if (updateActionSpec) {
            if (updateActionSpec.hasActionForm || updateActionSpec.hasParameters) {
              updateActionForm = true;
              actionName = updateActionSpec.name;
            }
          }
        }

        openActionRedirectUrlTemplate = urltemplate.parse(this.listUrlInfo.openActionRedirectUrl);
        let contextResourceId = this.getDataViewSet().header.resourceId;
        if (this.listSpec.busListSpec.implementsTreeView &&
            this.listContentComponent.getSelectedTreeDataView() &&
            !this.listSpec.busListSpec.implementsOrgChartView &&
            !this.isCubeView) {

          if ((dataView as LMListDataView).parentId !== 0) {
            const parentDataView = this.listContentComponent.listTree.findParentNode(dataView);
            contextResourceId = parentDataView.contextResourceId;
          }
        }

        openActionRedirectUrl = openActionRedirectUrlTemplate.expand({
          resourceId: (this.isCubeView) ? dataView.openFormResId : dataView.resourceId,
          contextResourceId,
          actionName
        });

        const delimiter = (openActionRedirectUrl.indexOf('?') > -1) ? '&' : '?';
        if (!this.listUrlInfo.cubeParams?.cubeMediator
          && (this.listUrlInfo.sourceResource?.resourceType === AppConstants.RESOURCETYPE_DRILL
          ||  this.listUrlInfo.sourceResource?.resourceType === AppConstants.RESOURCETYPE_NAVIGATION
          ||  this.listUrlInfo.sourceResource?.resourceType === AppConstants.RESOURCETYPE_RELATION)) {
          const fromResource = this.buildFromResource();
          openActionRedirectUrl += `${delimiter}${fromResource.resourceType}=${fromResource.generateResourceId(true)}`;
        }

        if (this.lmContextService.isActionSpecRefactorOn()) {
          if (this.listSpec.userFolder) {
            openActionRedirectUrl += '&userfolder=' + this.listSpec.userFolder;
          }
          this._runOpenAction2(openActionRedirectUrl, dataView, fromDoubleClick);
          return;
        }
      }

      if (updateActionForm || (formRef?.isActionForm)) {
        this.showBusyIndicator();

        this.lmSpecService.getFormSpecFromRedirectActionUrl(openActionRedirectUrl).subscribe((response: LMActionFormUrlResponse | LMSystemException) => {

          if ((response as LMSystemException).status
            && ((response as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR
              || (response as LMSystemException).status === AppConstants.STATUS_UNAUTHORIZED)) {
            this.hideBusyIndicator();
            this.lmErrorUtilService.handleError((response as LMSystemException).statusText, (response as LMSystemException).details);
            return;
          }

          const formUrlInfo = (response as LMActionFormUrlResponse).formUrlInfo;
          const formSpec = (response as LMActionFormUrlResponse).formSpec;
          const resourceId =  (response as LMActionFormUrlResponse).resourceId;
          const action = (response as LMActionFormUrlResponse).action;
          const urlCompiledTemplate = urltemplate.parse(formUrlInfo.initialDataUrl);
          const url = urlCompiledTemplate.expand({ resourceId, actionName: action });

          this.lmListActionFormDialogService.getActionFormDialogDataView(url).subscribe((responseDV: any) => {
            const formDataView: LMDataView = responseDV;

            if (formDataView.status === AppConstants.STATUS_COMPLETED) {
              const actionSpec = this.lmActionService.getActionByName(this.listSpec.busClassSpec.actions, action);

              this.lmListActionFormDialogService.runActionFormDialog(
                formUrlInfo, formSpec, formDataView, actionSpec, this.modalPlaceholder
              ).subscribe((result: LMActionFormDialogResult) => {
                if (this.lmContextService.useListFormOverlay() && (this.isInOverlay || this.topLevelOverlayComponent)) {
                  // make sure busy indicators showed in the flyout when a preview button click opens an
                  // action form is dismissed
                  this.hideBusyIndicator();
                }
                if (result.result === LMActionFormDialogResultCode.ACTION_FORM_DIALOG_SAVED) {
                  this.executeRefresh().subscribe();
                  const title = actionSpec.label;
                  const message = result.transactionStateResult.completedTransactionList[ 0 ].message;
                  this.lmGlobalUtilService.displayToastMessage(title, message, AppConstants.TRA_ACTION_COMPLETED);
                }
              });
            } else {
              if (this.lmContextService.useListFormOverlay() && (this.isInOverlay || this.topLevelOverlayComponent)) {
                this.hideBusyIndicator();
              }
              this.lmLoggerService.error(responseDV);
              this.lmErrorUtilService.handleError(responseDV.message, responseDV.details, responseDV.status, responseDV.statusText);
            }
          });
        });
        } else {
          if (this.listSpec.userFolder) {
            openActionRedirectUrl += '&userfolder=' + this.listSpec.userFolder;
          }
            // todo spec-url-refactor - mikef - when running to a form we push the first and last
            //   viewkey info on them. But many of these are camel cased so I'm not sure how this pans out.
            //   pageSize is one I see that isn't really ever used in the back end AFAIK.
            const formPagingInfo: LMPagingInfo = this.buildFormPagingInfo(this.getDataViewSet(), dataView);
            if (this.listSpec.listType === 'select' || this.listSpec.listType === 'helper') {
              // TODO: LMWEB-19598 - Can select or helper list display archive data or asofdate data?
              const options = this.lmContextService.usePortalTabs() ? { openNewPortalTab: true } : { openNewTab: true };
              this.lmNavigationService.runNavigation(openActionRedirectUrl, formPagingInfo, options);
            } else {
              openActionRedirectUrl = this.setGlobalModeOnNavigation(openActionRedirectUrl);
              if (this.isInOverlay || this.topLevelOverlayComponent) {
                this.runCreateUpdateOpenInOverlay(openActionRedirectUrl, dataView, 'open');
              } else {
                // Close the flyout if it's open or opening (e.g. from a double-click race condition)
                if (this.lmOverlayService.hasOpenOverlay) {
                  this.lmOverlayService.close();
                }
                this.lmNavigationService.runNavigation(openActionRedirectUrl, formPagingInfo);
              }
            }
          }
      }); // , 500);
    }

  private _runOpenAction2(openActionRedirectUrl: string, dataView: LMDataView, fromDoubleClick: boolean) {
    this.lmSpecService.getRedirectUrl(openActionRedirectUrl).subscribe(redirectResponse => {
      // getRedirectUrl response is not typed, unfortunately.

      // It will return redirect url from action controller.
      if (((redirectResponse as LMSystemException) as LMSystemException)
        && ((redirectResponse as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR
          || (redirectResponse as LMSystemException).status === AppConstants.STATUS_UNAUTHORIZED)) {
        const rResponse = redirectResponse as LMSystemException;
        this.lmErrorUtilService.handleError(rResponse.message, rResponse.details, rResponse.status, rResponse.message);
        return;
      }

      // NO MFA, since this is from _open

      if (redirectResponse.hasActionForm || redirectResponse.hasParameters) {

        this.showBusyIndicator();

        this.lmSpecService.getFormSpecFromDialogActionUrl(redirectResponse.redirectUrl).subscribe((response: LMFormSpecResponse | LMSystemException) => {

          if ((response as LMSystemException).status
            && ((response as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR
              || (response as LMSystemException).status === AppConstants.STATUS_UNAUTHORIZED)) {
            this.lmBusyIndicatorService.hideBusyIndicator();
            this.lmErrorUtilService.handleError((response as LMSystemException).statusText, (response as LMSystemException).details);
            return;
          }

          const formUrlInfo = (response as LMFormSpecResponse).formUrlInfo;
          const formSpec = (response as LMFormSpecResponse).formSpec;
          const resourceId =  (response as LMFormSpecResponse).resourceId;
          const action = (response as LMFormSpecResponse).action;
          const urlCompiledTemplate = urltemplate.parse(formUrlInfo.initialDataUrl);
          const url = urlCompiledTemplate.expand({ resourceId, actionName: action });

          this.lmListActionFormDialogService.getActionFormDialogDataView(url).subscribe((responseDV: any) => {
            const formDataView: LMDataView = responseDV;

            if (formDataView.status === AppConstants.STATUS_COMPLETED) {
              const actionSpec = this.lmActionService.getActionByName(this.listSpec.busClassSpec.actions, action);

              this.lmListActionFormDialogService.runActionFormDialog(
                formUrlInfo, formSpec, formDataView, actionSpec, this.modalPlaceholder
              ).subscribe((result: LMActionFormDialogResult) => {
                if (this.lmContextService.useListFormOverlay() && (this.isInOverlay || this.topLevelOverlayComponent)) {
                  // make sure busy indicators showed in the flyout when a preview button click opens an
                  // action form is dismissed
                  this.hideBusyIndicator();
                }
                if (result.result === LMActionFormDialogResultCode.ACTION_FORM_DIALOG_SAVED) {
                  this.executeRefresh().subscribe();
                  const title = actionSpec.label;
                  const message = result.transactionStateResult.completedTransactionList[ 0 ].message;
                  this.lmGlobalUtilService.displayToastMessage(title, message, AppConstants.TRA_ACTION_COMPLETED);
                }
              });
            } else {
              if (this.lmContextService.useListFormOverlay() && (this.isInOverlay || this.topLevelOverlayComponent)) {
                this.hideBusyIndicator();
              }
              this.lmLoggerService.error(responseDV);
              this.lmErrorUtilService.handleError(responseDV.message, responseDV.details, responseDV.status, responseDV.statusText);
            }
          });
        });
      } else {
        let redirectUrl = (this.lmContextService.inMingleWidget())
          ? redirectResponse.redirectUrl : this.lmUrlUtilService.toRelativeUrl(redirectResponse.redirectUrl, true, true);

        const formPagingInfo: LMPagingInfo = this.buildFormPagingInfo(this.getDataViewSet(), dataView);
        if (formPagingInfo) {
          const delimiter = redirectUrl.indexOf('?') === -1 ? '?' : '&';
          redirectUrl += delimiter + Object.entries(formPagingInfo).map(pair => LMUrlUtilService.toUrlParam(pair, true)).join('&');
        }
        if (this.listSpec.listType === 'select'
          || this.listSpec.listType === 'helper') {
          redirectUrl = this.lmUrlUtilService.encodeParens(redirectUrl);
          if (this.lmContextService.usePortalTabs()) {
            this.lmContextUtilService.openPortalTab(redirectUrl);
          } else {
            this.lmUrlUtilService.openExternalUrl(redirectUrl);
          }
        } else {
          redirectUrl = this.setGlobalModeOnNavigation(redirectUrl);
          if (this.isInOverlay || this.topLevelOverlayComponent) {
            this._runCreateUpdateOpenInOverlay(redirectUrl, dataView, 'open');
          } else {
            this.lmGlobalUtilService.navigateByUrl(redirectUrl);
          }
        }
      }
    });
  }

  private runRedirectAction(dataView: LMDataView, actionSpec?: LMActionSpec) {
    const redirectAction = actionSpec ? actionSpec.name : dataView.redirectAction;
    if (!redirectAction || !dataView.actionMeta) {
      return;
    }

    const actionMeta = dataView.actionMeta[ redirectAction ];
    if (!actionMeta || !actionMeta.isActionRedirect) {
      return;
    }
    if (actionMeta.postAction) {
      // Run Post action, if it is valid
      const postActionSpec = this.lmActionService.getActionByName(this.listSpec.busClassSpec.actions, actionMeta.postAction);
      if (this.lmActionService.isValidAction(postActionSpec, this.listSpec.busClassSpec.actions, dataView.actionIndexes)) {
        const refreshList = (actionMeta.redirectType === AppConstants.ACTIONREDIRECT_TYPE_VIEW || // Refresh list if "VIEW" (documents, which open in a new tab or download)
          (actionMeta.redirectType === AppConstants.ACTIONREDIRECT_TYPE_ACTION                    // or if opening in modal (typically action forms)
            && (actionMeta.hasParameters || actionMeta.hasActionForm)));  // ok to check hasActionForm. redirectBusFormBase uses the new API when actionspec refactor is on
        this.runPostActionForActionRedirect(postActionSpec, dataView, refreshList);
      }
    }

    switch (actionMeta.redirectType) {
      case AppConstants.ACTIONREDIRECT_TYPE_ACTION:
        if (actionMeta.hasParameters || actionMeta.hasActionForm) {
          this.lmBusyIndicatorService.showBusyIndicator();
          setTimeout(() => {
            const openActionRedirectUrlTemplate = urltemplate.parse(this.listUrlInfo.openActionRedirectUrl);
            const openActionRedirectUrl = openActionRedirectUrlTemplate.expand({
              resourceId: dataView.resourceId,
              contextResourceId: this.getDataViewSet().header.resourceId,
              actionName: redirectAction
            });
            this.lmSpecService.getFormSpecFromRedirectActionUrl(openActionRedirectUrl).subscribe((response: LMActionFormUrlResponse | LMSystemException) => {

              if ((response as LMSystemException).status
                && ((response as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR
                  || (response as LMSystemException).status === AppConstants.STATUS_UNAUTHORIZED)) {
                this.lmBusyIndicatorService.hideBusyIndicator();
                this.lmErrorUtilService.handleError((response as LMSystemException).statusText, (response as LMSystemException).details);
                return;
              }

              const formUrlInfo = (response as LMActionFormUrlResponse).formUrlInfo;
              const formSpec = (response as LMActionFormUrlResponse).formSpec;
              const resourceId = (response as LMActionFormUrlResponse).resourceId;
              const action = (response as LMActionFormUrlResponse).action;
              const urlCompiledTemplate = urltemplate.parse(formUrlInfo.initialDataUrl);
              const url = urlCompiledTemplate.expand({ resourceId, actionName: action });
              // LMCLIENT-18522: We can use ContextualActionPanel when this issue is resolved -  https://github.com/infor-design/enterprise/issues/1943
              // At that time, all modal dialogs invoked from the contextual panel should have the class modal in the
              // dialog place holder in order for it to work.
              // Eg. Look up dialog from a form in Contextual panel requires modal class in the dialog placeholder.

              // this.lmContextualActionPanelService.getContextualPanelDataView(url).subscribe((responseDV: any) => {
              this.lmListActionFormDialogService.getActionFormDialogDataView(url).subscribe((responseDV: any) => {
                const formDataView: LMDataView = responseDV;
                if (formDataView.status === AppConstants.STATUS_COMPLETED) {
                  const redirectActionSpec = this.lmActionService.getActionByName(formSpec.busClassSpec.actions, action);
                  this.lmListActionFormDialogService.runActionFormDialog(formUrlInfo, formSpec, formDataView, redirectActionSpec, this.modalPlaceholder)
                    .subscribe((result: LMActionFormDialogResult) => {
                      if (result.result === LMActionFormDialogResultCode.ACTION_FORM_DIALOG_SAVED) {
                        this.executeRefresh().subscribe();
                        const title = redirectActionSpec.label;
                        const message = result.transactionStateResult.completedTransactionList[ 0 ].message;
                        this.lmGlobalUtilService.displayToastMessage(title, message, AppConstants.TRA_ACTION_COMPLETED);
                      }
                    });
                } else {
                  this.lmLoggerService.error(responseDV);
                  this.lmErrorUtilService.handleError(responseDV.message, responseDV.details, responseDV.status, responseDV.statusText);
                }
              });
            });

          });
        } else if(actionSpec?.auditCorrection) {
          // If audit correction and has parameters, change effective date action will be served by the block above.
          // This is specifically for Audit Delete.
          this.runAuditDeleteRedirectAction(dataView, redirectAction);
        } else {
          // Message notifications are of action type and navigates to form
          const updateActionRedirectUrlTemplate = urltemplate.parse(this.listUrlInfo.actionRedirectUrl);
          const updateActionRedirectUrl: string = updateActionRedirectUrlTemplate.expand({
            resourceId: dataView.resourceId,
            actionName: redirectAction,
            contextResourceId: this.getDataViewSet().header.resourceId,
          });
          const formPagingInfo: LMPagingInfo = this.buildFormPagingInfo(this.getDataViewSet(), dataView);
          this.lmNavigationService.runNavigation(updateActionRedirectUrl, formPagingInfo);
        }
        break;
      case AppConstants.ACTIONREDIRECT_TYPE_NAVIGATION:
      case AppConstants.ACTIONREDIRECT_TYPE_URL:
        const navUrl = actionMeta.url.substr(0, actionMeta.url.indexOf('?'));
        if (navUrl.indexOf('/form/') > -1) {
          setTimeout(() => {
            this.lmGlobalUtilService.navigateByUrl(actionMeta.url);
          });
        } else {
          setTimeout(() => {
            const formPagingInfo: LMPagingInfo = this.buildFormPagingInfo(this.getDataViewSet(), dataView);
            this.lmNavigationService.runNavigation(actionMeta.url, formPagingInfo);
          });
        }
        break;
      case AppConstants.ACTIONREDIRECT_TYPE_PAGE:
      case AppConstants.ACTIONREDIRECT_TYPE_LIST:
      case AppConstants.ACTIONREDIRECT_TYPE_FOLDER:
        setTimeout(() => {
          this.lmGlobalUtilService.navigateByUrl(actionMeta.url);
        });
        break;
      case AppConstants.ACTIONREDIRECT_TYPE_VIEW:
        setTimeout(() => {
          const documentResource = new DocumentResource({
            resourceId: actionMeta.resourceId,
            fieldName: actionMeta.fieldName
          }, '');
          const url = this.lmUrlUtilService.buildUrl({ resource: documentResource });
          if (actionMeta.mimeType === 'application/pdf') {
            this.lmGlobalUtilService.navigate(url, null, 'external');
          } else {
            this.lmGlobalUtilService.navigate(url);
          }
        });
        break;
      case AppConstants.ACTIONREDIRECT_TYPE_NEWWEBAPP:
        const newAppDialogId = 'NewApplication';
        let message: LMMessageWrapperDialogRef;
        const buttons = [
          // tslint:disable-next-line - shadowed variable e
          {
            id: this.lmUniqueIdService.uniqueId([ newAppDialogId, LMDialogButtonKey.CLOSE ]),
            text: Soho.Locale.translate(LMDialogButtonKey.CLOSE),
            click: (e, modal) => {
              modal.close();
            }
          }
        ];
        if (!actionMeta.appDeployed) {
          message = this.lmModalWrapperService
            .message()
            .message(Soho.Locale.translate('NewApplicationisnotDeployed'))
            .title('')
            .buttons(buttons)
            .open();
          return;
        }
        if (actionMeta.securedApp) {
          message = this.lmModalWrapperService
            .message()
            .message(Soho.Locale.translate('NewApplicationisSecured'))
            .title('')
            .buttons(buttons)
            .open();
          return;
        }
        setTimeout(() => {
          this.lmGlobalUtilService.navigateByUrl(actionMeta.url);
        });
        break;
      default:
        const dialogId = 'ActionRedirectNotImplemented';
        const defButtons = [
          // tslint:disable-next-line - shadowed variable e
          {
            id: this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.CLOSE ]),
            text: Soho.Locale.translate(LMDialogButtonKey.CLOSE),
            click: (e, modal) => {
              modal.close();
            }
          }
        ];
        this.lmModalWrapperService
          .message()
          .message('Action Redirect type ' + actionMeta.redirectType + ' is not implemented.')
          .title('')
          .buttons(defButtons)
          .open();
    }
  }

  private runPostActionForActionRedirect(actionSpec: LMActionSpec, dataView: LMDataView, refreshList: boolean) {
    // Run Post action, if it is valid
    if (this.lmActionService.isValidAction(actionSpec, this.listSpec.busClassSpec.actions, dataView.actionIndexes)) {
      // this.runInstanceAction(actionSpec, this.getDataViewSet(), [this.selectedRow]);
      const listContext: LMListContext = {
        listUrlInfo: this.listUrlInfo,
        listSpec: this.listSpec
      };
      const dataViewList: LMDataView[] = [ dataView ];

      this.lmListTransactionService.runInstanceAction(listContext, actionSpec, { actionName: actionSpec.name, hasActionForm: false }, this.getDataViewSet(), dataViewList)
        .subscribe((transactionState: LMTransactionState) => {
          const resultList = transactionState.completedTransactionList;
          if (transactionState.isFinished && AppConstants.STATUS_COMPLETED === resultList[0].status) {
            this.lmGlobalUtilService.displayToastMessage(actionSpec.label, resultList[0].message, AppConstants.TRA_ACTION_COMPLETED);
            if (refreshList) {
              this.executeRefresh().subscribe();
            }
          }
        });
    }
  }

  private runAuditDeleteRedirectAction(dataView: LMDataView, redirectAction: string) {
    // Algorithm for Audit Delete:
    // AuditDelete in Auditlog redirects to EffectiveDatedGroup, CancelNew action
    // No parameters to run the action, so rich client runs the redirect action, an instance action, directly.
    // Web client takes you to the form for EffectiveDatedGroup and expects the user to click CancelNew.
    // The preferred behavior is to run the instance action seamlessly like rich client.
    //
    // ActionControllerAction returns RedirectDataView and RedirectActionSpec
    // Get BusClassSpec for EffectiveDatedGroup, since transaction service requires it.

    this.lmBusyIndicatorService.showBusyIndicator();
    const updateActionRedirectUrlTemplate = urltemplate.parse(this.listUrlInfo.actionRedirectUrl);
    let updateActionRedirectUrl: string = updateActionRedirectUrlTemplate.expand({
      resourceId: dataView.resourceId,
      actionName: redirectAction,
      contextResourceId: this.getDataViewSet().header.resourceId,
    });
    updateActionRedirectUrl = this.lmUrlUtilService.updateUrlParams(updateActionRedirectUrl, { output: 'spec' });
    this.lmNavigationService.getActionNavigationUrl(updateActionRedirectUrl).subscribe(actionResponse => {
      if (actionResponse.status && actionResponse.status === AppConstants.STATUS_SYSTEM_ERROR) {
        this.lmBusyIndicatorService.hideBusyIndicator();
        this.lmErrorUtilService.handleError(actionResponse.message, actionResponse.details, actionResponse.status, actionResponse.statusText);
        return;
      }
      if (actionResponse.redirectActionSpec && actionResponse.redirectDataView) {
        // Get the list spec for EffectiveDateGroup business class
        const urlParamsToBeEncoded = { ...this.lmContextService.getContext().contextSessionKeys };
        const listUrl = LMUrlUtilService.buildUrl2(this.lmUrlUtilService.getBaseUrl(), 'list',
          actionResponse.redirectDataView.busClassName, urlParamsToBeEncoded);
        this.lmSpecService.getListSpec(listUrl).subscribe((listResponse: LMListSpecResponse | LMSystemException) => {
          if ((listResponse as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR) {
            this.lmBusyIndicatorService.hideBusyIndicator();
            const statusText = (listResponse as LMSystemException).statusText;
            const details = (listResponse as LMSystemException).details;
            this.lmErrorUtilService.handleError(statusText, details);
            return;
          }
          // Build a DVS using redirectDataView
          const dvsForRedirectBusclassList: LMDataViewSet = { header: actionResponse.redirectDataView, data: [ actionResponse.redirectDataView ] };
          const lmListContext = { listSpec: (listResponse as LMListSpecResponse).listSpec, listUrlInfo: (listResponse as LMListSpecResponse).listUrlInfo };
          const actionInfo = { actionName: actionResponse.action, hasActionForm: actionResponse.hasActionForm, redirectUrl: actionResponse.redirectUrl };
          // Execute the instance action
          this.lmListTransactionService.runInstanceAction(lmListContext, actionResponse.redirectActionSpec, actionInfo, dvsForRedirectBusclassList, [ actionResponse.redirectDataView ])
            .subscribe((transactionState: LMTransactionState) => {
              this.lmBusyIndicatorService.hideBusyIndicator();

              if (transactionState.isError) {
                this.lmErrorUtilService.handleError(
                  transactionState.response.message,
                  transactionState.response.details,
                  transactionState.response.status,
                  transactionState.response.message);
              }

              const resultList = transactionState.completedTransactionList;
              if (transactionState.isFinished && AppConstants.STATUS_COMPLETED === resultList[0].status) {
                this.lmGlobalUtilService.displayToastMessage(actionResponse.redirectActionSpec.label, resultList[0].message, AppConstants.TRA_ACTION_COMPLETED);
                this.executeRefresh().subscribe();
              }
            });
        });
      }
    });
  }

  private notifyHandCodedTransactionComplete(resourceId: string, transactionState?: LMTransactionState) {
    const htmlDocComp: LMHtmlUrlDocComponent = this.currentComponent.getHtmlUrlDocComponent();
    const transactionList: LMActionRequest[] = transactionState instanceof LMTransactionState ? transactionState?.completedTransactionList : undefined;
    const actionName: string = (transactionList && transactionList.length > 0) ? transactionList[0]?.actionSpec?.name: '';
    let message = '';

    if (htmlDocComp) {
      const transListDataView = transactionList ? transactionList[0]?.dataView : undefined;
      message = transactionList ? transactionList[0]?.['message'] : '';
      htmlDocComp.fireFormActionComplete(LMActionFormDialogResultCode.ACTION_FORM_DIALOG_SAVED,
        { message: message, resourceId: resourceId, action: actionName,  dataview: transListDataView });
    }
  }

  /**
   * merge posToViewKey into LMPagingInfo for use in form paging.
   */
  private buildFormPagingInfo(dataViewSet: LMDataViewSet, dataView: LMDataView): LMPagingInfo {
    if (this.listUrlInfo.filterId) {
      return undefined;
    }

    const formPagingInfo: LMPagingInfo = Object.assign({}, dataViewSet.pagingInfo, dataView.posToViewKey);
    return formPagingInfo;
  }

  /**
   * Runs the update action for the BusActionReference against the passed in LMDataView
   * @param actionReference - the actionReference of the action to open the update form with.
   * @param dataView - the dataView to run the actionUrl against
   */
  private runUpdateAction(actionSpec: LMActionSpec, dataView: LMDataView, actionReferenceId: string = null): void {
    if (dataView.isSubtotalView || dataView.isSubtotalSummaryView) {
      return; // For Total rows, we do not run update action
    }

    if (actionReferenceId === AppConstants.STANDARD_TOOLBAR_UPDATE) {
      const updateActionSpec = this.lmActionService.getDefaultUpdateAction(this.listSpec.busClassSpec.actions, dataView.actionIndexes, true, true);
      if (!updateActionSpec) {
        // if there is no valid updateActionSpec then run against the standard _open
        this.runOpenAction(dataView);
        return;
      }
      actionSpec = updateActionSpec; // todo doesn't seem to get used?!?
    } else if (actionSpec !== null) {
      if (actionSpec.name === dataView.redirectAction) {
        this.runRedirectAction(dataView);
        return;
      } else if (dataView.actionMeta && dataView.actionMeta[actionSpec.name] !== undefined) {
        this.runRedirectAction(dataView, actionSpec);
        return;
      }

      if (this.lmContextService.isActionSpecRefactorOn()) {
        this.runUpdateAction2(actionSpec, dataView);
        return;
      }

      if (actionSpec.hasParameters || actionSpec.hasActionForm) {
        this.lmBusyIndicatorService.showBusyIndicator();
        // Get the action redirect url from list spec.
        setTimeout(() => {
          const actionRedirectUrlTemplate = urltemplate.parse(this.listUrlInfo.actionRedirectUrl);
          const actionRedirectUrl = actionRedirectUrlTemplate.expand({
            actionName: actionSpec.name,
            resourceId: dataView.resourceId,
            contextResourceId: this.getDataViewSet().header.resourceId,
          });

          let stepUpActionResult;
          if (this.stepUpActionResult) {
            stepUpActionResult = this.stepUpActionResult;
            this.stepUpActionResult = undefined;
          }
          this.lmSpecService.getFormSpecFromRedirectActionUrl(actionRedirectUrl, stepUpActionResult).subscribe((response: LMActionFormUrlResponse | LMSystemException) => {

            if ((response as LMSystemException).status
              && ((response as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR || (response as LMSystemException).status === AppConstants.STATUS_UNAUTHORIZED)) {
              this.lmBusyIndicatorService.hideBusyIndicator();
              const message = (response as LMSystemException).statusText !== undefined ? (response as LMSystemException).statusText : (response as LMSystemException).message;
              this.lmErrorUtilService.handleError(message, (response as LMSystemException).details);
              return;
            }

            const formUrlInfo = (response as LMActionFormUrlResponse).formUrlInfo;
            const formSpec = (response as LMActionFormUrlResponse).formSpec;
            const resourceId = (response as LMActionFormUrlResponse).resourceId;
            const action = (response as LMActionFormUrlResponse).action;
            const urlCompiledTemplate = urltemplate.parse(formUrlInfo.initialDataUrl);
            const url = urlCompiledTemplate.expand({ resourceId, actionName: action });

            this.lmListActionFormDialogService.getActionFormDialogDataView(url).subscribe((responseDV: any) => {
              const formDataView: LMDataView = responseDV;
              if (formDataView.status === AppConstants.STATUS_COMPLETED) {
                this.lmListActionFormDialogService.runActionFormDialog(formUrlInfo, formSpec, formDataView, actionSpec, this.modalPlaceholder)
                  .subscribe((result: LMActionFormDialogResult) => {
                    if (result.result === LMActionFormDialogResultCode.ACTION_FORM_DIALOG_SAVED) {
                      const actionResult = result.transactionStateResult.getTransactionResult();
                      if (actionResult.message.length > 0 && !actionResult.actionSpec?.suppressCompletionMessage) {
                        this.lmGlobalUtilService.displayToastMessage(actionSpec.label, actionResult.message, AppConstants.TRA_ACTION_COMPLETED);
                        this.notifyHandCodedTransactionComplete(this.getDataViewSet()?.header?.resourceId, result?.transactionStateResult);
                      }
                      if (actionResult.status === AppConstants.STATUS_COMPLETED) {
                        if (actionResult?.isCompletionNavigation && actionResult?.redirectUrl) {
                          const formPagingInfo: LMPagingInfo = this.buildFormPagingInfo(this.getDataViewSet(), actionResult.dataView);
                          this.lmNavigationService.runNavigation(actionResult.redirectUrl, formPagingInfo);
                        } else {
                          this.executeRefresh().subscribe();
                          const listTransactionEvent: LMListTransactionEvent = new LMListTransactionEvent(this, [ actionResult ]);
                          this.listTransactionEvent.emit(listTransactionEvent);
                        }
                      }
                    }
                  });
              } else {
                this.lmBusyIndicatorService.hideBusyIndicator();
                this.lmLoggerService.error(responseDV);
                this.lmErrorUtilService.handleError(responseDV.message, responseDV.details, responseDV.status, responseDV.statusText);
              }
            });
          });
        });
        return;
      } else {
        if (this.stepUpActionResult) {
          const redirectUrl = (this.lmContextService.inMingleWidget())
            ? this.stepUpActionResult.redirectUrl : this.lmUrlUtilService.toRelativeUrl(this.stepUpActionResult.redirectUrl, true, true);
          this.stepUpActionResult = undefined;
          this.lmGlobalUtilService.navigateByUrl(redirectUrl);
          return;
        }

        const updateActionRedirectUrlTemplate = urltemplate.parse(this.listUrlInfo.actionRedirectUrl);
        const updateActionRedirectUrl: string = updateActionRedirectUrlTemplate.expand({
          resourceId: dataView.resourceId,
          actionName: actionSpec.name,
          contextResourceId: this.getDataViewSet().header.resourceId,
        });

        const formPagingInfo: LMPagingInfo = this.buildFormPagingInfo(this.getDataViewSet(), dataView);
        if (this.listSpec.listType === 'select' || this.listSpec.listType === 'helper') {
          const options = this.lmContextService.usePortalTabs() ? { openNewPortalTab: true } : { openNewTab: true };
          this.lmNavigationService.runNavigation(updateActionRedirectUrl, formPagingInfo, options);
        } else {
          if (this.isInOverlay || this.topLevelOverlayComponent) {
            this.runCreateUpdateOpenInOverlay(updateActionRedirectUrl, dataView, 'update');
          } else {
            this.lmNavigationService.runNavigation(updateActionRedirectUrl, formPagingInfo);
          }
        }
      }
    } else {
      // -------------------------------------------------------------------
      // get actionSpec and verify it's valid
      // -------------------------------------------------------------------
      if (!this.lmActionService.isValidAction(actionSpec, this.listSpec.busClassSpec.actions, dataView.actionIndexes)) {
        throw 'Cannot run update Action: \'' + actionSpec.name + '\' is not a valid update action.';
      }
    }
  }

  private runCreateUpdateOpenInOverlay(redirectUrl: string, dataView: LMDataView, navigationName: string) {
    if (this.lmOverlayService.isOpening) {
      return;
    }
    this.lmOverlayService.isOpening = true;

    const navigationUrl = this.lmUrlUtilService.updateUrlParams(redirectUrl, { output: 'spec' });
    this.lmNavigationService.getActionNavigationUrl(navigationUrl).subscribe(response => {
      if (response.messageId && !response.redirectUrl) {
        // Common Inbox Integration - Direct route to open notification may return error messages.
        this.lmErrorUtilService.handleError(Soho.Locale.translate(response.messageId));
        this.lmOverlayService.isOpening = false;
        return;
      } else if (response.status && response.status === AppConstants.STATUS_SYSTEM_ERROR) {
        this.lmErrorUtilService.handleError(response.message, response.details, response.status, response.statusText);
        this.lmOverlayService.isOpening = false;
        return;
      }
      const redirectUrl = this.lmUrlUtilService.toRelativeUrl(response.redirectUrl, true, true);

      this._runCreateUpdateOpenInOverlay(redirectUrl, dataView, navigationName);
    });
  }

  private _runCreateUpdateOpenInOverlay(redirectUrl: string, dataView: LMDataView, navigationName: string) {
    let resourceId = '';
    if (dataView)
      resourceId = dataView.resourceId;

    this.lmOverlayService.open({
      open: true,
      url: redirectUrl,
      listOpenedId: this.listSpec.resourceId,
      resourceId,
      isNavigation: true,
      navigationName,
      replaceCurrentContent: this.lmOverlayService.hasOpenOverlay,
      navigationType: 'form',
      insideOverlayNav: true
    });
  }

  private runUpdateAction2(actionSpec: LMActionSpec, dataView: LMDataView) {
    const updateActionRedirectUrlTemplate = urltemplate.parse(this.listUrlInfo.actionRedirectUrl);
    const updateActionRedirectUrl: string = updateActionRedirectUrlTemplate.expand({
      resourceId: dataView.resourceId,
      actionName: actionSpec.name,
      contextResourceId: this.getDataViewSet().header.resourceId,
    });
    let stepUpActionResult;
    if (this.stepUpActionResult) {
      stepUpActionResult = this.stepUpActionResult;
      this.stepUpActionResult = undefined;
    }
    this.lmSpecService.getRedirectUrl(updateActionRedirectUrl, stepUpActionResult).subscribe(redirectResponse => {
      // getRedirectUrl response is not typed, unfortunately.

      // It will return redirect url from action controller. It may be mfaUrl, if action is privileged
      // Or if stepUpActionResult is available, it is action result after mfa code is verified. In that case, the redirect url in the stepUpActionResult is the form url to go to.
      if (((redirectResponse as LMSystemException) as LMSystemException)
        && ((redirectResponse as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR
          || (redirectResponse as LMSystemException).status === AppConstants.STATUS_UNAUTHORIZED)) {
        const rResponse = redirectResponse as LMSystemException;
        this.lmErrorUtilService.handleError(rResponse.message, rResponse.details, rResponse.status, rResponse.message);
        return;
      }

      if(redirectResponse.mfaUrl) {
        this.lmGlobalUtilService.navigate(redirectResponse.mfaUrl);
        // window.location.href = redirectResponse.mfaUrl;
        return;
      }

      if (actionSpec.hasParameters || redirectResponse.hasActionForm) {
        this.lmBusyIndicatorService.showBusyIndicator();
        setTimeout(() => {

          this.lmSpecService.getFormSpecFromDialogActionUrl(redirectResponse.redirectUrl).subscribe((response: LMFormSpecResponse | LMSystemException) => {

            if ((response as LMSystemException).status
              && ((response as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR || (response as LMSystemException).status === AppConstants.STATUS_UNAUTHORIZED)) {
              this.lmBusyIndicatorService.hideBusyIndicator();
              const message = (response as LMSystemException).statusText !== undefined ? (response as LMSystemException).statusText : (response as LMSystemException).message;
              this.lmErrorUtilService.handleError(message, (response as LMSystemException).details);
              return;
            }

            const formUrlInfo = (response as LMFormSpecResponse).formUrlInfo;
            const formSpec = (response as LMFormSpecResponse).formSpec;
            const resourceId = (response as LMFormSpecResponse).resourceId;
            const action = (response as LMFormSpecResponse).action;
            const urlCompiledTemplate = urltemplate.parse(formUrlInfo.initialDataUrl);
            const url = urlCompiledTemplate.expand({ resourceId, actionName: action });

            this.lmListActionFormDialogService.getActionFormDialogDataView(url).subscribe((responseDV: any) => {
              const formDataView: LMDataView = responseDV;
              if (formDataView.status === AppConstants.STATUS_COMPLETED) {
                this.lmListActionFormDialogService.runActionFormDialog(formUrlInfo, formSpec, formDataView, actionSpec, this.modalPlaceholder)
                .subscribe((result: LMActionFormDialogResult) => {
                  if (result.result === LMActionFormDialogResultCode.ACTION_FORM_DIALOG_SAVED) {
                    const actionResult = result.transactionStateResult.getTransactionResult();
                    if (actionResult.message.length > 0 && !actionResult.actionSpec?.suppressCompletionMessage) {
                      this.lmGlobalUtilService.displayToastMessage(actionSpec.label, actionResult.message, AppConstants.TRA_ACTION_COMPLETED);
                    }
                    if (actionResult.status === AppConstants.STATUS_COMPLETED) {
                      if (actionResult?.isCompletionNavigation && actionResult?.redirectUrl) {
                        const formPagingInfo: LMPagingInfo = this.buildFormPagingInfo(this.getDataViewSet(), actionResult.dataView);
                        this.lmNavigationService.runNavigation(actionResult.redirectUrl, formPagingInfo);
                      } else {
                        this.executeRefresh().subscribe();
                        const listTransactionEvent: LMListTransactionEvent = new LMListTransactionEvent(this, [ actionResult ]);
                        this.listTransactionEvent.emit(listTransactionEvent);
                      }
                    }
                  }
                });
              } else {
                this.lmBusyIndicatorService.hideBusyIndicator();
                this.lmLoggerService.error(responseDV);
                this.lmErrorUtilService.handleError(responseDV.message, responseDV.details, responseDV.status, responseDV.statusText);
              }
            });
          });
        });
        return;
      } else {
        let redirectUrl = (this.lmContextService.inMingleWidget())
          ? redirectResponse.redirectUrl : this.lmUrlUtilService.toRelativeUrl(redirectResponse.redirectUrl, true, true);

        const formPagingInfo: LMPagingInfo = this.buildFormPagingInfo(this.getDataViewSet(), dataView);
        if (formPagingInfo) {
          const delimiter = redirectUrl.indexOf('?') === -1 ? '?' : '&';
          redirectUrl += delimiter + Object.entries(formPagingInfo).map(pair => LMUrlUtilService.toUrlParam(pair, true)).join('&');
        }
        if (this.listSpec.listType === 'select'
          || this.listSpec.listType === 'helper') {
          redirectUrl = this.lmUrlUtilService.encodeParens(redirectUrl);
          if (this.lmContextService.usePortalTabs()) {
            this.lmContextUtilService.openPortalTab(redirectUrl);
          } else {
            this.lmUrlUtilService.openExternalUrl(redirectUrl);
          }
        } else {
          if (this.isInOverlay || this.topLevelOverlayComponent) {
            if (!this.lmOverlayService.isOpening) {
              this.lmOverlayService.isOpening = true;
              this.lmOverlayService.open({
                open: true,
                url: redirectUrl,
                listOpenedId: this.listSpec.resourceId,
                resourceId: dataView.resourceId,
                isNavigation: true,
                navigationName: 'update',
                replaceCurrentContent: this.lmOverlayService.hasOpenOverlay,
                navigationType: 'form',
                insideOverlayNav: true
              });
            }
          } else {
            this.lmGlobalUtilService.navigateByUrl(redirectUrl);
          }
        }
      }
    });
  }
  private runDeleteAction(actionSpec: LMActionSpec, dataViewList: Array<LMDataView>, isFromHotKey = false): void {

    // check if deleting an inline create dataView that is not dirty
    if (this.isInlineCreateModeOn() && dataViewList.length === 1 && dataViewList[ AppConstants.INLINE_CREATE_ROW ].isNewRow) {
      if (!this.isInlineCreateDataViewDirty()) {
        this.turnOnInlineCreateMode(false);
        return;
      }
    }

    this.checkForUnsavedChanged(actionSpec).subscribe((continueOn: boolean) => {  // DPB needs to be addressed

      if (continueOn) {
        const listContext: LMListContext = {
          listUrlInfo: this.listUrlInfo,
          listSpec: this.listSpec
        };

        if (this.stepUpActionResult) {
          listContext.stepUpActionResult = this.stepUpActionResult;
          this.stepUpActionResult = undefined;
        }

        if (this.lmContextService.isActionSpecRefactorOn() && !actionSpec.privileged) {
          // For privileged actions, prompt confirmation message first.
          this.runDeleteAction2(listContext, actionSpec, dataViewList, isFromHotKey);
          return;
        }
        this.showBusyIndicator();
        this.lmListTransactionService.runDeleteAction(listContext, actionSpec, undefined, this.getDataViewSet(), dataViewList).subscribe(
          (transactionState: LMTransactionState) => {
            this.handleDeleteActionResult(transactionState, isFromHotKey);
          });
      }
    });
  }

  private handleDeleteActionResult(transactionState: LMTransactionState, isFromHotKey: boolean) {
    this.hideBusyIndicator();

    if (transactionState.isError) {
      this.lmErrorUtilService.handleError(
        transactionState.response.message,
        transactionState.response.details,
        transactionState.response.status,
        transactionState.response.message);
    } else if (transactionState.isCanceled) {
      // TODO: noop
    } else if (transactionState.isFinished) {
      const resultList = transactionState.completedTransactionList;
      let successes = 0;
      let failures = 0;
      let cancelledRT = 0;
      let message = '';
      const transactionSize = resultList.length;

      for (let i = 0; i < transactionSize; i++) {
        const result: LMActionResult = resultList[ i ];
        message = result.message || '';

        // todo odd use of terniary operation, consider refactoring
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        AppConstants.STATUS_COMPLETED === result.status ? successes++ :
          (AppConstants.CONFIRMATION_REQUIRED === result.status) ? cancelledRT++ : failures++;

        // Phillip, what would you like to happen here.
        // if its all failure or cancel should we refresh?
        // if it is mixed results we need to refresh or remove the succesfully deleted records.

        // toasts each error
        if (AppConstants.STATUS_COMPLETED !== result.status && AppConstants.CONFIRMATION_REQUIRED !== result.status) {
          if (message !== '') {
            const toastId = transactionSize === 1 ? AppConstants.TRA_ACTION_FAILED : `${AppConstants.TRA_ACTION_FAILED}_${i}`;
            this.lmGlobalUtilService.displayToastMessage('', message, toastId);
            this.notifyHandCodedTransactionComplete(this.getDataViewSet()?.header?.resourceId, transactionState);
          }
        }
      }

      if (successes === transactionSize) {
        // need to toast success
        if (transactionSize !== 1) {
          message = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('DeleteActionCompleteSuccessResults'), successes);
        }
        this.lmGlobalUtilService.displayToastMessage('', message, AppConstants.TRA_ACTION_COMPLETED);
        this.notifyHandCodedTransactionComplete(this.getDataViewSet()?.header?.resourceId, transactionState);
      } else if (transactionSize !== 1) {
        // need to toast mixed results
        message = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('DeleteActionCompleteMixedResults'), [ successes, failures, cancelledRT ]);
        this.lmGlobalUtilService.displayToastMessage('', message, AppConstants.TRA_ACTION_PARTIALLY_COMPLETED);
        this.notifyHandCodedTransactionComplete(this.getDataViewSet()?.header?.resourceId, transactionState);
      }

      if (this.isInlineCreateModeOn()) {
        this.turnOnInlineCreateMode(false);

        if (!this.isRouterOutletRootComponent) {
          this.updateToolbarStateEvent.emit();
        }
      }
      if (!isFromHotKey) {
        this.executeRefresh().subscribe();
        const listTransactionEvent1: LMListTransactionEvent = new LMListTransactionEvent(this, resultList);
        this.listTransactionEvent.emit(listTransactionEvent1);
      } else {
        const listTransactionEvent: LMListTransactionEvent = new LMListTransactionEvent(this, resultList);
        this.listTransactionEvent.emit(listTransactionEvent);
      }
    }
  }

  private runDeleteAction2(listContext: LMListContext, actionSpec: LMActionSpec, dataViewList: Array<LMDataView>, isFromHotKey: boolean) {
    // need to weed out inine creae rows that have not been saved!!!
    const prunedList:Array<LMDataView> = [];

    dataViewList.forEach(dv => {
      if (!dv.isNewRow) {
        prunedList.push(dv);
      }
    });

    if (prunedList.length === 0) {
      // only deleting an unsaved new row.
      // no need to try to get the true action spec, instead just use the one passed in
      // because a delete isn't really happening.
      this.showBusyIndicator();
      this.lmListTransactionService.runDeleteAction(listContext, actionSpec, undefined, this.getDataViewSet(), dataViewList).subscribe(
          (transactionState: LMTransactionState) => {
            this.handleDeleteActionResult(transactionState, isFromHotKey);
          });

      return;
    }

    // To support csk.actionrefactor toggle, use the local variable to build action redirect url.
    // listTransactionService.runInstanceAction and runDeleteAction converts the dataview to target for template list
    const dataViewListForActionRedirectUrl = (this.listSpec.isTemplateList) ? prunedList.map(dataView => dataView.dataView) : prunedList;

    const instanceActionUrl = this.lmListTransactionService.createActionRedirectUrl(listContext, actionSpec, this.getDataViewSet(), dataViewListForActionRedirectUrl);
    this.lmSpecService.getRedirectUrl(instanceActionUrl, listContext.stepUpActionResult).subscribe(redirectResponse => {
      // getRedirectUrl response is not typed, unfortunately.

      // It will return redirect url from action controller. It may be mfaUrl, if action is privileged
      // Or if stepUpActionResult is available, it is action result after mfa code is verified. In that case, the redirect url in the stepUpActionResult is the form url to go to.
      if (((redirectResponse as LMSystemException) as LMSystemException)
        && ((redirectResponse as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR
          || (redirectResponse as LMSystemException).status === AppConstants.STATUS_UNAUTHORIZED)) {
        const rResponse = redirectResponse as LMSystemException;
        this.lmErrorUtilService.handleError(rResponse.message, rResponse.details, rResponse.status, rResponse.message);
        return;
      }

      if(redirectResponse.mfaUrl) {
        this.lmGlobalUtilService.navigate(redirectResponse.mfaUrl);
        // window.location.href = redirectResponse.mfaUrl;
        return;
      }

      this.showBusyIndicator();
      const lmActionInfo: LMActionInfo = { actionName: actionSpec.name, hasActionForm: redirectResponse.hasActionForm, redirectUrl: redirectResponse.redirectUrl };
      this.lmListTransactionService.runDeleteAction(listContext, actionSpec, lmActionInfo, this.getDataViewSet(), dataViewList).subscribe(
      (transactionState: LMTransactionState) => {
        this.handleDeleteActionResult(transactionState, isFromHotKey);
      });
    });
  }
  private runCheckControlAction(columnDef: ListGridColumn, dataView: LMDataView, row: number): void {
    let exit = false;
    let displayField: LMListDisplayField = null;
    let checkedStateField: LMField = null;

    // check passed in arguments
    if (columnDef === null) {
      this.lmLoggerService.warn([ this, this.instanceId, 'runCheckControlAction: No listGridColumn received.' ]);
      exit = true;
    } else if (dataView === null) {
      this.lmLoggerService.warn([ this, this.instanceId, 'runCheckControlAction: No dataView received.' ]);
      exit = true;
    } else if (dataView.fields === null) {
      this.lmLoggerService.warn([ this, this.instanceId, 'runCheckControlAction: No dataView.fields received.' ]);
      exit = true;
    } else if (row === null || row < 0) {
      this.lmLoggerService.warn([ this, this.instanceId, 'runCheckControlAction: invalid row received: ' + row ]);
      exit = true;
    } else {
      displayField = columnDef.displayField;
      if (displayField === null) {
        this.lmLoggerService.warn([ this, this.instanceId, 'runCheckControlAction: listGridColumn did not have a displayField.' ]);
        exit = true;
      } else {
        const checkStateFieldId: string = displayField.fieldId;
        checkedStateField = dataView.fields[ checkStateFieldId ];

        // TODO need to handle the case where there isn't a checkstate field;

        if (checkedStateField === null) {
          this.lmLoggerService.warn([ this, this.instanceId, 'runCheckControlAction: Unable to find the check control state field using the field id: ' + checkStateFieldId ]);
          exit = true;
        }
      }
    }

    if (exit) {
      this.lmErrorUtilService.handleError('Action not run due to an unexpected error.  See log file for details');
      return;
    }

    const isChecked: boolean = checkedStateField.value ? true : false;
    const actionSpec: LMActionSpec = this.getCheckControlActionSpec(isChecked, displayField, dataView);

    if (!actionSpec) {
      checkedStateField.value = !isChecked;
      this.listContentComponent.updateDataView(row, dataView);
      this.lmErrorUtilService.handleError('Action not run due to an unexpected error.  See log file for details');
      return;
    }

    new Observable<boolean>(observer => {
      this.runInstanceAction(actionSpec, this.getDataViewSet(), [ row ], observer);
    }).subscribe((result: boolean) => {
      this.lmLoggerService.log([ this, this.instanceId, 'runCheckControlAction' + result ]);
      if (!result) {
        checkedStateField.value = !isChecked;
      }
    });
  }

  private getCheckControlActionSpec(isChecked: boolean, displayField: LMListDisplayField, dataView: LMDataView): LMActionSpec {
    const checkControlActions: Array<LMCheckControlAction> = isChecked ? displayField.checkActions : displayField.uncheckActions;

    if (checkControlActions === null || checkControlActions.length === 0) {
      this.lmLoggerService.warn([ this, this.instanceId, 'getCheckControlActionSpec: No ' + (isChecked ? 'Check' : 'Uncheck') + ' actions defined on LMListDisplayField.' ]);
      return;
    }

    const validAction: LMActionSpec = this.getFirstValidCheckControlAction(checkControlActions, dataView);

    if (validAction === null) {
      this.lmLoggerService.warn([ this, this.instanceId, 'getCheckControlActionSpec: No valid ' + (isChecked ? 'Check' : 'Uncheck') + ' action defined.' ]);
      return;
    }

    if (AppConstants.ACTION_TYPE_FUNCTION !== validAction.type) {
      this.lmLoggerService.warn([ this, this.instanceId, 'getCheckControlActionSpec: Only Instance Actions are supported for Check Controls. Action: ' + validAction.name ]);
      return;
    }

    return validAction;
  }

  private getFirstValidCheckControlAction(checkControlActions: Array<LMCheckControlAction>, dataView: LMDataView): LMActionSpec {
    for (const checkControlAction of checkControlActions) {
      if (checkControlAction.condition) {
        const conditions: LMCondition[] = [];
        conditions[0] = checkControlAction.condition;

        if (this.lmConditionUtilService.isValid(conditions, dataView)) {
          return checkControlAction.actionSpec;
        }
      } else {
        return checkControlAction.actionSpec;
      }
    }

    return null;
  }

  private openDocumentResource(documentResourceId: string, dataView: LMDataView, fieldId?: string): void {
    const documentResource = new DocumentResource({
      resourceId: documentResourceId,
      dataView
    }, '');
    const url: string = this.lmUrlUtilService.buildUrl({ resource: documentResource });
    let option: string;
    if (fieldId) {
      const documentField = dataView.fields[fieldId];
      option = (documentField && documentField.mimeType && documentField.mimeType === 'application/pdf') ? 'external' : undefined;
    }
    this.lmGlobalUtilService.navigate(url, null, option);
  }

  private runFormInvoke(formInvokeName: string, dataView: LMDataView): void {
    const listResource = new ListResource({ resourceId: dataView.resourceId, listName: this.listSpec.busListSpec.name });
    const url: string = this.lmUrlUtilService.buildUrl({ resource: listResource });
    this.lmNavigationService.runFormInvoke(url, formInvokeName, dataView);
  }

  private runHttpUrl(columnDef: ListGridColumn, dataView: LMDataView): void {

    const openExternal = !!columnDef.displayField?.openExternal;
    let url: string;

    if (columnDef.displayField?.isLazyUrlRetrieval && columnDef.displayField?.httpUrl?.variables) {
      const reqFields = Array.from(columnDef.displayField.httpUrl?.variables, field => field.fieldId );
      const openActionRedirectUrlTemplate = urltemplate.parse(this.lmUrlUtilService.buildFormRequestUrl(this.listUrlInfo));
      const requestUrl = openActionRedirectUrlTemplate.expand({
        resourceId: dataView?.resourceId,
      });
      this.lmFormRequestService.getFieldValues(requestUrl, reqFields).pipe(
        first(),
        catchError( error => {
          this.lmLoggerService.error(error);
          return throwError(error || 'Internal Server Error');
        })
      ).subscribe( response => {
        if (response.status === 'Completed') {
          const fields: LMDataView = { fields: response.fields };
          url = this.lmFormatUtilService.formatMessageRule( columnDef.displayField?.httpUrl, fields );
          if (url.indexOf('web10x=true') > -1) {
            // Add csk parameters to the URL built by WebUrlBuilder for processflow
            url = this.lmUrlUtilService.propagateSessionKeys(url, '&');
          }
          // TODO: LMWEB-19598 Set context in the url for archive or asofdate?
          this.lmNavigationService.postProcessHttpUrl(url, openExternal);
        } else if (response.status === 'Exception') {
          this.lmErrorUtilService.handleError(response?.message, response?.details, response.status);
        }
      });
    } else if (dataView?.buttonLinks?.[columnDef.fieldId]) {
      url = dataView.buttonLinks[columnDef.fieldId];
      if (url.indexOf('web10x=true') > -1) {
        // Add csk parameters to the URL built by WebUrlBuilder for processflow
        url = this.lmUrlUtilService.propagateSessionKeys(url, '&');
      }
      // TODO LMWEB-19598 Set context in the url for archive or asofdate?
      this.lmNavigationService.postProcessHttpUrl(url, openExternal);
    } else {
      url = this.lmFormatUtilService.formatMessageRule(columnDef.displayField.httpUrl, dataView);
      if (url.indexOf('web10x=true') > -1) {
        // Add csk parameters to the URL built by WebUrlBuilder for processflow
        url = this.lmUrlUtilService.propagateSessionKeys(url, '&');
      }
      // TODO: LMWEB-19598 Set context in the url for archive or asofdate?
      this.lmNavigationService.postProcessHttpUrl(url, openExternal);
    }
  }

  private runUILinkHttpUrl(actionReference: LMBusActionReference, selectedDataView?: LMDataView): void {
    const option: string = (actionReference?.httpURL?.externalLink) ? 'external' : '';
    let url: string;

    if (actionReference.isLazyUrlRetrieval && actionReference.httpURL?.messageRule.variables) {
      this.lmFormRequestService.handleLazyUrl(
        this.lmUrlUtilService.buildFormRequestUrl(this.listUrlInfo),
        selectedDataView?.resourceId,
        actionReference.httpURL?.messageRule,
        !!actionReference.httpURL?.externalLink,
        false
      );

    } else {
      url = this.lmFormatUtilService.formatMessageRule( actionReference.httpURL.messageRule, selectedDataView );
      if (url.indexOf('web10x=true') > -1) {
        // Add csk parameters to the URL built by WebUrlBuilder for processflow
        url = this.lmUrlUtilService.propagateSessionKeys(url, '&');
        this.lmGlobalUtilService.navigate(url, null, option);
        return;
      }

      const actionName = this.lmUrlUtilService.getUrlParam(url, 'action');
      // LMWEB-173 introduced code to handle Business task urls as HTTPURL, but there is no good way to identify external URL such as https://google.com
      // The following block of code is to catch the error we run into in lmSpecService.getFormSpecFromDialogActionUrl.
      // Kind of kludge fix for the client ticket LMWEB-16987.
      // Better way to deal with this issue is to have a UILink LPL syntax to identify application url vs external url.
      let isAppUrl = false;
      if (actionName?.length > 0) {
        // Action name is in the URL, maybe it is a business task. Verify by building urlinfo.
        // Keyed resource throws an error when parsing the url for form resource
        try {
          const formUrlInfo = this.lmUrlInfoBuilderService.getFormUrlInfoFromHttpUrl(url);
          isAppUrl = true;
        } catch (e) {
          // TODO: noop
        }
      }
      if (!isAppUrl) {
        this.lmGlobalUtilService.navigate(url, null, option);
        return;
      }
      // Yikes! BusinessTask URL built this way throws SPECURL Errors. If we know for sure based on LPL syntax, then csk params can be added to the url
      this.lmSpecService.getFormSpecFromDialogActionUrl(url).subscribe((response: LMFormSpecResponse) => {
        const formUrlInfo = (response as LMFormSpecResponse).formUrlInfo;
        const formSpec = (response as LMFormSpecResponse).formSpec;

        if (this.lmFormSpecUtilService.isBusinessTask(formSpec) || (this.lmFormSpecUtilService.isActionForm(formSpec))) {
          const actionSpec: LMActionSpec = formSpec.busClassSpec.actions ?
            formSpec.busClassSpec.actions.find(a => a.name === actionName) : formSpec.busClassSpec.actionSpec;
          const resourceId = formSpec.resourceId;
          const urlCompiledTemplate = urltemplate.parse(formUrlInfo.initialDataUrl);
          url = urlCompiledTemplate.expand({ resourceId, actionName });

          this.lmListActionFormDialogService.getActionFormDialogDataView(url).subscribe((responseDV: any) => {
            const formDataView: LMDataView = responseDV;
            if (formDataView.status === AppConstants.STATUS_COMPLETED) {
              this.lmListActionFormDialogService.runActionFormDialog(formUrlInfo, formSpec, formDataView, actionSpec, null)
                .subscribe((result: LMActionFormDialogResult) => {
                  if (result.result === LMActionFormDialogResultCode.ACTION_FORM_DIALOG_SAVED) {
                    const actionResult = result.transactionStateResult.completedTransactionList[0];
                    if (!actionResult.actionSpec?.suppressCompletionMessage) {
                      const title = '';
                      const message = actionResult.message;
                      this.lmGlobalUtilService.displayToastMessage(title, message, AppConstants.TRA_ACTION_COMPLETED);
                    }
                    if (actionResult.isCompletionNavigation && actionResult.redirectUrl) {
                      this.lmNavigationService.runNavigation(actionResult.redirectUrl);
                    }
                  }
                });
            } else {
              this.lmLoggerService.error(responseDV);
              this.lmErrorUtilService.handleError(responseDV.message, responseDV.details, responseDV.status, responseDV.statusText);
            }
          });
        } else {
          this.lmGlobalUtilService.navigate(url, null, option);
        }
      });
    }
  }

  private runLinkNavigation(
    navigationName: string,
    resourceId: string,
    showAsPdf: boolean,
    xtrParameters?: string,
    setFromListResource = true,
    allowOverlay = false,
    overlayNavType?: 'list' | 'form' | 'page',
    event?: LMFormOverlayClickedEvent): void {
      const compiledUrlTemplate = urltemplate.parse(this.listUrlInfo.navigationUrl);
      let url = compiledUrlTemplate.expand({ resourceId, navigationName });

      if (setFromListResource) {
        const fromListResource = new ListResource({
          busClassName: this.listSpec.busClassSpec.name,
          listName: this.listSpec.busListSpec.name
        });
        url = this.lmUrlUtilService.appendToQueryString(url, this.lmUrlUtilService.objectToQueryString({ fromlist: fromListResource.resourceId }));
      }

      if (xtrParameters) {
        url = this.lmUrlUtilService.appendToQueryString(url, xtrParameters);
      }

      if (!showAsPdf) {
        url = this.setGlobalModeOnNavigation(url);
      } else {
        // Update URL to get archive data. PDF will open in a new page. It is not required to turn on the red bar yet.
        if (this.listSpec.busListSpec.userFolderArchiveReport) {
          //redirectUrl in the response will have the csk set already.
          url = this.lmUrlUtilService.updateUrlParams(url, { 'csk.archivemode': true });
        } else if (this.listSpec.busListSpec.userFolderAsOfDate) {
          // TODO: LMWEB-20291 - Pass as of date in url?
        }
      }

      if (this.lmContextService.useListFormOverlay() && allowOverlay && !showAsPdf && !event?.event?.ctrlKey) {
        this.openNavigationInOverlay(url, navigationName, overlayNavType, event);
      } else {
        this.lmNavigationService.runNavigation(url, undefined, { showAsPdf });
      }
  }

  private runCubeNavigation(columnDef: ListGridColumn, dataView: LMDataView) {
    if (this.listState.cubeOverrides?.periodView
      || this.listState.cubeOverrides?.pivotView
      || this.listState.cubeOverrides?.periodOverrides?.overridePeriods) {
      this.listState.cubeOverrides.cubeDrillNavigation = true;
    }
    if ((!dataView.cubeInfo.isFactRowElement
      || (dataView.cubeInfo.isFactRowElement && !columnDef.displayField.linkNavigation && !columnDef.displayField.hasHttpUrl))) {
      // Not a link navigation
      // Add reporting basis and top dimensions, if available
      const cubeDataViewSet = this.getDataViewSet();
      const cubeInfoClone = JSON.parse(JSON.stringify(dataView.cubeInfo));
      cubeInfoClone.extraInfo = { cubeNm: this.listSpec.busListSpec.name, cubeFld: columnDef.displayField.fieldId };
      if (cubeDataViewSet.cubeInfo.reportingBasis
        && this.listState.cubeOverrides) {
        cubeInfoClone.extraInfo = Object.assign({}, cubeInfoClone.extraInfo, {
          periodKey: cubeDataViewSet.cubeInfo.periodKey,
          reportingBasis: cubeDataViewSet.cubeInfo.reportingBasis,
          topNodeDims: this.listState.cubeOverrides.topDimensions,
        });
      }
      if (cubeDataViewSet.cubeInfo.periodView) {
        cubeInfoClone.extraInfo.periodView = cubeDataViewSet.cubeInfo.periodView;
      } else if (this.listSpec.cubeOptions.pCommands?.length > 0) {
        cubeInfoClone.extraInfo.periodView = this.listSpec.cubeOptions.pCommands[0];
      }
      if (cubeDataViewSet.cubeInfo.pivotView) {
        cubeInfoClone.extraInfo.pivotView = cubeDataViewSet.cubeInfo.pivotView;
      } else if (this.listSpec.cubeOptions.pivotViews?.length > 0) {
        let pivot;
        pivot = this.listSpec.cubeOptions.pivotViews.find((p) => p.default !== undefined && p.default);
        if (!pivot) {
          pivot = this.listSpec.cubeOptions.pivotViews[0];
        }
        cubeInfoClone.extraInfo.pivotView = pivot.name;
      }
      if (cubeDataViewSet.cubeInfo.columnView) {
        cubeInfoClone.extraInfo.columnView = cubeDataViewSet.cubeInfo.columnView;
      } else if(this.listSpec.cubeOptions.columnViews?.length > 0) {
        let columnView;
        columnView = this.listSpec.cubeOptions.columnViews.find((c) => c.default !== undefined && c.default);
        if (!columnView) {
          columnView = this.listSpec.cubeOptions.columnViews[0];
        }
        cubeInfoClone.extraInfo.columnView = columnView.name;
      }
      if (cubeDataViewSet.cubeInfo.topContextFields) {
        cubeInfoClone.extraInfo = Object.assign({}, cubeInfoClone.extraInfo, { topContextFields: cubeDataViewSet.cubeInfo.topContextFields });
      }
      // The cubeDrillUrl is built based on busFormField.getLinkList business class name, listname and '?cubeDrill=true' is already appended to the url.
      let url = columnDef.displayField.cubeDrillUrl + '&' + this.lmUrlUtilService.objectToCubeQueryString(cubeInfoClone);
      if (cubeInfoClone.extraInfo) {
        url += '&' + this.lmUrlUtilService.objectToCubeQueryString(cubeInfoClone.extraInfo);
      }

      if (columnDef.displayField.addtlFilter
        && columnDef.displayField.addtlFilter.length > 0
        && !cubeDataViewSet.cubeInfo.suppressCurPeriod) {
        url = url + '&' + this.lmUrlUtilService.objectToQueryString({ addtlFilter: columnDef.displayField.addtlFilter });
      }

      this.lmGlobalUtilService.navigateByUrl(url);
    } else if (columnDef.displayField.linkNavigation) {
      // link navigation
      dataView.cubeInfo.periodDate = columnDef.displayField.periodDate;
      const navigationResource = new KeyedResource({ resourceType: 'navigation', resourceId: columnDef.displayField.resourceId, dataView });
      let navResourceId = navigationResource.generateResourceId(false); // Will be encoded by url template processing.
      navResourceId = navResourceId.substr(0, navResourceId.lastIndexOf('.')); // Removing the nav name since it will be put in place by url template processing.
      this.runLinkNavigation(columnDef.displayField.linkNavigation, navResourceId, false,  this.lmUrlUtilService.objectToQueryString({ cubeDrill: true }), false);
    }
  }

  private getPdfType(busListSpec: LMBusListSpec): string {
    if (busListSpec.implementsTreeView) {
      return (busListSpec.detailSections) ?
        AppConstants.TREE_LIST_WITH_DETAILS_PDF : AppConstants.TREE_LIST_PDF;
    }

    if (busListSpec.detailSections || busListSpec.showChangedValuesOnRight) {
      return AppConstants.LIST_WITH_DETAILS_PDF;
    }

    if (busListSpec?.expandableRowCardView) {
      return AppConstants.LIST_WITH_EXPANDABLE_CARD_ROW_PDF;
    }

    return AppConstants.REGULAR_LIST_PDF;
  }

  private buildFromResource(): KeyedResource {
    // Case 1: Navigation to List or Drill to List -- This is not a dependent list and we may not have a from dataview. Just a source resource.
    // Case 2: Composite panel or Detail section panel or dashboard panel lists are dependent lists. They have a Rel resource and fromDataView.
    let fromResource: KeyedResource;

    if (this.listUrlInfo.sourceResource) {
      fromResource = new KeyedResource({
        resourceId: this.listUrlInfo.sourceResource.resourceId,
        resourceType: this.listUrlInfo.sourceResource.resourceType
      });
    }

    if (this.listSpec.dependentList && this.fromDataView) {
      fromResource = new KeyedResource({
        resourceId: this._fromDataView.resourceId,
        resourceType: this.listUrlInfo.sourceResource.resourceType
      }, fromResource.uiResourceName);
    }
    return fromResource;
  }

  private runPdfAction(actionReference: LMBusActionReference) {
    const info: LMDialogInfo = { message: Soho.Locale.translate('UnsavedChangesContinuingMsg'), type: LMDialogType.NOYES };
    this.handleUnsavedChanges(info).subscribe(response => {
      if (response) {
        this._runPdfAction(actionReference);
      }
    });
  }

  private _runPdfAction(actionReference: LMBusActionReference) {
    const pdfType = this.getPdfType(this.listSpec.busListSpec);

    const busClassSpec = this.listSpec.busClassSpec;
    // LMCLIENT-34223
    const includeSearchForm = (!this.listSpec.busListSpec.implementsTreeView || !busClassSpec.implementsChildHierarchy || busClassSpec.hasChildHierarchyDescendants) &&
      (
        pdfType === AppConstants.REGULAR_LIST_PDF ||
        pdfType === AppConstants.LIST_WITH_DETAILS_PDF ||
        pdfType === AppConstants.TREE_LIST_PDF ||
        pdfType === AppConstants.TREE_LIST_WITH_DETAILS_PDF
      );

    const settings = <LMPrintPdfInfo>{
      resource: this.listResourceImpl,
      fromResource: this.buildFromResource(),
      fromList: this.listUrlInfo.fromListResource,
      actionReference,
      name: this.listTitle,
      pdfType,
      includeSearchForm,
      // Cube overrides is set when the user changes cube parameters of a cube view.
      cubeOverrides: (this.listState.cubeOverrides) ? this.listState.cubeOverrides : undefined,
      // Cube options is set when a user performs a cube drill from a cube view to navigate to a simple list.
      // For eg. what transaction records are behind an aggregate for a dimension like a bank branch.
      // Also send cubeoptions over for a cube view detail section list
      cubeOptions: (this.listUrlInfo.cubeParams) ? this.listUrlInfo.cubeParams : undefined,
      userFolder: this.listSpec.userFolder,
      fontOffset: this.listSpec.pdfFontOffset || this.listSpec.busListSpec.fontOffset,
      orientation: this.listSpec.pdfOrientation || this.listSpec.busListSpec.orientation,
      paperSize: this.listSpec.pdfPaperSize,
      customWidth: this.listSpec.pdfCustomWidth,
      customHeight: this.listSpec.pdfCustomHeight,
      customUnit: this.listSpec.pdfCustomUnit,
      dataViewSet: this.getDataViewSet(),
      selectedRows: this.selectedRows,
      filterFields: this.getExportActionFilterCriteria(),
      scheduleActionAllowed: this.listSpec.scheduleActionAllowed,
      includeRecordLimit: true,
      selectRequestData: this.selectRequestData,
      retentionDuration: this.listSpec.retentionDuration,
      isArchiveData: this.getStateInfo().isArchiveData
    };

    const chartNames = this.getChartNames();
    if (Object.keys(chartNames).length > 0) {
      settings.chartNames = chartNames;
    }

    this.lmPrintDialogService.openPdfDialog(settings);
  }

  private runCsvAction(actionReference: LMBusActionReference) {
    const info: LMDialogInfo = { message: Soho.Locale.translate('UnsavedChangesContinuingMsg'), type: LMDialogType.NOYES };
    this.handleUnsavedChanges(info).subscribe(response => {
      if (response) {
        let detailList: LMPanelDetail[] = [];

        if (this.isDetailSectionsView) {
          if (this.isMultiListDetailSection(this.detailSectionPanels)) {
            detailList = this.buildDetailSectionData(this.detailSectionPanels[this.listState.selectedTabIndex].sections);
          } else if (this.isDashboardDetailSection(this.detailSectionPanels)) {
            detailList = this.buildDetailSectionData(this.detailSectionPanels[this.listState.selectedTabIndex].dashBoardPanes);
          }
        } else if (this.hasDetailSections && this.listSpec.busListSpec.implementsDashBoardView) {
          detailList = this.buildDetailSectionData(this.detailSectionPanels);
        } else if (this.lmBuildDependentPaneDetail) {
          detailList = this.lmBuildDependentPaneDetail();
        }

        this._runCsvAction(actionReference, detailList);
      }
    });
  }

  private getChartNames(): LMChartNames {
    const chartNames: LMChartNames = { };

    if (this.listSpec.busListSpec?.charts) {
      // if a chart is not displaying set the chartName to '' to indicate we want the list to print.
      const chartName = this.listState.displayAs === 'chart' ? this.listState.chartName : '';
      chartNames[this.listSpec.busListSpec.name] = chartName;
    }

    // detail sections & multi-list view
    if (this.hasDetailSections &&
        this.detailSectionsComponent?.detailListComponents &&
        this.detailSectionsComponent?.detailListComponents.length > 0) {
      const chartDetailList = this.getDetailListWithChart(this.detailSectionsComponent?.detailListComponents.toArray());
      chartDetailList?.forEach(chartList => {
        if (chartNames[chartList.listSpec.busListSpec.name] === undefined) {
          const chart = (chartList.listState.displayAs === 'chart') ? chartList.listState.chartName : '';
          chartNames[chartList.listSpec.busListSpec.name] = chart;
        }
      });
    }

    return chartNames;
  }

  private getDetailListWithChart(detailListComponents: LMDetailSectionBase[]) : LMListComponent[] {
    const detailList: LMListComponent[] = [];
    detailListComponents.forEach( detailSection => {
      if (detailSection instanceof LMDetailSectionListComponent) {
        const section = detailSection as LMDetailSectionListComponent;
        if (section?.lmListComponent && section.lmListComponent.listSpec.busListSpec.charts) {
          detailList.push(section.lmListComponent);
        }
      } else if (detailSection instanceof LMDetailSectionMultiListComponent) {
        const section = detailSection as LMDetailSectionMultiListComponent;
        section.listComponents?.forEach(listComponent => {
          if (listComponent && listComponent.listSpec.busListSpec.charts) {
            detailList.push(listComponent);
          }
        });
      }
    });
    return detailList;
  }

  private buildDetailSectionData(sections: LMMultiListSectionSpec[] | LandmarkPanel[]) {
    const multiListData: LMPanelDetail[] = [];
    const all = {
      name: 'All',
      title: Soho.Locale.translate('AllListDetailSections')
    };
    multiListData.push(all);

    for (let i = 0; i < sections.length; i++) {
      if (sections[i].type === 'list') {
        const title = this.lmFormatUtilService.formatMessageRule(sections[i].listSpec.busListSpec.title);
        const listTitle = title?.trim().length > 0
            ? title
            : Soho.Locale.translate('DependentListWithNoTitle', i);
        multiListData.push({ name: sections[i].detailSectionName, title: listTitle });
      }
    }
    return multiListData;
  }

  private _runCsvAction(actionReference: LMBusActionReference, detailList?: LMPanelDetail[]) {
    const csvType = this.getCSVType(this.listSpec.busListSpec);
    const settings = <LMPrintCsvInfo>{
      modalPlaceholder: this.modalPlaceholder,
      resource: this.listResourceImpl,
      fromResource: this.buildFromResource(),
      fromList: this.listUrlInfo.fromListResource,
      actionReference,
      csvType,
      name: this.listTitle,
      detailList: detailList,
      // Cube overrides is set when the user changes cube parameters of a cube view.
      cubeOverrides: (this.listState.cubeOverrides) ? this.listState.cubeOverrides : undefined,
      // Cube options is set when a user performs a cube drill from a cube view to navigate to a simple list.
      // For eg. what transaction records are behind an aggregate for a dimension like a bank branch.
      // Also send cubeoptions over for a cube view detail section list
      cubeOptions: (this.listUrlInfo.cubeParams) ? this.listUrlInfo.cubeParams : undefined,
      userFolder: this.listSpec.userFolder,
      selectedRows: this.selectedRows,
      filterFields: this.getExportActionFilterCriteria(),
      scheduleActionAllowed: this.listSpec.scheduleActionAllowed,
      includeRecordLimit: true,
      // implements tree view will include both tree and cube
      isTreeList:  this.listSpec.busListSpec.implementsTreeView,
      hasDetailSections: this.hasDetailSections,
      singleRecordSelected: (this.selectedRows.length === 1) ? true : false,
      dataViewSet: this.getDataViewSet(),
      selectRequestData: this.selectRequestData,
      selectedDetailPanelIndex: this.listState.selectedTabIndex,
      implementsAuditCompare: this.listSpec.busListSpec.implementsAuditCompare,
      showChangedValuesOnRight: this.listSpec.busListSpec.showChangedValuesOnRight,
      retentionDuration: this.listSpec.retentionDuration,
      isArchiveData: this.getStateInfo().isArchiveData,
      allowMultiThread: this.lmListUtilService.allowMultiThread(this.listSpec, this.chartName)
    };

    if (this.lmListSpecUtilService.isColumnarView(this.listSpec)) {
      const chartNames = this.getChartNames();
      if (Object.keys(chartNames).length > 0) {
        settings.chartNames = chartNames;
      }
    }

    this.lmPrintDialogService.openCsvDialog(settings);
  }

  private getCSVType(busListSpec: LMBusListSpec): string {
    if (busListSpec.implementsTreeView) {
      return (busListSpec.detailSections) ?
        AppConstants.TREE_LIST_WITH_DETAILS_CSV : AppConstants.TREE_LIST_CSV;
    }

    //detail section
    if (this.hasDetailSections &&
       (this.isListDetailSection(busListSpec.detailSections) || this.isMultiListDetailSection(this.detailSectionPanels) ||
       (this.listSpec.busListSpec.implementsDashBoardView || this.isDashboardDetailSection(this.detailSectionPanels)))) {
      return AppConstants.LIST_WITH_DETAILS_CSV;
    }

    //dependent panel
    if (this.hasDependentData && !this.hasDetailSections) {
      return AppConstants.LIST_WITH_DETAILS_CSV;
    }

    if (this.listSpec.busListSpec?.implementsAuditCompare
    && this.listSpec.busListSpec?.showChangedValuesOnRight
    && !this.hasDetailSections) {
      return AppConstants.AUDIT_LIST_WITH_DETAILS_ON_RIGHT_CSV;
    }

    return AppConstants.REGULAR_LIST_CSV;
  }

  private runGenAISummarize(actionReference: LMBusActionReference) {
    const pdfType = this.getPdfType(this.listSpec.busListSpec);

    const busClassSpec = this.listSpec.busClassSpec;
    // LMCLIENT-34223
    const includeSearchForm = (!this.listSpec.busListSpec.implementsTreeView || !busClassSpec.implementsChildHierarchy || busClassSpec.hasChildHierarchyDescendants) &&
      (
        pdfType === AppConstants.REGULAR_LIST_PDF ||
        pdfType === AppConstants.LIST_WITH_DETAILS_PDF ||
        pdfType === AppConstants.TREE_LIST_PDF ||
        pdfType === AppConstants.TREE_LIST_WITH_DETAILS_PDF
      );

    const settings = <LMGenAISummarizeInfo>{
      resource: this.listResourceImpl,
      fromResource: this.buildFromResource(),
      fromList: this.listUrlInfo.fromListResource,
      actionReference,
      name: this.listTitle,
      pdfType,
      includeSearchForm,
      cubeOverrides: (this.listState.cubeOverrides) ? this.listState.cubeOverrides : undefined,
      cubeOptions: (this.listUrlInfo.cubeParams) ? this.listUrlInfo.cubeParams : undefined,
      userFolder: this.listSpec.userFolder,
      dataViewSet: this.getDataViewSet(),
      selectedRows: this.selectedRows,
      filterFields: this.getExportActionFilterCriteria(),
      scheduleActionAllowed: this.listSpec.scheduleActionAllowed,
      selectRequestData: this.selectRequestData
    };

    if (this.listState.displayAs === 'chart') {
      settings.chartNames[this.listSpec.busListSpec.name] = this.chartName;
    }

    this.lmGenAIDialogService.promptGenAISummarizeDialog(this.placeHolder, settings)
    .pipe(first())
    .subscribe((result: GenAISummarizeDialogResult) => {
      // if (result.status !== GenAIDialogStatus.RESPONSE_OK) {
      //   return;
      // }
      // this.lmLoggerService.log(result.generated);
      // this.model.updateModelFromGenAI(result.dataView, result.model, result.fieldId, result.generated);
    });
  }

  private isListDetailSection(detailSections: Array<LMBusDetailSection>): boolean {
    if (detailSections && detailSections.length > 0 && this.listState.selectedTabIndex !== undefined) {
      return ((detailSections[this.listState.selectedTabIndex].type) === 'list');
    }
    return false;
  }

  private isMultiListDetailSection(detailSections: Array<LandmarkPanel>): boolean {
    if (detailSections && detailSections.length > 0 && this.listState.selectedTabIndex !== undefined) {
      return ((detailSections[this.listState.selectedTabIndex].type) === 'multilist');
    }
    return false;
  }

  private isDashboardDetailSection(detailSections: Array<LandmarkPanel>): boolean {
    if (detailSections && detailSections.length > 0 && this.listState.selectedTabIndex !== undefined) {
      return ((detailSections[this.listState.selectedTabIndex].type) === 'dashboard');
    }
    return false;
  }

  private runHelperAction(dataView: LMDataView, index: number): void {
    const helperListActions = this.listSpec.busListSpec.helperLists[index].listSpec.helperActions;
    this.lmBusyIndicatorService.showBusyIndicator(); // Dialog open will hide the busy indicator
    this.lmHelperListDialogService
      .runHelperListDialog(this.listSpec.busListSpec.helperLists[index].listSpec, dataView, this.getDataViewSet().header, helperListActions, this, this.modalPlaceholder)
      .subscribe((result: LMHelperListDialogResult) => {

        const listTransactionEvent: LMListTransactionEvent = new LMListTransactionEvent(this, []);
        this.listTransactionEvent.emit(listTransactionEvent);
        if (result === undefined) {
          return;
        }
        return;
      });
  }

  private runListPersonalization(actionReference?: LMBusActionReference): void {
    const info: LMDialogInfo = { message: Soho.Locale.translate('UnsavedChangesContinuingMsg'), type: LMDialogType.NOYES };
    this.handleUnsavedChanges(info).subscribe(response => {
      if (response) {
        this._runListPersonalization(actionReference);
      }
    });
  }

  private _runListPersonalization(actionReference?: LMBusActionReference): void {
    const mode = actionReference ? actionReference.id === AppConstants.STANDARD_TOOLBAR_PERSONALIZE ? 'Create' : actionReference.id : 'Create';

    if (mode === 'Update' || mode === 'Create' || mode === 'View') {
      this.lmReportPersonalizationDialogService.runReportPersonalizationDialog(
        this.listSpec.userFolder ? 'personalizeReport' : 'personalizeList',
        this.modalPlaceholder,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        this.listSpec.busListSpec.title.resourceValue,
        this.listUrlInfo,
        this.listSpec,
        this.getDataViewSet(),
        this.listSpec?.busListSpec.implementsCubeView ? this.listState : null,
        // todo spec-url-refactor dboehm pwpatton what todo about filterCondition?
        mode === 'Update' ? true : false,
        this.listSpec.includeBaseFilter,
        this.listSpec.filterCondition,
        this.chartName,
        mode === 'View' ? true : false
      ).subscribe((result: LMReportPersonalizationDialogResult) => {
        if (this.lmContextService.isRouteReuse()) {
            this.lmRouteReuseCacheService.removeRouteHandleFromCache(this.route.snapshot);
        }
        if (result.status === LMReportPersonalizationDialogResultCode.REPORT_PERSONALIZATION_DIALOG_SAVED) {
          this.lmGlobalUtilService.displayToastMessage('', result.message, AppConstants.TRA_ACTION_COMPLETED);
     //     this.clearComponentStateAfterPersonalization();
      //    this.setAllowRouteReuseSaveFlag(false);
          this.navigateAfterPersonalieAction();
        }
      });
    } else if (actionReference.id === 'Delete') {
      this.lmConfirmationMessageService.promptConfirmationMessage({
        title: this.lmContextService.simplifyOptionsMenu() ? Soho.Locale.translate('RemoveChangesMessage') : Soho.Locale.translate('ResetPersonalization'),
        dialogTitle: this.lmContextService.simplifyOptionsMenu() ? Soho.Locale.translate('RemoveChangesMessage') : Soho.Locale.translate('ResetPersonalization'),
        message: this.lmContextService.simplifyOptionsMenu() ? Soho.Locale.translate('RemoveChangesConfirmationMessage') : Soho.Locale.translate('ListPersonalizationResetConfirmationMessage'),
        okToAll: false
      }).subscribe((confirmationResult: number) => {
        if (confirmationResult === ConfirmationDialogResult.CONFIRMATION_OK) {
          if (this.lmContextService.isRouteReuse()) {
            this.lmRouteReuseCacheService.removeRouteHandleFromCache(this.route.snapshot);
          }

          this.lmConfigurationService.runPersonalizeAction(this.listUrlInfo.reportPersonalizationUrl, { action: actionReference.id, userfolder: this.listSpec.userFolder })
            .subscribe((result: LMPersonalizeActionResponse) => {
              if (result.status === AppConstants.STATUS_COMPLETED) {
                this.lmGlobalUtilService.displayToastMessage('', result.message, AppConstants.TRA_ACTION_COMPLETED);
         //       this.clearComponentStateAfterPersonalization();
                this.navigateAfterPersonalieAction();
              } else {
                this.lmErrorUtilService.handleError(result.message, null, result.status, null);
              }
            });
        }
      });
    } else if (actionReference.id === 'Deactivate' || actionReference.id === 'Activate') {
      this.lmConfigurationService.runPersonalizeAction(
        this.listUrlInfo.reportPersonalizationUrl,
        { action: actionReference.id, userfolder: this.listSpec.userFolder }
      ).subscribe((result: LMPersonalizeActionResponse) => {
        if (result.status === AppConstants.STATUS_COMPLETED) {
          this.lmGlobalUtilService.displayToastMessage('', result.message, AppConstants.TRA_ACTION_COMPLETED);
      //    this.clearComponentStateAfterPersonalization();
          this.navigateAfterPersonalieAction();
        } else {
          this.lmErrorUtilService.handleError(result.message, null, result.status, null);
        }
      });
    } else if (actionReference.id === 'EditLPL') {
      this.runLPLEditorDialog();
    }
  }

  private navigateAfterPersonalieAction() {
      this.clearComponentStateAfterPersonalization();
      this.setAllowRouteReuseSaveFlag(false);
      setTimeout(() => {
          this.router.navigateByUrl(this.router.url, {});
      }, 100);
  }

  private clearComponentStateAfterPersonalization() {
    if (this.lmContextService.showBreadcrumbs()
      && this.listState.breadcrumbsByCategory && Object.keys(this.listState.breadcrumbsByCategory).length > 0) {
      Object.keys(this.listState.breadcrumbsByCategory).forEach(k => this.lmBannerHeaderCompRef.deleteBreadcrumb(this.listState.breadcrumbsByCategory [k]));
    }
    this.clearComponentState(false);

    // Need to know if this is correct way to handle this. The clearComponentStateAfterPersonalization causes the listState.displayAs to be removed but is needed later in the process.
    this.listState = { displayAs: this.listState.displayAs };
  }
  private runCreateReport(): void {
    const info: LMDialogInfo = { message: Soho.Locale.translate('UnsavedChangesContinuingMsg'), type: LMDialogType.NOYES };
    this.handleUnsavedChanges(info).subscribe(response => {
      if (response) {
        this._runCreateReport();
      }
    });
  }

  private _runCreateReport(): void {
    this.lmReportPersonalizationDialogService.runReportPersonalizationDialog(
      'createReportFromMenu',
      this.modalPlaceholder,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      this.listTitle,
      this.listUrlInfo,
      this.listSpec,
      this.getDataViewSet(),
      this.listSpec?.busListSpec.implementsCubeView ? this.listState : null,
      false,
      this.listSpec.includeBaseFilter,
      this.listSpec.filterCondition,
      this.chartName,
      false,
      true
    ).subscribe((result: LMReportPersonalizationDialogResult) => {
      if (result.status === LMReportPersonalizationDialogResultCode.REPORT_PERSONALIZATION_DIALOG_SAVED) {
        if (result.viewReport) {
          this.lmGlobalUtilService.navigateByUrl(result.reportUrl);
        } else {
          this.lmGlobalUtilService.displayToastMessage('', result.message, AppConstants.TRA_ACTION_COMPLETED);
        }
      }
      return;
    });
  }

  private openSubFormDialog(columnDef: ListGridColumn, row: number, cell: number, dataView: LMDataView) {
    // make a deep clone of the dataView
    let subFormDataView: LMDataView = JSON.parse(JSON.stringify(dataView));

    const actionType = (subFormDataView.isNewRow) ? AppConstants.ACTION_TYPE_CREATE : AppConstants.ACTION_TYPE_UPDATE;
    const actionSpecs = this.lmActionService.getActions(this.listSpec.busClassSpec.actions, subFormDataView.actionIndexes, actionType);
    let actionSpec: LMActionSpec = undefined;

    if (columnDef.displayField.subFormAction) {
      actionSpec = actionSpecs.find(a => a.name === columnDef.displayField.subFormAction);
    } else if ( actionSpecs.length > 0) {
      actionSpec = actionSpecs[0];
    }

    subFormDataView.action = actionSpec ? actionSpec.name : '';
    const busFormSpec = columnDef.displayField.buttonSubForm;

    const subFormName = this.listSpec.busListSpec.name + '_subform';
    const subFormResourceId = this.listSpec.busClassSpec.name + '.' + subFormName;
    const subFormSpec: LMFormSpec = {
      isImplicit: true,
      resourceId: subFormResourceId,
      busClassSpec: this.listSpec.busClassSpec,
      busFormSpec,
      selectViewType: 'form',
      formElementId: subFormName,
    };

    const subFormUrlInfo = this.lmUrlInfoBuilderService.getFormUrlInfoFromFormSpec(subFormSpec);

    // ensure there is a formRequestUrl on the formUrlInfo, so that initial value rules will work
    subFormUrlInfo.formRequestUrl = this.lmUrlUtilService.buildFormRequestUrl(subFormUrlInfo, subFormSpec);
    const formName = busFormSpec.name;
    const formResource = new FormResource({ resourceId: subFormDataView.resourceId + '.' + formName });
    const urlOptions: URLOptions = { resource: formResource };
    const url = this.lmUrlUtilService.buildUrl(urlOptions);

    this.lmBusyIndicatorService.showBusyIndicator();
    this.lmSubFormDialogService.getBlankSubFormDataView(url, actionSpec).subscribe((blankFormView: LMDataView) => {
      this.lmBusyIndicatorService.hideBusyIndicator();
      if (blankFormView.fields) {
        subFormDataView = this.lmSubFormDialogService.updateDataView(subFormDataView, blankFormView);

        this._openSubFormDialog(null, subFormDataView,
          actionSpec, [ row ], busFormSpec, subFormSpec, subFormUrlInfo,
          columnDef, row, cell, false);

      } else if (blankFormView.status === AppConstants.STATUS_SYSTEM_ERROR
              || blankFormView.status === AppConstants.VIEW_EXCEPTION) {
        // log error and open dialog like it did before.
        this.lmLoggerService.log([ this, this.instanceId, 'Failed to retrieve blankFormView.' ]);

        this._openSubFormDialog(null, subFormDataView,
          actionSpec, [ row ], busFormSpec, subFormSpec, subFormUrlInfo,
          columnDef, row, cell, false);
      }
    });
  }

  private openSubFormFromToolbarDialog(actionReference: LMBusActionReference, selectedDataView?: LMDataView) {
    // only update the first dataview with subform data, else all the selected
    // dataviews will be updated and that will change key field values as well as
    // field vaues set in the deisplay field.
    let subFormDataView: LMDataView;
    let rows: Array<number>;

    if (selectedDataView) {
      rows = [ this.getDataViewRow(selectedDataView) ];

      subFormDataView = JSON.parse(JSON.stringify(selectedDataView));
    } else {
      // make a deep clone of the dataView
      rows = this.listContentComponent.getSelectedRows();

      if (!rows || rows.length === 0) {
        return;
      }

      const dataView: LMListDataView = this.getDataView(rows[0]);

      if (!dataView) {
        return;
      }
      subFormDataView = JSON.parse(JSON.stringify(dataView));
    }


    const actionType = AppConstants.ACTION_TYPE_UPDATE;
    const actionSpecs = this.lmActionService.getActions(this.listSpec.busClassSpec.actions, subFormDataView.actionIndexes, actionType);
    let actionSpec: LMActionSpec = undefined;

    if (actionReference.subformAction) {
      actionSpec = actionSpecs.find(a => a.name === actionReference.subformAction);
    } else if ( actionSpecs.length > 0) {
      actionSpec = actionSpecs[0];
    }
    subFormDataView.action =actionSpec ? actionSpec.name : '';
    const busFormSpec = actionReference.subformSpec;

    const subFormName = this.listSpec.busListSpec.name + '_subform';
    const subFormResourceId = this.listSpec.busClassSpec.name + '.' + subFormName;
    const subFormSpec: LMFormSpec = {
      isImplicit: true,
      resourceId: subFormResourceId,
      busClassSpec: this.listSpec.busClassSpec,
      busFormSpec,
      selectViewType: 'form',
    };
    const subFormUrlInfo = this.lmUrlInfoBuilderService.getFormUrlInfoFromFormSpec(subFormSpec);

    // ensure there is a formRequestUrl on the formUrlInfo, so that initial value rules will work
    subFormUrlInfo.formRequestUrl = this.lmUrlUtilService.buildFormRequestUrl(subFormUrlInfo, subFormSpec);
    const formName = actionReference.subformSpec.name;
    const formResource = new FormResource({ resourceId: subFormDataView.resourceId + '.' + formName });
    const urlOptions: URLOptions = { resource: formResource };
    const url = this.lmUrlUtilService.buildUrl(urlOptions);

    this.lmBusyIndicatorService.showBusyIndicator();
    this.lmSubFormDialogService.getBlankSubFormDataView(url, actionSpec).subscribe((blankFormView: LMDataView) => {
      this.lmBusyIndicatorService.hideBusyIndicator();
      if (blankFormView.fields) {
        subFormDataView = this.lmSubFormDialogService.updateDataView(subFormDataView, blankFormView);

        this._openSubFormDialog(actionReference, subFormDataView,
          actionSpec, rows, busFormSpec, subFormSpec, subFormUrlInfo,
          null, null, null, true);

      } else if (blankFormView.status === AppConstants.STATUS_SYSTEM_ERROR
              || blankFormView.status === AppConstants.VIEW_EXCEPTION) {
        // log error and open dialog like it did before
        this.lmLoggerService.log([ this, this.instanceId, 'Failed to retrieve blankFormView.' ]);

        this._openSubFormDialog(actionReference, subFormDataView,
          actionSpec, rows, busFormSpec, subFormSpec, subFormUrlInfo,
          null, null, null, true);
      }
    });
  }

  private _openSubFormDialog(
      actionReference?: LMBusActionReference,
      subFormDataView?: LMDataView,
      actionSpec?: LMActionSpec,
      rows?: Array<number>,
      busFormSpec?: LMBusFormSpec,
      subFormSpec?: LMFormSpec,
      subFormUrlInfo?: LMFormUrlInfo,
      columnDef?: ListGridColumn,
      row?: number,
      cell?: number,
      fromToolbar?: boolean) {
    const subFormAction = (fromToolbar) ? actionReference.subformAction : columnDef.displayField.subFormAction;
    let actionInfo: LMSubFormActionInfo;
    if (subFormAction) {
      const actionSubject$ = new Subject<LMSubFormActionResults>();
      actionInfo = {
        actionSpec: actionSpec,
        rows: (fromToolbar) ? rows : [ row ],
        actionSubject$: actionSubject$,
        actionCallback: (result: LMSubFormResult, actionSpec: LMActionSpec, rows: Array<number>) => {
          if (fromToolbar) {
            this.updateListRecordFromToolbarSubForm(rows, result, busFormSpec.fields);
          } else {
            this.updateListRecordFromSubForm(row, cell, result);
          }
          this.subformActionCallBack(actionSubject$, result, actionSpec, rows);
        }
      };
    }

    const fieldId = (fromToolbar) ? null : columnDef.fieldId;
    const title = (fromToolbar) ? actionReference.label : columnDef.displayField.buttonSubForm.title;

    this.lmSubFormDialogService.promptSubFormDialog({
      placeholder: this.modalPlaceholder,
      fieldId: fieldId,
      title: title,
      busFormSpec,
      dataView: subFormDataView,
      formSpec: subFormSpec,
      formUrlInfo: subFormUrlInfo,
      model: null,
      actionInfo: actionInfo
    }).pipe(
        first()) // causes the subscription to complete after its messaged the first time
        .subscribe(
            (result: LMSubFormResult) => {
              // result can be undefined if the user closes the modal by hitting the escape key, so adding a safety
              if (result) {
                if (result.result === LMSubFormDialogResult.RESPONSE_OK) {
                  this.lmLoggerService.log(result.result);
                  if (result.model.isDirty) {
                    //If the subform is tied to an action, then the subform stays open while the action is ran
                    //the response back should do nothing the runSubFormAction sends events and refreshes the list.
                    if (fromToolbar) {
                      if (!actionReference.subformAction) {
                        this.updateListRecordFromToolbarSubForm(rows, result, busFormSpec.fields);
                        this.onContentModified(<LMListFieldChangedEvent>{ dataView: this.selectedDataView });
                      }
                    } else {
                      if (!columnDef.displayField.subFormAction) {
                        this.updateListRecordFromSubForm(row, cell, result);
                        this.onContentModified(<LMListFieldChangedEvent>{ dataView: this.selectedDataView });
                      }
                    }
                  }
                } else if (result.result === LMSubFormDialogResult.RESPONSE_ERROR && result.error) {
                  this.lmErrorUtilService.handleError(result.error.message, result.error.details, result.error.status);
                }
              }
              //clean up subject!
              if (actionInfo) {
                actionInfo.actionSubject$.complete();
              }
            });
  }

  private subformActionCallBack(actionSubject$: Subject<LMSubFormActionResults>, result: LMSubFormResult, actionSpec: LMActionSpec, rows: Array<number>) {
    this.runSubFormAction(actionSpec, this.getDataViewSet(), rows, actionSubject$);
  }

  private runSubFormAction(actionSpec: LMActionSpec, dataViewSet: LMDataViewSet, rows: Array<number>, actionSubject$: Subject<LMSubFormActionResults>, contextDataView?: LMDataView) {
    const dataViewList: LMDataView[] = [];
    rows.forEach((row: number) => {
      const dataView: LMListDataView | LMListTreeMoreLink = this.getDataView(row);
      // LMCLIENT-28640 - Let's not perform actions on "more" link or totals dvs.
      if (!(dataView.isTreeMoreLink ||
          dataView.isSubtotalView ||
          dataView.isSubtotalSummaryView)) {
        dataViewList.push(dataView);
      }
    });

    // this.lmBusyIndicatorService.showBusyIndicator();

    const listContext: LMListContext = {
      listUrlInfo: this.listUrlInfo,
      listSpec:    this.listSpec
    };

    if (this.stepUpActionResult) {
      listContext.stepUpActionResult = this.stepUpActionResult;
      this.stepUpActionResult = undefined;
    }
    const instanceActionUrl = this.lmListTransactionService.createActionRedirectUrl(listContext, actionSpec, dataViewSet, dataViewList);
    this.lmSpecService.getRedirectUrl(instanceActionUrl, listContext.stepUpActionResult).subscribe(redirectResponse => {
      // getRedirectUrl response is not typed, unfortunately.

      // It will return redirect url from action controller. It may be mfaUrl, if action is privileged
      // Or if stepUpActionResult is available, it is action result after mfa code is verified. In that case, the redirect url in the stepUpActionResult is the form url to go to.
      if (((redirectResponse as LMSystemException) as LMSystemException)
        && ((redirectResponse as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR
          || (redirectResponse as LMSystemException).status === AppConstants.STATUS_UNAUTHORIZED)) {
        const rResponse = redirectResponse as LMSystemException;
        this.lmErrorUtilService.handleError(rResponse.message, rResponse.details, rResponse.status, rResponse.message);
        return;
      }

      if(redirectResponse.mfaUrl) {
        this.lmGlobalUtilService.navigate(redirectResponse.mfaUrl);
        // window.location.href = redirectResponse.mfaUrl;
        return;
      }

      this.lmBusyIndicatorService.showBusyIndicator();
      const lmActionInfo: LMActionInfo = { actionName: actionSpec.name, hasActionForm: redirectResponse.hasActionForm, redirectUrl: redirectResponse.redirectUrl };


      const unprocessedDataViews: Array<number> = [];
      let firstFailure: LMActionResult;

      this.lmListTransactionService.runInstanceAction(listContext, actionSpec, undefined, dataViewSet, dataViewList, contextDataView).subscribe(
        (transactionState: LMTransactionState) => {

          // this.lmBusyIndicatorService.hideBusyIndicator();

          if (transactionState.isError) {
            actionSubject$.next( { okToClose: true, actionSpec: actionSpec, unprocessedRows: unprocessedDataViews, result: firstFailure });

            this.lmErrorUtilService.handleError(
                transactionState.response.message,
                transactionState.response.details,
                transactionState.response.status,
                transactionState.response.message);
            return;
          }

          if (transactionState.isCanceled) {
            actionSubject$.next( { okToClose: true, actionSpec: actionSpec, unprocessedRows:unprocessedDataViews, result: firstFailure });
            return;
          }

          if (transactionState.isFinished) {
            const resultList = transactionState.completedTransactionList;
            let successes = 0;
            let failures = 0;
            let cancelledRT = 0;
            const adjustment = this.isInlineCreateModeOn() ? 0 : 1;
            let title = '';
            let message = '';
            const updateMap: Map<number, LMActionResult> = new Map<number, LMActionResult>();
            const transactionSize = resultList.length;

            for (let i = 0; i < transactionSize; i++) {
              const result: LMActionResult = resultList[ i ];
              let dataViewId = result.dataView.id;
              if (dataViewId === undefined && result.dataView.resourceId) {
                // find the dataView using the resourceId
                const dataView = dataViewList.find( dv => dv.resourceId === result.dataView.resourceId);
                dataViewId = dataView?.id;
              }
              const key = (dataViewId === -1) ? 0 : dataViewId - adjustment;
              message = result.message || '';
              updateMap.set(key, result);

              if (AppConstants.STATUS_COMPLETED === result.status) {
                successes++;
              } else if (AppConstants.CONFIRMATION_REQUIRED === result.status) {
                cancelledRT++;
                unprocessedDataViews.push(key);
              } else {
                failures++;
                unprocessedDataViews.push(key);
                if (!firstFailure) {
                  firstFailure = result;
                }
              }
            }

            // todo this code is duplicated in some of the transaction functions. any way to consolidate any of this?
            let toastId = '';
            if (transactionSize !== 1) {
              if (successes === transactionSize) {
                // all transactions succeeded
                title = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('TransactionCompleteSuccess'), successes);
                message = transactionState.allRequestsSuccessfulForSameReason() ? message : '';
                toastId = AppConstants.TRA_ACTION_COMPLETED;
              } else if (failures === transactionSize) {
                // all transactions failed
                title = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('TransactionCompleteFailure'), failures);
                message = transactionState.allRequestsFailedForSameReason() ? message : '';
                toastId = AppConstants.TRA_ACTION_FAILED;
              } else if (cancelledRT === transactionSize) {
                // all transactions runtime confirmation cancelled
                message = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('TransactionCompleteCancelledRT'), cancelledRT);
                toastId = AppConstants.TRA_ACTION_CANCELED;
              } else {
                // some transactions succeeded and some failed
                message = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('TransactionCompleteResults'), [ successes, failures, cancelledRT ]);
                toastId = AppConstants.TRA_ACTION_PARTIALLY_COMPLETED;
              }
            } else {
              toastId = AppConstants.TRA_ACTION_COMPLETED;
            }

            if (failures === 0 && cancelledRT === 0) {
              if (!resultList[0].actionSpec?.suppressCompletionMessage) {
                this.lmGlobalUtilService.displayToastMessage(title, message, toastId);
              }
            }

            if (failures === 0 && cancelledRT === 0) {                            // not errors or cancels!!!
              // need to refresh and wait!, Issue when a composite form is single panel and
              // the single panel switches to another panel. https://jira.lawson.com/browse/LMCLIENT-27540
              // The component listState is corrupted because of a race condition.
              this.lmListToolbarService.updateToolbar(this.listSpec, this.getStateInfo(), this.listUrlInfo);
              this.executeRefresh().subscribe();
              const listTransactionEvent: LMListTransactionEvent = new LMListTransactionEvent(this, resultList);
              this.listTransactionEvent.emit(listTransactionEvent);
            } else if (failures > 0){                                           // at least one failed transcation!!!
              updateMap.forEach((result: LMActionResult, key: number) => {
                // when running an actionForm, the dataView.id (key) is lost if the transaction is successful.
                // Should be ok for an instance action because the row should be dirty
                if (!isNaN(key)) {
                  this.listContentComponent.updateDataViewTransaction(key, result.status, result.message);
                }
              });
            }

            //test transactionState.isError
            const okToClose = failures === 0 && cancelledRT === 0;
            actionSubject$.next( { okToClose: okToClose, actionSpec: actionSpec, unprocessedRows: unprocessedDataViews, result: firstFailure });
          }
        });
    });
  }

  private updateListRecordFromSubForm(row: number, cell: number, result: LMSubFormResult) {
    this.listContentComponent.getDataViewSet().data[row].fields = result.dataView.fields;
    this.listContentComponent.updateDataView(row, result.dataView);

    if (cell) {
      this.listContentComponent.setDirtyIndicator(row, cell, true, { isDirty: true });
    }

    this.listContentComponent.rowStatus(row, 'in-progress', Soho.Locale.translate('RowDataChanged'));
  }

  private updateListRecordFromToolbarSubForm(rows: Array<number>, result: LMSubFormResult, fields: LMSpecFields) {

    rows.forEach((row: number) => {
      const dataView: LMListDataView | LMListTreeMoreLink = this.getDataView(row);
      Object.keys(result.dataView.fields).forEach((fieldId) => {
        if (result.bindIds.includes(fieldId)) {
          const fieldSpec = fields[fieldId];
          if (!fieldSpec.isContextKey) {
            dataView.fields[fieldId].value = result.dataView.fields[fieldId].value;
          }
        }
        this.listContentComponent.updateDataView(row, dataView);
        this.listContentComponent.rowStatus(row, 'in-progress', Soho.Locale.translate('RowDataChanged'));
      });
    });
  }

  private openCompactFormDialog(event: LMListOpenCompactFormEvent) {
    // make a deep clone of the dataView
    const compactFormDataView: LMDataView = JSON.parse(JSON.stringify(event.dataView));

    const dataView = event.dataView;
    const fieldId = event.fieldId;
    const row = event.row;
    const cell = event.cell;
    const dataGrid = event.datagrid;

    const originalCompoundFieldLayout: LMCompoundFieldLayout = {
      bindId: fieldId,
      delimiter: dataView.fields[fieldId].delimiter,
      label: event.columnDef.displayField.label,
      type: 'compactFormatByForm'
    };

    this.listSpec.busListSpec.fields[fieldId].layout = event.layout;

    const compactFormName = this.listSpec.busListSpec.name + '_compactGroupForm';
    const compactFormResourceId = this.listSpec.busClassSpec.name + '.' + compactFormName;
    const compactFormSpec: LMFormSpec = {
      isImplicit: true,  // set to true so form
      resourceId: compactFormResourceId,
      busClassSpec: this.listSpec.busClassSpec,
      busFormSpec: this.listSpec.busListSpec,
      selectViewType: 'list',
      dataEntryMode: true,
      formElementId: compactFormName,
    };

    const compactFormUrlInfo = this.lmUrlInfoBuilderService.getFormUrlInfoFromFormSpec(compactFormSpec);

    // ensure there is a formRequestUrl on the formUrlInfo, so that Show Field History/Pending History
    // will work
    compactFormUrlInfo.formRequestUrl = this.lmUrlUtilService.buildFormRequestUrl(compactFormUrlInfo, compactFormSpec);

    this.lmCompactFormDialogService.promptCompactFormDialog({
      placeholder: this.modalPlaceholder,
      fieldId: event.fieldId,
      title: event.title,
      layout: event.layout, // event.layout,
      formUrlInfo: compactFormUrlInfo,
      formSpec: compactFormSpec,
      dataView: compactFormDataView,
      specFields: this.listSpec.busListSpec.fields,
      originalCompoundFieldLayout,
      model: null,
      excludeOriginalField: false
    }).pipe(
      first()) // causes the subscription to complete after its messaged the first time
      .subscribe(
        (result: LMCompactFormResult) => {
          if (result.result === LMCompactFormDialogResult.RESPONSE_OK) {
            this.lmLoggerService.log(result.result);
            if (result.model.isDirty) {
              result.dataView.fields[fieldId].value = this.lmCompoundFieldService.computeCompactFieldValue(result.dataView, fieldId);

              Object.keys(result.model.dirtyFields).forEach((key) => {
                dataView.fields[key].value = result.dataView.fields[key].value;
              });
            }
          }

          // force the cell out of edit mode
          dataGrid.commitCellEdit();

          this.listContentComponent.setActiveCell(row, cell);
        }
      );
  }

  private nextEditableCell(cell: number): number {
    let nextEditableCell = cell;
    const columns: Array<ListGridColumn> = this.listContentComponent.getColumns();
    for (let i = cell + 1, len = columns.length; i < len; i++) {
      const column = columns[ i ];
      if (column.hidden) {
        continue;
      }

      if (column.editor) {
        nextEditableCell = i;
        break;
      }
    }
    return nextEditableCell;
  }

  public openAddTagDialog() {

    const rows = this.listContentComponent.getSelectedRows();
    const taggableDataViews: Array<LMListDataView> = [];
    rows.forEach((r) => taggableDataViews.push(this.getDataView(r)));

    const listResource = new ListResource({ resourceId: this.listSpec.resourceId });
    const urlOptions: URLOptions = { resource: listResource };
    const url = this.lmUrlUtilService.buildUrl(urlOptions);

    this.lmAddTagDialogService.openAddTagDialog(url, taggableDataViews);
  }

  /**
   * sets activated row and selected rows from this.listState. if non exists then
   * set a default selection.
   */
  private performInitialRowSelection(resetSelection: boolean): number {
    if (!this.listContentComponent) {
      return -1;
    }

    const dataViewSet =  this.listContentComponent.getDataViewSet();
    if (!dataViewSet || !dataViewSet.data || !dataViewSet.data.length) {
      this.listContentComponent.activateRow(-1);
      this.listContentComponent.setSelectedRows([]);
      this.listState.selectedRowsResourceIds = [];
      this.performInitialRowSelectionComplete = true;
      return -1;
    }

    if (this.listSpec.dependentList && !this.fromDataView) {
      return -1;
    }

    this.performInitialRowSelectionComplete = false;

    this.lmLoggerService.trace([ this, this.instanceId, 'performInitialRowSelection()', this.listComponentId ]);

    const selectionMode: SohoDataGridSelectable = (this.displayType === 'chart'
        ? 'single' : this.lmListSpecUtilService.getSelectionMode(this.listSpec));

    // const isColumnarView = this.lmListSpecUtilService.isColumnarView(this.listSpec);
    // const isAggChartDisplaying = this.lmListSpecUtilService.isAggChart(this.listSpec, this.getStateInfo());
    // const selectionMode: SohoDataGridSelectable =
    //   (this.displayType === 'chart' && (!isColumnarView || isAggChartDisplaying)) ? 'single' :
    //     this.lmListSpecUtilService.getSelectionMode(this.listSpec);

    switch (selectionMode) {
      case 'mixed':
        // --------------------------------------------------
        // set activated row
        // --------------------------------------------------
        let activatedRow = !resetSelection ? this.lmListUtilService.getInitialActivatedRow(this.listSpec, this.listState, this.fromDataView) : 0;

        if (activatedRow >= dataViewSet.data.length) {
          activatedRow =  dataViewSet.data.length - 1;
        }


        this.listContentComponent.activateRow(activatedRow, true);

        // --------------------------------------------------
        // set selected row
        // --------------------------------------------------
        if (resetSelection) {
          delete this.listState.selectedRows;
          this.listState.selectedRowsResourceIds = [];
        } else  {
          const rowsToBeSelected = this.lmListUtilService.getInitialSelectedRows(this.listSpec, this.listState, this.getDataViewSet(), this.fromDataView);
          if (rowsToBeSelected !== undefined) {
            this.listContentComponent.setSelectedRows(rowsToBeSelected);
          }
        }

        this.performInitialRowSelectionComplete = true;
        return activatedRow;

      case 'multiple':
      case 'single':
        let selectedRow = -1;
        if ((this.displayType === 'chart' && !this.hasDependentData) // skip default selection for charts that don't have related data. This makes the chart look better initially.
          || ((this.displayType === 'list' || this.displayType === 'listView' || this.displayType === 'tree') && this.isDashBoardContent)) {
          // ------------------------------------------------------------------
          // - Skip default selection for charts that don't have related data.
          //    This makes the chart look better initially.
          // - Skip default selection for lists that are in dashboard panels.
          //    This make dashboard panels look nicer initially.
          // ------------------------------------------------------------------
          if (!resetSelection && this.listState.selectedRows && this.listState.selectedRows.length === 1) {
            selectedRow = (this.listState.selectedRows && this.listState.selectedRows.length > 0) ? this.listState.selectedRows[ 0 ] : -1;
            this.listContentComponent.setSelectedRows([ selectedRow ], true);
          }
        } else {
          if (resetSelection || (this.listSpec.dependentList && this.listState.fromResourceId !== this.fromDataView.resourceId)) {
            selectedRow = 0;
          } else {
            if (this.lmContextService.enableMaintainingSelectedRows()) {
              const rowsToBeSelected = this.lmListUtilService.convertResourceIdsToRowIndexes(this.listState.selectedRowsResourceIds, this.getDataViewSet());
              selectedRow = (rowsToBeSelected?.length === 1) ? rowsToBeSelected[0] : 0;
            } else {
              selectedRow = (this.listState.selectedRows && this.listState.selectedRows.length > 0) ? this.listState.selectedRows[0] : 0;
            }
          }

          // selectedRow is null|undefined when reloading the browser, or changing panels
          // hasDependentData makes sure that we only want to trigger and select first index (data point) when it has dependent pane/s
          //    or when it is the last pane on the page and we don't want to preselect the fisrt index data point
          if (selectedRow == null && this.displayType === 'chart' && this.hasDependentData) {
            selectedRow = 0;
          }

          this.listContentComponent.setSelectedRows([ selectedRow ], true);
        }
        this.performInitialRowSelectionComplete = true;
        return selectedRow;

      case 'siblings':
        let selectedRows = [ -1 ];
        selectedRows = (this.listState.selectedRows && this.listState.selectedRows.length > 0) ? this.listState.selectedRows : [ 0 ];
        this.listContentComponent.setSelectedRows(selectedRows, true);
        const activatedRow2 = !resetSelection ? this.lmListUtilService.getInitialActivatedRow(this.listSpec, this.listState, this.fromDataView) : 0;
        this.listContentComponent.activateRow(activatedRow2, true);
        this.performInitialRowSelectionComplete = true;
        return selectedRows[ 0 ];
    }

    // todo ppatton is this needed? 2/21/2020
    // let pageState = this._getPageState();
    // if (dataViewSet.data.length > 0) {
    //   /**
    //   * Set forRelatedDataReload in case selected row has not changed.
    //   * When paging for example.
    //   */
    //   this.forceRelatedDataReload = true;
    //
    //   if (pageState
    //   &&  pageState.selectedRows !== undefined
    //   &&  pageState.selectedRows.length > 0) {
    //     for (let i = 0, pageStateRowsLen = pageState.selectedRows.length; i < pageStateRowsLen; i++) {
    //       let selectedRow = pageState.selectedRows[i];
    //       if (dataViewSet.data[selectedRow] === undefined) {
    //         break;
    //       }
    //     }
    //
    //     if (this.listSpec.isHelperList) {
    //       this.listContentComponent.setSelectedRows([]);
    //     } else if (i === pageStateRowsLen) {
    //       this.listContentComponent.setSelectedRows(pageState.selectedRows);
    //     } else {
    //       this.listContentComponent.setSelectedRows([0]);
    //     }
    //   } else if (this.listSpec.isHelperList) {
    //     this.listContentComponent.setSelectedRows([]);
    //   } else {
    //     this.listContentComponent.setSelectedRows([0]);
    //   }
    // } else {
    //  //there is no data on the grid. This is for the page where -1 row index needs to be set
    //  //in order to trigger the onRowSelected trigger
    //  this.listContent.setSelectedRows([-1]);
    // }
  }

  public getDataViewSet(): LMDataViewSet {
    return this.listContentComponent?.getDataViewSet();
  }

  public getDataView(row: number): LMDataView {
    const dataViewSet = this.getDataViewSet();
    if (!dataViewSet || dataViewSet.data.length <= 0) {
      return null;
    }

    if (this.exportFilterCriteria) {
      const dv = dataViewSet.data[ row ];
      if (dv != undefined) {
        dv.exportFilterCriteria = this.exportFilterCriteria;
      }
      return dv;
    } else {
      return dataViewSet.data[ row ];
    }
  }

  // --------------------------------------------------------------------
  // simple helper methods
  // --------------------------------------------------------------------
  private get selectedRow(): number {
    const selectedRows = this.listContentComponent.getSelectedRows();
    if (!selectedRows || selectedRows.length !== 1) {
      throw 'selectedRow failed: more than 1 row is selected.';
    }
    return selectedRows[ 0 ];
  }

  private get selectedRows(): Array<number> {
    return this.listContentComponent.getSelectedRows();
  }

  private get selectedDataViews(): Array<LMDataView> {
    // todo use something like this instead.
    // return this.selectedRows.map(rowIndex => this.getDataView[rowIndex]);

    const selectedRows: Array<number> = this.selectedRows;
    const dataViewList: Array<LMDataView> = [];

    if (this.isSelectListInSelectionMode()) {
      return dataViewList;
    }

    // TODO do rows need to be sorted?  Brad Preston issue reported against 3.5
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < selectedRows.length; i++) {
      dataViewList.push(this.getDataView(selectedRows[ i ]));
    }

    return dataViewList;
  }

  private isSelectListInSelectionMode(): boolean {
    if (!this.lmContextService.useSingleSelectList()) {
      return false;
    }

    if (this.listSpec.listType !== 'select') {
      return false;
    }

    return !this.inSelectListEditMode;
  }

  private setMultiSelectedValues(): void {
    if (!this.showMultiSelectTags) {
      return;
    }

    if (this.listState.multiSelectedValues) {
      // data loaded via a filter or sort so the selected values are on listState
      this.listContentComponent.multiSelectedValuesChanged();
      delete this.listState.multiSelectedValues;
    } else {
      // data loaded initially so use the selected values passed from the lookup field
      const multiSelectedValuesArray: Array<LMMultiSelectedValue> = [];
      if (!this.selectRequestData.selectedValuesData) {
        this.selectRequestData.selectedValuesData = {} as SelectedValuesData;
      }

      const selectedValuesData = this.selectRequestData?.selectedValuesData;
      const multiFieldValues = this.lmFormatUtilService.getMultipleFilterFieldValue(selectedValuesData.selectedValues, selectedValuesData.type,
        selectedValuesData.decSize, selectedValuesData.precision);

      // Remove the double quotes that surrounds a search term when it contains a ';'
      const regExp = new RegExp('"([^\"]*(?:\\.[^\"]*)*)"', 'g');
      for (let i = 0; i < multiFieldValues.formattedFilterValue.length; i++) {
        const selectedValue = multiFieldValues.formattedFilterValue[i];
        const value = (typeof selectedValue === 'string')
          ? selectedValue.replace(regExp, `$1`) : selectedValue;

        const multiSelectedValue: LMMultiSelectedValue = {
          fieldId: selectedValuesData.fieldId,
          formattedValue: value,
          enteredValue: multiFieldValues.enteredFilterValue[i],
        };
        multiSelectedValuesArray.push(multiSelectedValue);
      }
      this.multiSelectedValues = multiSelectedValuesArray;
    }
  }

  public get allowMaintainingSelectedValues(): boolean {
    if (!this.lmContextService.enableMaintainingSelectedValues()) {
      return false;
    }

    if (this.listSpec.listType !== 'select') {
      return false;
    }

    return this.selectRequestData?.maintainSelectedValues;
  }

  public get showMultiSelectTags(): boolean {
    // selection tags configured to be maintained?
    if (!this.allowMaintainingSelectedValues) {
      return false;
    }

    // show selection tags only in selection mode
    return !this.inSelectListEditMode;
  }

  public onSelectionTagRemoved(selectionTag: LMListSelectionTag) {
    const tagValue = selectionTag.tag;
    const tagFieldId = selectionTag.id;

    // Unselect the row when it's found in the dataViewSet
    const selectedDataView: LMDataView = this.getDataViewSet().data
      .find(dataView => dataView.fields[ tagFieldId ]?.value === tagValue);
    if (selectedDataView) {
      this.listContentComponent.unSelectRow(selectedDataView.id - 1);
    }

    const multiSelectedValuesArray = this.multiSelectedValues
      .filter((selectedValue: LMMultiSelectedValue) => tagValue !== selectedValue.formattedValue);

    this.multiSelectedValues = multiSelectedValuesArray;
  }

  public updateSelectionTags(listRowSelectedEvent: LMListRowSelectedEvent) {
    if (!this.showMultiSelectTags || !listRowSelectedEvent) {
      return;
    }

    const fieldId = this.selectRequestData.selectedValuesData.fieldId;
    if (listRowSelectedEvent.type === 'select') {
      // add a selection tag for the selected row
      const selectedDataView: LMDataView = listRowSelectedEvent.rows
        .map(row => row.data)
        .find(rowDataView => {
          const selectedValue = rowDataView.fields[ fieldId ]?.value;
          return !this.multiSelectedValues.some(item => item.formattedValue === selectedValue);
        });

      if (selectedDataView) {
        const selectedValue: string = selectedDataView.fields[ fieldId ]?.value as string;
        this.multiSelectedValues.push( { fieldId, formattedValue: selectedValue, enteredValue: selectedValue } );
      }
    } else if (listRowSelectedEvent.type === 'deselect') {
      // remove the selection tag for the unselected row
      if (listRowSelectedEvent.rowData) {
        const deselectedDataView: LMDataView = listRowSelectedEvent.rowData;
        const deselectedValue = deselectedDataView.fields[fieldId]?.value;
        this.multiSelectedValues = this.multiSelectedValues.filter(item => item.formattedValue !== deselectedValue);
      }
    } else if (listRowSelectedEvent.type === 'selectall') {
      // TODO: this code can be removed when the select all checkbox is not shown in selection mode
      // add a selection tag for any newly selected row
      const selectedDataViews: LMDataView[] = listRowSelectedEvent.rows
        .map(row => row.data)
        .filter(rowDataView => {
          const selectedValue = rowDataView.fields[ fieldId ]?.value;
          return !this.multiSelectedValues.some(item => item.formattedValue === selectedValue);
        });

      selectedDataViews.forEach(selectedDataView => {
        const selectedValue: string = selectedDataView.fields[ fieldId ]?.value as string;
        this.multiSelectedValues.push({ fieldId, formattedValue: selectedValue, enteredValue: selectedValue });
      });
    } else if (listRowSelectedEvent.type === 'deselectall') {
      // TODO: this code can be removed when the select all checkbox is not shown in selection mode
      // Ignore the 'deselectall' when the user hasn't initiated
      if (listRowSelectedEvent.doNotClearSelectionTags) {
        return;
      }
      // remove the selection tag for the deselected rows
      this.multiSelectedValues = this.multiSelectedValues
        .filter(item => {
          const deselectdValues = this.getDataViewSet().data
            .map(dataView => dataView.fields[fieldId]?.value);
          return deselectdValues.indexOf(item.formattedValue) === -1;
        });
    }

    this._selectionTags = this.multiSelectedValues?.length ? this.lmListUtilService.buildSelectionTags(this.multiSelectedValues) : [];
  }

  public getUserWebRequestId(): string {
    return  this.isRouterOutletRootComponent ? (this.listSpec ?  this.listSpec.busClassSpec.name + '.' +this.listSpec.busListSpec.name : 'NO_LIST_SPEC') + '-' + this.getBaseCompId()
      : this.getRouteCompUserWebRequestId();
  }

  // eslint-disable-next-line no-unused-vars
  public getComponentInfo(additionalInfo?: LMCompInfoAdditionalInfo): LMComponentInfo {
    let dViewSet: LMDataViewSet;
    try {
      dViewSet = this.getDataViewSet();
    } catch ( error ) {
      return;
    }
    const pagingUrls = dViewSet ? dViewSet.pagingUrls : undefined;
    const listUrl = dViewSet ? dViewSet.listUrl : undefined;
    const resourceInfo = this.listSpec && this.listSpec.busListSpec && this.listSpec.busListSpec.resourceInfo ? this.listSpec.busListSpec.resourceInfo : undefined;
    const compConfigInfo: ConfigInfo = {};
    compConfigInfo['personalization'] = this.listSpec?.busListSpec?.personalization;
    compConfigInfo['configuration'] = this.listSpec?.busListSpec?.configuration;
    compConfigInfo['folder'] = this.listSpec?.busListSpec?.folder;
    compConfigInfo['userlist'] = this.listSpec?.busListSpec?.userlist;
    compConfigInfo['isReport'] = this.listSpec?.busListSpec?.isReport;
    compConfigInfo['configStamp'] = this.listSpec ? this.listSpec.busListSpec.configStamp : 0;
    compConfigInfo['classConfigStamp'] = this.listSpec ? this.listSpec.busListSpec.classConfigStamp : 0;

    const formInfo: LMComponentInfo = {
      componentType: 'LIST',
      name: this.listSpec ? this.listSpec.busListSpec.name : this.getCompNameFromRoute(this.route.snapshot, undefined),
      userWebRequestId: this.getUserWebRequestId(),
      busClassName : this.listSpec ? (this.listSpec.busClassSpec && this.listSpec.busClassSpec.name) ? this.listSpec.busClassSpec.name : undefined : undefined,
      module : this.listSpec ? (this.listSpec.busClassSpec && this.listSpec.busClassSpec.module) ? this.listSpec.busClassSpec.module : undefined : undefined,
      type: this.listSpec ? this.listSpec.listType : 'formlist',
      displayType: this.listSpec ? this.listState.displayAs : 'list',
      listState: this.listState ? this.listState : undefined,
      chartName: this.chartName,
      developer: this.listSpec ? this.listSpec.developer : undefined,
      resourceId: this.listSpec ? this.listState.fromResourceId : undefined,
      lpl: this.listSpec ? this.listSpec.busListSpec.lpl : undefined,
      routeReuse: this.lmContextService.isRouteReuse(),
      resourceInfo,
      configInfo: compConfigInfo,
      listUrl: listUrl ? listUrl : undefined,
      reloadPageUrl: pagingUrls ? pagingUrls.reloadPageUrl : undefined,
      drillbackUrl: pagingUrls ? this.lmUrlUtilService.removeParam(pagingUrls.reloadPageUrl, 'pageop') : undefined,
      firstPageUrl: pagingUrls ? pagingUrls.firstPageUrl : undefined,
      nextPageUrl: pagingUrls ? pagingUrls.nextPageUrl : undefined,
      previousPageUrl: pagingUrls ? pagingUrls.previousPageUrl : undefined,
      lastPageUrl: pagingUrls ? pagingUrls.lastPageUrl : undefined,
      tenant: this.lmContextService.getContext() ? this.lmContextService.getContext().dataArea : undefined,
      hasConfigAccess: this.lmContextService.hasConfigAccess(),
    };
    if (this.listSpec && this.listUrlInfo?.fromListResource) {
      formInfo.fromListResourceId =  this.listUrlInfo?.fromListResource?.resourceId;
    }

    return formInfo;
  }

  public isModified(): boolean {
    if (this.legacyWebUI) {
      return false;
    }

    // A list hosted in a flyout/overlay panel is destroyed when the panel closes
    // (ngOnDestroy -> resetListComponent clears listSpec), but a parent component's
    // @ViewChild reference can still point at this instance. Guard against the now
    // undefined listSpec so save-required checks (e.g. breadcrumb navigation) do not
    // throw "Cannot read properties of undefined (reading 'busListSpec')" (LMWEB-26022).
    // A destroyed or uninitialized list has no unsaved changes.
    if (this.componentDestroyed || !this.listSpec?.busListSpec) {
      return false;
    }

    if (this.lmContextService.isDataModificationNotAllowed()
      || this.listSpec.busListSpec.userFolderArchiveReport !== undefined
      || this.listSpec.busListSpec.userFolderAsOfDate !== undefined) {
      return false;
    }

    if (this.listContentComponent && this.listContentComponent.isModified()) {
      return true;
    }

    if (this.detailSectionsComponent) {
      return this.detailSectionsComponent.isModified();
    }

    return false;
  }

  public getComponentPlaceHolder() {
    return this.modalPlaceholder;
  }

  private hasListState() {
    if (this.lmContextService.getClearPageState() || this.hasDFCParameters()) {
      return false;
    }

    return this.lmListStateService.hasListState(this.buildListStateKeyParams());
  }

  private hasDFCParameters() {
    const fcParams: Params = this.lmUrlUtilService.getPrefixedParams(decodeURI(this.router.url), 'dfc.');
    return (isEmpty(fcParams)) ? false : true;
  }

  loadComponentState(rebuildStateKey = false) {
    if (this.lmContextService.disablePageState()) {
      return;
    }

    if (this.lmContextService.getClearPageState() || this.hasDFCParameters()) {
      if (this.lmContextService.resetBreadCrumbs() && this.isRouterOutletRootComponent && !this.bannerInRoute && this.lmContextService.showBreadcrumbs()) {
        // If Portal drillback or favorite, override the breadcrumb category and clear it.
        const category = this.lmContextService.isPortalNavigation() ? 'PORTAL' : this.getBreadcrumbMenuResourceCategory();
        this.lmBannerHeaderCompRef.resetBreadCrumbs(category);
      }
      this.clearComponentState(true);
      this.lmContextService.setClearNextPageState(false);
    }

    this.listState = this.lmListStateService.getListState(this.buildListStateKeyParams(rebuildStateKey));

    // LMCLIENT-34223: exclude search for tree lists with Child Hierarchy without Child Hierarchy Descendants
    const busClassSpec = this.listSpec.busClassSpec;
    if (this.listSpec.busListSpec.implementsTreeView && busClassSpec.implementsChildHierarchy && !busClassSpec.hasChildHierarchyDescendants) {
      this.showFilter = false;
      this.listState.isFilterBarOpened = false;
    }

    if (this.lmContextService.isStepUpAuthetication()) {
      const listStateAfterStepUpParams: LMListStateKeyParams = this.lmStateHelperService.buildListStateKeyParams(this.route.snapshot.params['resourceId'], this.listUrlInfo, this.listSpec);
      // After registration or login (or after step up auth), apply the list state for anonymous user
      listStateAfterStepUpParams.actorId = 'Anonymous';
      const listStateAfterStepup = this.lmListStateService.getListState(listStateAfterStepUpParams);
      if (listStateAfterStepup && Object.keys(listStateAfterStepup).length > 0) {
        // Only interested in current page url and selected rows for now.
        this.listState.selectedRows = (listStateAfterStepup.selectedRows) ? listStateAfterStepup.selectedRows : this.listState.selectedRows;
        this.listState.currentPageUrl = (listStateAfterStepup.currentPageUrl) ? listStateAfterStepup.currentPageUrl : this.listState.currentPageUrl;
        // TODO: If a detail section component initiates the transaction, bring up the current panel
        // and pass down the action result. The JobPostingsDisplay example is a single panel, form detail section.
        // Form component handles the result on form data loaded.
      }
    }

    if (!rebuildStateKey) {
      this.listPersonalization = this.lmListPersonalizationService.getListPersonalization(this.buildListPersonalizationKeyParams());
    }

    // Observables needed for the drawer
    this.drawerCollapse$ = this.lmListEventService.drawerCollapse$.pipe(
      startWith(this.listState.drawerCollapsed),
      distinctUntilChanged(),
      tap((collapsed: boolean) => this.listState.drawerCollapsed = collapsed),
    );

    this.isAbovePhoneView$ = this.breakpointChangeService.isAbovePhoneView$.pipe(
      tap((isAbovePhoneView: boolean) => {
        if (this.listState.drawerCollapsed && !isAbovePhoneView) {
          this.expandDrawerSide();
        }
        if (this.listState.showDetails && isAbovePhoneView) {
          if (this.lmBannerHeaderCompRef?.instance && this.pushedBackReferences) {
            this.lmBannerHeaderCompRef.resetBackReferences(true);
            this.pushedBackReferences = false;
          }
        }
      })
    );

    // if there is a user list view currently applied, then use it. Do not have to load default.
    if (!this.hasListState()) {
      if (this.defaultUserListViewItem) {
        this.applyDefaultUserListView();
      } else if (this.searchInitialValueCriteria || this.drillbackFilterCriteria) {
        this.applySearchInitialValue();
      }
    }
  }

  private applyDefaultUserListView() {
    try {
      const savedSearchState: LMSearchState = JSON.parse(this.defaultUserListViewItem.searchState);
      this.listState.userListViewItem = this.defaultUserListViewItem;
      this.listState.filterCriteria = savedSearchState.filters;

      const delimiter: string = this.listUrlInfo.initialDataUrl.indexOf('?') === -1 ? '?' : '&';
      this.listState.currentPageUrl = this.listUrlInfo.initialDataUrl + delimiter + this.lmUrlUtilService.filterFieldCriteriaToUrlParams(this.listState.filterCriteria, 'fc');

      this.sortOrder = savedSearchState.sortOrder;
      if (!this.hasSearchForm) {
        this.showFilter = true;
        this.listState.isFilterBarOpened = true;
      }
    } catch (exception) {
      // Log and proceed
      this.lmLoggerService.log([ this, this.instanceId, 'Failed to parse default UserListView.' ]);
    }
  }

  private applySearchInitialValue() {
    try {
      this.listState.filterCriteria = this.drillbackFilterCriteria ? this.drillbackFilterCriteria : this.searchInitialValueCriteria;
      this.searchInitialValueCriteria = null;
      this.drillbackFilterCriteria = null;
      const delimiter: string = this.listUrlInfo.initialDataUrl.indexOf('?') === -1 ? '?' : '&';
      this.listState.currentPageUrl = this.listUrlInfo.initialDataUrl + delimiter + this.lmUrlUtilService.filterFieldCriteriaToUrlParams(this.listState.filterCriteria, 'fc');

      if (!this.hasSearchForm) {
        this.showFilter = true;
        this.listState.isFilterBarOpened = true;
      }
    } catch (exception) {
      // Log and proceed
      this.lmLoggerService.log([ this, this.instanceId, 'Failed to applySearchInitialValue.' ]);
    }
  }

  saveComponentState(includeSubComponents?: boolean, stateOnly = false): void {
    if (this.previewMode) {
      return;
    }

    if (this.listSpec) {
      this.lmListStateService.saveListState(this.buildListStateKeyParams(stateOnly), this.listState);

      if (!stateOnly) {
        this.lmListPersonalizationService.saveListPersonalization(this.buildListPersonalizationKeyParams(), this.listPersonalization);

        if (includeSubComponents) {
          if (this.detailSectionsComponent) {
            this.detailSectionsComponent.saveDetailSectionsState();
          }
        }
      }
    } else {
      console.log('Cannot save component state');
    }
  }

  clearComponentState(includeSubComponents?: boolean): void {
    const routeResourceId = this.route.snapshot.params['resourceId']; // routeResourceId is always browser urls resourceId.
    this.lmStateHelperService.clearListComponentState(routeResourceId, this.listUrlInfo, this.listSpec, includeSubComponents);
  }

  get displayToolbar(): boolean {
    if (this.listSpec.showAsMingleWidget) {
      return false;
    }

    if (this.isCardViewWithDetailSections
      || (!this.isRouterOutletRootComponent && !this.isDashBoardContent)
      || (this.isRouterOutletRootComponent && (this.bannerInRoute || this.toolbarAboveList))
    ) {
      return true;
    }

    if (this.listSpec.busListSpec && this.isCubeView/* && !this.isDashBoardContent*/) {
      return false;
    }

    return false;
  }

  get isDashBoardContent(): boolean {
    return this.lmListSpecUtilService.isDashBoardContent(this.listSpec);
  }

  get isDashBoardContentWithRecordCount(): boolean {
    return this.isDashBoardContent && this.showResultSet;
  }

  get showDetailsOnSide(): boolean {
    return this.isCardViewWithDetailSections ||
           this.listSpec.busListSpec.hasDetailFieldsOnSide ||
           this.listSpec.busListSpec.showDetailSectionsOnSide;
  }

  get drawerAdditionalClasses(): string[] {
    const classNames = [];

    if (this.showSearchForm) {
      classNames.push('list-form-content');
    }

    if (this.isCardViewWithDetailSections) {
      classNames.push('list-detail');
      classNames.push('composite-form');
    }

    if (this.listSpec.busListSpec.showDetailSectionsOnSide) {
      classNames.push('list-detail');
      classNames.push('composite-form');
    }

    // if (!this.isDashBoardContent) {
    //   classNames.push('non-dashboard-content');
    // }

    if (this.hasStandardDetailSections || this.hasDetailFields) {
      classNames.push('details-content');
    }

    return classNames;
  }

  get standardListClasses(): string {
    const classNames = [ 'standard-list' ];

    if (this.showSearchForm) {
      classNames.push('list-form-content');
    }

    // if (this.isDashBoardContent) {
    //   classNames.push('dashboard-content');
    // }

    if ((this.showSearchForm || this.searchFormIsAlways) && this.searchFormOnLeft) {
      classNames.push('search-form-on-left-is-open');
    }

    // if (this.listSpec.busListSpec.hasDetailFieldsOnSide) {
    //   classNames.push('page-container two-column fixed-mm');
    // }

    return classNames.join(' ');
  }

  get listContainerClasses(): string {
    if (this.isFilterList) {
      return '';
    }

    if (this.listSpec.showAsMingleWidget) {
      return 'lm-list-widget';
    }

    // -------------------------------------------------------
    // If isDashboardContent then don't add pane or sidebar
    // classes.
    // If isMultiPanePanelContent then don't add pane classes
    // as lm-page.component has already added pane classes.
    // -------------------------------------------------------
    if (this.lmListSpecUtilService.isDashBoardContent(this.listSpec)
      || this.lmListSpecUtilService.isMultiPanePanelContent(this.listSpec)
      || this.lmListSpecUtilService.isMultiListPanelContent(this.listSpec)
      || this.lmListSpecUtilService.isHelperList(this.listSpec)) {
      return '';
    }

    if (this.lmListSpecUtilService.isSelectList(this.listSpec)
      && !(this.hasSearchForm && this.showSearchForm)
      && !this.listSpec.busListSpec.implementsTreeView) {
      return 'lm-lookup-list';
    }
    // -------------------------------------------------------
    // if this list is the cardView on the left then set
    // the sidebar classes and return.
    // -------------------------------------------------------
    if (this.isCardViewWithDetailSections) {
      return 'sidebar';
    }

    // -------------------------------------------------------
    // if hasStandardDetailSections then make it the top pane.
    // If there are standard detail sections then make this
    // a pane top. The detail section will get a pane bottom
    // in the html to match this pane top.
    // -------------------------------------------------------
    if ((this.hasStandardDetailSections && !this.showListDetailOnSide)|| this.hasDetailFields) {
      return 'lm-list-detail top';
    }

    if (this.hasStandardDetailSections && this.showListDetailOnSide) {
      return 'sidebar main-list-side';
    }

    // -------------------------------------------------------
    // if no detail section and not a detail section itself
    // then make it a pane single.
    // -------------------------------------------------------
    if (!this.hasDetailSections && !this.isDetailSection && !this.hasDetailFields) {
      if (this.lmListSpecUtilService.isFormListPanelContent(this.listSpec) && !this.formContextOnLeft) {
        return 'lm-list-standalone lm-form-list';
      }

      if (this.hasSearchForm && this.showSearchForm) {
        return 'lm-list-standalone lm-search-form';
      }

      if (this.listState.displayAs === 'hierarchy') {
        return 'lm-list-standalone lm-hierarchy-list';
      }

      if (this.hasChart && !this.isDashBoardContent) {
        return 'lm-list-standalone lm-chart-alone';
      }

      return 'lm-list-standalone';
    }

    return '';
  }

  get listContainerContentStyleHeight(): string {
    // LMWEB-22753: when the search form is open in a vertical page pane,
    // let the scrollable-flex grow to natural height
    if (this.paneIsVertical && this.showSearchForm) {
      return 'auto';
    }
    return this.hasStandardDetailSections ? 'auto' : '100%';
  }

  get standardCubeListClasses(): string {
    const classNames = [ 'standard-list' ];
    // TODO: class for search form
    return classNames.join(' ');
  }

  get cubeListContainerClasses(): string {
    if (this.hasSearchForm && this.showSearchForm) {
      return 'lm-cube-container lm-search-form';
    }

    if (this.hasSearchForm && this.hasSearchTags) {
      return 'lm-cube-container lm-list-searchtags';
    }

    if (this.hasStandardDetailSections) {
      return 'lm-cube-container top';
    }
    return 'lm-cube-container';
  }


  public get isDetailDashboardView(): boolean {
    return this.hasDetailSections && this.listSpec.busListSpec.implementsDashBoardView && !this.listSpec.busListSpec.useTwelveColumnGrid && !this.listSpec.showAsMingleWidget;
  }

  public get isDetailSectionsView(): boolean {
    return this.hasDetailSections && !this.listSpec.busListSpec.implementsDashBoardView && !this.listSpec.showAsMingleWidget;
  }

  public get isDetailTwelveColumnGridView(): boolean {
    return this.hasDetailSections && this.listSpec.busListSpec.implementsDashBoardView && this.listSpec.busListSpec.useTwelveColumnGrid && !this.listSpec.showAsMingleWidget;
  }

  // ---------------------------------------------------------
  // PUBLIC METHODS
  // ---------------------------------------------------------
  // This is called by components using the LmListComponent,
  // it should NOT be called by LmListComponent
  public refresh(request?: LMRefreshRequest): Observable<boolean> {
    return this.executeRefresh(request);
  }

  public getSelectedRow(): number {
    return this.listContentComponent.getSelectedRow();
  }

  public getSelectedRows(): Array<number> {
    return this.listContentComponent.getSelectedRows();
  }

  public toolbarMoreMenuSettings: SohoPopupMenuOptions = {
    beforeOpen: this.onBeforeListToolbarMoreMenuOpen,
    attachToBody: true,
    autoFocus: true
  };

  public commitCellEdit(): void {
    this.listContentComponent.commitCellEdit();
  }

  private syncSelectedToActivated(activatedRow: number, unselectOtherRows: boolean) {
    if (activatedRow === -1) {
      return;
    }

    /**
     * modify selection model so that if a row is activated it is also selected.
     * And all other selected rows are cleared. If the rows to be activated is already
     * selected then do not clear the other selected rows.
     */
    const selectedRows: number[] = this.getSelectedRows();
    const rowIsSelected = selectedRows.length > 0 ?
      this.getSelectedRows().find(row => row === activatedRow) !== undefined : false;

    if (!rowIsSelected) {
      if (unselectOtherRows) {
        this.listContentComponent.unSelectAllRows();
      }
      this.listContentComponent.setSelectedRows([ activatedRow ], false);
    }
  }

  private get isDetailFieldsPatternSupported(): boolean {
    let isDisplayTypeSupported = false;
    let isSelectionModeSupported = false;
    let isRowActivatedValid = false;

    // by display type
    if (this.displayType === 'list' || this.displayType === 'tree') {
      isDisplayTypeSupported = true;
    }
    // by selection mode
    const selectionMode = this.lmListSpecUtilService.getSelectionMode(this.listSpec);
    if (selectionMode === 'mixed' || selectionMode === 'single') {
      isSelectionModeSupported = true;
    }
    // for safety
    if (this.listState?.activatedRow > -1 || this.listState.selectedRows?.length) {
      isRowActivatedValid = true;
    }
    return isDisplayTypeSupported && isSelectionModeSupported && isRowActivatedValid;
  }

  private createFormModel(dataView: LMDataView): LMModel {
    const modelOptions: LMModelOptions = { formUrlInfo: this.detailFieldsFormUrlInfo, formSpec: this.detailFieldsFormSpec };
    const model: LMModel = new LMModel(this.lmModelServiceAdapter, modelOptions);
    model.populate(this.detailFieldsSpecFields);
    model.setData(dataView, { notifyListeners: false });
    return model;
  }

  private processDetailFieldsFormModelChanges(event: LMModelStatusEvent): void {
    if (!(event?.cause) || !this.isDetailFieldsPatternSupported) {
      return;
    }

    const row: number =  this.lmListSpecUtilService.getSelectionMode(this.listSpec) === 'single' ? this.getSelectedRow() : this.listState.activatedRow;
    const model: LMModel = this.detailFieldsFormModel;
    const bindId: string = event.cause.bindId;
    const columns: Array<ListGridColumn> = this.listContentComponent.getColumns();
    const field: LMField = model.getField(bindId);
    const cell: number = columns.findIndex(column => column.fieldId === bindId);
    const fieldEvent = {
      row,
      cell,
      value: field.value,
      oldValue: field.originalValue,
      column: columns[cell]
    } as SohoDataGridCellChangeEvent;
    const isFieldDirty: boolean = model.isFieldDirty(bindId);

    if (row === -1) {
      return;
    }

    if (isFieldDirty) {
      this.listContentComponent.setDirtyIndicator(row, cell, true, { isDirty: isFieldDirty });
    } else {
      this.listContentComponent.clearDirtyCell(row, cell);
    }

    if (this.displayType === 'list') {
      this.listContentComponent.listGrid.onCellChange(fieldEvent);
    } else if (this.displayType === 'tree') {
      this.listContentComponent.listTree.onCellChange(fieldEvent);
    }
  }

  private processDetailFieldsFormModelCache(row: number): void {
    if (!this.isDetailFieldsPatternSupported) {
      return;
    }
    const resourceId = this.getDataView(row)?.resourceId;
    const modelCache = this.detailfieldsFormModelCache.find(state => state.id === resourceId);

    if (modelCache) {
      if (Object.keys(modelCache.cache.dirtyFields || {}).length) {
        this.detailFieldsFormModel.applyCache(modelCache.cache);
      }
    } else {
      this.detailfieldsFormModelCache.push({
        id: resourceId,
        dataView: JSON.parse(JSON.stringify(this.selectedDataView)),
        cache: <LMModelCache> {},
      });
    }
  }

  private syncDetailFieldsFormModelAndListDataviews(isCurrentDataView = true): void {
    let row = -1;

    if (isCurrentDataView) {
      row = this.lmListSpecUtilService.getSelectionMode(this.listSpec) === 'single' ? this.getSelectedRow() : this.listState.activatedRow;
    } else {
      row = this.listState.previousActivatedRow;
    }

    if (row === -1) {
      return;
    }

    const listDataView = this.getDataView(row);

    if (this.detailFieldsFormModel.isDirty) {
      const cache = this.detailFieldsFormModel.getCache();

      Object.keys(cache.dirtyFields || {}).forEach(field => {
        listDataView.fields[field].value = this.detailFieldsFormModel.getField(field).value;
      });
      this.listContentComponent.updateDataView(row, listDataView);
    }
  }

  private clearDetailFieldsFormModelCache(dataViews?: LMDataView[]): void {
    if (!this.isDetailFieldsPatternSupported) {
      return;
    }
    if (!dataViews) {
      this.detailfieldsFormModelCache.length = 0;
    } else if (dataViews.length) {
      dataViews.forEach(dataView => {
        const resourceId: string = dataView?.resourceId;
        this.detailfieldsFormModelCache.splice(this.detailfieldsFormModelCache.findIndex(model => model.id === resourceId, 1));
      });
    }
  }

  private subscribeToDetailFieldsFormModelChanges(): void {
    //lm-model's applycache has setTimeout, wait till completed
    setTimeout(() => {
      this.detailFieldsFormModelSub$ = this.detailFieldsFormModel.statusChanges.subscribe(event => this.processDetailFieldsFormModelChanges(event));
    }, 2);

  }
  private inDrillAroundMode(): boolean {
    return this.lmDrillAroundStateService ? true : false;
  }

  private setExportedFilterCriteria(efc: Array<LMFilterFieldCriteria>): void {
    if (this.exportFilterCriteria === undefined || this.exportFilterCriteria === null || this.exportFilterCriteria?.length === 0) {
      this.exportFilterCriteria = efc;
      return;
    }

    if (efc === undefined || efc.length === 0) {
      // no passed in EFC from filtering, make sure the EFC matches what was passed in from fromDataView
      if (this.fromDataView?.exportFilterCriteria === undefined || this.fromDataView?.exportFilterCriteria === null) {
        this.exportFilterCriteria = [];
        return;
      }
      this.exportFilterCriteria = this.fromDataView?.exportFilterCriteria;
      return;
    }
    // combine the export filter criterias, with the value from the incoming being used if there is duplicate
    // filter fields
    // Need to do a deep clone, so we don't modify this.exportFilterCriteria when dealing with duplicates
    const existingEFG = JSON.parse(JSON.stringify(this.exportFilterCriteria));
    const duplicates = existingEFG.filter(o1 => efc.some(o2 => o1.fieldId === o2.fieldId));
    if (duplicates === undefined || duplicates.length === 0) {
      // no duplicates, just combine the two arrays
      this.exportFilterCriteria = [ ...existingEFG, ...efc ];
      return;
    } else {
      // have the duplicates take the value passed in on efc
      duplicates.forEach((dup: LMFilterFieldCriteria) => {
        for (let i = 0; i < existingEFG.length; i++) {
          if (existingEFG[i].fieldId === dup.fieldId) {
            existingEFG.splice(i--, 1);
          }
        }
      });

      // since duplicates have been removed from the existing efc, just combine with the incoming
      this.exportFilterCriteria = [ ...existingEFG, ...efc ];
      return;
    }
  }

  private setGlobalModeOnNavigation(url: string): string {
    // app.component honors this csk for global state also.
    if (this.lmContextService.disablePageState()) {
      return url;
    }

    // If the list is in mingle widget or overlay, do not show the red banner
    // Drillback to open a record? Will the drillback have csk.archivemode set on it?
    if (this.lmContextService.inMingleWidget() || this.lmContextService.inMingleOverlay()) {
      return url;
    }

    if (this.enterGlobalModeOnNavigation()) {
      if (this.isListDisplayingArchiveDataLocally()) {
        this.lmContextService.setArchiveMode(true);
        const globalState = this.lmGlobalStateService.getGlobalState();
        globalState.archiveMode = true;
        this.lmGlobalStateService.saveGlobalState(globalState);
        // Check if the banner is hidden for some reason
        if (this.lmBannerHeaderCompRef?.instance) {
          this.lmBannerHeaderCompRef.instance.showArchive = true;
        }
        url = this.lmUrlUtilService.updateUrlParams(url, { 'csk.archivemode': true });
      }

      if (this.isListDisplayingAsOfDateDataLocally()) {
        const asOfDateString = this.reportAsOfDate || this.listSpec.busListSpec.userFolderAsOfDate.toString();

        if (this.lmBannerHeaderCompRef?.instance) {
          this.lmBannerHeaderCompRef.instance.asOfDate = asOfDateString;
          this.lmBannerHeaderCompRef.instance.asOfDateChanged.next(asOfDateString);
        }
        url = this.lmUrlUtilService.updateUrlParams(url, { 'csk.asofdate' : asOfDateString });
      }
    }
    return url;
  }
  private enterGlobalModeOnNavigation(): boolean {
    // App component sets as of date and archive mode in context service.
    // Check if archive mode or asOfDate is set globally.
    // If so, don't set the archive mode or as of date mode based on userfolder attributes
      return this.isListDisplayingArchiveDataLocally() || this.isListDisplayingAsOfDateDataLocally();
    // TODO: Refine for LMWEB-20048 to display mustache
    // TODO: It may or may not display live data, depends on busclass is archivable or not.
    // TODO: What if the userfolder as of date does not match global as of date.
    // return false;
  }

  private isListDataFromArchive(): boolean {
    // Userfolder may be set to fetch archive data, but it can be overridden by configuration parameter.
    // EnableArchivable is a boolean config param that can be set globally or per business class.
    // Check DataView first to see if the userfolder definition is overridden
    // Check if DVS is loaded. List may implement manual load
    if (this.getDataViewSet()) {
      return (this.getDataViewSet().header.isArchiveData !== undefined && this.getDataViewSet().header.isArchiveData);
    }
    return false;
  }

  private isListDisplayingArchiveDataLocally(): boolean {
    if (!this.lmContextService.isArchiveMode()) {
      if (this.getDataViewSet()) {
        return this.isListDataFromArchive();
      }
      return this.listSpec.busListSpec.userFolderArchiveReport;
    }
    return false;
  }

  private isListDisplayingAsOfDateDataLocally(): boolean {
    // if global as of date is the SAME as local as of date return false, don't need to do anything
    return this.listSpec.busListSpec.userFolderAsOfDate !== undefined && this.listSpec.busListSpec.userFolderAsOfDate > 0
        && this.lmContextService.getAsOfDate() !== this.listSpec.busListSpec.userFolderAsOfDate.toString();
  }

  private handleTransactionResponse(transactionState: LMTransactionState, dataViewList: LMDataView[], observer?: Observer<boolean>,) {
    this.lmBusyIndicatorService.hideBusyIndicator();

    if (transactionState.isError) {
      this.lmErrorUtilService.handleError(
          transactionState.response.message,
          transactionState.response.details,
          transactionState.response.status,
          transactionState.response.message);
    } else if (transactionState.isCanceled) {
      // TODO: noop
    } else if (transactionState.isFinished) {
      // helper lists need to inform the target list that the transaction
      if (this.helperListOptions && this.helperListOptions.helperListDialog$) {
        this.helperListOptions.helperListDialog$.next({
          result: LMHelperListDialogResultCode.HELPER_LIST_ACTION_FORM_DIALOG_SAVED
        });
      }
      const transactionResultInfo = this.buildTransactionResultInfo(dataViewList, transactionState);

      if (transactionResultInfo.displayToastMessage) {
        this.lmGlobalUtilService.displayToastMessage(transactionResultInfo.title, transactionResultInfo.message, transactionResultInfo.resultAttributeValue);
      }

      if (transactionResultInfo.navigateWay) {
        const result = transactionState.getTransactionResult();
        const formPagingInfo: LMPagingInfo = this.buildFormPagingInfo(this.getDataViewSet(), result.dataView);
        this.lmNavigationService.runNavigation(result.redirectUrl, formPagingInfo);
        return;
      }

      if (transactionResultInfo.failedTotal === 0 && transactionResultInfo.canceledTotal === 0) {
        // need to refresh and wait!, Issue when a composite form is single panel and
        // the single panel switches to another panel. https://jira.lawson.com/browse/LMCLIENT-27540
        // The component listState is corrupted because of a race condition.
        this.executeRefresh().subscribe();
        const listTransactionEvent: LMListTransactionEvent = new LMListTransactionEvent(this, transactionResultInfo.resultList);
        this.listTransactionEvent.emit(listTransactionEvent);
      } else if (transactionResultInfo.failedTotal > 0)  {
        transactionResultInfo.updateMap.forEach((result: LMActionResult, key: number) => {
          // when running an actionForm, the dataView.id (key) is lost if the transaction is successful.
          // Should be ok for an instance action because the row should be dirty
          if (!isNaN(key)) {
            this.listContentComponent.updateDataViewTransaction(key, result.status, result.message);
          }
        });

        this.lmListToolbarService.updateToolbar(this.listSpec, this.getStateInfo(), this.listUrlInfo);
      }
    }

    if (observer) {
      observer.next(transactionState.isSuccess());
      observer.complete();
    }
  }

  private getDataViewRow(dataView: LMDataView): number {
    const adjustment = this.isInlineCreateModeOn() ? 0 : 1;
    return dataView.id === -1 ? 0 : dataView.id - adjustment;
  }

  private findDataViewByResourceId(resourceId: string, dataViewList: LMDataView[]): LMDataView {
    if (resourceId) {
      return dataViewList.find( dv => dv.resourceId === resourceId);
    }

    return undefined;
  }

  private buildTransactionResultInfo(dataViewList: LMDataView[], transactionState: LMTransactionState) : LMListTransactionResultInfo {
    const resultList = transactionState.completedTransactionList;
    const updateMap: Map<number, LMActionResult> = new Map<number, LMActionResult>();
    const transactionSize = resultList.length;
    let result: LMActionResult;
    let navigateWay = false;
    let displayToastMessage = false;
    let title = '';
    let message = '';
    let resultAttributeValue = '';
    let succeededTotal = 0;
    let failedTotal = 0;
    let canceledTotal = 0;
    let status: string;

    for (let i = 0; i < transactionSize; i++) {
      result = resultList[ i ];
      message = result.message;
      const dataView = this.findDataViewByResourceId(result.dataView.resourceId, dataViewList);
      const key = this.getDataViewRow(dataView);
      updateMap.set(key, result);

      if (AppConstants.STATUS_COMPLETED === result.status) {
        succeededTotal++;
      } else if (AppConstants.CONFIRMATION_REQUIRED === result.status) {
        canceledTotal++;
      } else {
        failedTotal++;
      }
    }

    if (canceledTotal === 0 || transactionSize !== 1) {
      if (!result.actionSpec?.suppressCompletionMessage) {
        displayToastMessage  = true;
      }
    }

    if (transactionSize === 1 && result.isCompletionNavigation && result.redirectUrl) {
      navigateWay = true;
    }

    if (succeededTotal === transactionSize) {
      status = 'allSucceeded';
      title = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('TransactionCompleteSuccess'), succeededTotal);
      resultAttributeValue = AppConstants.TRA_ACTION_COMPLETED;
    } else if (failedTotal === transactionSize) {
      status = 'allFailed';
      title = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('TransactionCompleteFailure'), failedTotal);
      resultAttributeValue = AppConstants.TRA_ACTION_FAILED;
    } else if (canceledTotal === transactionSize) {
      status = 'allCanceled';
      message = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('TransactionCompleteCancelledRT'), canceledTotal);
      resultAttributeValue = AppConstants.TRA_ACTION_CANCELED;
    } else {
      status = 'mixed';
      message = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('TransactionCompleteResults'), [ succeededTotal, failedTotal, canceledTotal ]);
      resultAttributeValue = AppConstants.TRA_ACTION_PARTIALLY_COMPLETED;
    }

    return <LMListTransactionResultInfo>{
      resultList,
      transactionSize,
      succeededTotal,
      failedTotal,
      canceledTotal,
      updateMap,
      status,
      displayToastMessage,
      title,
      message,
      resultAttributeValue,
      navigateWay
    };
  }

  public setLiveMsgListResultCount(listTitle: string, data: Array<LMDataView> = []): void {
    //additional checking for null or undefined values
    if (!listTitle) return;
    let count: number = data.length;

    if (this.listState?.displayAs === 'tree') {
      count = data.filter(item => !item.hasOwnProperty('isTreeMoreLink')).length;
    }
    // Using object spreader so that it will be treated as new object
    this.liveMessageList = { ...this.liveMessageList, liveMessage: this.lmFormatUtilService.formatMessage(
          Soho.Locale.translate('SearchResultsAvailable'),
          [ listTitle, count ]
      ) };
  }

  private openForcedLink(event: LMFormOverlayClickedEvent): void {
    if (this.lmOverlayService.isOpening) {
      return;
    }
    this.lmOverlayService.isOpening = true;

    const info: LMDialogInfo = { message: Soho.Locale.translate('UnsavedChangesContinuingMsg')  };
    this.overlayDataView = this.getDataView(event.row);
    const defaultOpenAction = this.lmActionService.getDefaultUpdateAction(this.listSpec.busClassSpec.actions, this.overlayDataView.actionIndexes, true, true);

    // include the paging info, so we know to display next/previous, and our location in the paging list
    if (defaultOpenAction && (defaultOpenAction.hasParameters || defaultOpenAction.hasActionForm)) {
      this.lmOverlayService.isOpening = false;
      this.runOpenAction(this.overlayDataView);
    } else {
      if (this.isDetailSection || this.listSpec.listType === 'formlist') {
        this.lmOverlayService.routerOutletUnsavedChanges(info).subscribe(response => {
          if (response)
            // need in a timeout for the case where it's a list on a page, unsaved changes is seen and
            // the user clicked to save. This causes the page to reload, so we need to be in the next tick
            // to not have an error
            this.zone.runOutsideAngular(() => {
              setTimeout(() => this.setUpForcedLink(event), 1);
            });
          else
            this.lmOverlayService.isOpening = false;
        });
      } else {
        this.handleUnsavedChanges(info).subscribe(response => {
          if (response) {
            this.setUpForcedLink(event);
          } else {
            this.lmOverlayService.isOpening = false;
          }
        });
      }
    }
  }

  private setUpForcedLink(event: LMFormOverlayClickedEvent) {
    const formPagingInfo: LMPagingInfo = this.buildFormPagingInfo(this.getDataViewSet(), this.getDataView(event.row));
    if (this.lmOverlayService.hasOpenOverlay &&
        !this.lmOverlayService.isNavigation &&
        !this.isInOverlay &&
        !this.lmOverlayService.hasNavigated &&
        this.lmOverlayService.listOpenOverlayID === this.listSpec.resourceId) {
      // Open overlay that is not a navigation means that a forced link was previously open. The listSpec resourceIds
      // match, so just updated the data in the overlay
      this.lmOverlayService.isOpening = false;
      const comm: LMOverlayAction = {
        resourceId: this.overlayDataView.resourceId,
        from: 'openingList',
        action: 'record'
      };
      this.lmOverlayService.overlayComm.next(comm);
    } else {
      let openActionRedirectUrlTemplate = urltemplate.parse(this.listUrlInfo.openActionRedirectUrl);
      let contextResourceId = this.getDataViewSet().header.resourceId;
      let resourceId = this.overlayDataView.resourceId;
      let actionName = AppConstants.ACTION_OPEN;

      if (this.listSpec.isTemplateList) {
        // need to get the correct ids for the template list case
        const dataView = this.getDataView(event.row);
        const templateDataView = dataView.dataView;
        if (templateDataView.isAlreadyDefined) {
          contextResourceId = this.listResource.resourceId;
          resourceId = templateDataView.resourceId;
        } else {
          const createAction = this.lmActionService.getDefaultCreateAction(this.listSpec.busClassSpec.actions, templateDataView.actionIndexes);
          openActionRedirectUrlTemplate = urltemplate.parse(this.listUrlInfo.actionRedirectUrl);
          contextResourceId = templateDataView.resourceId;
          resourceId = templateDataView.resourceId;
          actionName = createAction.name;
        }
      }

      let validFormRef: BusListSpecForm;
      if (this.listSpec.busListSpec.formRefs) {
        // const navs: Array<BusListSpecForm> = this.listSpec.busListSpec.formRefs.filter(formRef => formRef.type === 'nav');
        if (this.listSpec.busListSpec.formRefs?.length > 0) {
          // Check for a valid navigation
          const dataView = this.getDataView(event.row);
          for (const ref of this.listSpec.busListSpec.formRefs) {
            if (ref.validity === undefined) {
              validFormRef = ref;
              break;
            }


            if (ref.type === 'nav' && dataView.navigations.indexOf(ref.name) === -1) {
              // The navigations themselves will have validity conditions. If they are not valid, continue
              continue;
            }
            // Evaluate validity condition defined in ListDefinition for 'form is ..' or 'form navigation is ..'
            if (this.lmConditionUtilService.isValid([ ref.validity ], dataView)) {
              validFormRef = ref;
              break;
            }
          }
          if (validFormRef && validFormRef.type === 'nav') {
            this.lmOverlayService.isOpening = false;
            this.runLinkNavigation(validFormRef.name, dataView.resourceId, false, undefined, true, true, 'form', event);
            return;
          }
        }
      }

      this._openForcedLink(openActionRedirectUrlTemplate, contextResourceId, resourceId, event, actionName, formPagingInfo);
    }
  }

  private _openForcedLink(
    openActionTemplate: any,
    contextResourceId: string,
    resourceId: string,
    event?: LMFormOverlayClickedEvent,
    actionName?: string,
    formPagingInfo?: LMPagingInfo,
    sourceFromResource?: KeyedResource) {

    const an = actionName?.length > 0? actionName : AppConstants.ACTION_OPEN;

    let openActionRedirectUrl = openActionTemplate.expand({
      resourceId,
      contextResourceId,
      actionName: an
    });

    openActionRedirectUrl = this.setGlobalModeOnNavigation(openActionRedirectUrl);

    let delimiter = (openActionRedirectUrl.indexOf('?') > -1) ? '&' : '?';
    if (!this.listUrlInfo.cubeParams?.cubeMediator
      && (this.listUrlInfo.sourceResource?.resourceType === AppConstants.RESOURCETYPE_DRILL
        ||  this.listUrlInfo.sourceResource?.resourceType === AppConstants.RESOURCETYPE_NAVIGATION
        ||  this.listUrlInfo.sourceResource?.resourceType === AppConstants.RESOURCETYPE_RELATION)) {
      let fromResource: KeyedResource;
      if (sourceFromResource) {
        // we've bubbled up from a detail section, use the info passed along
        fromResource = sourceFromResource;
      } else {
        fromResource = this.buildFromResource();
      }
      openActionRedirectUrl += `${delimiter}${fromResource.resourceType}=${fromResource.generateResourceId(true)}`;
      delimiter = '&';
    }

    const navigationUrl = this.lmUrlUtilService.updateUrlParams(openActionRedirectUrl, { output: 'spec' });
    this.lmNavigationService.getActionNavigationUrl(navigationUrl).subscribe(response => {
      if (response.messageId && !response.redirectUrl) {
        // Common Inbox Integration - Direct route to open notification may return error messages.
        this.lmErrorUtilService.handleError(Soho.Locale.translate(response.messageId));
        this.lmOverlayService.isOpening = false;
        return;
      } else if (response.status && response.status === AppConstants.STATUS_SYSTEM_ERROR) {
        this.lmErrorUtilService.handleError(response.message, response.details, response.status, response.statusText);
        this.lmOverlayService.isOpening = false;
        return;
      }

      const redirectUrl = this.lmUrlUtilService.toRelativeUrl(response.redirectUrl, true, true);

      let relativeUrl = this.lmUrlUtilService.toRelativeUrl(redirectUrl);
      relativeUrl = this.lmUrlUtilService.encodePlus(relativeUrl);
      relativeUrl = this.lmUrlUtilService.encodeParens(relativeUrl);

      if (formPagingInfo) {
        // ---------------------------------------------------------------------------
        // if navigating to a new route (form) then apply paging
        // information to the url so the form next/prev functionality works.
        // ---------------------------------------------------------------------------
        const delimiter = redirectUrl.indexOf('?') === -1 ? '?' : '&';
        relativeUrl += delimiter + Object.entries(formPagingInfo).map(pair => LMUrlUtilService.toUrlParam(pair, true)).join('&');
      }

      if (response.hasActionForm) {
        // open action could be an action form, so just call the open action
        this.lmOverlayService.isOpening = false;
        const dv = this.getDataViewSet().data[event.row];
        this.runOpenAction(dv);
      } else {
        if (this.lmOverlayService.hasOpenOverlay)
          this.lmOverlayService.busyIndicator(true);
        this.lmOverlayService.open({
          open: true,
          url: relativeUrl,
          listOpenedId: this.listSpec.resourceId,
          resourceId,
          isNavigation: false,
          replaceCurrentContent: this.lmOverlayService.hasOpenOverlay,
          navigationType: 'form',
          insideOverlayNav: this.isInOverlay || this.topLevelOverlayComponent,
          event
        });
      }
    },
    error => {
      this.lmOverlayService.isOpening = false;
      this.lmErrorUtilService.handleUnexpectedError(error, this.modalPlaceholder);
    });
  }

  private openDefineInOverlay(url: string, resourceId: string, event: any): void {
    if (this.lmOverlayService.isOpening) {
      return;
    }
    this.lmOverlayService.isOpening = true;

    const info: LMDialogInfo = { message: Soho.Locale.translate('UnsavedChangesContinuingMsg')  };
    if (this.isDetailSection || this.listSpec.listType === 'formlist') {
      // Need to make sure the parent runs the unsaved changes, for the case that a parent list is dirty and
      // a navigation is clicked on the child
      this.lmOverlayService.routerOutletUnsavedChanges(info).subscribe((response) => {
        if (response) {
          // need in a timeout for the case where it's a list on a page, unsaved changes is seen and
          // the user clicked to save. This causes the page to reload, so we need to be in the next tick
          // to not have an error
          this.zone.runOutsideAngular(() => {
            setTimeout(() => this._openDefineInOverlay(url, resourceId, event), 1);
          });
        } else {
          this.lmOverlayService.isOpening = false;
        }
      });
    } else {
      this.handleUnsavedChanges(info).subscribe(response => {
        if (response) {
          this._openDefineInOverlay(url, resourceId, event);
        } else {
          this.lmOverlayService.isOpening = false;
        }
      });
    }
  }

  private _openDefineInOverlay(url: string, resourceId: string, event: any) {
    const navigationUrl = this.lmUrlUtilService.updateUrlParams(url, { output: 'spec' });
    const redirectUrl = this.lmUrlUtilService.toRelativeUrl(navigationUrl, true, true);
    let relativeUrl = this.lmUrlUtilService.toRelativeUrl(redirectUrl);
    relativeUrl = this.lmUrlUtilService.encodePlus(relativeUrl);
    relativeUrl = this.lmUrlUtilService.encodeParens(relativeUrl);

    // let's worry about the optimization of updating the data in the current overlay form!

    this.lmOverlayService.open({
      open: true,
      url: relativeUrl,
      listOpenedId: this.listSpec.resourceId,
      resourceId: resourceId,
      isNavigation: false,
      replaceCurrentContent: this.lmOverlayService.hasOpenOverlay,
      navigationType: 'form',
      insideOverlayNav: this.isInOverlay || this.topLevelOverlayComponent,
      event
    });
  }

  private openNavigationInOverlay(url: string, navigationName: string, overlayNavType: 'list' | 'form' | 'page', event: any): void {
    if (this.lmOverlayService.isOpening) {
      return;
    }
    this.lmOverlayService.isOpening = true;

    const info: LMDialogInfo = { message: Soho.Locale.translate('UnsavedChangesContinuingMsg')  };
    if (this.isDetailSection || this.listSpec.listType === 'formlist') {
      // Need to make sure the parent runs the unsaved changes, for the case that a parent list is dirty and
      // a navigation is clicked on the child
      this.lmOverlayService.routerOutletUnsavedChanges(info).subscribe((response) => {
        if (response){
          // need in a timeout for the case where it's a list on a page, unsaved changes is seen and
          // the user clicked to save. This causes the page to reload, so we need to be in the next tick
          // to not have an error
          this.zone.runOutsideAngular(() => {
            setTimeout(() => this._openNavigationInOverlay(url, navigationName, overlayNavType, event), 1);
          });
        } else {
          this.lmOverlayService.isOpening = false;
        }
      });
    } else {
      this.handleUnsavedChanges(info).subscribe(response => {
        if (response) {
          this.zone.runOutsideAngular(() => {
            setTimeout(() => {
              this.zone.run(() => this._openNavigationInOverlay(url, navigationName, overlayNavType, event));
            }, 1);
          });
        } else {
          this.lmOverlayService.isOpening = false;
        }
      });
    }
  }

  private _openNavigationInOverlay(url: string, navigationName: string, overlayNavType: 'list' | 'form' | 'page', event: LMFormOverlayClickedEvent) {
    const navigationUrl = this.lmUrlUtilService.updateUrlParams(url, { output: 'spec' });
    this.lmNavigationService.getActionNavigationUrl(navigationUrl).subscribe(response => {
      if (response.messageId && !response.redirectUrl) {
        // Common Inbox Integration - Direct route to open notification may return error messages.
        this.lmErrorUtilService.handleError(Soho.Locale.translate(response.messageId));
        this.lmOverlayService.isOpening = false;
        return;
      } else if (response.status && response.status === AppConstants.STATUS_SYSTEM_ERROR) {
        this.lmErrorUtilService.handleError(response.message, response.details, response.status, response.statusText);
        this.lmOverlayService.isOpening = false;
        return;
      }

      const redirectUrl = this.lmUrlUtilService.toRelativeUrl(response.redirectUrl, true, true);

      let relativeUrl = this.lmUrlUtilService.toRelativeUrl(redirectUrl);
      relativeUrl = this.lmUrlUtilService.encodePlus(relativeUrl);
      relativeUrl = this.lmUrlUtilService.encodeParens(relativeUrl);

      const isGenUrl = this.lmUrlUtilService.isGenUrlUsingHref(relativeUrl); // urlParams['csk.gen'] === 'true';
      const urlPath = this.lmUrlUtilService.getUrlPath(relativeUrl);
      const newResource = this.lmUrlUtilService.getResource(urlPath, isGenUrl);
      const newResourceId = newResource.generateBusObjectId(false);

      // worry about optimization for opening the same nav on a different record in the future
      this.lmOverlayService.open({
        open: true,
        url: relativeUrl,
        listOpenedId: this.listSpec.resourceId,
        resourceId: newResourceId,
        isNavigation: true,
        navigationName: navigationName,
        replaceCurrentContent: this.lmOverlayService.hasOpenOverlay,
        navigationType: overlayNavType,
        insideOverlayNav: this.isInOverlay || this.topLevelOverlayComponent,
        event: event
      });
    });
  }

  private updateDatagridAriaLabel(title: string) {
    const grid = this.elementRef?.nativeElement?.querySelector('.datagrid');
    grid?.setAttribute('aria-label', title);
  }

  /**
   * LMWEB-25692: Close the flyout when the list content is about to change (search, filter clear, tag removal),
   * since the flyout content becomes stale when the underlying list reloads.
   */
  private closeFlyoutIfOpen(): void {
    if (this.formIsOverlayPOC && !this.isInOverlay && !this.topLevelOverlayComponent &&
           this.listSpec.listType !== 'select' && this.listSpec.listType !== 'helper' &&
           this.lmOverlayService.hasOpenOverlay) {
      this.lmOverlayService.close();
    }
  }
}
